import * as React from 'react';
import React__default, { useContext, useState, useLayoutEffect, useEffect, useMemo, useCallback, useRef, useReducer, forwardRef, Children } from 'react';
import PropTypes from 'prop-types';
import { jsx, css as css$1, keyframes } from '@emotion/react';
import crypto from 'crypto';
import { jsx as jsx$1, jsxs } from '@emotion/react/jsx-runtime';
import _reactDom from 'react-dom';

var WindowContext = /*#__PURE__*/ React__default.createContext();
function WindowProvider(_ref) {
    var window = _ref.window, children = _ref.children;
    return jsx(WindowContext.Provider, {
        value: window
    }, children);
}
WindowProvider.propTypes = {
    window: PropTypes.object,
    children: PropTypes.node.isRequired
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var accordion = (function (theme, _a) {
    var getColor = _a.getColor, getTextStyle = _a.getTextStyle;
    function getContentColor(headerColor) {
        return headerColor === "grey.t07"
            ? "grey.t03"
            : headerColor === "secondary.lightBlue.t25"
                ? "secondary.lightBlue.t15"
                : "white";
    }
    return {
        getContentColor: getContentColor,
        getCSS: function (options) {
            switch (options.targetElement) {
                case "headerContainer": {
                    return {
                        margin: 0,
                    };
                }
                case "headerButton": {
                    return __assign(__assign(__assign(__assign(__assign({ display: "flex", alignItems: "center", width: "100%", border: 0, borderRadius: theme.radii[0], boxSizing: "border-box", padding: theme.space[3] + " " + theme.space[4] + " " + theme.space[3] + " " + theme.space[6], textAlign: "left" }, getTextStyle({ name: "subtitle2", mode: "self-bold" })), { outline: 0 }), theme.focusStyles.focusVisible), (options.__internal__keyboardFocus &&
                        theme.focusStyles.__keyboardFocus)), { backgroundColor: getColor(options.color), color: getColor(options.textColor) });
                }
                case "headerContent": {
                    return {
                        display: "flex",
                        alignItems: "center",
                        flexGrow: 1,
                    };
                }
                case "headerIcon": {
                    return {
                        display: "flex",
                        marginRight: theme.space[2],
                    };
                }
                case "headerChevron": {
                    return __assign({ display: "flex", transformOrigin: "50% 50%", transition: "transform .25s ease" }, (options.isOpen && {
                        transform: "translateZ(0) rotate(180deg)",
                    }));
                }
                case "content": {
                    return {
                        textAlign: "left",
                        backgroundColor: getColor(getContentColor(options.color)),
                        padding: theme.space[4] + " " + theme.space[11] + " " + theme.space[4] + " " + theme.space[6],
                    };
                }
                case "item": {
                    return {
                        ":not(:first-of-type)": {
                            marginTop: options.itemGap === "small"
                                ? "1px" // This is an exception to our space scale
                                : theme.space[1],
                        },
                    };
                }
                default: {
                    return {};
                }
            }
        },
    };
});

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found.\n\n",
  "75": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format$1() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format$1.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor);

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor);

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var button = (function (theme) {
    function addStates(css, _a) {
        var hover = _a.hover, active = _a.active, loading = _a.loading, showLoadingIcon = _a.showLoadingIcon, disabled = _a.disabled, __internal__hover = _a.__internal__hover, __internal__active = _a.__internal__active;
        if (showLoadingIcon) {
            return __assign(__assign({}, css), loading);
        }
        return __assign(__assign(__assign(__assign(__assign(__assign({}, css), { ":hover:not(:disabled)": hover }), (__internal__hover && hover)), { ":active:not(:disabled)": active }), (__internal__active && active)), (disabled && {
            ":disabled": __assign(__assign({}, css[":disabled"]), disabled),
        }));
    }
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "button": {
                    var variant = options.variant, color = options.color, showLoadingIcon = options.showLoadingIcon, __internal__active = options.__internal__active, __internal__keyboardFocus = options.__internal__keyboardFocus, __internal__hover = options.__internal__hover;
                    var css = __assign(__assign(__assign({ position: "relative", fontSize: theme.fontSizes[2], lineHeight: theme.lineHeights[3], fontFamily: theme.fonts.body, fontWeight: theme.fontWeights.medium, margin: 0, border: 0, padding: "0 " + theme.space[6], minHeight: "48px", overflow: "hidden", transition: theme.transitions.button, borderRadius: theme.radii[1], outline: 0 }, theme.focusStyles.focusVisible), (__internal__keyboardFocus && theme.focusStyles.__keyboardFocus)), (!showLoadingIcon && {
                        ":disabled": {
                            backgroundColor: theme.colors.grey.t30,
                            color: theme.colors.grey.t75,
                            opacity: 0.7,
                            cursor: "not-allowed",
                        },
                    }));
                    switch (true) {
                        case variant === "primary" && color === "highlight.blue.t100": {
                            css = addStates(__assign(__assign({}, css), { backgroundColor: theme.colors.highlight.blue.t100, color: theme.colors.white }), {
                                hover: {
                                    backgroundColor: theme.colors.primary.blue.t100,
                                    color: theme.colors.white,
                                },
                                active: {
                                    backgroundColor: theme.colors.primary.blue.t100,
                                    color: theme.colors.white,
                                },
                                loading: {
                                    backgroundColor: "transparent",
                                    borderWidth: theme.borderWidths[0],
                                    borderStyle: "solid",
                                    borderColor: rgba(theme.colors.black, 0.35),
                                    cursor: "progress",
                                },
                                showLoadingIcon: showLoadingIcon,
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                            break;
                        }
                        case variant === "primary" && color === "white": {
                            css = addStates(__assign(__assign({}, css), { backgroundColor: theme.colors.white, color: theme.colors.highlight.blue.t100 }), {
                                hover: {
                                    backgroundColor: theme.colors.secondary.lightBlue.t25,
                                    color: theme.colors.primary.blue.t100,
                                },
                                active: {
                                    backgroundColor: theme.colors.secondary.lightBlue.t25,
                                    color: theme.colors.primary.blue.t100,
                                },
                                loading: {
                                    backgroundColor: "transparent",
                                    borderWidth: theme.borderWidths[0],
                                    borderStyle: "solid",
                                    borderColor: rgba(theme.colors.white, 0.35),
                                    cursor: "progress",
                                },
                                showLoadingIcon: showLoadingIcon,
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                            break;
                        }
                        case variant === "primary" && color === "green": {
                            css = addStates(__assign(__assign({}, css), { backgroundColor: "#21a637", color: theme.colors.white }), {
                                hover: {
                                    backgroundColor: "#007414",
                                    color: theme.colors.white,
                                },
                                active: {
                                    backgroundColor: "#007414",
                                    color: theme.colors.white,
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                            break;
                        }
                        case variant === "secondary" && color === "highlight.blue.t100": {
                            css = addStates(__assign(__assign({}, css), { backgroundColor: "transparent", color: theme.colors.highlight.blue.t100, borderWidth: theme.borderWidths[0], borderStyle: "solid", borderColor: theme.colors.highlight.blue.t100 }), {
                                hover: {
                                    backgroundColor: theme.colors.highlight.blue.t100,
                                    color: theme.colors.white,
                                },
                                active: {
                                    backgroundColor: theme.colors.highlight.blue.t100,
                                    color: theme.colors.white,
                                },
                                loading: {
                                    backgroundColor: "transparent",
                                    borderWidth: theme.borderWidths[0],
                                    borderStyle: "solid",
                                    borderColor: rgba(theme.colors.black, 0.35),
                                    cursor: "progress",
                                },
                                showLoadingIcon: showLoadingIcon,
                                disabled: {
                                    borderColor: theme.colors.grey.t65,
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                            break;
                        }
                        case variant === "secondary" && color === "black": {
                            css = addStates(__assign(__assign({}, css), { backgroundColor: "transparent", color: theme.colors.black, borderWidth: theme.borderWidths[0], borderStyle: "solid", borderColor: theme.colors.black }), {
                                hover: {
                                    backgroundColor: theme.colors.highlight.blue.t100,
                                    color: theme.colors.white,
                                    borderColor: theme.colors.highlight.blue.t100,
                                },
                                active: {
                                    backgroundColor: theme.colors.highlight.blue.t100,
                                    color: theme.colors.white,
                                    borderColor: theme.colors.highlight.blue.t100,
                                },
                                loading: {
                                    backgroundColor: "transparent",
                                    borderWidth: theme.borderWidths[0],
                                    borderStyle: "solid",
                                    borderColor: rgba(theme.colors.black, 0.35),
                                    cursor: "progress",
                                },
                                showLoadingIcon: showLoadingIcon,
                                disabled: {
                                    borderColor: theme.colors.grey.t65,
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                            break;
                        }
                        case variant === "secondary" && color === "white": {
                            css = addStates(__assign(__assign({}, css), { backgroundColor: "transparent", color: theme.colors.white, borderWidth: theme.borderWidths[0], borderStyle: "solid", borderColor: theme.colors.white }), {
                                hover: {
                                    backgroundColor: theme.colors.white,
                                    color: theme.colors.highlight.blue.t100,
                                },
                                active: {
                                    backgroundColor: theme.colors.white,
                                    color: theme.colors.highlight.blue.t100,
                                },
                                loading: {
                                    backgroundColor: "transparent",
                                    borderWidth: theme.borderWidths[0],
                                    borderStyle: "solid",
                                    borderColor: rgba(theme.colors.white, 0.35),
                                    cursor: "progress",
                                },
                                showLoadingIcon: showLoadingIcon,
                                disabled: {
                                    backgroundColor: theme.colors.grey.t30,
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                            break;
                        }
                        case variant === "icon": {
                            css = addStates(__assign(__assign({}, css), { display: "flex", alignItems: "center", padding: "0 " + theme.space[2], backgroundColor: "transparent" }), {
                                hover: {
                                    backgroundColor: theme.colors.grey.t10,
                                },
                                active: {
                                    backgroundColor: theme.colors.grey.t10,
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                            break;
                        }
                    }
                    return css;
                }
                case "loadingIcon": {
                    return {
                        position: "absolute",
                        top: "calc(50% - 10px)",
                        left: "calc(50% - 10px)",
                    };
                }
                case "content": {
                    if (options.showLoadingIcon) {
                        return {
                            opacity: 0,
                        };
                    }
                    return {};
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var autoComplete = (function (theme) {
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "container": {
                    return {
                        position: "relative",
                    };
                }
                case "searchIcon": {
                    return {
                        width: theme.space[11],
                        height: theme.space[11],
                        border: 0,
                        background: "none",
                        appearance: "none",
                        cursor: "pointer",
                    };
                }
                case "clearIcon": {
                    return options.showClearIcon
                        ? {
                            width: theme.space[11],
                            height: theme.space[11],
                            border: 0,
                            background: "none",
                            appearance: "none",
                            cursor: "pointer",
                        }
                        : { display: "none" };
                }
                case "ul": {
                    return {
                        padding: 0,
                        position: "absolute",
                        overflowX: "hidden",
                        overflowY: "auto",
                        margin: 0,
                        borderTop: 0,
                        zIndex: 1000,
                        listStyle: "none",
                        transition: "opacity .1s ease",
                        borderRadius: theme.radii[0],
                        minWidth: "200px",
                        backgroundColor: "white",
                        width: "100%",
                    };
                }
                case "li": {
                    return __assign(__assign({ display: "flex", justifyContent: "flex-start", alignItems: "center", border: "1px solid " + theme.colors.grey.t10, borderTop: "none", padding: theme.space[4] + " " + theme.space[6], cursor: "pointer" }, (options.isHighlighted && {
                        backgroundColor: theme.colors.secondary.lightBlue.t25,
                    })), { borderRadius: theme.radii[0] });
                }
                case "listItemContent": {
                    return theme.textStyles["body1"];
                }
                case "right": {
                    return {
                        display: "flex",
                        position: "absolute",
                        right: 0,
                        marginTop: "-" + theme.space[11],
                        alignItems: "center",
                    };
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var checkbox = (function (theme, _a) {
    var getColor = _a.getColor;
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "container": {
                    return {
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                    };
                }
                case "input": {
                    return __assign(__assign({}, theme.focusStyles.focusVisibleAdjacentLabel), { ":checked + label": {
                            backgroundColor: theme.colors.secondary.lightBlue.t25,
                            color: theme.colors.primary.blue.t100,
                        } });
                }
                case "label": {
                    return __assign({ display: "inline-flex", alignItems: "flex-start", padding: theme.space[3] + " " + theme.space[4], minHeight: "24px", fontSize: theme.fontSizes[1], fontWeight: theme.fontWeights.light, lineHeight: theme.lineHeights[2], fontFamily: theme.fonts.body, color: theme.colors.black, backgroundColor: getColor(options.color), borderRadius: theme.radii[0] }, (options.__internal__keyboardFocus &&
                        theme.focusStyles.__keyboardFocusAdjacentLabel));
                }
                case "svg": {
                    return {
                        flexShrink: 0,
                        width: "24px",
                        height: "24px",
                        marginRight: theme.space[3],
                    };
                }
                case "svgRect": {
                    return {
                        fill: getColor(options.color === "grey.t05" || options.isChecked
                            ? "white"
                            : "secondary.lightBlue.t25"),
                    };
                }
                case "svgPath": {
                    return {
                        stroke: theme.colors.primary.blue.t100,
                    };
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var dropdown = (function (theme, _a) {
    var getColor = _a.getColor;
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "container": {
                    return {
                        position: "relative",
                    };
                }
                case "button": {
                    return __assign(__assign(__assign(__assign({ display: "flex", alignItems: "center", boxSizing: "border-box", padding: theme.space[4], width: "100%", color: theme.colors.black, backgroundColor: getColor(options.color), textAlign: "left", margin: 0, border: 0, borderRadius: theme.radii[0], outline: 0 }, theme.focusStyles.focusVisible), (options.isPlaceholder && {
                        padding: theme.space[2] + " " + theme.space[4],
                    })), (options.__internal__focus && theme.focusStyles.__keyboardFocus)), { 
                        // See: https://stackoverflow.com/a/199319/247243
                        "::-moz-focus-inner": {
                            border: 0,
                        } });
                }
                case "buttonContent": {
                    return {
                        display: "flex",
                        alignItems: "center",
                        flexGrow: 1,
                    };
                }
                case "buttonChevron": {
                    return {
                        display: "flex",
                        transformOrigin: "50% 50%",
                        transition: "transform .25s ease",
                    };
                }
                case "options": {
                    return {
                        position: "absolute",
                        width: "100%",
                        margin: 0,
                        padding: 0,
                        backgroundColor: theme.colors.white,
                        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.3)",
                        overflowY: "auto",
                        zIndex: theme.zIndices.dropdown,
                        ":focus": {
                            outline: 0,
                        },
                    };
                }
                case "option": {
                    return __assign({ listStyleType: "none", padding: theme.space[4], borderTop: theme.borderWidths[0] + " solid " + theme.colors.grey.t10, cursor: "default" }, (options.isHighlighted && {
                        backgroundColor: theme.colors.secondary.lightBlue.t25,
                    }));
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var field = (function (theme) {
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "fieldContainer": {
                    return __assign(__assign({ display: "inline-flex", flexDirection: "column", position: "relative" }, (options.fullWidth && {
                        display: "flex",
                        width: "100%",
                        minWidth: 0, // See: https://stackoverflow.com/a/36247448/247243
                    })), (options.disabled && { opacity: 0.5 }));
                }
                case "label": {
                    return {
                        display: "flex",
                        fontFamily: theme.fonts.body,
                        fontSize: theme.fontSizes[1],
                        fontWeight: theme.fontWeights.medium,
                        lineHeight: theme.lineHeights[2],
                        color: theme.colors.grey.t75,
                        marginBottom: theme.space[2],
                    };
                }
                case "optionalTag": {
                    return {
                        alignSelf: "flex-end",
                        fontSize: theme.fontSizes[0],
                        lineHeight: theme.lineHeights[0],
                        paddingLeft: theme.space[2],
                        paddingRight: theme.space[2],
                        border: theme.borderWidths[1] + " solid " + theme.colors.grey.t75,
                        borderRadius: theme.radii[2],
                        opacity: 0.66,
                        marginLeft: "auto",
                    };
                }
                case "helpText": {
                    return {
                        paddingTop: theme.space[2],
                    };
                }
                case "errorsContainer": {
                    return {
                        paddingTop: theme.space[1],
                        borderTop: theme.borderWidths[2] + " solid " + theme.colors.conditional.negative.graphics,
                        zIndex: 1,
                    };
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var input = (function (theme, _a) {
    var getColor = _a.getColor;
    return {
        getCSS: function (options) {
            var hasPrefix = typeof options.prefix === "string" && options.prefix.length > 0;
            var hasSuffix = typeof options.suffix === "string" && options.suffix.length > 0;
            switch (options.targetElement) {
                case "inputContainer": {
                    return __assign(__assign({ position: "relative", fontSize: theme.fontSizes[1], fontWeight: theme.fontWeights.light, lineHeight: theme.lineHeights[2], fontFamily: theme.fonts.body, color: theme.colors.black }, (hasPrefix && {
                        "::before": {
                            content: "\"" + options.prefix + "\"",
                            position: "absolute",
                            top: "13px",
                            left: theme.space[4],
                        },
                    })), (hasSuffix && {
                        "::after": {
                            content: "\"" + options.suffix + "\"",
                            position: "absolute",
                            top: "13px",
                            right: theme.space[4],
                        },
                    }));
                }
                case "input": {
                    var focusStyle = {
                        outline: 0,
                        borderRadius: theme.radii[0],
                        boxShadow: theme.shadows.focus,
                    };
                    var paddingRight = hasSuffix && options.suffix
                        ? "calc(" + theme.space[4] + " + " + (options.suffix.length + 1) + "ch)"
                        : theme.space[4];
                    paddingRight =
                        options.isLoading && options.hasSuffixButton
                            ? "84px"
                            : paddingRight; // Auto complete with loading
                    paddingRight =
                        !options.isLoading && options.hasSuffixButton
                            ? theme.space[11]
                            : paddingRight; // Auto complete without loading
                    return __assign({ boxSizing: "border-box", width: "100%", height: "48px", border: 0, margin: 0, paddingTop: 0, paddingBottom: 0, fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit", fontFamily: "inherit", color: "inherit", backgroundColor: getColor(options.color), paddingLeft: hasPrefix && options.prefix
                            ? "calc(" + theme.space[4] + " + " + (options.prefix.length + 1) + "ch)"
                            : theme.space[4], paddingRight: paddingRight, ":focus": focusStyle }, (options.__internal__focus && focusStyle));
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var link = (function (theme) {
    function addStates(css, _a) {
        var hover = _a.hover, active = _a.active, __internal__hover = _a.__internal__hover, __internal__active = _a.__internal__active;
        return __assign(__assign(__assign(__assign(__assign({}, css), { ":hover": hover }), (__internal__hover && hover)), { ":active": active }), (__internal__active && active));
    }
    function getButtonCSS(css) {
        return __assign(__assign({}, css), { display: "inline-flex", alignItems: "center", justifyContent: "center", textDecoration: "none", boxSizing: "border-box", width: "100%" });
    }
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "anchor": {
                    return __assign(__assign({ textDecoration: "none", borderRadius: theme.radii[1], outline: 0, display: ["primary-button", "secondary-button", "icon"].includes(options.appearance)
                            ? "inline-flex"
                            : null, verticalAlign: options.appearance === "icon" ? "top" : null }, theme.focusStyles.focusVisible), (options.__internal__keyboardFocus &&
                        theme.focusStyles.__keyboardFocus));
                }
                case "span": {
                    var variant = options.variant, buttonTheme = options.buttonTheme, appearance = options.appearance, __internal__active = options.__internal__active, __internal__hover = options.__internal__hover;
                    switch (variant) {
                        case "light-bg": {
                            return addStates({
                                fontFamily: theme.fonts.body,
                                fontWeight: theme.fontWeights.light,
                                borderBottomWidth: theme.borderWidths[0],
                                borderBottomStyle: "solid",
                                transition: theme.transitions.link,
                                color: theme.colors.primary.blue.t100,
                                borderBottomColor: rgba(theme.colors.primary.blue.t100, 0.5),
                            }, {
                                hover: {
                                    borderBottomColor: theme.colors.primary.blue.t100,
                                    backgroundColor: theme.colors.secondary.lightBlue.t25,
                                },
                                active: {
                                    borderBottomColor: theme.colors.primary.blue.t100,
                                    backgroundColor: theme.colors.secondary.lightBlue.t25,
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                        }
                        case "medium-bg": {
                            return addStates({
                                fontFamily: theme.fonts.body,
                                fontWeight: theme.fontWeights.light,
                                borderBottomWidth: theme.borderWidths[0],
                                borderBottomStyle: "solid",
                                transition: theme.transitions.link,
                                color: theme.colors.primary.blue.t100,
                                borderBottomColor: rgba(theme.colors.primary.blue.t100, 0.5),
                            }, {
                                hover: {
                                    borderBottomColor: theme.colors.primary.blue.t100,
                                    backgroundColor: theme.colors.white,
                                },
                                active: {
                                    borderBottomColor: theme.colors.primary.blue.t100,
                                    backgroundColor: theme.colors.white,
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                        }
                        case "dark-bg": {
                            return addStates({
                                fontFamily: theme.fonts.body,
                                fontWeight: theme.fontWeights.light,
                                borderBottomWidth: theme.borderWidths[0],
                                borderBottomStyle: "solid",
                                transition: theme.transitions.link,
                                color: theme.colors.white,
                                borderBottomColor: rgba(theme.colors.white, 0.5),
                            }, {
                                hover: {
                                    borderBottomColor: theme.colors.secondary.lightBlue.t25,
                                    backgroundColor: rgba(theme.colors.black, 0.45),
                                },
                                active: {
                                    borderBottomColor: theme.colors.secondary.lightBlue.t25,
                                    backgroundColor: rgba(theme.colors.black, 0.45),
                                },
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            });
                        }
                        case "blue-button": {
                            return getButtonCSS(buttonTheme.getCSS({
                                targetElement: "button",
                                variant: appearance === "primary-button" ? "primary" : "secondary",
                                color: "highlight.blue.t100",
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            }));
                        }
                        case "white-button": {
                            return getButtonCSS(buttonTheme.getCSS({
                                targetElement: "button",
                                variant: appearance === "primary-button" ? "primary" : "secondary",
                                color: "white",
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            }));
                        }
                        case "black-button": {
                            return getButtonCSS(buttonTheme.getCSS({
                                targetElement: "button",
                                variant: "secondary",
                                color: "black",
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            }));
                        }
                        case "green-button": {
                            return getButtonCSS(buttonTheme.getCSS({
                                targetElement: "button",
                                variant: "primary",
                                color: "green",
                                __internal__hover: __internal__hover,
                                __internal__active: __internal__active,
                            }));
                        }
                    }
                    return {};
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var list = (function (theme, _a) {
    var getTextStyle = _a.getTextStyle;
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "list": {
                    return __assign(__assign(__assign(__assign(__assign({ margin: 0, listStyleType: "none" }, (options.type === "unordered" && {
                        paddingLeft: "1.25em",
                    })), (options.type === "ordered" && {
                        counterReset: "ordered",
                        paddingLeft: "1.25em",
                    })), (options.type === "steps" && {
                        counterReset: "steps",
                        padding: "0.25em 0 0.25em 2.5em",
                    })), getTextStyle({ name: options.textStyle, mode: "container" })), { color: theme.colors.black });
                }
                case "item": {
                    switch (options.type) {
                        case "unordered": {
                            return {
                                position: "relative",
                                ":not(:first-of-type)": {
                                    marginTop: options.textStyle === "subtitle1"
                                        ? theme.space[4]
                                        : options.textStyle === "subtitle2"
                                            ? theme.space[3]
                                            : theme.space[2],
                                },
                                "::before": {
                                    content: '""',
                                    width: "0.5em",
                                    height: "0.5em",
                                    borderRadius: theme.radii[3],
                                    position: "absolute",
                                    top: "0.5em",
                                    left: "-1.25em",
                                    backgroundColor: options.variant === "danger"
                                        ? theme.colors.conditional.negative.graphics
                                        : theme.colors.secondary.lightBlue.t100,
                                },
                                "& ul, & ol": {
                                    marginTop: "0.5em",
                                },
                                "&:not(:last-of-type) ul, &:not(:last-of-type) ol": {
                                    marginBottom: "1em",
                                },
                            };
                        }
                        case "ordered": {
                            return {
                                position: "relative",
                                counterIncrement: "ordered",
                                ":not(:first-of-type)": {
                                    marginTop: options.textStyle === "subtitle1"
                                        ? theme.space[4]
                                        : options.textStyle === "subtitle2"
                                            ? theme.space[3]
                                            : theme.space[2],
                                },
                                "::before": {
                                    content: 'counter(ordered, decimal) ". "',
                                    position: "absolute",
                                    top: 0,
                                    left: "-1.25em",
                                },
                                "& ul, & ol": {
                                    marginTop: "0.5em",
                                },
                                "&:not(:last-of-type) ul, &:not(:last-of-type) ol": {
                                    marginBottom: "1em",
                                },
                                "& ol li::before": {
                                    content: 'counter(ordered, lower-alpha) ". "',
                                },
                                "& ol ol li::before": {
                                    content: 'counter(ordered, lower-roman) ". "',
                                },
                            };
                        }
                        case "steps": {
                            return {
                                position: "relative",
                                counterIncrement: "steps",
                                marginBottom: "1.4em",
                                ":last-of-type": {
                                    marginBottom: 0,
                                },
                                "::before": {
                                    content: "counter(steps, decimal)",
                                    width: "2em",
                                    height: "2em",
                                    lineHeight: "2em",
                                    color: theme.colors.white,
                                    backgroundColor: theme.colors.primary.blue.t100,
                                    fontWeight: theme.fontWeights.medium,
                                    textAlign: "center",
                                    borderRadius: theme.radii[3],
                                    position: "absolute",
                                    top: "-0.25em",
                                    left: "-2.5em",
                                },
                                "& ul, & ol": {
                                    marginTop: "1em",
                                },
                                "&:not(:last-of-type) ul, &:not(:last-of-type) ol": {
                                    marginBottom: "1.25em",
                                },
                                "& ol li::before": {
                                    content: "counter(steps, lower-alpha)",
                                    color: theme.colors.black,
                                    backgroundColor: theme.colors.secondary.lightBlue.t100,
                                },
                            };
                        }
                        default: {
                            return {};
                        }
                    }
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var radioGroup = (function (theme, _a) {
    var getColor = _a.getColor, getTextStyle = _a.getTextStyle;
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "radio": {
                    return {
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    };
                }
                case "radioInput": {
                    return __assign(__assign({}, theme.focusStyles.focusVisibleAdjacentLabel), { ":checked + label": {
                            backgroundColor: theme.colors.secondary.lightBlue.t25,
                            color: theme.colors.primary.blue.t100,
                        } });
                }
                case "radioLabel": {
                    return __assign(__assign({ display: "inline-flex", alignItems: "flex-start", padding: theme.space[3] + " " + theme.space[4], minHeight: "24px", height: "100%" }, getTextStyle({ name: "body1", mode: "container" })), { color: theme.colors.black, backgroundColor: getColor(options.color), borderRadius: theme.radii[0] });
                }
                case "circleSvg": {
                    return {
                        flexShrink: 0,
                        width: "24px",
                        height: "24px",
                        marginRight: theme.space[3],
                    };
                }
                case "outerCircle": {
                    return {
                        fill: getColor(options.color === "grey.t05" || options.isChecked
                            ? "white"
                            : "secondary.lightBlue.t25"),
                    };
                }
                case "innerCircle": {
                    return {
                        fill: theme.colors.primary.blue.t100,
                    };
                }
                case "description": {
                    return {
                        marginTop: theme.space[1],
                    };
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var select = (function (theme, _a) {
    var getColor = _a.getColor;
    return {
        getCSS: function (_a) {
            var color = _a.color, fullWidth = _a.fullWidth, __internal__focus = _a.__internal__focus;
            var focusStyle = {
                outline: 0,
                borderRadius: theme.radii[0],
                boxShadow: theme.shadows.focus,
            };
            return __assign({ display: "inline-block", fontSize: theme.fontSizes[1], fontWeight: theme.fontWeights.light, lineHeight: theme.lineHeights[2], fontFamily: theme.fonts.body, color: theme.colors.black, width: fullWidth ? "100%" : undefined, height: "48px", paddingLeft: theme.space[4], paddingRight: theme.space[10], margin: 0, border: 0, borderRadius: 0, appearance: "none", backgroundColor: getColor(color), backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' role='img' aria-label='Triangle down'%3E%3Cpath d='M20.747 14.509l-4.181 4.25a.786.786 0 01-1.132 0l-4.179-4.247a.885.885 0 01-.231-.827c.07-.3.287-.536.569-.62.282-.084 8.607-.101 8.912.035a.86.86 0 01.495.802.874.874 0 01-.253.607z' fill='%23000'%3E%3C/path%3E%3C/svg%3E\")", backgroundRepeat: "no-repeat", backgroundPosition: "right " + theme.space[4] + " top 50%", alignSelf: "flex-start", 
                // See: https://stackoverflow.com/a/19451423/247243
                ":-moz-focusring": {
                    color: "transparent",
                    textShadow: "0 0 0 #000",
                }, ":focus": focusStyle }, (__internal__focus && focusStyle));
        },
    };
});

var stepper = (function (theme) {
    return {
        getCSS: function (options) {
            switch (options.targetElement) {
                case "container": {
                    return {
                        display: "flex",
                    };
                }
                case "item": {
                    return {
                        paddingTop: theme.space[4],
                        paddingBottom: theme.space[4],
                        width: 100 / options.stepsCount + "%",
                    };
                }
                case "labelContainer": {
                    return {
                        display: "flex",
                        height: "20px",
                    };
                }
                case "label": {
                    return {
                        position: "relative",
                        left: "50%",
                        transform: "translateX(-50%)",
                        whiteSpace: "nowrap",
                    };
                }
                case "itemContent": {
                    return {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "40px",
                        marginTop: theme.space[2],
                        position: "relative",
                    };
                }
                case "progressLeft": {
                    return {
                        position: "absolute",
                        left: 0,
                        width: "50%",
                        height: "8px",
                        top: "calc(50% - 4px)",
                        backgroundColor: options.isPrevious || options.isCurrent
                            ? theme.colors.primary.blue.t100
                            : theme.colors.white,
                    };
                }
                case "progressRight": {
                    return {
                        position: "absolute",
                        left: "50%",
                        width: "50%",
                        height: "8px",
                        top: "calc(50% - 4px)",
                        backgroundColor: options.isPrevious
                            ? theme.colors.primary.blue.t100
                            : theme.colors.white,
                    };
                }
                case "circle": {
                    return __assign(__assign(__assign({ display: "flex", alignItems: "center", justifyContent: "center", width: "40px", height: "40px", borderRadius: theme.radii[3], backgroundColor: theme.colors.white, color: theme.colors.black, boxSizing: "border-box", flexShrink: 0, zIndex: 1 }, (options.isMinor && {
                        width: "20px",
                        height: "20px",
                    })), (options.isCurrent && {
                        border: theme.borderWidths[1] + " solid " + theme.colors.primary.blue.t100,
                    })), (options.isPrevious && {
                        backgroundColor: theme.colors.primary.blue.t100,
                    }));
                }
                default: {
                    return {};
                }
            }
        },
    };
});

var text = (function (_theme, _a) {
    var getColor = _a.getColor;
    return {
        getCSS: function (_a) {
            var color = _a.color, align = _a.align, wrap = _a.wrap;
            return __assign({ margin: 0, color: getColor(color), textAlign: align }, (!wrap &&
                {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }));
        },
    };
});

var textarea = (function (theme, _a) {
    var getColor = _a.getColor;
    return {
        getCSS: function (_a) {
            var color = _a.color, __internal__focus = _a.__internal__focus;
            var focusStyle = {
                outline: 0,
                borderRadius: theme.radii[0],
                boxShadow: theme.shadows.focus,
            };
            return __assign({ boxSizing: "border-box", width: "100%", minHeight: "60px", resize: "vertical", border: 0, margin: 0, fontSize: theme.fontSizes[1], fontWeight: theme.fontWeights.light, lineHeight: theme.lineHeights[2], fontFamily: theme.fonts.body, color: theme.colors.black, backgroundColor: getColor(color), padding: theme.space[2] + " " + theme.space[4], ":focus": focusStyle }, (__internal__focus && focusStyle));
        },
    };
});

var textStyles = (function (theme) {
    return ({
        hero: {
            fontFamily: theme.fonts.heading,
            fontWeight: theme.fontWeights.semiBold,
            fontSize: theme.fontSizes[8],
            lineHeight: theme.lineHeights[7],
            letterSpacing: theme.letterSpacings.hero,
        },
        // This is needed in order to override browser's default
        "hero.bold": {
            fontWeight: theme.fontWeights.semiBold,
        },
        heading1: {
            fontFamily: theme.fonts.heading,
            fontWeight: theme.fontWeights.semiBold,
            fontSize: theme.fontSizes[7],
            lineHeight: theme.lineHeights[6],
            letterSpacing: theme.letterSpacings.heading1,
        },
        "heading1.bold": {
            fontWeight: theme.fontWeights.semiBold,
        },
        heading2: {
            fontFamily: theme.fonts.heading,
            fontWeight: theme.fontWeights.semiBold,
            fontSize: theme.fontSizes[6],
            lineHeight: theme.lineHeights[5],
            letterSpacing: theme.letterSpacings.heading2,
        },
        "heading2.bold": {
            fontWeight: theme.fontWeights.semiBold,
        },
        heading3: {
            fontFamily: theme.fonts.heading,
            fontWeight: theme.fontWeights.semiBold,
            fontSize: theme.fontSizes[5],
            lineHeight: theme.lineHeights[4],
            letterSpacing: theme.letterSpacings.heading3,
        },
        "heading3.bold": {
            fontWeight: theme.fontWeights.semiBold,
        },
        heading4: {
            fontFamily: theme.fonts.heading,
            fontWeight: theme.fontWeights.semiBold,
            fontSize: theme.fontSizes[4],
            lineHeight: theme.lineHeights[3],
            letterSpacing: theme.letterSpacings.heading4,
        },
        "heading4.bold": {
            fontWeight: theme.fontWeights.semiBold,
        },
        heading5: {
            fontFamily: theme.fonts.heading,
            fontWeight: theme.fontWeights.semiBold,
            fontSize: theme.fontSizes[3],
            lineHeight: theme.lineHeights[2],
            letterSpacing: theme.letterSpacings.heading5,
        },
        "heading5.bold": {
            fontWeight: theme.fontWeights.semiBold,
        },
        heading6: {
            fontFamily: theme.fonts.heading,
            fontWeight: theme.fontWeights.semiBold,
            fontSize: theme.fontSizes[1],
            lineHeight: theme.lineHeights[1],
            letterSpacing: theme.letterSpacings.heading6,
        },
        "heading6.bold": {
            fontWeight: theme.fontWeights.semiBold,
        },
        subtitle1: {
            fontFamily: theme.fonts.body,
            fontWeight: theme.fontWeights.light,
            fontSize: theme.fontSizes[4],
            lineHeight: theme.lineHeights[4],
            letterSpacing: theme.letterSpacings.body,
        },
        "subtitle1.bold": {
            fontWeight: theme.fontWeights.medium,
        },
        subtitle2: {
            fontFamily: theme.fonts.body,
            fontWeight: theme.fontWeights.light,
            fontSize: theme.fontSizes[2],
            lineHeight: theme.lineHeights[3],
            letterSpacing: theme.letterSpacings.body,
        },
        "subtitle2.bold": {
            fontWeight: theme.fontWeights.medium,
        },
        body1: {
            fontFamily: theme.fonts.body,
            fontWeight: theme.fontWeights.light,
            fontSize: theme.fontSizes[1],
            lineHeight: theme.lineHeights[2],
            letterSpacing: theme.letterSpacings.body,
        },
        "body1.bold": {
            fontWeight: theme.fontWeights.medium,
        },
        body2: {
            fontFamily: theme.fonts.body,
            fontWeight: theme.fontWeights.light,
            fontSize: theme.fontSizes[0],
            lineHeight: theme.lineHeights[0],
            letterSpacing: theme.letterSpacings.body,
        },
        "body2.bold": {
            fontWeight: theme.fontWeights.medium,
        },
        legal: {
            fontFamily: theme.fonts.body,
            fontWeight: theme.fontWeights.light,
            fontSize: theme.fontSizes[0],
            lineHeight: theme.lineHeights[2],
            letterSpacing: theme.letterSpacings.body,
        },
        "legal.bold": {
            fontWeight: theme.fontWeights.medium,
        },
        overline: {
            fontFamily: theme.fonts.body,
            fontWeight: theme.fontWeights.bold,
            fontSize: theme.fontSizes[0],
            lineHeight: theme.lineHeights[0],
            letterSpacing: theme.letterSpacings.overline,
            textTransform: "uppercase",
        },
        "overline.bold": {
            fontWeight: theme.fontWeights.bold,
        },
    });
});

// This alphabet uses `A-Za-z0-9_-` symbols. The genetic algorithm helped
// optimize the gzip compression for this alphabet.
let urlAlphabet =
  'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW';

// It is best to make fewer, larger requests to the crypto module to
// avoid system call overhead. So, random numbers are generated in a
// pool. The pool is a Buffer that is larger than the initial random
// request size by this multiplier. The pool is enlarged if subsequent
// requests exceed the maximum buffer size.
const POOL_SIZE_MULTIPLIER = 32;
let pool, poolOffset;

let random = bytes => {
  if (!pool || pool.length < bytes) {
    pool = Buffer.allocUnsafe(bytes * POOL_SIZE_MULTIPLIER);
    crypto.randomFillSync(pool);
    poolOffset = 0;
  } else if (poolOffset + bytes > pool.length) {
    crypto.randomFillSync(pool);
    poolOffset = 0;
  }

  let res = pool.subarray(poolOffset, poolOffset + bytes);
  poolOffset += bytes;
  return res
};

let nanoid = (size = 21) => {
  let bytes = random(size);
  let id = '';
  // A compact alternative for `for (let i = 0; i < size; i++)`.
  while (size--) {
    // It is incorrect to use bytes exceeding the alphabet size.
    // The following mask reduces the random byte in the 0-255 value
    // range to the 0-63 value range. Therefore, adding hacks, such
    // as empty string fallback or magic numbers, is unneccessary because
    // the bitmask trims bytes down to the alphabet size.
    id += urlAlphabet[bytes[size] & 63];
  }
  return id
};

function isObjectEmpty(obj) {
    for (var _key in obj) {
        return false;
    }
    return true;
}
/*
  ESLint complains about:
    obj.hasOwnProperty(key)
  
  See: https://eslint.org/docs/rules/no-prototype-builtins
*/
function hasOwnProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
var getUniqueId = nanoid;

function getPath(obj, path) {
    var result = obj;
    var keys = path.split(".");
    for (var i = 0; i < keys.length; i++) {
        result = result[keys[i]];
        if (typeof result === "undefined") {
            return;
        }
    }
    return result;
}
function setPath(obj, path, value) {
    var keys = path.split(".");
    var result = value;
    for (var i = keys.length - 1; i > 0; i--) {
        var subPath = keys.slice(0, i).join(".");
        var _value = getPath(obj, subPath);
        var valueType = _typeof(_value);
        if (valueType !== "object" && valueType !== "undefined") {
            throw new Error("Values along the path \"".concat(path, "\" must be objects. Found \"").concat(valueType, "\" at path \"").concat(subPath, "\"."));
        }
        result = _objectSpread2(_objectSpread2({}, _value), {}, _defineProperty({}, keys[i], result));
    }
    return _objectSpread2(_objectSpread2({}, obj), {}, _defineProperty({}, keys[0], result));
}
function deletePath(obj, path) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref$deleteEmptyObjec = _ref.deleteEmptyObjects, deleteEmptyObjects = _ref$deleteEmptyObjec === void 0 ? false : _ref$deleteEmptyObjec;
    var keys = path.split(".");
    var pathsArr = [obj];
    var value = obj;
    for (var i = 0; i < keys.length - 1; i++) {
        var key = keys[i];
        value = value[key];
        if (_typeof(value) !== "object") {
            return obj;
        }
        pathsArr.push(value);
    }
    var result = _objectSpread2({}, pathsArr[pathsArr.length - 1]);
    delete result[keys[keys.length - 1]];
    for (var _i = pathsArr.length - 2; _i >= 0; _i--) {
        var _key = keys[_i];
        var shouldDeleteKey = deleteEmptyObjects === true || Array.isArray(deleteEmptyObjects === null || deleteEmptyObjects === void 0 ? void 0 : deleteEmptyObjects.except) && deleteEmptyObjects.except.includes(_key) === false;
        if (shouldDeleteKey && isObjectEmpty(result)) {
            result = _objectSpread2({}, pathsArr[_i]);
            delete result[_key];
        }
        else {
            result = _objectSpread2(_objectSpread2({}, pathsArr[_i]), {}, _defineProperty({}, _key, result));
        }
    }
    return result;
}

var zIndices = {
    aboveNormalFlow: 1,
    stickyItem: 100,
    dropdown: 700,
};
var colors = {
    black: "#000000",
    grey: {
        t75: "#414141",
        t65: "#595959",
        t30: "#b2b2b2",
        t16: "#d6d6d6",
        t10: "#e5e5e5",
        t07: "#ececec",
        t05: "#f2f2f2",
        t03: "#f8f8f8",
    },
    white: "#ffffff",
    primary: {
        blue: {
            t100: "#0046aa",
            t80: "#336bbb",
            t60: "#7fa2d4",
            t30: "#b2c7e5",
            t10: "#e5ecf6",
        },
    },
    secondary: {
        lightBlue: {
            t100: "#63b8ff",
            t80: "#82c6ff",
            t60: "#b1dbff",
            t25: "#d8edff",
            t15: "#eff7ff",
        },
        pink: {
            t100: "#ff94ca",
            t80: "#ffa9d5",
            t60: "#ffc9e4",
            t30: "#ffdeef",
            t15: "#fff4f9",
        },
        purple: {
            t100: "#aba7f6",
            t80: "#bcb9f8",
            t60: "#d5d3fa",
            t30: "#e5e4fc",
            t15: "#f6f6fe",
        },
        turquoise: {
            t100: "#0fdbf3",
            t80: "#3fe2f5",
            t60: "#87edf9",
            t30: "#b7f4fb",
            t10: "#e7fbfd",
        },
    },
    highlight: {
        blue: {
            t100: "#006aff",
            t80: "#337ef8",
            t50: "#4693fa",
            t30: "#52a0fb",
            t15: "#54acff",
        },
        pink: {
            t100: "#c31b6c",
            t80: "#cf337f",
            t50: "#e1589b",
            t30: "#ed6fae",
            t15: "#f682bc",
        },
        purple: {
            t100: "#7a65d4",
            t80: "#8472db",
            t50: "#9386e5",
            t30: "#9c93ec",
            t15: "#a49df1",
        },
    },
    conditional: {
        positive: {
            graphics: "#1a8450",
            text: "#1b633c",
        },
        attention: {
            graphics: "#f9b845",
            text: "#414141",
        },
        negative: {
            graphics: "#cf000f",
            text: "#b3000c",
        },
    },
};
var fonts = {
    heading: "'Montserrat', sans-serif",
    body: "'Roboto', sans-serif",
};
var fontWeights = {
    light: 300,
    medium: 500,
    semiBold: 600,
    bold: 700,
};
var letterSpacings = {
    hero: "-2.28px",
    heading1: "-1.05px",
    heading2: "-0.88px",
    heading3: "-0.7px",
    heading4: "-0.52px",
    heading5: "-0.44px",
    heading6: "-0.35px",
    body: "0px",
    overline: "2.6px",
};
var fontSizes = [
    "14px",
    "16px",
    "18px",
    "20px",
    "24px",
    "32px",
    "40px",
    "48px",
    "104px", // 8
];
var lineHeights = [
    "20px",
    "22px",
    "24px",
    "28px",
    "36px",
    "48px",
    "56px",
    "120px", // 7
];
var space = [
    "0px",
    "4px",
    "8px",
    "12px",
    "16px",
    "20px",
    "24px",
    "28px",
    "32px",
    "36px",
    "40px",
    "48px",
    "56px",
    "64px",
    "72px", // 14
];
var transitions = {
    button: "background-color 150ms ease, color 150ms ease",
    link: "background-color 200ms ease-out, border-bottom-color 200ms ease-out",
    icon: "fill 200ms ease-out",
};
var borderWidths = ["1px", "2px", "4px"];
var radii = ["1px", "4px", "12px", "50%"];
var shadows = {
    header: "inset 0 " + borderWidths[1] + " 0 0 rgba(0, 0, 0, .05)",
    focus: "0 0 0px " + radii[1] + " " + colors.secondary.lightBlue.t80,
};
var focusStyle = {
    boxShadow: shadows.focus,
    // Make sure that the focus style sits above the surrounding elements with normal page flow
    position: "relative",
    zIndex: zIndices.aboveNormalFlow,
};
var focusStyles = {
    focusVisible: {
        ":focus": {
            '[data-basis-keyboard-mode="true"] &': focusStyle,
        },
    },
    focusVisibleAdjacentLabel: {
        ":focus + label": {
            '[data-basis-keyboard-mode="true"] &': focusStyle,
        },
    },
    __keyboardFocus: focusStyle,
    __keyboardFocusAdjacentLabel: focusStyle,
};
var getColor$1 = function (color) {
    return getPath(theme.colors, color);
};
var getTextStyle = function (_a) {
    var name = _a.name, mode = _a.mode;
    switch (mode) {
        case "self": {
            return theme.textStyles[name];
        }
        case "self-bold": {
            return __assign(__assign({}, theme.textStyles[name]), theme.textStyles[name + ".bold"]);
        }
        case "container": {
            var boldCSS = theme.textStyles[name + ".bold"];
            return __assign(__assign({}, theme.textStyles[name]), (boldCSS && {
                "& strong": boldCSS,
                "& b": boldCSS,
            }));
        }
        default: {
            return null;
        }
    }
};
var baseTheme = {
    // margin, padding
    space: space,
    fontSizes: fontSizes,
    lineHeights: lineHeights,
    letterSpacings: letterSpacings,
    fonts: fonts,
    fontWeights: fontWeights,
    colors: colors,
    borderWidths: borderWidths,
    radii: radii,
    breakpoints: {
        xs: "375px",
        sm: "576px",
        md: "768px",
        lg: "992px",
        xl: "1200px",
    },
    breakpointMaxWidths: {
        sm: "540px",
        md: "720px",
        lg: "960px",
        xl: "1140px",
    },
    transitions: transitions,
    zIndices: zIndices,
    textStyles: textStyles({
        fonts: fonts,
        fontSizes: fontSizes,
        fontWeights: fontWeights,
        lineHeights: lineHeights,
        letterSpacings: letterSpacings,
    }),
    shadows: shadows,
    focusStyles: focusStyles,
};
var helpers = {
    getColor: getColor$1,
    getTextStyle: getTextStyle,
};
var theme = __assign(__assign({}, baseTheme), { accordion: accordion(baseTheme, helpers), autoComplete: autoComplete(baseTheme), button: button(baseTheme), textarea: textarea(baseTheme, helpers), text: text({}, helpers), stepper: stepper(baseTheme), select: select(baseTheme, helpers), radioGroup: radioGroup(baseTheme, helpers), list: list(baseTheme, helpers), link: link(baseTheme), input: input(baseTheme, helpers), field: field(baseTheme), dropdown: dropdown(baseTheme, helpers), checkbox: checkbox(baseTheme, helpers) });

const copyProperty = (to, from, property, ignoreNonConfigurable) => {
	// `Function#length` should reflect the parameters of `to` not `from` since we keep its body.
	// `Function#prototype` is non-writable and non-configurable so can never be modified.
	if (property === 'length' || property === 'prototype') {
		return;
	}

	// `Function#arguments` and `Function#caller` should not be copied. They were reported to be present in `Reflect.ownKeys` for some devices in React Native (#41), so we explicitly ignore them here.
	if (property === 'arguments' || property === 'caller') {
		return;
	}

	const toDescriptor = Object.getOwnPropertyDescriptor(to, property);
	const fromDescriptor = Object.getOwnPropertyDescriptor(from, property);

	if (!canCopyProperty(toDescriptor, fromDescriptor) && ignoreNonConfigurable) {
		return;
	}

	Object.defineProperty(to, property, fromDescriptor);
};

// `Object.defineProperty()` throws if the property exists, is not configurable and either:
//  - one its descriptors is changed
//  - it is non-writable and its value is changed
const canCopyProperty = function (toDescriptor, fromDescriptor) {
	return toDescriptor === undefined || toDescriptor.configurable || (
		toDescriptor.writable === fromDescriptor.writable &&
		toDescriptor.enumerable === fromDescriptor.enumerable &&
		toDescriptor.configurable === fromDescriptor.configurable &&
		(toDescriptor.writable || toDescriptor.value === fromDescriptor.value)
	);
};

const changePrototype = (to, from) => {
	const fromPrototype = Object.getPrototypeOf(from);
	if (fromPrototype === Object.getPrototypeOf(to)) {
		return;
	}

	Object.setPrototypeOf(to, fromPrototype);
};

const wrappedToString = (withName, fromBody) => `/* Wrapped ${withName}*/\n${fromBody}`;

const toStringDescriptor = Object.getOwnPropertyDescriptor(Function.prototype, 'toString');
const toStringName = Object.getOwnPropertyDescriptor(Function.prototype.toString, 'name');

// We call `from.toString()` early (not lazily) to ensure `from` can be garbage collected.
// We use `bind()` instead of a closure for the same reason.
// Calling `from.toString()` early also allows caching it in case `to.toString()` is called several times.
const changeToString = (to, from, name) => {
	const withName = name === '' ? '' : `with ${name.trim()}() `;
	const newToString = wrappedToString.bind(null, withName, from.toString());
	// Ensure `to.toString.toString` is non-enumerable and has the same `same`
	Object.defineProperty(newToString, 'name', toStringName);
	Object.defineProperty(to, 'toString', {...toStringDescriptor, value: newToString});
};

const mimicFn = (to, from, {ignoreNonConfigurable = false} = {}) => {
	const {name} = to;

	for (const property of Reflect.ownKeys(from)) {
		copyProperty(to, from, property, ignoreNonConfigurable);
	}

	changePrototype(to, from);
	changeToString(to, from, name);

	return to;
};

var mimicFn_1 = mimicFn;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var pDefer = () => {
	const ret = {};

	ret.promise = new Promise((resolve, reject) => {
		ret.resolve = resolve;
		ret.reject = reject;
	});

	return ret;
};

var dist$1 = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const p_defer_1 = __importDefault(pDefer);
function mapAgeCleaner(map, property = 'maxAge') {
    let processingKey;
    let processingTimer;
    let processingDeferred;
    const cleanup = () => __awaiter(this, void 0, void 0, function* () {
        if (processingKey !== undefined) {
            // If we are already processing an item, we can safely exit
            return;
        }
        const setupTimer = (item) => __awaiter(this, void 0, void 0, function* () {
            processingDeferred = p_defer_1.default();
            const delay = item[1][property] - Date.now();
            if (delay <= 0) {
                // Remove the item immediately if the delay is equal to or below 0
                map.delete(item[0]);
                processingDeferred.resolve();
                return;
            }
            // Keep track of the current processed key
            processingKey = item[0];
            processingTimer = setTimeout(() => {
                // Remove the item when the timeout fires
                map.delete(item[0]);
                if (processingDeferred) {
                    processingDeferred.resolve();
                }
            }, delay);
            // tslint:disable-next-line:strict-type-predicates
            if (typeof processingTimer.unref === 'function') {
                // Don't hold up the process from exiting
                processingTimer.unref();
            }
            return processingDeferred.promise;
        });
        try {
            for (const entry of map) {
                yield setupTimer(entry);
            }
        }
        catch (_a) {
            // Do nothing if an error occurs, this means the timer was cleaned up and we should stop processing
        }
        processingKey = undefined;
    });
    const reset = () => {
        processingKey = undefined;
        if (processingTimer !== undefined) {
            clearTimeout(processingTimer);
            processingTimer = undefined;
        }
        if (processingDeferred !== undefined) { // tslint:disable-line:early-exit
            processingDeferred.reject(undefined);
            processingDeferred = undefined;
        }
    };
    const originalSet = map.set.bind(map);
    map.set = (key, value) => {
        if (map.has(key)) {
            // If the key already exist, remove it so we can add it back at the end of the map.
            map.delete(key);
        }
        // Call the original `map.set`
        const result = originalSet(key, value);
        // If we are already processing a key and the key added is the current processed key, stop processing it
        if (processingKey && processingKey === key) {
            reset();
        }
        // Always run the cleanup method in case it wasn't started yet
        cleanup(); // tslint:disable-line:no-floating-promises
        return result;
    };
    cleanup(); // tslint:disable-line:no-floating-promises
    return map;
}
exports.default = mapAgeCleaner;
// Add support for CJS
module.exports = mapAgeCleaner;
module.exports.default = mapAgeCleaner;
});

const cacheStore = new WeakMap();

const mem = (fn, {
	cacheKey,
	cache = new Map(),
	maxAge
} = {}) => {
	if (typeof maxAge === 'number') {
		dist$1(cache);
	}

	const memoized = function (...arguments_) {
		const key = cacheKey ? cacheKey(arguments_) : arguments_[0];

		const cacheItem = cache.get(key);
		if (cacheItem) {
			return cacheItem.data;
		}

		const result = fn.apply(this, arguments_);

		cache.set(key, {
			data: result,
			maxAge: maxAge ? Date.now() + maxAge : Infinity
		});

		return result;
	};

	try {
		// The below call will throw in some host environments
		// See https://github.com/sindresorhus/mimic-fn/issues/10
		mimicFn_1(memoized, fn);
	} catch (_) {}

	cacheStore.set(memoized, cache);

	return memoized;
};

var mem_1 = mem;

var clear = fn => {
	if (!cacheStore.has(fn)) {
		throw new Error('Can\'t clear a function that was not memoized!');
	}

	const cache = cacheStore.get(fn);
	if (typeof cache.clear === 'function') {
		cache.clear();
	}
};
mem_1.clear = clear;

var TEXT_STYLES$1 = [
    "hero",
    "heading1",
    "heading2",
    "heading3",
    "heading4",
    "heading5",
    "heading6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "legal",
    "overline",
];
var TEXT_ALIGNS = ["inherit", "left", "center", "right"];
var FLEX_DIRECTIONS = [
    "row",
    "row-reverse",
    "column",
    "column-reverse",
];
var FLEX_PLACE_ITEMS = [
    "top left",
    "top center",
    "top right",
    "center left",
    "center center",
    "center right",
    "bottom left",
    "bottom center",
    "bottom right",
    "left top",
    "center top",
    "right top",
    "left center",
    "right center",
    "left bottom",
    "center bottom",
    "right bottom",
    "center",
];

function getGapValues(gap, theme) {
    if (typeof gap === "number") {
        gap = String(gap);
    }
    if (typeof gap !== "string") {
        return null;
    }
    var parts = gap.split(/\s+/).filter(Boolean);
    if (parts.length < 1 || parts.length > 2) {
        return null;
    }
    var rowGapPx = theme.space[Number(parts[0])] || "0px";
    var columnGapPx = parts.length === 2 ? theme.space[Number(parts[1])] || "0px" : rowGapPx;
    return {
        rowGap: rowGapPx,
        columnGap: columnGapPx,
    };
}
function getTextAlignValue(textAlign) {
    if (TEXT_ALIGNS.includes(textAlign)) {
        return textAlign;
    }
    return null;
}
var OVERFLOW_VALUES = ["visible", "hidden", "scroll", "auto"];
function getOverflowValue(overflow) {
    var parts = typeof overflow === "string" ? overflow.trim().split(/\s+/) : null;
    if (parts !== null && parts.every(function (part) { return OVERFLOW_VALUES.includes(part); })) {
        return parts.join(" ");
    }
    return null;
}
var SPAN_LINES_REGEX = /^(\d+)(-(\d+))?$/;
function getGridRowColumn(span, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.allAllowed, allAllowed = _c === void 0 ? false : _c;
    if (allAllowed && span === "all") {
        return "1 / -1";
    }
    if (typeof span === "number") {
        return span + 1 + " / " + (span + 2);
    }
    if (typeof span !== "string") {
        return null;
    }
    var match = span.match(SPAN_LINES_REGEX);
    if (match) {
        var start = parseInt(match[1], 10);
        var end = match[3] === undefined ? start : parseInt(match[3], 10);
        return start + 1 + " / " + (end + 2);
    }
    return span;
}
function getGapPx(gap, theme) {
    // Exception to our space scale
    if (gap === "30px") {
        return gap;
    }
    return theme.space[Number(gap)] || "0px";
}
function getGridTemplateColumns(cols) {
    var colsInt = Number(cols);
    if (colsInt) {
        return "repeat(" + colsInt + ", 1fr)";
    }
    if (typeof cols === "string") {
        return cols;
    }
    return null;
}
var getGridTemplateRows = getGridTemplateColumns;
var DEFAULT_BREAKPOINT = "default";
function compareBreakpoints(bp1, bp2, theme) {
    var breakpoints = __spreadArray([DEFAULT_BREAKPOINT], Object.keys(theme.breakpoints));
    var index1 = breakpoints.indexOf(bp1);
    var index2 = breakpoints.indexOf(bp2);
    if (index1 === -1 || index2 === -1) {
        return null;
    }
    if (index1 === index2) {
        return 0;
    }
    return index1 < index2 ? -1 : 1;
}
function getMinMediaQueries(breakpoints) {
    if (!breakpoints) {
        throw new Error("Theme expects breakpoints but none were recieved");
    }
    var result = {};
    var bp;
    for (bp in breakpoints) {
        result[bp] = "@media (min-width: " + breakpoints[bp] + ")";
    }
    return result;
}
function getExclusiveMediaQueries(breakpoints) {
    var _a;
    if (!breakpoints) {
        throw new Error("Theme expects breakpoints but none were recieved");
    }
    var entries = Object.entries(breakpoints).map(function (_a) {
        var bp = _a[0], px = _a[1];
        return ({
            bp: bp,
            px: parseInt(px, 10),
        });
    });
    if (!entries[0]) {
        throw new Error("Theme expects breakpoints to be an object with values");
    }
    var result = (_a = {},
        _a[DEFAULT_BREAKPOINT] = "(max-width: " + (entries[0].px - 1) + "px)",
        _a);
    var i, len;
    for (i = 0, len = entries.length - 1; i < len; i++) {
        result[entries[i].bp] = "(min-width: " + entries[i].px + "px) and (max-width: " + (entries[i + 1].px - 1) + "px)";
    }
    result[entries[i].bp] = "(min-width: " + entries[i].px + "px)";
    return result;
}
function sortMediaQueries(css) {
    var result = {};
    var minWidths = [];
    for (var key in css) {
        var match = key.match(/^@media \(min-width: (\d+)px\)$/);
        if (match) {
            var minWidth = parseInt(match[1], 10);
            minWidths.push(minWidth);
        }
        else {
            result[key] = css[key];
        }
    }
    minWidths
        .sort(function (a, b) { return a - b; })
        .forEach(function (minWidth) {
        var mediaQuery = "@media (min-width: " + minWidth + "px)";
        result[mediaQuery] = css[mediaQuery];
    });
    return result;
}
function mergeResponsiveCSS(css1, css2) {
    var result = {};
    for (var key in css1) {
        var value = css1[key];
        if (typeof value === "object") {
            result[key] = __assign({}, value);
        }
        else {
            result[key] = css1[key];
        }
    }
    for (var key in css2) {
        var value = css2[key];
        if (typeof value === "object") {
            if (hasOwnProperty(result, key)) {
                // merge with css1
                result[key] = __assign(__assign({}, result[key]), value);
            }
            else {
                result[key] = css2[key];
            }
        }
        else {
            result[key] = css2[key]; // override css1
        }
    }
    return sortMediaQueries(result);
}
function responsiveMargin(propsAtBreakpoint, theme) {
    var margin = theme.getSpaceValue(propsAtBreakpoint.margin);
    return margin === null ? {} : { margin: margin };
}
function responsivePadding(propsAtBreakpoint, theme) {
    var padding = theme.getSpaceValue(propsAtBreakpoint.padding);
    return padding === null ? {} : { padding: padding };
}
var NUMBERS_ONLY_REGEX = /^\d+$/;
function addPxIfNeeded(str) {
    if (NUMBERS_ONLY_REGEX.test(str)) {
        return str + "px";
    }
    return str;
}
var responsiveSize = function (prop) { return function (propsAtBreakpoint) {
    var _a;
    var value = typeof propsAtBreakpoint[prop] === "string" &&
        propsAtBreakpoint[prop].trim() !== ""
        ? addPxIfNeeded(propsAtBreakpoint[prop])
        : null;
    return value === null ? {} : (_a = {}, _a[prop] = value, _a);
}; };
function responsiveHasBreakpointWidth(_a, theme, bp) {
    var hasBreakpointWidth = _a.hasBreakpointWidth, margin = _a.margin;
    if (hasBreakpointWidth !== true) {
        if (margin) {
            return {
                maxWidth: "initial",
            };
        }
        return {
            maxWidth: "initial",
            marginLeft: "initial",
            marginRight: "initial",
        };
    }
    if (bp === DEFAULT_BREAKPOINT || !theme.breakpointMaxWidths[bp]) {
        return {
            marginLeft: "15px",
            marginRight: "15px",
        };
    }
    return {
        maxWidth: theme.breakpointMaxWidths[bp],
        marginLeft: "auto",
        marginRight: "auto",
    };
}
function responsiveTextStyle(propsAtBreakpoint, theme) {
    var css = theme.getTextStyleCSS(propsAtBreakpoint.textStyle);
    return css === null ? {} : css;
}
function responsiveTextAlign(propsAtBreakpoint) {
    var textAlign = getTextAlignValue(propsAtBreakpoint.textAlign);
    return textAlign === null ? {} : { textAlign: textAlign };
}
function responsiveOverflow(propsAtBreakpoint) {
    var overflow = getOverflowValue(propsAtBreakpoint.overflow);
    return overflow === null ? {} : { overflow: overflow };
}
function responsiveFlexDirection(_a) {
    var direction = _a.direction;
    if (!FLEX_DIRECTIONS.includes(direction)) {
        return {};
    }
    return {
        flexDirection: direction,
    };
}
function responsiveFlexPlaceItems(_a) {
    var direction = _a.direction, placeItems = _a.placeItems;
    if (!FLEX_PLACE_ITEMS.includes(placeItems)) {
        return {};
    }
    var parts = placeItems.trim().split(/\s+/);
    if (parts.length === 1) {
        if (parts[0] === "center") {
            return {
                alignItems: "center",
                justifyContent: "center",
            };
        }
        return {};
    }
    if (parts.length !== 2) {
        return {};
    }
    if (parts[0] === "center" && parts[1] === "center") {
        return {
            alignItems: "center",
            justifyContent: "center",
        };
    }
    var hasLeft = parts[0] === "left" || parts[1] === "left";
    var hasRight = parts[0] === "right" || parts[1] === "right";
    var hasTop = parts[0] === "top" || parts[1] === "top";
    var hasBottom = parts[0] === "bottom" || parts[1] === "bottom";
    var horizontalAlignment = hasLeft
        ? "flex-start"
        : hasRight
            ? "flex-end"
            : "center";
    var verticalAlignment = hasTop
        ? "flex-start"
        : hasBottom
            ? "flex-end"
            : "center";
    return {
        alignItems: direction === "row" ? verticalAlignment : horizontalAlignment,
        justifyContent: direction === "row" ? horizontalAlignment : verticalAlignment,
    };
}

function getColor(colorName, theme) {
    if (typeof colorName !== "string" || colorName === "transparent") {
        return null;
    }
    return getPath(theme.colors, colorName);
}
function getTextStyleCSS(textStyle, theme) {
    if (typeof textStyle !== "string") {
        return null;
    }
    var boldCSS = theme.textStyles[textStyle + ".bold"];
    return __assign(__assign({}, theme.textStyles[textStyle]), (boldCSS &&
        {
            "& strong": boldCSS,
            "& b": boldCSS,
        }));
}
function getSpaceValue(space, theme) {
    if (typeof space === "number") {
        return theme.space[space] || "0px";
    }
    if (typeof space !== "string") {
        return null;
    }
    var parts = space.split(/\s+/).filter(Boolean);
    if (parts.length < 1 || parts.length > 4) {
        return null;
    }
    return parts
        .map(function (n) {
        if (n === "auto") {
            return n;
        }
        if (n[0] === "-") {
            var pxValue = theme.space[n.slice(1)];
            return pxValue ? "-" + pxValue : "0px";
        }
        return theme.space[n] || "0px";
    })
        .join(" ");
}
function memoizeGetCSS(theme) {
    var result = {};
    for (var key in theme) {
        if (typeof theme[key].getCSS === "function") {
            var _a = theme[key], getCSS = _a.getCSS, rest = __rest(_a, ["getCSS"]);
            var memoizedGetCSS = mem_1(getCSS, { cacheKey: JSON.stringify });
            result[key] = __assign({ getCSS: memoizedGetCSS }, rest);
        }
        else {
            result[key] = theme[key];
        }
    }
    return result;
}
function enhanceTheme(theme) {
    theme = memoizeGetCSS(theme);
    return __assign(__assign({}, theme), { minMediaQueries: getMinMediaQueries(theme.breakpoints), exclusiveMediaQueries: getExclusiveMediaQueries(theme.breakpoints), getColor: function (color) { return getColor(color, theme); }, getTextStyleCSS: function (textStyle) {
            return getTextStyleCSS(textStyle, theme);
        }, getSpaceValue: function (space) {
            return getSpaceValue(space, theme);
        } });
}

var ThemeContext = React__default.createContext(enhanceTheme(theme));
function useTheme() {
    return useContext(ThemeContext);
}

function useWindow() {
    var windowFromContext = useContext(WindowContext);
    return windowFromContext !== null && windowFromContext !== void 0 ? windowFromContext : typeof window === "undefined" ? null : window;
}

var BreakpointContext = /*#__PURE__*/ React__default.createContext();
function useBreakpoint() {
    var breakpoint = useContext(BreakpointContext);
    return breakpoint;
}

function BreakpointProvider(props) {
    var children = props.children;
    var theme = useTheme();
    var windowObj = useWindow();
    var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), mediaQueryListMap = _useState2[0], setMediaQueryListMap = _useState2[1];
    var _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), breakpoint = _useState4[0], setBreakpoint = _useState4[1];
    useLayoutEffect(function () {
        if (!windowObj.matchMedia) {
            return;
        }
        var mediaQueryListMap = {};
        for (var bp in theme.exclusiveMediaQueries) {
            mediaQueryListMap[bp] = windowObj.matchMedia(theme.exclusiveMediaQueries[bp]);
            if (mediaQueryListMap[bp].matches) {
                setBreakpoint(bp);
            }
        }
        setMediaQueryListMap(mediaQueryListMap);
    }, [windowObj, theme.exclusiveMediaQueries]);
    useEffect(function () {
        var mounted = true;
        var removeListeners = [];
        var _loop = function _loop(bp) {
            var mediaQueryList = mediaQueryListMap[bp]; // eslint-disable-next-line no-loop-func
            var listener = function listener(event) {
                if (event.matches && mounted) {
                    setBreakpoint(bp);
                }
            };
            mediaQueryList.addListener(listener);
            removeListeners.push(function () {
                mediaQueryList.removeListener(listener);
            });
        };
        for (var bp in mediaQueryListMap) {
            _loop(bp);
        }
        return function () {
            mounted = false;
            removeListeners.forEach(function (fn) {
                fn();
            });
        };
    }, [mediaQueryListMap]);
    return jsx(BreakpointContext.Provider, {
        value: breakpoint
    }, children);
}
BreakpointProvider.propTypes = {
    children: PropTypes.node.isRequired
};

var LinkContext = /*#__PURE__*/ React__default.createContext(); // See: https://www.gatsbyjs.org/docs/gatsby-link/#reminder-use-link-only-for-internal-links
function defaultIsLinkInternal(href) {
    return /^\/(?!\/)/.test(href);
}
function LinkProvider(_ref) {
    var InternalLink = _ref.InternalLink, _ref$isLinkInternal = _ref.isLinkInternal, isLinkInternal = _ref$isLinkInternal === void 0 ? defaultIsLinkInternal : _ref$isLinkInternal, children = _ref.children;
    return jsx(LinkContext.Provider, {
        value: {
            InternalLink: InternalLink,
            isLinkInternal: isLinkInternal
        }
    }, children);
}
LinkProvider.propTypes = {
    InternalLink: PropTypes.elementType,
    isLinkInternal: PropTypes.func,
    children: PropTypes.node.isRequired
};

function FocusVisiblePolyfill() {
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isKeyboardMode = _useState2[0], setIsKeyboardMode = _useState2[1];
    var onKeyDown = function onKeyDown() {
        return setIsKeyboardMode(true);
    };
    var onMouseDown = function onMouseDown() {
        return setIsKeyboardMode(false);
    };
    var window = useWindow();
    useEffect(function () {
        if (window) {
            window.addEventListener("keydown", onKeyDown);
            window.addEventListener("mousedown", onMouseDown);
        }
        return function () {
            if (window) {
                window.removeEventListener("keydown", onKeyDown);
                window.removeEventListener("mousedown", onMouseDown);
            }
        };
    }, [window]);
    useEffect(function () {
        if (window) {
            window.document.body.dataset.basisKeyboardMode = String(isKeyboardMode);
        }
    }, [window, isKeyboardMode]);
    return null;
}

function BasisProvider(_ref) {
    var theme = _ref.theme, _ref$isRoot = _ref.isRoot, isRoot = _ref$isRoot === void 0 ? false : _ref$isRoot, window = _ref.window, InternalLink = _ref.InternalLink, isLinkInternal = _ref.isLinkInternal, children = _ref.children;
    var enhancedTheme = useMemo(function () {
        return enhanceTheme(theme);
    }, [theme]);
    var content = isRoot ? jsx("div", {
        "data-basis-modal-app": true
    }, children) : children;
    return jsx(ThemeContext.Provider, {
        value: enhancedTheme
    }, jsx(WindowProvider, {
        window: window
    }, jsx(FocusVisiblePolyfill, null), jsx(BreakpointProvider, null, jsx(LinkProvider, {
        InternalLink: InternalLink,
        isLinkInternal: isLinkInternal
    }, content))));
}
BasisProvider.propTypes = {
    theme: PropTypes.object.isRequired,
    isRoot: PropTypes.bool,
    window: PropTypes.object,
    InternalLink: PropTypes.elementType,
    isLinkInternal: PropTypes.func,
    children: PropTypes.node.isRequired
};

function getInputColor(backgroundColor) {
    return [undefined, "transparent", "white"].includes(backgroundColor)
        ? "grey.t05"
        : "white";
}
function mapResponsiveValues(map, mapFn, theme) {
    var _a, _b;
    if (map) {
        var result_1 = (_a = {},
            _a[DEFAULT_BREAKPOINT] = mapFn(map[DEFAULT_BREAKPOINT]),
            _a);
        var bp = void 0;
        for (bp in theme.breakpoints) {
            result_1[bp] = mapFn(map[bp]);
        }
        return result_1;
    }
    var defaultValue = mapFn();
    var result = (_b = {},
        _b[DEFAULT_BREAKPOINT] = defaultValue,
        _b);
    for (var bp in theme.breakpoints) {
        result[bp] = defaultValue;
    }
    return result;
}
function getBgMapFromValue(value, theme) {
    var _a;
    var result = (_a = {},
        _a[DEFAULT_BREAKPOINT] = value,
        _a);
    for (var bp in theme.breakpoints) {
        result[bp] = value;
    }
    return result;
}
var BackgroundContext = React__default.createContext(undefined);
function BackgroundProvider(_a) {
    var value = _a.value, children = _a.children;
    var theme = useTheme();
    var bgMap = typeof value === "object" ? value : getBgMapFromValue(value, theme);
    return (jsx$1(BackgroundContext.Provider, __assign({ value: bgMap }, { children: children }), void 0));
}
function useBackground() {
    var theme = useTheme();
    var bgMap = useContext(BackgroundContext);
    var inputColorMap = mapResponsiveValues(bgMap, getInputColor, theme);
    return {
        bgMap: bgMap,
        inputColorMap: inputColorMap,
    };
}

var AccordionContext = /*#__PURE__*/ React__default.createContext();
var AccordionProvider = AccordionContext.Provider;
function useAccordion() {
    var accordionInfo = useContext(AccordionContext);
    return accordionInfo;
}

var AccordionItemContext = /*#__PURE__*/ React__default.createContext();
var AccordionItemProvider = AccordionItemContext.Provider;
function useAccordionItem() {
    var accordionItemInfo = useContext(AccordionItemContext);
    var _ref = accordionItemInfo !== null && accordionItemInfo !== void 0 ? accordionItemInfo : {
        headerId: null,
        contentId: null,
        isOpen: false,
        toggleAccordionItem: function toggleAccordionItem() { }
    }, headerId = _ref.headerId, contentId = _ref.contentId, isOpen = _ref.isOpen, toggleAccordionItem = _ref.toggleAccordionItem;
    return {
        headerId: headerId,
        contentId: contentId,
        isOpen: isOpen,
        toggleAccordionItem: toggleAccordionItem
    };
}

function getPropName(name, breakpoint) {
    return "".concat(name, "-").concat(breakpoint);
}
function responsivePropType(propName, propType) {
    var result = _defineProperty({}, propName, propType);
    /*
      Note:
      Here, as opposed to useResponsiveProp, we use defaultTheme.breakpoints, not theme.breakpoints.
      Ideally, we want to use theme.breakpoints, but the theme is not accessible when
      responsivePropType is called.
    */
    for (var bp in theme.breakpoints) {
        var prop = getPropName(propName, bp);
        result[prop] = propType;
    }
    return result;
}
var responsiveMarginType = responsivePropType("margin", PropTypes.oneOfType([PropTypes.number, PropTypes.string]));
var responsivePaddingType = responsivePropType("padding", PropTypes.oneOfType([PropTypes.number, PropTypes.string]));
var SIZE_PX_REGEX = /^\s*(\d+)(px)?\s*$/;
var responsiveSizeType = function responsiveSizeType(prop) {
    return responsivePropType(prop, function (props, propName, componentName) {
        var _match$;
        if (!hasOwnProperty(props, propName)) {
            return;
        }
        if (typeof props[propName] !== "string") {
            return new Error("".concat(componentName, ": ").concat(propName, " is expected to be a string. Found: ").concat(_typeof(props[propName]), "."));
        }
        if (props[propName].trim() === "") {
            return new Error("".concat(componentName, ": ").concat(propName, " can't be empty."));
        }
        if (props[propName].trim()[0] === "-") {
            return new Error("".concat(componentName, ": ").concat(propName, " can't be negative."));
        }
        var match = props[propName].match(SIZE_PX_REGEX);
        if (match === null) {
            return;
        }
        var intValue = parseInt(match[1], 10);
        var px = (_match$ = match[2]) !== null && _match$ !== void 0 ? _match$ : "";
        if (intValue % 4 !== 0) {
            var n = Math.floor(intValue / 4);
            return new Error("".concat(componentName, ": ").concat(propName, "=\"").concat(props[propName], "\". Please use a multiple of 4").concat(px, " (e.g. \"").concat(n * 4).concat(px, "\" or \"").concat((n + 1) * 4).concat(px, "\")."));
        }
    });
};
var responsiveWidthType = responsiveSizeType("width");
var responsiveHeightType = responsiveSizeType("height");
var responsiveMaxWidthType = responsiveSizeType("maxWidth");
var responsiveMaxHeightType = responsiveSizeType("maxHeight");
function useResponsiveProp(props, propName) {
    var theme = useTheme();
    var breakpoint = useBreakpoint();
    var result = props[propName] || null;
    if (breakpoint === null || breakpoint === DEFAULT_BREAKPOINT) {
        return result;
    }
    var breakpoints = Object.keys(theme.breakpoints);
    for (var i = 0, len = breakpoints.length; i < len; i++) {
        var bp = breakpoints[i];
        var prop = getPropName(propName, bp);
        if (hasOwnProperty(props, prop)) {
            result = props[prop];
        }
        if (bp === breakpoint) {
            break;
        }
    }
    return result;
}

function klona(x) {
	if (typeof x !== 'object') return x;

	var k, tmp, str=Object.prototype.toString.call(x);

	if (str === '[object Object]') {
		if (x.constructor !== Object && typeof x.constructor === 'function') {
			tmp = new x.constructor();
			for (k in x) {
				if (tmp.hasOwnProperty(k) && tmp[k] !== x[k]) {
					tmp[k] = klona(x[k]);
				}
			}
		} else {
			tmp = {}; // null
			for (k in x) {
				if (k === '__proto__') {
					Object.defineProperty(tmp, k, {
						value: klona(x[k]),
						configurable: true,
						enumerable: true,
						writable: true,
					});
				} else {
					tmp[k] = klona(x[k]);
				}
			}
		}
		return tmp;
	}

	if (str === '[object Array]') {
		k = x.length;
		for (tmp=Array(k); k--;) {
			tmp[k] = klona(x[k]);
		}
		return tmp;
	}

	if (str === '[object Set]') {
		tmp = new Set;
		x.forEach(function (val) {
			tmp.add(klona(val));
		});
		return tmp;
	}

	if (str === '[object Map]') {
		tmp = new Map;
		x.forEach(function (val, key) {
			tmp.set(klona(key), klona(val));
		});
		return tmp;
	}

	if (str === '[object Date]') {
		return new Date(+x);
	}

	if (str === '[object RegExp]') {
		tmp = new RegExp(x.source, x.flags);
		tmp.lastIndex = x.lastIndex;
		return tmp;
	}

	if (str === '[object DataView]') {
		return new x.constructor( klona(x.buffer) );
	}

	if (str === '[object ArrayBuffer]') {
		return x.slice(0);
	}

	// ArrayBuffer.isView(x)
	// ~> `new` bcuz `Buffer.slice` => ref
	if (str.slice(-6) === 'Array]') {
		return new x.constructor(x);
	}

	return x;
}

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var utils = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(exports);
  }
})(commonjsGlobal, function (exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports.isDate = function isDate(d) {
    return d instanceof Date;
  };
  exports.isEmpty = function isEmpty(o) {
    return Object.keys(o).length === 0;
  };
  var isObject = exports.isObject = function isObject(o) {
    return o != null && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
  };
  exports.properObject = function properObject(o) {
    return isObject(o) && !o.hasOwnProperty ? _extends({}, o) : o;
  };
});
});

var diff = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(module, exports, utils);
  }
})(commonjsGlobal, function (module, exports, _utils) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var diff = function diff(lhs, rhs) {
    if (lhs === rhs) return {}; // equal return no diff

    if (!(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return rhs; // return updated rhs

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    var deletedValues = Object.keys(l).reduce(function (acc, key) {
      return r.hasOwnProperty(key) ? acc : _extends({}, acc, _defineProperty({}, key, undefined));
    }, {});

    if ((0, _utils.isDate)(l) || (0, _utils.isDate)(r)) {
      if (l.valueOf() == r.valueOf()) return {};
      return r;
    }

    return Object.keys(r).reduce(function (acc, key) {
      if (!l.hasOwnProperty(key)) return _extends({}, acc, _defineProperty({}, key, r[key])); // return added r key

      var difference = diff(l[key], r[key]);

      if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference) && !(0, _utils.isDate)(difference)) return acc; // return no diff

      return _extends({}, acc, _defineProperty({}, key, difference)); // return updated key
    }, deletedValues);
  };

  exports.default = diff;
  module.exports = exports['default'];
});
});

var added = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(module, exports, utils);
  }
})(commonjsGlobal, function (module, exports, _utils) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var addedDiff = function addedDiff(lhs, rhs) {

    if (lhs === rhs || !(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return {};

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    return Object.keys(r).reduce(function (acc, key) {
      if (l.hasOwnProperty(key)) {
        var difference = addedDiff(l[key], r[key]);

        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference)) return acc;

        return _extends({}, acc, _defineProperty({}, key, difference));
      }

      return _extends({}, acc, _defineProperty({}, key, r[key]));
    }, {});
  };

  exports.default = addedDiff;
  module.exports = exports['default'];
});
});

var deleted = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(module, exports, utils);
  }
})(commonjsGlobal, function (module, exports, _utils) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var deletedDiff = function deletedDiff(lhs, rhs) {
    if (lhs === rhs || !(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return {};

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    return Object.keys(l).reduce(function (acc, key) {
      if (r.hasOwnProperty(key)) {
        var difference = deletedDiff(l[key], r[key]);

        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference)) return acc;

        return _extends({}, acc, _defineProperty({}, key, difference));
      }

      return _extends({}, acc, _defineProperty({}, key, undefined));
    }, {});
  };

  exports.default = deletedDiff;
  module.exports = exports['default'];
});
});

var updated = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(module, exports, utils);
  }
})(commonjsGlobal, function (module, exports, _utils) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var updatedDiff = function updatedDiff(lhs, rhs) {

    if (lhs === rhs) return {};

    if (!(0, _utils.isObject)(lhs) || !(0, _utils.isObject)(rhs)) return rhs;

    var l = (0, _utils.properObject)(lhs);
    var r = (0, _utils.properObject)(rhs);

    if ((0, _utils.isDate)(l) || (0, _utils.isDate)(r)) {
      if (l.valueOf() == r.valueOf()) return {};
      return r;
    }

    return Object.keys(r).reduce(function (acc, key) {

      if (l.hasOwnProperty(key)) {
        var difference = updatedDiff(l[key], r[key]);

        if ((0, _utils.isObject)(difference) && (0, _utils.isEmpty)(difference) && !(0, _utils.isDate)(difference)) return acc;

        return _extends({}, acc, _defineProperty({}, key, difference));
      }

      return acc;
    }, {});
  };

  exports.default = updatedDiff;
  module.exports = exports['default'];
});
});

var detailed = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(module, exports, added, deleted, updated);
  }
})(commonjsGlobal, function (module, exports, _added, _deleted, _updated) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _added2 = _interopRequireDefault(_added);

  var _deleted2 = _interopRequireDefault(_deleted);

  var _updated2 = _interopRequireDefault(_updated);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var detailedDiff = function detailedDiff(lhs, rhs) {
    return {
      added: (0, _added2.default)(lhs, rhs),
      deleted: (0, _deleted2.default)(lhs, rhs),
      updated: (0, _updated2.default)(lhs, rhs)
    };
  };

  exports.default = detailedDiff;
  module.exports = exports['default'];
});
});

var dist = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(exports, diff, added, deleted, updated, detailed);
  }
})(commonjsGlobal, function (exports, _diff, _added, _deleted, _updated, _detailed) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.detailedDiff = exports.updatedDiff = exports.deletedDiff = exports.diff = exports.addedDiff = undefined;

  var _diff2 = _interopRequireDefault(_diff);

  var _added2 = _interopRequireDefault(_added);

  var _deleted2 = _interopRequireDefault(_deleted);

  var _updated2 = _interopRequireDefault(_updated);

  var _detailed2 = _interopRequireDefault(_detailed);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.addedDiff = _added2.default;
  exports.diff = _diff2.default;
  exports.deletedDiff = _deleted2.default;
  exports.updatedDiff = _updated2.default;
  exports.detailedDiff = _detailed2.default;
});
});

// @ts-ignore
function getBreakpointToPropsMap(theme, props, defaultProps) {
    var breakpoints = Object.entries(theme.breakpoints)
        .sort(function (a, b) { return a[1].localeCompare(b[1], "en", { numeric: true }); })
        .map(function (_a) {
        var bp = _a[0];
        return bp;
    });
    /*
      If `props` is { "height-sm": "40px" }, `getResponsiveProps` will include "height".
      But, `getDefaultBreakpointProps` will not.
    */
    var breakpointsWithDefault = __spreadArray([
        DEFAULT_BREAKPOINT
    ], breakpoints);
    var result = Object.fromEntries(breakpointsWithDefault.map(function (bp) { return [bp, {}]; }));
    var allProps = __assign(__assign({}, defaultProps), props);
    Object.entries(allProps).forEach(function (_a) {
        var prop = _a[0], value = _a[1];
        var startIndex = breakpoints.findIndex(function (bp) { return prop.endsWith("-" + bp); }); // -1
        // adding 1 because of adding the default breakpoint
        var i = startIndex === -1 ? 0 : startIndex + 1;
        var propWithoutSuffix = startIndex === -1
            ? prop
            : prop.slice(0, -("-" + breakpoints[startIndex]).length);
        for (i; i < breakpointsWithDefault.length; i += 1) {
            var breakpoint = breakpointsWithDefault[i];
            result[breakpoint][propWithoutSuffix] = value;
        }
    });
    return result;
}
// @ts-ignore
function getCSSforBreakpoint(responsiveProps, propsAtBreakpoint, theme, bp) {
    var result = {};
    for (var prop in responsiveProps) {
        result = __assign(__assign({}, result), responsiveProps[prop](propsAtBreakpoint, theme, bp));
    }
    return result;
}
// @ts-ignore
function removeRedundantCSS(newCSS, existingCSS, mediaQueries) {
    var remainingNewCSS = klona(newCSS);
    var result = {};
    for (var i = mediaQueries.length - 1; i >= 0 && !isObjectEmpty(remainingNewCSS); i--) {
        var breakpointCSS = existingCSS[mediaQueries[i]] || {};
        // @ts-ignore
        var _a = dist.detailedDiff(breakpointCSS, remainingNewCSS), added = _a.added, updated = _a.updated; // The order is important here
        result = cjs(result, updated);
        remainingNewCSS = added;
    }
    result = cjs(result, remainingNewCSS);
    return result;
}
var DEFAULT_BREAKPOINT_MEDIA_QUERY_PLACEHOLDER = "";
var useResponsivePropsCSS = function (props, defaultProps, responsiveProps) {
    var theme = useTheme();
    var breakpointToPropsMap = getBreakpointToPropsMap(theme, props, defaultProps);
    var breakpoints = [DEFAULT_BREAKPOINT].concat(Object.keys(theme.minMediaQueries));
    var result = {};
    for (var i = 0; i < breakpoints.length; i++) {
        var bp = breakpoints[i];
        var newCSS = getCSSforBreakpoint(responsiveProps, 
        // @ts-ignore
        breakpointToPropsMap[bp], theme, bp);
        var necessaryNewCSS = removeRedundantCSS(newCSS, result, breakpoints.slice(0, i).map(function (bp) {
            // @ts-ignore
            return theme.minMediaQueries[bp] ||
                DEFAULT_BREAKPOINT_MEDIA_QUERY_PLACEHOLDER;
        }));
        if (!isObjectEmpty(necessaryNewCSS)) {
            // @ts-ignore
            result[
            // @ts-ignore
            theme.minMediaQueries[bp] || DEFAULT_BREAKPOINT_MEDIA_QUERY_PLACEHOLDER] = necessaryNewCSS;
        }
    }
    /*
      Note: The merge order is important here!
            Media queries should come after the default CSS.
            Also, the media queries should be in order.
  
      If the default CSS was placed after the media queries, e.g.:
  
        {
          "@media (min-width: 576px)": {
            height: "24px"
          },
          height: "48px"
        }
  
      the media query definition would be overridden by Order of Appearance (https://www.w3.org/TR/css-cascade-3/#cascade-order).
  
      Is the media queries were is the wrong order, e.g.:
  
        {
          "@media (min-width: 576px)": {
            height: "24px"
          },
          "@media (min-width: 375px)": {
            height: "48px"
          }
        }
  
      on screen sizes >= 576px, the height would be 48px, which is wrong.
    */
    result = __assign(__assign({}, result[DEFAULT_BREAKPOINT_MEDIA_QUERY_PLACEHOLDER]), result);
    // @ts-ignore
    delete result[DEFAULT_BREAKPOINT_MEDIA_QUERY_PLACEHOLDER];
    return result;
};

function filterValidProps(props) {
    var validations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var result = {};
    for (var propName in props) {
        var validationFn = validations[propName];
        var propValue = props[propName];
        if ((validationFn === null || validationFn === void 0 ? void 0 : validationFn(propValue)) === false) {
            continue;
        } // validationFn doesn't exist or returned true
        result[propName] = propValue;
    }
    return result;
}
function mergeProps$1(props, defaultProps, inheritedProps, validations) {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, defaultProps), filterValidProps(inheritedProps, validations)), filterValidProps(props, validations));
}
function areOptionsValid(options) {
    if (!Array.isArray(options) || options.length === 0) {
        return false;
    }
    var _iterator = _createForOfIteratorHelper(options), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var option = _step.value;
            if (!(typeof option.value === "string" && (typeof option.label === "string" && option.label.trim() !== "" || /*#__PURE__*/ React__default.isValidElement(option.label)))) {
                return false;
            }
        }
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
    return true;
}
function areCheckboxOptionsValid(options) {
    if (!Array.isArray(options) || options.length === 0) {
        return false;
    }
    var _iterator2 = _createForOfIteratorHelper(options), _step2;
    try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var option = _step2.value;
            if (!(typeof option.key === "string" && (typeof option.label === "string" && option.label.trim() !== "" || /*#__PURE__*/ React__default.isValidElement(option.label)))) {
                return false;
            }
        }
    }
    catch (err) {
        _iterator2.e(err);
    }
    finally {
        _iterator2.f();
    }
    return true;
}
function areDropdownOptionsValid(options) {
    if (!Array.isArray(options) || options.length === 0) {
        return false;
    }
    var _iterator3 = _createForOfIteratorHelper(options), _step3;
    try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var option = _step3.value;
            if (_typeof(option.data) !== "object" || typeof option.value !== "string") {
                return false;
            }
        }
    }
    catch (err) {
        _iterator3.e(err);
    }
    finally {
        _iterator3.f();
    }
    return true;
}
function getPropsFromMap(prop, map) {
    var result = {};
    for (var bp in map) {
        var propName = bp === DEFAULT_BREAKPOINT ? prop : "".concat(prop, "-").concat(bp);
        result[propName] = String(map[bp]);
    }
    return result;
}
function getResponsivePropMap(props, defaultProps, prop, theme) {
    var lastValue = hasOwnProperty(props, prop) ? props[prop] : defaultProps[prop];
    var result = _defineProperty({}, DEFAULT_BREAKPOINT, lastValue);
    for (var bp in theme.breakpoints) {
        var responsiveProp = "".concat(prop, "-").concat(bp);
        result[bp] = hasOwnProperty(props, responsiveProp) ? props[responsiveProp] : lastValue;
        lastValue = result[bp];
    }
    return result;
}
function mergeResponsivePropMaps(parentMap, childMap, theme) {
    if (!parentMap) {
        return childMap;
    }
    var result = _defineProperty({}, DEFAULT_BREAKPOINT, childMap[DEFAULT_BREAKPOINT] === "transparent" ? parentMap[DEFAULT_BREAKPOINT] : childMap[DEFAULT_BREAKPOINT]);
    for (var bp in theme.breakpoints) {
        result[bp] = childMap[bp] === "transparent" ? parentMap[bp] : childMap[bp];
    }
    return result;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$T() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$R = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "gg7wbs-ArrowBack",
    styles: "display:block;label:ArrowBack;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFycm93LWJhY2suanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiYXJyb3ctYmFjay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gQXJyb3dCYWNrKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE5LjcxIDIyLjM2NWExIDEgMCAwMS0xLjQyIDEuNDA4bC03LTcuMDdhMSAxIDAgMDEuMDAzLTEuNDFsNy03YTEgMSAwIDAxMS40MTQgMS40MTRsLTYuMjk2IDYuMjk2IDYuMyA2LjM2MnpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5BcnJvd0JhY2sucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBBcnJvd0JhY2s7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
};
function ArrowBack(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$R,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M19.71 22.365a1 1 0 01-1.42 1.408l-7-7.07a1 1 0 01.003-1.41l7-7a1 1 0 011.414 1.414l-6.296 6.296 6.3 6.362z",
        fill: primaryColor
    }));
}
ArrowBack.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$S() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$Q = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "231wav-ArrowForward",
    styles: "display:block;label:ArrowForward;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFycm93LWZvcndhcmQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiYXJyb3ctZm9yd2FyZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gQXJyb3dGb3J3YXJkKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTEyLjI5IDIyLjM2NWExIDEgMCAwMDEuNDIgMS40MDhsNy03LjA3YTEgMSAwIDAwLS4wMDMtMS40MWwtNy03YTEgMSAwIDAwLTEuNDE0IDEuNDE0bDYuMjk2IDYuMjk2LTYuMyA2LjM2MnpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5BcnJvd0ZvcndhcmQucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBBcnJvd0ZvcndhcmQ7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
function ArrowForward(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$Q,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M12.29 22.365a1 1 0 001.42 1.408l7-7.07a1 1 0 00-.003-1.41l-7-7a1 1 0 00-1.414 1.414l6.296 6.296-6.3 6.362z",
        fill: primaryColor
    }));
}
ArrowForward.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$R() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$P = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "7bd5ft-Assistance",
    styles: "display:block;label:Assistance;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFzc2lzdGFuY2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiYXNzaXN0YW5jZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gQXNzaXN0YW5jZSh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiA2YzUuNTIyIDAgMTAgNC40NzcgMTAgMTAgMCA1LjUyMi00LjQ3OCAxMC0xMCAxMFM2IDIxLjUyMiA2IDE2YzAtNS41MjMgNC40NzgtMTAgMTAtMTB6bTIuMjcgMTUuNTU2QTUuOTkgNS45OSAwIDAxMTYgMjJhNS45OSA1Ljk5IDAgMDEtMi4yNy0uNDQ0bC0xLjUgMS40OTljMS4xMjUuNjAzIDIuNDA4Ljk0NSAzLjc3Ljk0NXMyLjY0NS0uMzQyIDMuNzctLjk0NXpNMTYgMTJjLTIuMjA2IDAtNCAxLjc5NC00IDRzMS43OTQgNCA0IDQgNC0xLjc5NCA0LTQtMS43OTQtNC00LTR6bTcuMjIzLjU2MmwtMS41MzIgMS41MzNhNi4wMDcgNi4wMDcgMCAwMS0uMDAxIDMuODExbDEuNTMzIDEuNTMyQzIzLjcyIDE4LjM5NiAyNCAxNy4yMyAyNCAxNnMtLjI3OS0yLjM5Ni0uNzc3LTMuNDM4em0tMTQuNDQ2IDBDOC4yOCAxMy42MDQgOCAxNC43NyA4IDE2cy4yNzkgMi4zOTYuNzc3IDMuNDM4bDEuNTMzLTEuNTMxYTYuMDAzIDYuMDAzIDAgMDEtLjAwMS0zLjgxMnpNMTYgOGE3Ljk1NSA3Ljk1NSAwIDAwLTMuNzcuOTQ1bDEuNSAxLjVBNS45NzIgNS45NzIgMCAwMTE2IDEwYy44MDMgMCAxLjU3LjE1OCAyLjI3LjQ0NGwxLjUtMS40OTlBNy45NjEgNy45NjEgMCAwMDE2IDh6XCJcbiAgICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQXNzaXN0YW5jZS5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEFzc2lzdGFuY2U7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
function Assistance(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$P,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 6c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10S6 21.522 6 16c0-5.523 4.478-10 10-10zm2.27 15.556A5.99 5.99 0 0116 22a5.99 5.99 0 01-2.27-.444l-1.5 1.499c1.125.603 2.408.945 3.77.945s2.645-.342 3.77-.945zM16 12c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm7.223.562l-1.532 1.533a6.007 6.007 0 01-.001 3.811l1.533 1.532C23.72 18.396 24 17.23 24 16s-.279-2.396-.777-3.438zm-14.446 0C8.28 13.604 8 14.77 8 16s.279 2.396.777 3.438l1.533-1.531a6.003 6.003 0 01-.001-3.812zM16 8a7.955 7.955 0 00-3.77.945l1.5 1.5A5.972 5.972 0 0116 10c.803 0 1.57.158 2.27.444l1.5-1.499A7.961 7.961 0 0016 8z",
        fillRule: "evenodd",
        fill: primaryColor
    }));
}
Assistance.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$Q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$O = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1qtj2g-Birthday",
    styles: "display:block;label:Birthday;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJpcnRoZGF5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImJpcnRoZGF5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBCaXJ0aGRheSh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xMSA4djQuOTk5aDRWOGgydjQuOTk5aDRWOGgydjQuOTk5TDI0IDEzYTMgMyAwIDAxMyAzdjVhMy4wMDEgMy4wMDEgMCAwMS0yIDIuODI5VjI3aDN2Mkg0di0yaDN2LTIuMTdBMy4wMDEgMy4wMDEgMCAwMTUgMjJ2LTZhMyAzIDAgMDEzLTNsMS0uMDAxVjhoMnptOSAxMmExIDEgMCAwMC0xIDF2MWEzIDMgMCAwMS02IDAgMSAxIDAgMDAtMiAwIDMuMDAxIDMuMDAxIDAgMDEtMiAyLjgyOVYyN2gxNHYtMy4xN0EzLjAwMSAzLjAwMSAwIDAxMjEgMjFhMSAxIDAgMDAtMS0xem00LTVIOGExIDEgMCAwMC0xIDF2NmExIDEgMCAwMDIgMCAzIDMgMCAwMTYgMCAxIDEgMCAwMDIgMHYtMWEzIDMgMCAwMTYgMCAxIDEgMCAwMDIgMHYtNWExIDEgMCAwMC0xLTF6TTEwIDNjLjU1MiAwIDEgMi4yMjYgMSAyLjg1N0MxMSA2LjQ4OCAxMC41NTIgNyAxMCA3cy0xLS41MTItMS0xLjE0M1M5LjQ0OCAzIDEwIDN6bTYgMGMuNTUyIDAgMSAyLjIyNiAxIDIuODU3QzE3IDYuNDg4IDE2LjU1MiA3IDE2IDdzLTEtLjUxMi0xLTEuMTQzUzE1LjQ0OCAzIDE2IDN6bTYgMGMuNTUyIDAgMSAyLjIyNiAxIDIuODU3QzIzIDYuNDg4IDIyLjU1MiA3IDIyIDdzLTEtLjUxMi0xLTEuMTQzUzIxLjQ0OCAzIDIyIDN6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQmlydGhkYXkucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBCaXJ0aGRheTtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Q
};
function Birthday(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$O,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M11 8v4.999h4V8h2v4.999h4V8h2v4.999L24 13a3 3 0 013 3v5a3.001 3.001 0 01-2 2.829V27h3v2H4v-2h3v-2.17A3.001 3.001 0 015 22v-6a3 3 0 013-3l1-.001V8h2zm9 12a1 1 0 00-1 1v1a3 3 0 01-6 0 1 1 0 00-2 0 3.001 3.001 0 01-2 2.829V27h14v-3.17A3.001 3.001 0 0121 21a1 1 0 00-1-1zm4-5H8a1 1 0 00-1 1v6a1 1 0 002 0 3 3 0 016 0 1 1 0 002 0v-1a3 3 0 016 0 1 1 0 002 0v-5a1 1 0 00-1-1zM10 3c.552 0 1 2.226 1 2.857C11 6.488 10.552 7 10 7s-1-.512-1-1.143S9.448 3 10 3zm6 0c.552 0 1 2.226 1 2.857C17 6.488 16.552 7 16 7s-1-.512-1-1.143S15.448 3 16 3zm6 0c.552 0 1 2.226 1 2.857C23 6.488 22.552 7 22 7s-1-.512-1-1.143S21.448 3 22 3z",
        fill: primaryColor
    }));
}
Birthday.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$P() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$N = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "106iywg-Blocking",
    styles: "display:block;label:Blocking;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJsb2NraW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImJsb2NraW5nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBCbG9ja2luZyh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiAyNGE3Ljk1MiA3Ljk1MiAwIDAxLTQuODk3LTEuNjg4bDExLjIwOS0xMS4yMDlBNy45NTQgNy45NTQgMCAwMTI0IDE2YzAgNC40MTEtMy41ODkgOC04IDhtLTgtOGMwLTQuNDExIDMuNTg5LTggOC04IDEuODQ2IDAgMy41NDMuNjM0IDQuODk3IDEuNjg4TDkuNjg4IDIwLjg5N0E3Ljk1MiA3Ljk1MiAwIDAxOCAxNm04LTEwQzEwLjQ3OCA2IDYgMTAuNDc3IDYgMTZjMCA1LjUyMiA0LjQ3OCAxMCAxMCAxMHMxMC00LjQ3OCAxMC0xMGMwLTUuNTIzLTQuNDc4LTEwLTEwLTEwXCJcbiAgICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQmxvY2tpbmcucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBCbG9ja2luZztcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
function Blocking(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$N,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 24a7.952 7.952 0 01-4.897-1.688l11.209-11.209A7.954 7.954 0 0124 16c0 4.411-3.589 8-8 8m-8-8c0-4.411 3.589-8 8-8 1.846 0 3.543.634 4.897 1.688L9.688 20.897A7.952 7.952 0 018 16m8-10C10.478 6 6 10.477 6 16c0 5.522 4.478 10 10 10s10-4.478 10-10c0-5.523-4.478-10-10-10",
        fillRule: "evenodd",
        fill: primaryColor
    }));
}
Blocking.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$O() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$M = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "zy4cyq-Calculator",
    styles: "display:block;label:Calculator;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhbGN1bGF0b3IuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiY2FsY3VsYXRvci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gQ2FsY3VsYXRvcih7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yNSAxYTIgMiAwIDAgMSAyIDJ2MjZhMiAyIDAgMCAxLTIgMkg3YTIgMiAwIDAgMS0yLTJWM2EyIDIgMCAwIDEgMi0yaDE4ek0xMiAyNkg3djJhMSAxIDAgMCAwIC44ODMuOTkzTDggMjloNHYtM3ptNiAwaC00djNoNHYtM3ptNy01aC01djhoNGExIDEgMCAwIDAgLjk5My0uODgzTDI1IDI4di03em0tNyAwaC00djNoNHYtM3ptLTYgMEg3djNoNXYtM3ptMC01SDd2M2g1di0zem02IDBoLTR2M2g0di0zem03IDBoLTV2M2g1di0zem0tMTMtNUg3djNoNXYtM3ptNiAwaC00djNoNHYtM3ptNyAwaC01djNoNXYtM3ptLTEtOEg4YTEgMSAwIDAgMC0uOTkzLjg4M0w3IDR2NWgxOFY0YTEgMSAwIDAgMC0xLTF6bS0yIDFhMSAxIDAgMCAxIDEgMXYyYTEgMSAwIDAgMS0xIDFoLTFhMSAxIDAgMCAxLTEtMVY1YTEgMSAwIDAgMSAxLTFoMXptMCAxaC0xdjJoMVY1elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkNhbGN1bGF0b3IucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBDYWxjdWxhdG9yO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
function Calculator(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$M,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M25 1a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h18zM12 26H7v2a1 1 0 0 0 .883.993L8 29h4v-3zm6 0h-4v3h4v-3zm7-5h-5v8h4a1 1 0 0 0 .993-.883L25 28v-7zm-7 0h-4v3h4v-3zm-6 0H7v3h5v-3zm0-5H7v3h5v-3zm6 0h-4v3h4v-3zm7 0h-5v3h5v-3zm-13-5H7v3h5v-3zm6 0h-4v3h4v-3zm7 0h-5v3h5v-3zm-1-8H8a1 1 0 0 0-.993.883L7 4v5h18V4a1 1 0 0 0-1-1zm-2 1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1zm0 1h-1v2h1V5z",
        fill: primaryColor
    }));
}
Calculator.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$N() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$L = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "quxff3-Call",
    styles: "display:block;label:Call;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhbGwuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiY2FsbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gQ2FsbCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xMS42NjcgOS4wNTFjLS4zNC4wNzMtLjY0My4xNDItLjk0MS4yMjgtLjc4NC44NS0xLjY2OCAyLjI0MS0xLjcyIDIuOTY3LS4wMjcuMzc1LjAzOS43ODIuMjE0IDEuMzIuNDQ4IDEuMzczIDEuMDU1IDIuOTU1IDIuMTY5IDQuMjcxLjk3MiAxLjE1IDEuOTIgMi4wODcgMi45IDIuODY1Ljg0NC42NzEgMS42NTQgMS4xNSAyLjQ3OCAxLjQ2My41MDYuMTk0IDEuMDEyLjM4NSAxLjUyMy41NjMuNDc0LjE2NC44OTYuMjQ1IDEuNTg0LjI2Mi40NjYtLjAzIDEuODQ3LS44MiAyLjgyMi0xLjcxNWEzLjIyIDMuMjIgMCAwMC4yNzUtLjkzbC0yLjU2Ny0xLjVjLS4xMTMuMTE2LS4yMDIuMjIxLS4yOTIuMzI1bC0uNDM1LjQ5NmMtLjE2LjE4Mi0uMzIuMzYzLS40ODYuNTQtLjUwOC41MzgtMS4yMjcuNjU2LTEuODc0LjMxYTMyLjI4NyAzMi4yODcgMCAwMS0xLjA2NC0uNTk2Yy0xLjQ0MS0uODUtMi41NTMtMS44NDMtMy40LTMuMDI5LS4zODItLjUzOS0uNzE2LTEuMS0xLjA0LTEuNjQ0bC0uMjk2LS40OTVjLS40MDQtLjY2Ny0uMjgyLTEuNDQ5LjMxLTEuOTkyLjE0My0uMTMuMjg5LS4yNTYuNDM0LS4zODIuMTItLjEwMy4yNC0uMjA2LjM1Ny0uMzEyLjItLjE4Mi4zNjktLjMzNC41MjItLjQ4bC0uMjY3LS40NWMtLjI0NC0uNDEtLjQ4OC0uODIyLS43My0xLjIzNS0uMTYyLS4yOC0uMzItLjU2NS0uNDc2LS44NXptOC4xODQgMTUuOTRjLTEgMC0xLjY1Ny0uMTc5LTIuMjE3LS4zNzVhNTIuMzcxIDUyLjM3MSAwIDAxLTEuNTgtLjU4MmMtMS4wMTgtLjM4OC0yLjAwMy0uOTY1LTMuMDEtMS43NjYtMS4wODMtLjg2Mi0yLjEyNC0xLjg4OS0zLjE4Mi0zLjE0LTEuMzM3LTEuNTgtMi4wMzYtMy4zODYtMi41NDMtNC45NDQtLjE2MS0uNDkyLS4zNjgtMS4yNDUtLjMwOC0yLjA4LjEwOS0xLjUyMiAxLjUzLTMuNDA2IDIuMjY3LTQuMTg5LjI1LS4yNjYuNTY5LS40NjUuODk3LS41NTkuNDMyLS4xMjQuODc1LS4yMTkgMS4zMTgtLjMxMi43NzctLjE2NiAxLjQzMi4xNDcgMS43ODkuNzk0bC4wOTguMTc4Yy4xNjIuMjk0LjMyNC41ODguNDkzLjg4LjIzNy40MDcuNDc5LjgxMy43MiAxLjIybC40MDYuNjgzYy4zOTcuNjY3LjMxOSAxLjQxNy0uMjAzIDEuOTZhMTUuMzUgMTUuMzUgMCAwMS0uNzYzLjcyM2MtLjIwMi4xODMtLjMzMy4yOTYtLjQ2NS40MWwtLjE1NS4xMzUuMTE5LjE5N2MuMzE2LjUzMi42MTUgMS4wMzUuOTUyIDEuNTA3LjY4Ljk1NCAxLjU5IDEuNzYxIDIuNzg3IDIuNDY3LjIyOC4xMzUuNDU4LjI2NC42ODkuMzkxLjA3Mi0uMDguMTQzLS4xNjIuMjE0LS4yNDNsLjQyMi0uNDhjLjE3My0uMi4zNDYtLjQuNTM3LS41ODMuNjU2LS42MjkgMS4zNjYtLjcwNCAyLjE3LS4yMjlsMi45MzkgMS43MTRjLjUyMy4zMS43OTcuODM0Ljc1NCAxLjQ0YTUuNTkxIDUuNTkxIDAgMDEtLjQ0IDEuODM1Yy0uMTEzLjI2LS4yODguNTAzLS41MDYuNzA0LS42Ni42MDYtMi42ODEgMi4xODgtNC4xMSAyLjI0Mi0uMDMuMDA0LS4wNi4wMDEtLjA5LjAwMXpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5DYWxsLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ2FsbDtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$N
};
function Call(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$L,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M11.667 9.051c-.34.073-.643.142-.941.228-.784.85-1.668 2.241-1.72 2.967-.027.375.039.782.214 1.32.448 1.373 1.055 2.955 2.169 4.271.972 1.15 1.92 2.087 2.9 2.865.844.671 1.654 1.15 2.478 1.463.506.194 1.012.385 1.523.563.474.164.896.245 1.584.262.466-.03 1.847-.82 2.822-1.715a3.22 3.22 0 00.275-.93l-2.567-1.5c-.113.116-.202.221-.292.325l-.435.496c-.16.182-.32.363-.486.54-.508.538-1.227.656-1.874.31a32.287 32.287 0 01-1.064-.596c-1.441-.85-2.553-1.843-3.4-3.029-.382-.539-.716-1.1-1.04-1.644l-.296-.495c-.404-.667-.282-1.449.31-1.992.143-.13.289-.256.434-.382.12-.103.24-.206.357-.312.2-.182.369-.334.522-.48l-.267-.45c-.244-.41-.488-.822-.73-1.235-.162-.28-.32-.565-.476-.85zm8.184 15.94c-1 0-1.657-.179-2.217-.375a52.371 52.371 0 01-1.58-.582c-1.018-.388-2.003-.965-3.01-1.766-1.083-.862-2.124-1.889-3.182-3.14-1.337-1.58-2.036-3.386-2.543-4.944-.161-.492-.368-1.245-.308-2.08.109-1.522 1.53-3.406 2.267-4.189.25-.266.569-.465.897-.559.432-.124.875-.219 1.318-.312.777-.166 1.432.147 1.789.794l.098.178c.162.294.324.588.493.88.237.407.479.813.72 1.22l.406.683c.397.667.319 1.417-.203 1.96a15.35 15.35 0 01-.763.723c-.202.183-.333.296-.465.41l-.155.135.119.197c.316.532.615 1.035.952 1.507.68.954 1.59 1.761 2.787 2.467.228.135.458.264.689.391.072-.08.143-.162.214-.243l.422-.48c.173-.2.346-.4.537-.583.656-.629 1.366-.704 2.17-.229l2.939 1.714c.523.31.797.834.754 1.44a5.591 5.591 0 01-.44 1.835c-.113.26-.288.503-.506.704-.66.606-2.681 2.188-4.11 2.242-.03.004-.06.001-.09.001z",
        fill: primaryColor,
        fillRule: "evenodd"
    }));
}
Call.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$M() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$K = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "z82wef-ChevronDown",
    styles: "display:block;label:ChevronDown;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZXZyb24tZG93bi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJjaGV2cm9uLWRvd24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIENoZXZyb25Eb3duKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIyLjY0NiAxNC45OGwtNS44NTQgNS42OTdjLS40NDIuNDMtMS4xNDMuNDMtMS41ODUgMGwtNS44NS01LjY5M2ExLjE1MyAxLjE1MyAwIDAxLjQ3My0xLjk0Yy4zOTUtLjExMi44Mi0uMDAyIDEuMTA3LjI4NGw1LjA2MiA0LjkyOCA1LjA1Ny00LjkyMmMuMzMtLjMzLjgyNC0uNDI1IDEuMjUtLjI0MmExLjE1IDEuMTUgMCAwMS4zNCAxLjg4OHpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5DaGV2cm9uRG93bi5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENoZXZyb25Eb3duO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
};
function ChevronDown(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$K,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M22.646 14.98l-5.854 5.697c-.442.43-1.143.43-1.585 0l-5.85-5.693a1.153 1.153 0 01.473-1.94c.395-.112.82-.002 1.107.284l5.062 4.928 5.057-4.922c.33-.33.824-.425 1.25-.242a1.15 1.15 0 01.34 1.888z",
        fill: primaryColor
    }));
}
ChevronDown.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$J = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "l807to-ChevronLeft",
    styles: "display:block;label:ChevronLeft;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZXZyb24tbGVmdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJjaGV2cm9uLWxlZnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIENoZXZyb25MZWZ0KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE3LjAyIDkuMzU0bC01LjY5NyA1Ljg1NGExLjEzNCAxLjEzNCAwIDAwMCAxLjU4NWw1LjY5MyA1Ljg1YTEuMTUzIDEuMTUzIDAgMDAxLjk0LS40NzNjLjExMi0uMzk1LjAwMi0uODItLjI4NC0xLjEwN2wtNC45MjgtNS4wNjIgNC45MjItNS4wNTdjLjMzLS4zMy40MjUtLjgyNC4yNDItMS4yNUExLjE0OCAxLjE0OCAwIDAwMTcuODMzIDljLS4zMS4wMDUtLjYwNi4xMzUtLjgxMy4zNTR6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQ2hldnJvbkxlZnQucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBDaGV2cm9uTGVmdDtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
};
function ChevronLeft(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$J,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M17.02 9.354l-5.697 5.854a1.134 1.134 0 000 1.585l5.693 5.85a1.153 1.153 0 001.94-.473c.112-.395.002-.82-.284-1.107l-4.928-5.062 4.922-5.057c.33-.33.425-.824.242-1.25A1.148 1.148 0 0017.833 9c-.31.005-.606.135-.813.354z",
        fill: primaryColor
    }));
}
ChevronLeft.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$I = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "139nfn1-ChevronRight",
    styles: "display:block;label:ChevronRight;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZXZyb24tcmlnaHQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiY2hldnJvbi1yaWdodC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gQ2hldnJvblJpZ2h0KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE0Ljk4IDkuMzU0bDUuNjk3IDUuODU0Yy40My40NDIuNDMgMS4xNDMgMCAxLjU4NWwtNS42OTMgNS44NWExLjE1MyAxLjE1MyAwIDAgMS0xLjk0LS40NzMgMS4xMzIgMS4xMzIgMCAwIDEgLjI4NC0xLjEwN2w0LjkyOC01LjA2Mi00LjkyMi01LjA1N2ExLjEzNCAxLjEzNCAwIDAgMS0uMjQyLTEuMjVBMS4xNDggMS4xNDggMCAwIDEgMTQuMTY3IDljLjMxLjAwNS42MDYuMTM1LjgxMy4zNTR6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQ2hldnJvblJpZ2h0LnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ2hldnJvblJpZ2h0O1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$K
};
function ChevronRight(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$I,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M14.98 9.354l5.697 5.854c.43.442.43 1.143 0 1.585l-5.693 5.85a1.153 1.153 0 0 1-1.94-.473 1.132 1.132 0 0 1 .284-1.107l4.928-5.062-4.922-5.057a1.134 1.134 0 0 1-.242-1.25A1.148 1.148 0 0 1 14.167 9c.31.005.606.135.813.354z",
        fill: primaryColor
    }));
}
ChevronRight.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$H = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1ib3grz-ChevronUp",
    styles: "display:block;label:ChevronUp;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZXZyb24tdXAuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiY2hldnJvbi11cC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gQ2hldnJvblVwKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTkuMzU0IDE3LjAybDUuODU0LTUuNjk3YTEuMTM0IDEuMTM0IDAgMDExLjU4NSAwbDUuODUgNS42OTNhMS4xNTMgMS4xNTMgMCAwMS0uNDczIDEuOTRjLS4zOTUuMTEyLS44Mi4wMDItMS4xMDctLjI4NGwtNS4wNjItNC45MjgtNS4wNTcgNC45MjJjLS4zMy4zMy0uODI0LjQyNS0xLjI1LjI0MkExLjE0OCAxLjE0OCAwIDAxOSAxNy44MzNjLjAwNS0uMzEuMTM1LS42MDYuMzU0LS44MTN6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQ2hldnJvblVwLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ2hldnJvblVwO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
};
function ChevronUp(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$H,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M9.354 17.02l5.854-5.697a1.134 1.134 0 011.585 0l5.85 5.693a1.153 1.153 0 01-.473 1.94c-.395.112-.82.002-1.107-.284l-5.062-4.928-5.057 4.922c-.33.33-.824.425-1.25.242A1.148 1.148 0 019 17.833c.005-.31.135-.606.354-.813z",
        fill: primaryColor
    }));
}
ChevronUp.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$G = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1yhjkoj-Comparison",
    styles: "display:block;label:Comparison;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$I
};
function Comparison(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$G,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M8.139 17.08a1 1 0 01.53 1.31A8.506 8.506 0 008 21.715C8 26.297 11.589 30 16 30s8-3.703 8-8.285c0-1.161-.23-2.287-.67-3.325a1 1 0 111.842-.78c.544 1.284.828 2.675.828 4.105C26 27.388 21.53 32 16 32S6 27.388 6 21.715c0-1.43.284-2.82.828-4.105a1 1 0 011.31-.53zM16 11c3.24 0 6.134 1.825 7.376 4.59l.184.41-.184.41C22.134 19.175 19.24 21 16 21s-6.134-1.825-7.376-4.59L8.44 16l.184-.41C9.866 12.825 12.76 11 16 11zm3.049 2.763l-3.764 5.198a6.576 6.576 0 002.086-.106l2.923-4.196a5.973 5.973 0 00-1.245-.896zm-2.465-.737l-3.733 5.156c.42.238.875.43 1.353.567l3.91-5.397a6.437 6.437 0 00-1.53-.326zm4.393 2.4l-1.975 2.837A5.752 5.752 0 0021.346 16a5.42 5.42 0 00-.37-.574zm-7.574-1.885l-2.369 3.047c.283.382.616.728.99 1.03l3.32-4.585a6.395 6.395 0 00-1.941.508zM16 0c5.53 0 10 4.612 10 10.286 0 1.43-.284 2.82-.828 4.104a1 1 0 11-1.842-.78 8.5 8.5 0 00.67-3.324C24 5.703 20.411 2 16 2s-8 3.703-8 8.286a8.5 8.5 0 00.67 3.324 1 1 0 11-1.842.78A10.506 10.506 0 016 10.286C6 4.612 10.47 0 16 0z",
        fill: primaryColor
    }));
}
Comparison.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$F = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "jf80n7-Critical",
    styles: "display:block;label:Critical;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyaXRpY2FsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImNyaXRpY2FsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBDcml0aWNhbCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yMC4zMTIgNmw1LjkyOCA1LjkyOHY4LjM4M2wtNS45MjggNS45MjhoLTguMzgzTDYgMjAuMzExdi04LjM4M0wxMS45MjkgNmg4LjM4M3ptLS44MjggMmgtNi43MjdMOCAxMi43NTZ2Ni43MjdsNC43NTcgNC43NTZoNi43MjdsNC43NTYtNC43NTZ2LTYuNzI3TDE5LjQ4NCA4em0tNS40ODMgMTEuNWExIDEgMCAwMS4xMTcgMS45OTNsLS4xMTcuMDA3YTEgMSAwIDExMC0yem00IDBhMSAxIDAgMDEuMTE3IDEuOTkzbC0uMTE3LjAwN2ExIDEgMCAxMTAtMnptLjA1OC04LjVjLjUyIDAgLjk0Mi40MjIuOTQyLjk0M3Y1LjExNWMwIC41Mi0uNDIxLjk0Mi0uOTQyLjk0MmgtLjExNWEuOTQzLjk0MyAwIDAxLS45NDMtLjk0MnYtNS4xMTVjMC0uNTIxLjQyMi0uOTQzLjk0My0uOTQzem0tNCAwYy41MiAwIC45NDIuNDIyLjk0Mi45NDN2NS4xMTVjMCAuNTItLjQyMS45NDItLjk0Mi45NDJoLS4xMTVhLjk0My45NDMgMCAwMS0uOTQzLS45NDJ2LTUuMTE1YzAtLjUyMS40MjItLjk0My45NDMtLjk0M3pcIlxuICAgICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5Dcml0aWNhbC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENyaXRpY2FsO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
};
function Critical(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$F,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M20.312 6l5.928 5.928v8.383l-5.928 5.928h-8.383L6 20.311v-8.383L11.929 6h8.383zm-.828 2h-6.727L8 12.756v6.727l4.757 4.756h6.727l4.756-4.756v-6.727L19.484 8zm-5.483 11.5a1 1 0 01.117 1.993l-.117.007a1 1 0 110-2zm4 0a1 1 0 01.117 1.993l-.117.007a1 1 0 110-2zm.058-8.5c.52 0 .942.422.942.943v5.115c0 .52-.421.942-.942.942h-.115a.943.943 0 01-.943-.942v-5.115c0-.521.422-.943.943-.943zm-4 0c.52 0 .942.422.942.943v5.115c0 .52-.421.942-.942.942h-.115a.943.943 0 01-.943-.942v-5.115c0-.521.422-.943.943-.943z",
        fillRule: "evenodd",
        fill: primaryColor
    }));
}
Critical.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$E = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1ccsb9e-CrossSmall",
    styles: "display:block;label:CrossSmall;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyb3NzLXNtYWxsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImNyb3NzLXNtYWxsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBDcm9zc1NtYWxsKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIxLjczMSAxMS4yNjlhLjkxNS45MTUgMCAwMTAgMS4yOTZsLTMuOTM1IDMuOTM0IDMuOTM1IDMuOTM2YS45MTUuOTE1IDAgMTEtMS4yOTYgMS4yOTZMMTYuNSAxNy43OTVsLTMuOTM1IDMuOTM2YS45MTQuOTE0IDAgMDEtMS4yOTYgMCAuOTE1LjkxNSAwIDAxMC0xLjI5NmwzLjkzNC0zLjkzNi0zLjkzNC0zLjkzNGEuOTE1LjkxNSAwIDExMS4yOTYtMS4yOTZsMy45MzUgMy45MzQgMy45MzUtMy45MzRhLjkxNi45MTYgMCAwMTEuMjk2IDB6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQ3Jvc3NTbWFsbC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENyb3NzU21hbGw7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
};
function CrossSmall(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$E,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M21.731 11.269a.915.915 0 010 1.296l-3.935 3.934 3.935 3.936a.915.915 0 11-1.296 1.296L16.5 17.795l-3.935 3.936a.914.914 0 01-1.296 0 .915.915 0 010-1.296l3.934-3.936-3.934-3.934a.915.915 0 111.296-1.296l3.935 3.934 3.935-3.934a.916.916 0 011.296 0z",
        fill: primaryColor
    }));
}
CrossSmall.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$D = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "syy8nd-Cross",
    styles: "display:block;label:Cross;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyb3NzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImNyb3NzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBDcm9zcyh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk05LjcwNyA4LjI5M2w2LjM2NCA2LjM2MyA2LjM2NC02LjM2M2ExIDEgMCAwMTEuNDE0IDEuNDE0bC02LjM2NCA2LjM2NCA2LjM2NCA2LjM2NGExIDEgMCAwMS0xLjQxNCAxLjQxNGwtNi4zNjQtNi4zNjQtNi4zNjQgNi4zNjRhMSAxIDAgMTEtMS40MTQtMS40MTRsNi4zNjMtNi4zNjQtNi4zNjMtNi4zNjRhMSAxIDAgMDExLjQxNC0xLjQxNHpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5Dcm9zcy5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENyb3NzO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
};
function Cross(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$D,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M9.707 8.293l6.364 6.363 6.364-6.363a1 1 0 011.414 1.414l-6.364 6.364 6.364 6.364a1 1 0 01-1.414 1.414l-6.364-6.364-6.364 6.364a1 1 0 11-1.414-1.414l6.363-6.364-6.363-6.364a1 1 0 011.414-1.414z",
        fill: primaryColor
    }));
}
Cross.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$C = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "a4b7i7-Devices",
    styles: "display:block;label:Devices;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRldmljZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiZGV2aWNlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gRGV2aWNlcyh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGggZD1cIk0yNi4xIDRIMTEuMzFhMS44NCAxLjg0IDAgMDAtMS44NSAxLjgzVjEwSDZhMiAyIDAgMDAtMiAydjE0YTIgMiAwIDAwMiAyaDIwLjFhMS44NCAxLjg0IDAgMDAxLjktMS44M1Y1LjgzQTEuODQgMS44NCAwIDAwMjYuMSA0ek0xMyAxMy41djExYS41LjUgMCAwMS0uNS41aC02YS41LjUgMCAwMS0uNS0uNXYtMTFhLjUuNSAwIDAxLjUtLjVoNmEuNS41IDAgMDEuNS41ek0yNiAyNkgxNVYxMmEyIDIgMCAwMC0yLTJoLTEuNTRWNkgyNnpcIiAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5EZXZpY2VzLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRGV2aWNlcztcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};
function Devices(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$C,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        fill: primaryColor,
        "data-testid": testId
    }, jsx("path", {
        d: "M26.1 4H11.31a1.84 1.84 0 00-1.85 1.83V10H6a2 2 0 00-2 2v14a2 2 0 002 2h20.1a1.84 1.84 0 001.9-1.83V5.83A1.84 1.84 0 0026.1 4zM13 13.5v11a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h6a.5.5 0 01.5.5zM26 26H15V12a2 2 0 00-2-2h-1.54V6H26z"
    }));
}
Devices.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$B = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1r762y8-Document",
    styles: "display:block;label:Document;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvY3VtZW50LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImRvY3VtZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBEb2N1bWVudCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xOCA2Yy4yNjYgMCAuNTIuMTA1LjcwNy4yOTNsNSA1QS45OTYuOTk2IDAgMDEyNCAxMnYxMmMwIDEuMTAzLS44OTcgMi0yIDJIMTBjLTEuMTAzIDAtMi0uODk3LTItMlY4YzAtMS4xMDMuODk3LTIgMi0yem0tMSAyaC03djE2aDEyVjEzaC0zYy0xLjEwMyAwLTItLjg5Ny0yLTJWOHptMi41IDEzYS41LjUgMCAwMTAgMWgtN2EuNS41IDAgMDEwLTFoN3ptMC0zYS41LjUgMCAwMTAgMWgtN2EuNS41IDAgMDEwLTFoN3ptMC0zYS41LjUgMCAwMTAgMWgtN2EuNS41IDAgMDEwLTFoN3ptLTUtM2EuNS41IDAgMDEwIDFoLTJhLjUuNSAwIDAxMC0xaDJ6TTE5IDkuNDE0VjExaDEuNTg2TDE5IDkuNDE0elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkRvY3VtZW50LnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRG9jdW1lbnQ7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
};
function Document(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$B,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M18 6c.266 0 .52.105.707.293l5 5A.996.996 0 0124 12v12c0 1.103-.897 2-2 2H10c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2zm-1 2h-7v16h12V13h-3c-1.103 0-2-.897-2-2V8zm2.5 13a.5.5 0 010 1h-7a.5.5 0 010-1h7zm0-3a.5.5 0 010 1h-7a.5.5 0 010-1h7zm0-3a.5.5 0 010 1h-7a.5.5 0 010-1h7zm-5-3a.5.5 0 010 1h-2a.5.5 0 010-1h2zM19 9.414V11h1.586L19 9.414z",
        fill: primaryColor,
        fillRule: "evenodd"
    }));
}
Document.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$A = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "17y2vvq-Download",
    styles: "display:block;label:Download;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvd25sb2FkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImRvd25sb2FkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBEb3dubG9hZCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yNSAyNGExIDEgMCAxMTAgMkg3YTEgMSAwIDExMC0yek0xNiA2YTEgMSAwIDAxMSAxdjEyLjE3Mmw0LjEzOS00LjE0YTEgMSAwIDExMS40MTUgMS40MTRsLTQuOTY4IDQuOTY4YTIgMiAwIDAxLTEuNDE0LjU4NmgtLjM0NGEyIDIgMCAwMS0xLjQxNC0uNTg2bC00Ljk2Ny00Ljk2OGExIDEgMCAwMTEuNDE1LTEuNDE0TDE1IDE5LjE3MlY3YTEgMSAwIDAxMS0xelwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkRvd25sb2FkLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRG93bmxvYWQ7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
};
function Download(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$A,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M25 24a1 1 0 110 2H7a1 1 0 110-2zM16 6a1 1 0 011 1v12.172l4.139-4.14a1 1 0 111.415 1.414l-4.968 4.968a2 2 0 01-1.414.586h-.344a2 2 0 01-1.414-.586l-4.967-4.968a1 1 0 011.415-1.414L15 19.172V7a1 1 0 011-1z",
        fill: primaryColor
    }));
}
Download.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$z = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1yl5efb-Duplicate",
    styles: "display:block;label:Duplicate;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImR1cGxpY2F0ZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJkdXBsaWNhdGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIER1cGxpY2F0ZSh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yNiAxMGEyIDIgMCAwMTIgMnYxNGEyIDIgMCAwMS0yIDJIMTJhMiAyIDAgMDEtMi0ydi0yaDJ2MmgxNFYxMkgxMnY2aC0ydi02YTIgMiAwIDAxMi0yem0tNi02YTIgMiAwIDAxMiAydjJoLTJWNkg2djE0aDEyLjA4NmwtMS4yOTMtMS4yOTNhLjk5OS45OTkgMCAxMTEuNDE0LTEuNDE0bDMgM2EuOTk5Ljk5OSAwIDAxMCAxLjQxNGwtMyAzYS45OTcuOTk3IDAgMDEtMS40MTQgMCAuOTk5Ljk5OSAwIDAxMC0xLjQxNEwxOC4wODYgMjJINmEyIDIgMCAwMS0yLTJWNmEyIDIgMCAwMTItMnpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5EdXBsaWNhdGUucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBEdXBsaWNhdGU7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
function Duplicate(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$z,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M26 10a2 2 0 012 2v14a2 2 0 01-2 2H12a2 2 0 01-2-2v-2h2v2h14V12H12v6h-2v-6a2 2 0 012-2zm-6-6a2 2 0 012 2v2h-2V6H6v14h12.086l-1.293-1.293a.999.999 0 111.414-1.414l3 3a.999.999 0 010 1.414l-3 3a.997.997 0 01-1.414 0 .999.999 0 010-1.414L18.086 22H6a2 2 0 01-2-2V6a2 2 0 012-2z",
        fill: primaryColor,
        fillRule: "evenodd"
    }));
}
Duplicate.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$y = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "s25we3-Edit",
    styles: "display:block;label:Edit;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVkaXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiZWRpdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gRWRpdCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yMi4xNTcgMTIuNjU3bC0yLjgzLTIuODMgMS40MTUtMS40MTIgMi44MjkgMi44MjgtMS40MTQgMS40MTR6TTEwLjgyOSAyMy45ODVsLTIuODI3LS4wMDFMOCAyMS4xNTdsOS45MTMtOS45MTUgMi44MjggMi44MjktOS45MTMgOS45MTR6bTE0Ljg2My0xMy40NWwtNC4yNDMtNC4yNDJhMSAxIDAgMDAtMS40MTQgMEw2LjI5MyAyMC4wMzVhLjk5Mi45OTIgMCAwMC0uMjkyLjcwN3Y0LjI0MmExIDEgMCAwMDEgLjk5OWw0LjI0Mi4wMDJjLjI2NSAwIC41MTktLjEwNi43MDctLjI5M0wyNS42OTIgMTEuOTVhMSAxIDAgMDAwLTEuNDE1elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkVkaXQucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBFZGl0O1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
};
function Edit(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$y,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M22.157 12.657l-2.83-2.83 1.415-1.412 2.829 2.828-1.414 1.414zM10.829 23.985l-2.827-.001L8 21.157l9.913-9.915 2.828 2.829-9.913 9.914zm14.863-13.45l-4.243-4.242a1 1 0 00-1.414 0L6.293 20.035a.992.992 0 00-.292.707v4.242a1 1 0 001 .999l4.242.002c.265 0 .519-.106.707-.293L25.692 11.95a1 1 0 000-1.415z",
        fill: primaryColor
    }));
}
Edit.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$x = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1uiisp-ExternalLink",
    styles: "display:block;label:ExternalLink;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV4dGVybmFsLWxpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiZXh0ZXJuYWwtbGluay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gRXh0ZXJuYWxMaW5rKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE2IDEwYTEgMSAwIDExMCAySDh2MTJoMTJ2LThhMSAxIDAgMTEyIDB2OWExIDEgMCAwMS0xIDFIN2ExIDEgMCAwMS0xLTFWMTFhMSAxIDAgMDExLTF6bTktNGExIDEgMCAwMTEgMXY5YTEgMSAwIDExLTIgMFY5LjQxNGwtOS40MDggOS40MDljLS4zOTEuMzktMS4wMjUuMzktMS40MTUgMGExLjAwMiAxLjAwMiAwIDAxMC0xLjQxNUwyMi41ODYgOEgxNmExIDEgMCAxMTAtMnpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5FeHRlcm5hbExpbmsucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBFeHRlcm5hbExpbms7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
};
function ExternalLink(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$x,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 10a1 1 0 110 2H8v12h12v-8a1 1 0 112 0v9a1 1 0 01-1 1H7a1 1 0 01-1-1V11a1 1 0 011-1zm9-4a1 1 0 011 1v9a1 1 0 11-2 0V9.414l-9.408 9.409c-.391.39-1.025.39-1.415 0a1.002 1.002 0 010-1.415L22.586 8H16a1 1 0 110-2z",
        fill: primaryColor
    }));
}
ExternalLink.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$w = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1ufxscv-EyeHidden",
    styles: "display:block;label:EyeHidden;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
};
function EyeHidden(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$w,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M27.294 4.707a1 1 0 01.084 1.318l-.084.095L6.12 27.294a1 1 0 01-1.497-1.318l.083-.095L9.087 21.5c-.496-.36-.987-.746-1.47-1.183a20.654 20.654 0 01-2.805-3.135 2 2 0 01-.096-2.219l.096-.143.328-.437a20.378 20.378 0 012.477-2.699C10.281 9.274 13.18 8 16 8c.196 0 .394.028.591.041l.027.002c1.397.092 2.805.476 4.19 1.163l.378.195 4.695-4.695a1 1 0 011.413 0zm-2.821 7.062a20.839 20.839 0 012.713 3.05 2 2 0 010 2.364l-.327.436a20.35 20.35 0 01-2.476 2.697C21.719 22.727 18.82 24 16 24c-1.062 0-2.133-.204-3.199-.559l1.621-1.621c.529.112 1.057.18 1.578.18 2.316 0 4.751-1.095 7.041-3.166a19.407 19.407 0 002.557-2.833 19.296 19.296 0 00-2.539-2.817zm-14.146.3c-.46.331-.917.69-1.368 1.098A19.355 19.355 0 006.402 16a19.218 19.218 0 002.557 2.834c.385.347.773.663 1.165.953l.393.282 1.542-1.542a5.978 5.978 0 01-1.732-6.458zm5.916 7.93l5.744-5.745a5.99 5.99 0 01-5.517 5.732l-.227.013 5.744-5.745zm-3.007-9.288a1.5 1.5 0 10-.001 2.999 1.5 1.5 0 00.001-2.999z",
        fill: primaryColor
    }));
}
EyeHidden.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$v = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1k6qx29-EyeVisible",
    styles: "display:block;label:EyeVisible;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV5ZS12aXNpYmxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6ImV5ZS12aXNpYmxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBFeWVWaXNpYmxlKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIzLjA0MSAxOC44MzRDMjAuNzUxIDIwLjkwNSAxOC4zMTYgMjIgMTYgMjJjLTIuMzE2IDAtNC43NTEtMS4wOTUtNy4wNDEtMy4xNjZBMTkuMjE4IDE5LjIxOCAwIDAxNi40MDIgMTZhMTkuMzU1IDE5LjM1NSAwIDAxMi41NTctMi44MzNjLjQ1MS0uNDA4LjkwOC0uNzY3IDEuMzY4LTEuMDk4QTYgNiAwIDAwMTAgMTQuMDExYTYgNiAwIDAwMTIgMCA2LjAxIDYuMDEgMCAwMC0uMzI3LTEuOTQzYy40Ni4zMzIuOTE3LjY5MSAxLjM2OCAxLjA5OWExOS4yNyAxOS4yNyAwIDAxMi41NTcgMi44MzQgMTkuNDA3IDE5LjQwNyAwIDAxLTIuNTU3IDIuODMzem0tOC4zMDUtNi42MjNhMS41IDEuNSAwIDExLTMuMDAxLS4wMDEgMS41IDEuNSAwIDAxMy4wMDEuMDAxem05LjY0Ny0uNTI3QzIxLjcxOSA5LjI3MyAxOC44MiA4IDE2IDhjLTIuODIgMC01LjcxOSAxLjI3My04LjM4MyAzLjY4NGEyMC42NTQgMjAuNjU0IDAgMDAtMi44MDUgMy4xMzQgMiAyIDAgMDAwIDIuMzY0Yy44NjUgMS4xOCAxLjggMi4yMjUgMi44MDUgMy4xMzRDMTAuMjgxIDIyLjcyNyAxMy4xOCAyNCAxNiAyNGMyLjgyIDAgNS43MTktMS4yNzMgOC4zODMtMy42ODRhMjAuNjU0IDIwLjY1NCAwIDAwMi44MDUtMy4xMzQgMiAyIDAgMDAwLTIuMzY0IDIwLjY1NCAyMC42NTQgMCAwMC0yLjgwNS0zLjEzNHpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5FeWVWaXNpYmxlLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRXllVmlzaWJsZTtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
};
function EyeVisible(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$v,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M23.041 18.834C20.751 20.905 18.316 22 16 22c-2.316 0-4.751-1.095-7.041-3.166A19.218 19.218 0 016.402 16a19.355 19.355 0 012.557-2.833c.451-.408.908-.767 1.368-1.098A6 6 0 0010 14.011a6 6 0 0012 0 6.01 6.01 0 00-.327-1.943c.46.332.917.691 1.368 1.099a19.27 19.27 0 012.557 2.834 19.407 19.407 0 01-2.557 2.833zm-8.305-6.623a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm9.647-.527C21.719 9.273 18.82 8 16 8c-2.82 0-5.719 1.273-8.383 3.684a20.654 20.654 0 00-2.805 3.134 2 2 0 000 2.364c.865 1.18 1.8 2.225 2.805 3.134C10.281 22.727 13.18 24 16 24c2.82 0 5.719-1.273 8.383-3.684a20.654 20.654 0 002.805-3.134 2 2 0 000-2.364 20.654 20.654 0 00-2.805-3.134z",
        fill: primaryColor
    }));
}
EyeVisible.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$u = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "16qj65h-FaceID",
    styles: "display:block;label:FaceID;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZhY2UtaWQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiZmFjZS1pZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gRmFjZUlEKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTcgMjBhMSAxIDAgMDExIDF2M2gzYTEgMSAwIDExMCAySDdhMSAxIDAgMDEtMS0xdi00YTEgMSAwIDAxMS0xem0xOCAwYTEgMSAwIDAxMSAxdjRhMSAxIDAgMDEtMSAxaC00YTEgMSAwIDExMC0yaDN2LTNhMSAxIDAgMDExLTF6bS00LS4xODl2LjAwNGMwIC4zNy0uMTk4LjcyMS0uNTI5Ljg4N0E5Ljk1NSA5Ljk1NSAwIDAxMTYgMjEuNzU0YTkuOTU1IDkuOTU1IDAgMDEtNC40NzEtMS4wNTIuOTg3Ljk4NyAwIDAxLS41MjktLjg4N3YtLjAwNGEuOTk2Ljk5NiAwIDAxMS40NDktLjg4NiA3Ljk2NyA3Ljk2NyAwIDAwMy41NTEuODMgNy45NjcgNy45NjcgMCAwMDMuNTUxLS44My45OTYuOTk2IDAgMDExLjQ0OS44ODZ6TTE2IDEzYTEgMSAwIDAxMSAxdjNhMSAxIDAgMDEtMSAxaC0xYTEgMSAwIDExMC0ydi0yYTEgMSAwIDAxMS0xem0tNC0yYTEgMSAwIDAxMSAxdjFhMSAxIDAgMDEtMiAwdi0xYTEgMSAwIDAxMS0xem04IDBhMSAxIDAgMDExIDF2MWExIDEgMCAxMS0yIDB2LTFhMSAxIDAgMDExLTF6bS05LTVhMSAxIDAgMDEwIDJIOHYzYTEgMSAwIDAxLTIgMFY3YTEgMSAwIDAxMS0xaDR6bTE0IDBhMSAxIDAgMDExIDF2NGExIDEgMCAxMS0yIDBWOGgtM2ExIDEgMCAxMTAtMmg0elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkZhY2VJRC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEZhY2VJRDtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
function FaceID(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$u,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M7 20a1 1 0 011 1v3h3a1 1 0 110 2H7a1 1 0 01-1-1v-4a1 1 0 011-1zm18 0a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h3v-3a1 1 0 011-1zm-4-.189v.004c0 .37-.198.721-.529.887A9.955 9.955 0 0116 21.754a9.955 9.955 0 01-4.471-1.052.987.987 0 01-.529-.887v-.004a.996.996 0 011.449-.886 7.967 7.967 0 003.551.83 7.967 7.967 0 003.551-.83.996.996 0 011.449.886zM16 13a1 1 0 011 1v3a1 1 0 01-1 1h-1a1 1 0 110-2v-2a1 1 0 011-1zm-4-2a1 1 0 011 1v1a1 1 0 01-2 0v-1a1 1 0 011-1zm8 0a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm-9-5a1 1 0 010 2H8v3a1 1 0 01-2 0V7a1 1 0 011-1h4zm14 0a1 1 0 011 1v4a1 1 0 11-2 0V8h-3a1 1 0 110-2h4z",
        fill: primaryColor
    }));
}
FaceID.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function Facebook(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, hoverColor = _ref.hoverColor, testId = _ref.testId;
    var theme = useTheme();
    return jsx("svg", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            fill: primaryColor,
            transition: hoverColor ? theme.transitions.icon : null,
            ":hover": _objectSpread2({}, hoverColor && {
                fill: hoverColor
            })
        }, process.env.NODE_ENV === "production" ? "" : ";label:Facebook;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZhY2Vib29rLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNNIiwiZmlsZSI6ImZhY2Vib29rLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHVzZVRoZW1lIGZyb20gXCIuLi9ob29rcy91c2VUaGVtZVwiO1xuXG5mdW5jdGlvbiBGYWNlYm9vayh7IHNpemUsIHByaW1hcnlDb2xvciwgaG92ZXJDb2xvciwgdGVzdElkIH0pIHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPHN2Z1xuICAgICAgY3NzPXt7XG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgICAgZmlsbDogcHJpbWFyeUNvbG9yLFxuICAgICAgICB0cmFuc2l0aW9uOiBob3ZlckNvbG9yID8gdGhlbWUudHJhbnNpdGlvbnMuaWNvbiA6IG51bGwsXG4gICAgICAgIFwiOmhvdmVyXCI6IHtcbiAgICAgICAgICAuLi4oaG92ZXJDb2xvciAmJiB7IGZpbGw6IGhvdmVyQ29sb3IgfSksXG4gICAgICAgIH0sXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTQgMTUuOTk4QzQgMjEuOTg2IDguNDM0IDI2Ljk1IDE0LjIzMiAyNy44NXYtOC4zODVoLTMuMDc5di0zLjQ2N2gzLjA3OXYtMi42NDNjMC0zLjAwNyAxLjgxLTQuNjY4IDQuNTgtNC42NjggMS4zMjYgMCAyLjcxNC4yMzQgMi43MTQuMjM0djIuOTUzaC0xLjUyOWMtMS41MDYgMC0xLjk3Ni45MjQtMS45NzYgMS44NzN2Mi4yNTFoMy4zNjNsLS41MzcgMy40NjdoLTIuODI2djguMzg1YzUuNzk4LS45IDEwLjIzMS01Ljg2NCAxMC4yMzEtMTEuODUyQzI4LjI1MiA5LjM3MiAyMi44MjMgNCAxNi4xMjYgNCA5LjQyOCA0IDQgOS4zNzIgNCAxNS45OTh6XCJcbiAgICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkZhY2Vib29rLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgaG92ZXJDb2xvcjogUHJvcFR5cGVzLnN0cmluZyxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRmFjZWJvb2s7XG4iXX0= */"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M4 15.998C4 21.986 8.434 26.95 14.232 27.85v-8.385h-3.079v-3.467h3.079v-2.643c0-3.007 1.81-4.668 4.58-4.668 1.326 0 2.714.234 2.714.234v2.953h-1.529c-1.506 0-1.976.924-1.976 1.873v2.251h3.363l-.537 3.467h-2.826v8.385c5.798-.9 10.231-5.864 10.231-11.852C28.252 9.372 22.823 4 16.126 4 9.428 4 4 9.372 4 15.998z",
        fillRule: "evenodd"
    }));
}
Facebook.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    hoverColor: PropTypes.string,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$t = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "5u74ma-Fingerprint",
    styles: "display:block;label:Fingerprint;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};
function Fingerprint(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$t,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M21.81 8.47c-.08 0-.16-.02-.23-.06C19.66 7.42 18 7 16.01 7c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 01.2-.68C11.82 6.52 13.86 6 16.01 6c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 01-.44.28zM7.5 13.72a.499.499 0 01-.41-.79c.99-1.4 2.25-2.5 3.75-3.27 3.14-1.62 7.16-1.63 10.31-.01 1.5.77 2.76 1.86 3.75 3.25a.5.5 0 01-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 00-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 01-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM18.91 26c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 01-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 01-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94-1.7 0-3.08-1.32-3.08-2.94 0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z",
        fill: primaryColor
    }));
}
Fingerprint.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function GitHub(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, hoverColor = _ref.hoverColor, testId = _ref.testId;
    var theme = useTheme();
    return jsx("svg", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            fill: primaryColor,
            transition: hoverColor ? theme.transitions.icon : null,
            ":hover": _objectSpread2({}, hoverColor && {
                fill: hoverColor
            })
        }, process.env.NODE_ENV === "production" ? "" : ";label:GitHub;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M15.846 4C9.304 4 4 9.148 4 15.5c0 5.08 3.394 9.388 8.102 10.91.593.105.809-.25.809-.555 0-.273-.01-.996-.016-1.955-3.295.694-3.99-1.542-3.99-1.542-.54-1.329-1.316-1.682-1.316-1.682-1.076-.713.081-.7.081-.7 1.19.083 1.815 1.186 1.815 1.186 1.057 1.757 2.772 1.25 3.448.956.107-.743.413-1.25.752-1.538-2.63-.29-5.397-1.276-5.397-5.683 0-1.255.462-2.281 1.22-3.085-.122-.29-.529-1.46.116-3.043 0 0 .995-.31 3.258 1.179a11.67 11.67 0 012.966-.388c1.006.005 2.02.132 2.966.388 2.261-1.488 3.254-1.18 3.254-1.18.647 1.584.24 2.753.118 3.044.76.804 1.218 1.83 1.218 3.085 0 4.418-2.77 5.39-5.41 5.674.426.355.805 1.057.805 2.13 0 1.537-.015 2.777-.015 3.154 0 .308.214.665.815.553 4.703-1.524 8.095-5.83 8.095-10.908C27.694 9.148 22.39 4 15.846 4",
        fillRule: "evenodd"
    }));
}
GitHub.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    hoverColor: PropTypes.string,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$s = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "66ac3d-Hamburger",
    styles: "display:block;label:Hamburger;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhhbWJ1cmdlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJoYW1idXJnZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIEhhbWJ1cmdlcih7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yNiAyMmExIDEgMCAwMTAgMkg2YTEgMSAwIDAxMC0yaDIwem0wLTdhMSAxIDAgMDEwIDJINmExIDEgMCAwMTAtMmgyMHptMC03YTEgMSAwIDAxMCAySDZhMSAxIDAgMTEwLTJoMjB6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuSGFtYnVyZ2VyLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgSGFtYnVyZ2VyO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
};
function Hamburger(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$s,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M26 22a1 1 0 010 2H6a1 1 0 010-2h20zm0-7a1 1 0 010 2H6a1 1 0 010-2h20zm0-7a1 1 0 010 2H6a1 1 0 110-2h20z",
        fill: primaryColor
    }));
}
Hamburger.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$r = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1qbszsr-Home",
    styles: "display:block;label:Home;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhvbWUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiaG9tZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gSG9tZSh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yMyAyNC4xODJoLTR2LTVhMSAxIDAgMDAtMS0xaC00YTEgMSAwIDAwLTEgMXY1SDl2LTguNzY4bDctNyA3IDd2OC43Njh6bTMuNzA3LTcuODlsLTEwLTEwYTEgMSAwIDAwLTEuNDE0IDBsLTEwIDEwYS45OTkuOTk5IDAgMTAxLjQxNCAxLjQxNUw3IDE3LjQxNHY3Ljc2OGExIDEgMCAwMDEgMWg2YTEgMSAwIDAwMS0xdi01aDJ2NWExIDEgMCAwMDEgMWg2YTEgMSAwIDAwMS0xdi03Ljc2OGwuMjkzLjI5M0EuOTkzLjk5MyAwIDAwMjYgMThhLjk5OS45OTkgMCAwMC43MDctMS43MDd6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuSG9tZS5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEhvbWU7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
};
function Home(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$r,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M23 24.182h-4v-5a1 1 0 00-1-1h-4a1 1 0 00-1 1v5H9v-8.768l7-7 7 7v8.768zm3.707-7.89l-10-10a1 1 0 00-1.414 0l-10 10a.999.999 0 101.414 1.415L7 17.414v7.768a1 1 0 001 1h6a1 1 0 001-1v-5h2v5a1 1 0 001 1h6a1 1 0 001-1v-7.768l.293.293A.993.993 0 0026 18a.999.999 0 00.707-1.707z",
        fill: primaryColor,
        fillRule: "evenodd"
    }));
}
Home.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$q = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "yseh7s-InfoOrMinor",
    styles: "display:block;label:InfoOrMinor;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZm8tb3ItbWlub3IuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiaW5mby1vci1taW5vci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gSW5mb09yTWlub3IoeyBzaXplLCBwcmltYXJ5Q29sb3IsIHRlc3RJZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPHN2Z1xuICAgICAgY3NzPXt7XG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgIH19XG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIHZpZXdCb3g9XCIwIDAgMzIgMzJcIlxuICAgICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgICAgcm9sZT1cImltZ1wiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMTYgNmM1LjUyMiAwIDEwIDQuNDc3IDEwIDEwIDAgNS41MjItNC40NzggMTAtMTAgMTBTNiAyMS41MjIgNiAxNmMwLTUuNTIzIDQuNDc4LTEwIDEwLTEwem0wIDJjLTQuNDExIDAtOCAzLjU4OS04IDhzMy41ODkgOCA4IDggOC0zLjU4OSA4LTgtMy41ODktOC04LTh6bS4wNTcgNS41Yy41MjEgMCAuOTQzLjQyMi45NDMuOTQzdjYuMTE1YzAgLjUyLS40MjIuOTQyLS45NDMuOTQyaC0uMTE1YS45NDIuOTQyIDAgMDEtLjk0Mi0uOTQydi02LjExNWMwLS41MjEuNDIxLS45NDMuOTQyLS45NDN6TTE2IDEwYTEgMSAwIDExLS4xMTcuMDA3TDE2IDEwelwiXG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkluZm9Pck1pbm9yLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgSW5mb09yTWlub3I7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
};
function InfoOrMinor(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$q,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 6c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10S6 21.522 6 16c0-5.523 4.478-10 10-10zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm.057 5.5c.521 0 .943.422.943.943v6.115c0 .52-.422.942-.943.942h-.115a.942.942 0 01-.942-.942v-6.115c0-.521.421-.943.942-.943zM16 10a1 1 0 11-.117.007L16 10z",
        fillRule: "evenodd",
        fill: primaryColor
    }));
}
InfoOrMinor.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function Instagram(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, hoverColor = _ref.hoverColor, testId = _ref.testId;
    var theme = useTheme();
    return jsx("svg", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            fill: primaryColor,
            transition: hoverColor ? theme.transitions.icon : null,
            ":hover": _objectSpread2({}, hoverColor && {
                fill: hoverColor
            })
        }, process.env.NODE_ENV === "production" ? "" : ";label:Instagram;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M17.16 4c2.224.004 2.678.021 3.788.071 1.276.059 2.15.262 2.913.558a5.883 5.883 0 012.124 1.385 5.886 5.886 0 011.385 2.125c.297.763.5 1.636.558 2.913.054 1.195.07 1.63.072 4.333v1.23c-.002 2.702-.018 3.138-.072 4.332-.058 1.278-.261 2.151-.558 2.913a5.89 5.89 0 01-1.385 2.126 5.893 5.893 0 01-2.124 1.384c-.764.297-1.637.5-2.913.558-1.195.054-1.63.07-4.334.072h-1.228c-2.704-.002-3.14-.018-4.334-.072-1.277-.058-2.15-.261-2.913-.558a5.888 5.888 0 01-2.125-1.384A5.873 5.873 0 014.63 23.86c-.297-.762-.5-1.635-.558-2.913-.051-1.109-.068-1.563-.072-3.787v-2.321c.004-2.223.021-2.678.072-3.787.058-1.277.261-2.15.558-2.913a5.87 5.87 0 011.384-2.125 5.878 5.878 0 012.125-1.385c.764-.296 1.636-.499 2.913-.558 1.11-.05 1.564-.067 3.788-.071h2.32zm-.28 2.162h-1.76c-2.41.003-2.83.018-3.97.069-1.17.054-1.804.249-2.227.414-.56.217-.96.478-1.38.897-.42.42-.68.82-.898 1.38-.164.423-.36 1.058-.413 2.228-.052 1.14-.067 1.561-.07 3.97v1.76c.003 2.409.018 2.83.07 3.969.053 1.171.249 1.805.413 2.228.218.561.478.96.897 1.38.42.42.82.68 1.38.897.424.166 1.058.361 2.228.415 1.098.049 1.529.065 3.71.068h2.28c2.181-.003 2.612-.019 3.71-.068 1.168-.054 1.804-.249 2.227-.415.56-.217.96-.477 1.38-.897.42-.42.68-.819.897-1.38.164-.423.36-1.057.413-2.228.05-1.097.067-1.528.07-3.709v-2.28c-.003-2.181-.02-2.613-.07-3.71-.053-1.17-.249-1.805-.413-2.228a3.71 3.71 0 00-.897-1.38 3.72 3.72 0 00-1.38-.897c-.423-.165-1.059-.36-2.227-.414-1.14-.051-1.56-.066-3.97-.069zM16 9.837a6.162 6.162 0 110 12.325 6.162 6.162 0 010-12.325zM16 12a4 4 0 100 8 4 4 0 000-8zm6.405-3.846a1.44 1.44 0 110 2.881 1.44 1.44 0 010-2.881z",
        fillRule: "evenodd"
    }));
}
Instagram.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    hoverColor: PropTypes.string,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$p = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "rjuwvq-Link",
    styles: "display:block;label:Link;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoibGluay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gTGluayh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNy40NyAyMS45NjRsLS4wNjQuMDExYTYuODgyIDYuODgyIDAgMDEtLjI1OS4wNGMtLjAzLjAwNS0uMDYxLjAwOC0uMDkyLjAxMmE2LjQ3IDYuNDcgMCAwMS0uNTYxLjA0MmwtLjExMy4wMDJoLS4yMTdsLS4xMTUtLjAwM2E2LjgxMiA2LjgxMiAwIDAxLS4yMTktLjAxM2wtLjExLS4wMDhhNi43NCA2Ljc0IDAgMDEtLjIzOC0uMDI3bC0uMDg4LS4wMWE2LjM5NiA2LjM5NiAwIDAxLS4zMjYtLjA1NGwtMi4wODQgMi4wODRhMy41NzcgMy41NzcgMCAwMS01LjA1MyAwIDMuNTc3IDMuNTc3IDAgMDEwLTUuMDUybDQuNDQ5LTQuNDVhMy41NzcgMy41NzcgMCAwMTUuMDUyIDAgMy41NiAzLjU2IDAgMDExLjAzOCAyLjY4M2wxLjY3Ni0xLjY3NmE1LjQ1NyA1LjQ1NyAwIDAwLTkuMDk5LTIuMzM5TDYuNiAxNy42NTZhNS40NTcgNS40NTcgMCAxMDcuNzE3IDcuNzE3bDMuNDc3LTMuNDc3YTYuMzU5IDYuMzU5IDAgMDEtLjMyMi4wNjhcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yNS40MDIgNi41OTlhNS40NTcgNS40NTcgMCAwMC03LjcxOCAwTDE0LjIgMTAuMDgzYTYuNDQ1IDYuNDQ1IDAgMDEyLjcyOC0uMDY0bDIuMDg4LTIuMDg4YTMuNTc3IDMuNTc3IDAgMDE1LjA1MyAwIDMuNTc3IDMuNTc3IDAgMDEwIDUuMDUzbC00LjQ0OSA0LjQ0OWEzLjU3NyAzLjU3NyAwIDAxLTUuMDUzIDAgMy41NTMgMy41NTMgMCAwMS0xLjAzNi0yLjY4NGwtMS42NzggMS42NzhhNS40NTcgNS40NTcgMCAwMDkuMSAyLjMzOGw0LjQ0OS00LjQ0OWE1LjQ1NyA1LjQ1NyAwIDAwMC03LjcxN1wiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkxpbmsucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMaW5rO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
};
function Link$1(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$p,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M17.47 21.964l-.064.011a6.882 6.882 0 01-.259.04c-.03.005-.061.008-.092.012a6.47 6.47 0 01-.561.042l-.113.002h-.217l-.115-.003a6.812 6.812 0 01-.219-.013l-.11-.008a6.74 6.74 0 01-.238-.027l-.088-.01a6.396 6.396 0 01-.326-.054l-2.084 2.084a3.577 3.577 0 01-5.053 0 3.577 3.577 0 010-5.052l4.449-4.45a3.577 3.577 0 015.052 0 3.56 3.56 0 011.038 2.683l1.676-1.676a5.457 5.457 0 00-9.099-2.339L6.6 17.656a5.457 5.457 0 107.717 7.717l3.477-3.477a6.359 6.359 0 01-.322.068",
        fill: primaryColor
    }), jsx("path", {
        d: "M25.402 6.599a5.457 5.457 0 00-7.718 0L14.2 10.083a6.445 6.445 0 012.728-.064l2.088-2.088a3.577 3.577 0 015.053 0 3.577 3.577 0 010 5.053l-4.449 4.449a3.577 3.577 0 01-5.053 0 3.553 3.553 0 01-1.036-2.684l-1.678 1.678a5.457 5.457 0 009.1 2.338l4.449-4.449a5.457 5.457 0 000-7.717",
        fill: primaryColor
    }));
}
Link$1.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function LinkedIn(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, hoverColor = _ref.hoverColor, testId = _ref.testId;
    var theme = useTheme();
    return jsx("svg", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            fill: primaryColor,
            transition: hoverColor ? theme.transitions.icon : null,
            ":hover": _objectSpread2({}, hoverColor && {
                fill: hoverColor
            })
        }, process.env.NODE_ENV === "production" ? "" : ";label:LinkedIn;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M21.6610422,10.8859127 C24.7727047,10.8859127 27,12.7847222 27,16.7132937 L27,26 L22.4799007,26 L22.4799007,18.3013784 C22.4799007,16.1894841 21.677132,15.0109127 20.0066606,15.0109127 C18.1890819,15.0109127 17.239206,16.2388784 17.239206,18.3013784 L17.239206,26 L12.8828784,26 L12.8828784,11.3333333 L17.239206,11.3333333 L17.239206,13.3085317 C17.239206,13.3085317 18.5493797,10.8859127 21.6610422,10.8859127 Z M9.97866005,11.3333333 L9.97866005,26 L5.43672457,26 L5.43672457,11.3333333 L9.97866005,11.3333333 Z M7.68585608,4 C9.16957033,4 10.3717122,5.21188388 10.3717122,6.70634921 C10.3717122,8.20081454 9.16957033,9.41269841 7.68585608,9.41269841 C6.20271647,9.41269841 5,8.20081454 5,6.70634921 C5,5.21188388 6.20271647,4 7.68585608,4 Z",
        fillRule: "evenodd"
    }));
}
LinkedIn.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    hoverColor: PropTypes.string,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$o = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "zs6e2b-LockSmall",
    styles: "display:block;label:LockSmall;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvY2stc21hbGwuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoibG9jay1zbWFsbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gTG9ja1NtYWxsKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE2IDEzYTEgMSAwIDAwLTEgMXYxaDJ2LTFhMSAxIDAgMDAtMS0xem0zIDJoLjJjLjQ0MiAwIC44LjMzNi44Ljc1djQuNWMwIC40MTQtLjM1OC43NS0uOC43NWgtNi40Yy0uNDQyIDAtLjgtLjMzNi0uOC0uNzV2LTQuNWMwLS40MTQuMzU4LS43NS44LS43NWguMnYtMWEzIDMgMCAwMTYgMHYxelwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkxvY2tTbWFsbC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IExvY2tTbWFsbDtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
};
function LockSmall(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$o,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 13a1 1 0 00-1 1v1h2v-1a1 1 0 00-1-1zm3 2h.2c.442 0 .8.336.8.75v4.5c0 .414-.358.75-.8.75h-6.4c-.442 0-.8-.336-.8-.75v-4.5c0-.414.358-.75.8-.75h.2v-1a3 3 0 016 0v1z",
        fill: primaryColor
    }));
}
LockSmall.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$n = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1pvhyh6-Lock",
    styles: "display:block;label:Lock;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvY2suanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoibG9jay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gTG9jayh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiAzYTcgNyAwIDAxNyA3djNoMWEyIDIgMCAwMTIgMnYxMmEyIDIgMCAwMS0yIDJIOGEyIDIgMCAwMS0yLTJWMTVhMiAyIDAgMDEyLTJoMXYtM2E3IDcgMCAwMTctN3ptOCAxMkg4djEyaDE2VjE1em0tOCAzYTIgMiAwIDAxMS4wMDEgMy43MzJMMTcgMjRoLTJ2LTIuMjY4QTIgMiAwIDAxMTYgMTh6bTAtMTNhNSA1IDAgMDAtNSA1djNoMTB2LTNhNSA1IDAgMDAtNS01elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkxvY2sucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMb2NrO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
};
function Lock(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$n,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 3a7 7 0 017 7v3h1a2 2 0 012 2v12a2 2 0 01-2 2H8a2 2 0 01-2-2V15a2 2 0 012-2h1v-3a7 7 0 017-7zm8 12H8v12h16V15zm-8 3a2 2 0 011.001 3.732L17 24h-2v-2.268A2 2 0 0116 18zm0-13a5 5 0 00-5 5v3h10v-3a5 5 0 00-5-5z",
        fill: primaryColor
    }));
}
Lock.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$m = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "7t407e-Logout",
    styles: "display:block;label:Logout;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvZ291dC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJsb2dvdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIExvZ291dCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xOCAxMlY4SDcuMDI3djE2SDE4di00XCJcbiAgICAgICAgZmlsbD1cIm5vbmVcIlxuICAgICAgICBzdHJva2U9e3ByaW1hcnlDb2xvcn1cbiAgICAgICAgc3Ryb2tlV2lkdGg9XCIyXCJcbiAgICAgICAgc3Ryb2tlTGluZWNhcD1cInJvdW5kXCJcbiAgICAgICAgc3Ryb2tlTGluZWpvaW49XCJyb3VuZFwiXG4gICAgICAvPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xMiAxN2ExIDEgMCAwMTAtMmgxMC42OTZsLTEuMjUxLTEuMjkzYTEuMDIzIDEuMDIzIDAgMDEwLTEuNDE0Ljk0NS45NDUgMCAwMTEuMzY4IDBsMi45MDMgM2ExLjAyMyAxLjAyMyAwIDAxMCAxLjQxNGwtMi45MDMgM2EuOTUuOTUgMCAwMS0uNjg0LjI5My45NS45NSAwIDAxLS42ODQtLjI5MyAxLjAyMyAxLjAyMyAwIDAxMC0xLjQxNEwyMi42OTUgMTdIMTJ6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuTG9nb3V0LnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTG9nb3V0O1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
};
function Logout(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$m,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M18 12V8H7.027v16H18v-4",
        fill: "none",
        stroke: primaryColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), jsx("path", {
        d: "M12 17a1 1 0 010-2h10.696l-1.251-1.293a1.023 1.023 0 010-1.414.945.945 0 011.368 0l2.903 3a1.023 1.023 0 010 1.414l-2.903 3a.95.95 0 01-.684.293.95.95 0 01-.684-.293 1.023 1.023 0 010-1.414L22.695 17H12z",
        fill: primaryColor
    }));
}
Logout.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$l = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "dz5952-Mail",
    styles: "display:block;label:Mail;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1haWwuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoibWFpbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gTWFpbCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yNiA4YTEgMSAwIDAxMSAxdjE0YTEgMSAwIDAxLTEgMUg2YTEgMSAwIDAxLTEtMVY5YTEgMSAwIDAxMS0xaDIwem0tMSAzLjA3OWwtOSA3LjIwMi05LTcuMjAxVjIyaDE4VjExLjA3OXpNMjMuMTQ5IDEwSDguODVMMTYgMTUuNzIgMjMuMTQ5IDEwelwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbk1haWwucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBNYWlsO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
};
function Mail(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$l,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M26 8a1 1 0 011 1v14a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1h20zm-1 3.079l-9 7.202-9-7.201V22h18V11.079zM23.149 10H8.85L16 15.72 23.149 10z",
        fill: primaryColor
    }));
}
Mail.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$k = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1q8a4n5-Message",
    styles: "display:block;label:Message;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1lc3NhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoibWVzc2FnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gTWVzc2FnZSh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk02IDhhMiAyIDAgMDEyLTJoMTZhMiAyIDAgMDEyIDJ2MTJhMiAyIDAgMDEtMiAySDExbC0yLjQgMy4yQTIgMiAwIDAxNyAyNmExIDEgMCAwMS0xLTFWOHpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5NZXNzYWdlLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTWVzc2FnZTtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
};
function Message$1(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$k,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M6 8a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H11l-2.4 3.2A2 2 0 017 26a1 1 0 01-1-1V8z",
        fill: primaryColor
    }));
}
Message$1.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$j = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "fvg3xo-NotificationNew",
    styles: "display:block;label:NotificationNew;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vdGlmaWNhdGlvbi1uZXcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoibm90aWZpY2F0aW9uLW5ldy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gTm90aWZpY2F0aW9uTmV3KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCBzZWNvbmRhcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xOCAyNC41YTIgMiAwIDAxLTQgMHpNMTYgNmExLjUgMS41IDAgMDExLjUgMS41djEuMjAyYzIuNjE5LjcwNyA0LjUgMy4yMiA0LjUgNi4wNDlWMjAuNWExIDEgMCAwMDEgMSAxIDEgMCAxMTAgMkg5YTEgMSAwIDExMC0yIDEgMSAwIDAwMS0xdi02YTUuOTk4IDUuOTk4IDAgMDE0LjUtNS44MDVWNy41QTEuNSAxLjUgMCAwMTE2IDZ6bTAgNC41YTQgNCAwIDAwLTQgNHY3aDh2LTdhNCA0IDAgMDAtNC00elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgICA8cGF0aCBkPVwiTTI0IDEyLjVhMyAzIDAgMTEtNiAwIDMgMyAwIDAxNiAwXCIgZmlsbD17c2Vjb25kYXJ5Q29sb3J9IC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbk5vdGlmaWNhdGlvbk5ldy5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHNlY29uZGFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE5vdGlmaWNhdGlvbk5ldztcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
};
function NotificationNew(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$j,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M18 24.5a2 2 0 01-4 0zM16 6a1.5 1.5 0 011.5 1.5v1.202c2.619.707 4.5 3.22 4.5 6.049V20.5a1 1 0 001 1 1 1 0 110 2H9a1 1 0 110-2 1 1 0 001-1v-6a5.998 5.998 0 014.5-5.805V7.5A1.5 1.5 0 0116 6zm0 4.5a4 4 0 00-4 4v7h8v-7a4 4 0 00-4-4z",
        fill: primaryColor
    }), jsx("path", {
        d: "M24 12.5a3 3 0 11-6 0 3 3 0 016 0",
        fill: secondaryColor
    }));
}
NotificationNew.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    secondaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$i = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "5dqfdc-Notification",
    styles: "display:block;label:Notification;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vdGlmaWNhdGlvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJub3RpZmljYXRpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIE5vdGlmaWNhdGlvbih7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xOCAyNC41YTIgMiAwIDAxLTQgMHpNMTYgNmExLjUgMS41IDAgMDExLjUgMS41djEuMjAyYzIuNjE5LjcwNyA0LjUgMy4yMiA0LjUgNi4wNDlWMjAuNWExIDEgMCAwMDEgMSAxIDEgMCAxMTAgMkg5YTEgMSAwIDExMC0yIDEgMSAwIDAwMS0xdi02YTUuOTk4IDUuOTk4IDAgMDE0LjUtNS44MDVWNy41QTEuNSAxLjUgMCAwMTE2IDZ6bTAgNC41YTQgNCAwIDAwLTQgNHY3aDh2LTdhNCA0IDAgMDAtNC00elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbk5vdGlmaWNhdGlvbi5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE5vdGlmaWNhdGlvbjtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
};
function Notification(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$i,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M18 24.5a2 2 0 01-4 0zM16 6a1.5 1.5 0 011.5 1.5v1.202c2.619.707 4.5 3.22 4.5 6.049V20.5a1 1 0 001 1 1 1 0 110 2H9a1 1 0 110-2 1 1 0 001-1v-6a5.998 5.998 0 014.5-5.805V7.5A1.5 1.5 0 0116 6zm0 4.5a4 4 0 00-4 4v7h8v-7a4 4 0 00-4-4z",
        fill: primaryColor
    }));
}
Notification.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$h = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "8dnzqg-OverflowMenu",
    styles: "display:block;label:OverflowMenu;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm92ZXJmbG93LW1lbnUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoib3ZlcmZsb3ctbWVudS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gT3ZlcmZsb3dNZW51KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE2IDIzYTIgMiAwIDExMCA0IDIgMiAwIDAxMC00em0wLTlhMiAyIDAgMTEwIDQgMiAyIDAgMDEwLTR6bTAtOWEyIDIgMCAxMTAgNCAyIDIgMCAwMTAtNHpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5PdmVyZmxvd01lbnUucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBPdmVyZmxvd01lbnU7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
function OverflowMenu(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$h,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 23a2 2 0 110 4 2 2 0 010-4zm0-9a2 2 0 110 4 2 2 0 010-4zm0-9a2 2 0 110 4 2 2 0 010-4z",
        fill: primaryColor
    }));
}
OverflowMenu.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$g = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1iwpsxk-Payment",
    styles: "display:block;label:Payment;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
};
function Payment(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$g,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M9.95 5.642a11.99 11.99 0 0113.393.866l-.015-.631a1 1 0 01.977-1.023c.52-.046 1.01.424 1.023.977l.07 3.006c.006.308-.127.59-.346.779l-.024.02a1.031 1.031 0 01-.666.24l-2.992.43a1.002 1.002 0 01-1.133-.846 1.001 1.001 0 01.848-1.133l1.13-.162a9.987 9.987 0 00-11.257-.796 9.988 9.988 0 00-4.34 12.086 9.99 9.99 0 0011.137 6.393 9.989 9.989 0 008.247-9.844 1 1 0 012 0 11.987 11.987 0 01-9.896 11.813 11.983 11.983 0 01-13.365-7.672A11.987 11.987 0 019.95 5.642zm6.081 1.861a1 1 0 011 1v1.1c.99.2 1.618.677 1.99 1.095 1.151 1.29.984 3.07.96 3.27a.992.992 0 01-1.107.88 1 1 0 01-.88-1.103c.03-.3.005-1.196-.472-1.723-.315-.349-.803-.519-1.492-.519-1.843 0-2.012 1.314-2.02 1.717.007.407.172 1.783 1.992 1.783 1.197 0 2.166.363 2.88 1.08 1.085 1.087 1.112 2.552 1.111 2.715v.027c-.003.245-.07 1.572-1.085 2.59-.498.498-1.132.816-1.877.972v1.116a1 1 0 11-2 0v-1.089c-1.022-.193-1.669-.679-2.049-1.105-1.15-1.29-.983-3.07-.96-3.27a1 1 0 011.988.224c-.03.303-.004 1.196.471 1.722.315.35.803.518 1.492.518 1.843 0 2.012-1.313 2.02-1.715-.007-.408-.172-1.785-1.99-1.785-1.198 0-2.168-.363-2.88-1.078-1.086-1.088-1.113-2.553-1.113-2.716v-.027c.005-.245.072-1.573 1.086-2.59.51-.513 1.164-.838 1.935-.988v-1.1a1 1 0 011-1z",
        fill: primaryColor,
        fillRule: "nonzero"
    }));
}
Payment.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$f = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1omd7bt-Person",
    styles: "display:block;label:Person;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBlcnNvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJwZXJzb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIFBlcnNvbih7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xOSAxOWE2IDYgMCAwMTYgNnYxaC0ydi0xYTQgNCAwIDAwLTQtNGgtNmE0IDQgMCAwMC00IDR2MUg3di0xYTYgNiAwIDAxNi02aDZ6TTE2IDZhNiA2IDAgMTEwIDEyIDYgNiAwIDAxMC0xMnptMCAyYTQgNCAwIDEwMCA4IDQgNCAwIDAwMC04elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblBlcnNvbi5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFBlcnNvbjtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
};
function Person(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$f,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M19 19a6 6 0 016 6v1h-2v-1a4 4 0 00-4-4h-6a4 4 0 00-4 4v1H7v-1a6 6 0 016-6h6zM16 6a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8z",
        fill: primaryColor
    }));
}
Person.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$e = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "afzs7b-Question",
    styles: "display:block;label:Question;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInF1ZXN0aW9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6InF1ZXN0aW9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBRdWVzdGlvbih7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiA4Yy00LjQxMSAwLTggMy41ODktOCA4czMuNTg5IDggOCA4IDgtMy41ODkgOC04LTMuNTg5LTgtOC04bTAgMThjLTUuNTE0IDAtMTAtNC40ODYtMTAtMTBTMTAuNDg2IDYgMTYgNnMxMCA0LjQ4NiAxMCAxMC00LjQ4NiAxMC0xMCAxMG0wLTMuOTRjLS4xMyAwLS4yNi0uMDMtLjM4LS4wOC0uMTMtLjA1LS4yMy0uMTItLjMzLS4yMS0uMTgxLS4xOS0uMjktLjQ1LS4yOS0uNzEgMC0uMjcuMTA5LS41Mi4yOS0uNzEuMS0uMDkuMi0uMTYuMzMtLjIxLjM1OS0uMTYuODEtLjA3IDEuMDkuMjEuMTguMTkuMjkuNDUuMjkuNzEgMCAuMjYtLjExLjUyLS4yOS43MS0uMTkuMTgtLjQ1LjI5LS43MS4yOW0tLjEwNy0zLjA3YTEgMSAwIDAxLTEtMXYtLjY3NWMwLS4xMDguMDE4LS4yMTMuMDQ5LS4zMS4xOTMtLjk4NC45MjItMS42OTUgMS41MjMtMi4yODIuNjU1LS42MzkgMS4wNTItMS4wNjIgMS4wNTItMS41NDggMC0uNDU2LS41Ni0uOTQtMS41OTYtLjk0LTEuMDk0IDAtMS41NS43OTgtMS41NTQuODA3YTEgMSAwIDExLTEuNzY2LS45MzljLjM2OC0uNjk0IDEuNDgyLTEuODY5IDMuMzItMS44NjkgMi4zMzYgMCAzLjU5NiAxLjUxNSAzLjU5NiAyLjk0MSAwIDEuMzY0LS45MTcgMi4yNi0xLjY1NCAyLjk4LS41LjQ4Ni0uOTcuOTQ2LS45NyAxLjM1N3YuNDc3YTEgMSAwIDAxLTEgMVwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblF1ZXN0aW9uLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgUXVlc3Rpb247XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
};
function Question(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$e,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 8c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 18c-5.514 0-10-4.486-10-10S10.486 6 16 6s10 4.486 10 10-4.486 10-10 10m0-3.94c-.13 0-.26-.03-.38-.08-.13-.05-.23-.12-.33-.21-.181-.19-.29-.45-.29-.71 0-.27.109-.52.29-.71.1-.09.2-.16.33-.21.359-.16.81-.07 1.09.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29m-.107-3.07a1 1 0 01-1-1v-.675c0-.108.018-.213.049-.31.193-.984.922-1.695 1.523-2.282.655-.639 1.052-1.062 1.052-1.548 0-.456-.56-.94-1.596-.94-1.094 0-1.55.798-1.554.807a1 1 0 11-1.766-.939c.368-.694 1.482-1.869 3.32-1.869 2.336 0 3.596 1.515 3.596 2.941 0 1.364-.917 2.26-1.654 2.98-.5.486-.97.946-.97 1.357v.477a1 1 0 01-1 1",
        fill: primaryColor
    }));
}
Question.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$d = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "5du6w6-Search",
    styles: "display:block;label:Search;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNlYXJjaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJzZWFyY2guanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIFNlYXJjaCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xOC4yNDMgMTguMjQzYTYgNiAwIDEwLTguNDg1LTguNDg1IDYgNiAwIDAwOC40ODUgOC40ODV6bTYuOTY0IDUuNTVjLjk0My45NDMtLjQ3MSAyLjM1Ny0xLjQxNCAxLjQxNGwtNC44ODctNC44ODdhOCA4IDAgMTExLjQxNC0xLjQxNGw0Ljg4NyA0Ljg4N3pcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5TZWFyY2gucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBTZWFyY2g7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
};
function Search(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$d,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M18.243 18.243a6 6 0 10-8.485-8.485 6 6 0 008.485 8.485zm6.964 5.55c.943.943-.471 2.357-1.414 1.414l-4.887-4.887a8 8 0 111.414-1.414l4.887 4.887z",
        fill: primaryColor
    }));
}
Search.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function SelectObject(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, hoverColor = _ref.hoverColor, testId = _ref.testId;
    var theme = useTheme();
    return jsx("svg", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            fill: primaryColor,
            transition: hoverColor ? theme.transitions.icon : null,
            ":hover": _objectSpread2({}, hoverColor && {
                fill: hoverColor
            })
        }, process.env.NODE_ENV === "production" ? "" : ";label:SelectObject;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNlbGVjdC1vYmplY3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU00iLCJmaWxlIjoic2VsZWN0LW9iamVjdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCB1c2VUaGVtZSBmcm9tIFwiLi4vaG9va3MvdXNlVGhlbWVcIjtcblxuZnVuY3Rpb24gU2VsZWN0T2JqZWN0KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCBob3ZlckNvbG9yLCB0ZXN0SWQgfSkge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgICBmaWxsOiBwcmltYXJ5Q29sb3IsXG4gICAgICAgIHRyYW5zaXRpb246IGhvdmVyQ29sb3IgPyB0aGVtZS50cmFuc2l0aW9ucy5pY29uIDogbnVsbCxcbiAgICAgICAgXCI6aG92ZXJcIjoge1xuICAgICAgICAgIC4uLihob3ZlckNvbG9yICYmIHsgZmlsbDogaG92ZXJDb2xvciB9KSxcbiAgICAgICAgfSxcbiAgICAgIH19XG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIHZpZXdCb3g9XCIwIDAgMzIgMzJcIlxuICAgICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgICAgcm9sZT1cImltZ1wiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoIGQ9XCJNMTQgMTRsMTQgMy41LTUuMiAzLjUgNC44NiA0LjkzYS40OS40OSAwIDAxMCAuN2wtMSAxYS41LjUgMCAwMS0uNyAwTDIxIDIyLjc3IDE3LjUgMjh6XCIgLz5cbiAgICAgIDxwYXRoIGQ9XCJNMTIgMjZINmEyIDIgMCAwMS0yLTJWNmEyIDIgMCAwMTItMmgxOGEyIDIgMCAwMTIgMnY2YTEgMSAwIDAxLTIgMFY2SDZ2MThoNmExIDEgMCAwMTAgMnpcIiAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5TZWxlY3RPYmplY3QucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBob3ZlckNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBTZWxlY3RPYmplY3Q7XG4iXX0= */"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M14 14l14 3.5-5.2 3.5 4.86 4.93a.49.49 0 010 .7l-1 1a.5.5 0 01-.7 0L21 22.77 17.5 28z"
    }), jsx("path", {
        d: "M12 26H6a2 2 0 01-2-2V6a2 2 0 012-2h18a2 2 0 012 2v6a1 1 0 01-2 0V6H6v18h6a1 1 0 010 2z"
    }));
}
SelectObject.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    hoverColor: PropTypes.string,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$c = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "b2j62p-Shield",
    styles: "display:block;label:Shield;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNoaWVsZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJzaGllbGQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIFNoaWVsZCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yNS45OTkgOC4wMjdhMiAyIDAgMDAtMi4yNTUtMS45ODIgOS40MzkgOS40MzkgMCAwMS02LjU3Ni0xLjY2OCAyIDIgMCAwMC0yLjMzNiAwIDkuNDE2IDkuNDE2IDAgMDEtNi41NzggMS42NjggMS45NjcgMS45NjcgMCAwMC0xLjU3NS40ODJBMS45OTYgMS45OTYgMCAwMDYgOC4wMjd2Ni40M2MwIDguMDY2IDcuMDQ1IDExLjc0OCA5LjIwNCAxMi42ODRhMS45ODkgMS45ODkgMCAwMDEuNTkyIDBDMTguOTU1IDI2LjIwNyAyNiAyMi41MjQgMjYgMTQuNDU5bC0uMDAxLTYuNDN6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuU2hpZWxkLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU2hpZWxkO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
};
function Shield(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$c,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M25.999 8.027a2 2 0 00-2.255-1.982 9.439 9.439 0 01-6.576-1.668 2 2 0 00-2.336 0 9.416 9.416 0 01-6.578 1.668 1.967 1.967 0 00-1.575.482A1.996 1.996 0 006 8.027v6.43c0 8.066 7.045 11.748 9.204 12.684a1.989 1.989 0 001.592 0C18.955 26.207 26 22.524 26 14.459l-.001-6.43z",
        fill: primaryColor
    }));
}
Shield.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$b = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "4s0so5-Stop",
    styles: "display:block;label:Stop;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0b3AuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoic3RvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gU3RvcCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yMC4zMTEgNmw1LjkyOCA1LjkyOHY4LjM4M2wtNS45MjggNS45MjhoLTguMzgzTDYgMjAuMzExdi04LjM4M0wxMS45MyA2aDguMzgyem0tLjgyOCAyaC02LjcyN0w4IDEyLjc1NnY2LjcyN2w0Ljc1NyA0Ljc1Nmg2LjcyN2w0Ljc1Ni00Ljc1NnYtNi43MjdMMTkuNDgzIDh6bS43NTYgNy4yMzlhMSAxIDAgMDExIDFsLS4wMDcuMTE2YTEgMSAwIDAxLS45OTMuODg0aC04YTEgMSAwIDExMC0yelwiXG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblN0b3AucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBTdG9wO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};
function Stop(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$b,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M20.311 6l5.928 5.928v8.383l-5.928 5.928h-8.383L6 20.311v-8.383L11.93 6h8.382zm-.828 2h-6.727L8 12.756v6.727l4.757 4.756h6.727l4.756-4.756v-6.727L19.483 8zm.756 7.239a1 1 0 011 1l-.007.116a1 1 0 01-.993.884h-8a1 1 0 110-2z",
        fillRule: "evenodd",
        fill: primaryColor
    }));
}
Stop.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$a = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "p80o4h-StopwatchAlt",
    styles: "display:block;label:StopwatchAlt;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0b3B3YXRjaC1hbHQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoic3RvcHdhdGNoLWFsdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gU3RvcHdhdGNoQWx0KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE2IDZjNS41MjMgMCAxMCA0LjQ3NyAxMCAxMCAwIDUuNTIyLTQuNDc3IDEwLTEwIDEwLTUuNTIyIDAtMTAtNC40NzgtMTAtMTAgMC01LjUyMyA0LjQ3OC0xMCAxMC0xMHptMCAyYy00LjQxMSAwLTggMy41ODgtOCA4IDAgNC40MTEgMy41ODkgOCA4IDhzOC0zLjU4OSA4LThjMC00LjQxMi0zLjU4OS04LTgtOHptMCAyYTEgMSAwIDAxLjk5My44ODNMMTcgMTF2NC41ODZsMy4yNDMgMy4yNDJhLjk5OS45OTkgMCAwMS0xLjMxMiAxLjUwNGwtLjEwMi0uMDktMy41MzUtMy41MzRhLjk5Ljk5IDAgMDEtLjI4NS0uNTc4TDE1IDE2di01YTEgMSAwIDAxMS0xem0zLThhMSAxIDAgMTEwIDJoLTZhMSAxIDAgMTEwLTJ6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuU3RvcHdhdGNoQWx0LnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU3RvcHdhdGNoQWx0O1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
};
function StopwatchAlt(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$a,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 6c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10-5.522 0-10-4.478-10-10 0-5.523 4.478-10 10-10zm0 2c-4.411 0-8 3.588-8 8 0 4.411 3.589 8 8 8s8-3.589 8-8c0-4.412-3.589-8-8-8zm0 2a1 1 0 01.993.883L17 11v4.586l3.243 3.242a.999.999 0 01-1.312 1.504l-.102-.09-3.535-3.534a.99.99 0 01-.285-.578L15 16v-5a1 1 0 011-1zm3-8a1 1 0 110 2h-6a1 1 0 110-2z",
        fill: primaryColor
    }));
}
StopwatchAlt.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$9 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1pxqjbu-Stopwatch",
    styles: "display:block;label:Stopwatch;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0b3B3YXRjaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiJzdG9wd2F0Y2guanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIFN0b3B3YXRjaCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiAyNGMtNC40MTEgMC04LTMuNTg5LTgtOCAwLTQuNDEyIDMuNTg5LTggOC04czggMy41ODggOCA4YzAgNC40MTEtMy41ODkgOC04IDhtMC0xOEMxMC40NzggNiA2IDEwLjQ3NyA2IDE2YzAgNS41MjIgNC40NzggMTAgMTAgMTBzMTAtNC40NzggMTAtMTBjMC01LjUyMy00LjQ3OC0xMC0xMC0xMG0xMC43MDcgMi4yOTNsLTQtNGEuOTk5Ljk5OSAwIDEwLTEuNDE0IDEuNDE0bDQgNGEuOTk3Ljk5NyAwIDAwMS40MTQgMCAuOTk5Ljk5OSAwIDAwMC0xLjQxNE0xNyAxNS41ODZWMTFhMSAxIDAgMTAtMiAwdjVjMCAuMTMuMDI2LjI2LjA3Ny4zODJhLjk5Ljk5IDAgMDAuMjE3LjMyNmwzLjUzNCAzLjUzNGEuOTkzLjk5MyAwIDAwLjcwNy4yOTMuOTk5Ljk5OSAwIDAwLjcwNy0xLjcwN0wxNyAxNS41ODZ6TTYuNzA3IDkuNzA3bDQtNGEuOTk5Ljk5OSAwIDEwLTEuNDE0LTEuNDE0bC00IDRhLjk5OS45OTkgMCAxMDEuNDE0IDEuNDE0XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuU3RvcHdhdGNoLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU3RvcHdhdGNoO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
};
function Stopwatch(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$9,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 24c-4.411 0-8-3.589-8-8 0-4.412 3.589-8 8-8s8 3.588 8 8c0 4.411-3.589 8-8 8m0-18C10.478 6 6 10.477 6 16c0 5.522 4.478 10 10 10s10-4.478 10-10c0-5.523-4.478-10-10-10m10.707 2.293l-4-4a.999.999 0 10-1.414 1.414l4 4a.997.997 0 001.414 0 .999.999 0 000-1.414M17 15.586V11a1 1 0 10-2 0v5c0 .13.026.26.077.382a.99.99 0 00.217.326l3.534 3.534a.993.993 0 00.707.293.999.999 0 00.707-1.707L17 15.586zM6.707 9.707l4-4a.999.999 0 10-1.414-1.414l-4 4a.999.999 0 101.414 1.414",
        fill: primaryColor
    }));
}
Stopwatch.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$8 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "2pytby-Success",
    styles: "display:block;label:Success;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN1Y2Nlc3MuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoic3VjY2Vzcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gU3VjY2Vzcyh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiA2YzUuNTIyIDAgMTAgNC40NzcgMTAgMTAgMCA1LjUyMi00LjQ3OCAxMC0xMCAxMFM2IDIxLjUyMiA2IDE2YzAtNS41MjMgNC40NzgtMTAgMTAtMTB6bTAgMmMtNC40MTEgMC04IDMuNTg5LTggOHMzLjU4OSA4IDggOCA4LTMuNTg5IDgtOC0zLjU4OS04LTgtOHptNC42NzQgMy44OWEuOTE1LjkxNSAwIDAxLjA5IDEuMzE0TDE0LjMzIDIwLjM0YS45NjkuOTY5IDAgMDEtMS40NDQtLjAwOWwtMS42NTgtMi4wM2EuOTE3LjkxNyAwIDAxLjEwNy0xLjMxNC45Ny45NyAwIDAxMS4zNDQuMTA1bC45NDIgMS4yMDkgNS43MDgtNi4zMjRhLjk2OC45NjggMCAwMTEuMzQ1LS4wODh6XCJcbiAgICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuU3VjY2Vzcy5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFN1Y2Nlc3M7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
};
function Success(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$8,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 6c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10S6 21.522 6 16c0-5.523 4.478-10 10-10zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm4.674 3.89a.915.915 0 01.09 1.314L14.33 20.34a.969.969 0 01-1.444-.009l-1.658-2.03a.917.917 0 01.107-1.314.97.97 0 011.344.105l.942 1.209 5.708-6.324a.968.968 0 011.345-.088z",
        fillRule: "evenodd",
        fill: primaryColor
    }));
}
Success.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$7 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1psyken-TickSmall",
    styles: "display:block;label:TickSmall;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRpY2stc21hbGwuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoidGljay1zbWFsbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gVGlja1NtYWxsKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTEzLjc0OSAxOC4xMjlsNS45ODUtNi43ODdhMSAxIDAgMDExLjUwNSAxLjMxN2wtNi43NDcgNy42NThhMSAxIDAgMDEtMS41MTQtLjAxbC0xLjc0LTIuMTc4YTEgMSAwIDExMS41MjMtMS4yOThsLjk4OCAxLjI5OHpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5UaWNrU21hbGwucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBUaWNrU21hbGw7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
};
function TickSmall(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$7,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M13.749 18.129l5.985-6.787a1 1 0 011.505 1.317l-6.747 7.658a1 1 0 01-1.514-.01l-1.74-2.178a1 1 0 111.523-1.298l.988 1.298z",
        fill: primaryColor
    }));
}
TickSmall.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$6 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "159ivmp-Tick",
    styles: "display:block;label:Tick;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRpY2suanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoidGljay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gVGljayh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xMy41MSAyMC40N2w5LjczNy0xMS4xMjlhMSAxIDAgMDExLjUwNiAxLjMxOGwtMTAuNSAxMmExIDEgMCAwMS0xLjUxNC0uMDFsLTQuNS01LjI4QTEgMSAwIDAxOS43NiAxNi4wN2wzLjc0OSA0LjM5OXpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5UaWNrLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgVGljaztcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
};
function Tick(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$6,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M13.51 20.47l9.737-11.129a1 1 0 011.506 1.318l-10.5 12a1 1 0 01-1.514-.01l-4.5-5.28A1 1 0 019.76 16.07l3.749 4.399z",
        fill: primaryColor
    }));
}
Tick.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$5 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "gswqia-Time",
    styles: "display:block;label:Time;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRpbWUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoidGltZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gVGltZSh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0xNiAyNGMtNC40MTEgMC04LTMuNTg5LTgtOCAwLTQuNDEyIDMuNTg5LTggOC04czggMy41ODggOCA4YzAgNC40MTEtMy41ODkgOC04IDhtMC0xOEMxMC40NzggNiA2IDEwLjQ3NyA2IDE2YzAgNS41MjIgNC40NzggMTAgMTAgMTBzMTAtNC40NzggMTAtMTBjMC01LjUyMy00LjQ3OC0xMC0xMC0xMG0xIDkuNTg2VjExYTEgMSAwIDEwLTIgMHY1YzAgLjEzLjAyNi4yNi4wNzcuMzgyYS45OS45OSAwIDAwLjIxNy4zMjZsMy41MzQgMy41MzRhLjk5My45OTMgMCAwMC43MDcuMjkzLjk5OS45OTkgMCAwMC43MDctMS43MDdMMTcgMTUuNTg2elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblRpbWUucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBUaW1lO1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
function Time(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$5,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 24c-4.411 0-8-3.589-8-8 0-4.412 3.589-8 8-8s8 3.588 8 8c0 4.411-3.589 8-8 8m0-18C10.478 6 6 10.477 6 16c0 5.522 4.478 10 10 10s10-4.478 10-10c0-5.523-4.478-10-10-10m1 9.586V11a1 1 0 10-2 0v5c0 .13.026.26.077.382a.99.99 0 00.217.326l3.534 3.534a.993.993 0 00.707.293.999.999 0 00.707-1.707L17 15.586z",
        fill: primaryColor
    }));
}
Time.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$4 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1s7nlix-Trash",
    styles: "display:block;label:Trash;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRyYXNoLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6InRyYXNoLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBUcmFzaCh7IHNpemUsIHByaW1hcnlDb2xvciwgdGVzdElkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnXG4gICAgICBjc3M9e3tcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgfX1cbiAgICAgIHdpZHRoPXtzaXplfVxuICAgICAgaGVpZ2h0PXtzaXplfVxuICAgICAgdmlld0JveD1cIjAgMCAzMiAzMlwiXG4gICAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgICByb2xlPVwiaW1nXCJcbiAgICAgIGRhdGEtdGVzdGlkPXt0ZXN0SWR9XG4gICAgPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yMyAyNkg5VjEwaDJ2MTMuNDI4YTEgMSAwIDAwMiAwVjEwaDJ2MTMuNDI4YTEgMSAwIDAwMiAwVjEwaDJ2MTMuNDI4YTEgMSAwIDAwMiAwVjEwaDJ2MTZ6TTE0IDhoNFY2aC00djJ6bTEyIDBoLTZWNmEyIDIgMCAwMC0yLTJoLTRhMiAyIDAgMDAtMiAydjJINmExIDEgMCAwMDAgMmgxdjE2YTIgMiAwIDAwMiAyaDE0YTIgMiAwIDAwMi0yVjEwaDFhMSAxIDAgMTAwLTJ6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuVHJhc2gucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBUcmFzaDtcbiJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
};
function Trash(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$4,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M23 26H9V10h2v13.428a1 1 0 002 0V10h2v13.428a1 1 0 002 0V10h2v13.428a1 1 0 002 0V10h2v16zM14 8h4V6h-4v2zm12 0h-6V6a2 2 0 00-2-2h-4a2 2 0 00-2 2v2H6a1 1 0 000 2h1v16a2 2 0 002 2h14a2 2 0 002-2V10h1a1 1 0 100-2z",
        fill: primaryColor,
        fillRule: "evenodd"
    }));
}
Trash.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$3 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "1tkmnzl-TriangleDown",
    styles: "display:block;label:TriangleDown;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRyaWFuZ2xlLWRvd24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoidHJpYW5nbGUtZG93bi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gVHJpYW5nbGVEb3duKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIwLjc0NyAxNC41MDlsLTQuMTgxIDQuMjVhLjc4Ni43ODYgMCAwMS0xLjEzMiAwbC00LjE3OS00LjI0N2EuODg1Ljg4NSAwIDAxLS4yMzEtLjgyN2MuMDctLjMuMjg3LS41MzYuNTY5LS42Mi4yODItLjA4NCA4LjYwNy0uMTAxIDguOTEyLjAzNWEuODYuODYgMCAwMS40OTUuODAyLjg3NC44NzQgMCAwMS0uMjUzLjYwN3pcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5UcmlhbmdsZURvd24ucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBUcmlhbmdsZURvd247XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
};
function TriangleDown(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$3,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M20.747 14.509l-4.181 4.25a.786.786 0 01-1.132 0l-4.179-4.247a.885.885 0 01-.231-.827c.07-.3.287-.536.569-.62.282-.084 8.607-.101 8.912.035a.86.86 0 01.495.802.874.874 0 01-.253.607z",
        fill: primaryColor
    }));
}
TriangleDown.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$2 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "3ivgai-TriangleUp",
    styles: "display:block;label:TriangleUp;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRyaWFuZ2xlLXVwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6InRyaWFuZ2xlLXVwLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBUcmlhbmdsZVVwKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTExLjI1MyAxNy40OTFsNC4xODEtNC4yNWEuNzg2Ljc4NiAwIDAxMS4xMzIgMGw0LjE3OSA0LjI0N2EuODg1Ljg4NSAwIDAxLjIzMS44MjcuODM4LjgzOCAwIDAxLS41NjkuNjJjLS4yODIuMDg0LTguNjA3LjEwMS04LjkxMi0uMDM1YS44Ni44NiAwIDAxLS40OTUtLjgwMi44NzQuODc0IDAgMDEuMjUzLS42MDd6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuVHJpYW5nbGVVcC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFRyaWFuZ2xlVXA7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};
function TriangleUp(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$2,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M11.253 17.491l4.181-4.25a.786.786 0 011.132 0l4.179 4.247a.885.885 0 01.231.827.838.838 0 01-.569.62c-.282.084-8.607.101-8.912-.035a.86.86 0 01-.495-.802.874.874 0 01.253-.607z",
        fill: primaryColor
    }));
}
TriangleUp.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function Twitter(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, hoverColor = _ref.hoverColor, testId = _ref.testId;
    var theme = useTheme();
    return jsx("svg", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            fill: primaryColor,
            transition: hoverColor ? theme.transitions.icon : null,
            ":hover": _objectSpread2({}, hoverColor && {
                fill: hoverColor
            })
        }, process.env.NODE_ENV === "production" ? "" : ";label:Twitter;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M4 16c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12S22.628 4 16 4C9.373 4 4 9.372 4 16zm12.246-2.238a2.894 2.894 0 012.892-2.892 2.88 2.88 0 012.112.912 5.872 5.872 0 001.836-.701 2.889 2.889 0 01-1.272 1.601 5.872 5.872 0 001.662-.456 5.931 5.931 0 01-1.446 1.501c.006.119.006.245.006.371 0 3.823-2.91 8.232-8.232 8.232a8.06 8.06 0 01-4.422-1.308 5.816 5.816 0 004.284-1.194 2.889 2.889 0 01-2.7-2.01 2.843 2.843 0 001.308-.048 2.897 2.897 0 01-2.322-2.838v-.036c.39.216.834.348 1.308.36a2.88 2.88 0 01-1.29-2.406c0-.528.144-1.026.39-1.452a8.208 8.208 0 005.964 3.024 2.651 2.651 0 01-.078-.66z",
        fillRule: "evenodd"
    }));
}
Twitter.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    hoverColor: PropTypes.string,
    testId: PropTypes.string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$1 = process.env.NODE_ENV === "production" ? {
    name: "4zleql",
    styles: "display:block"
} : {
    name: "12rd995-WarningOrSignificant",
    styles: "display:block;label:WarningOrSignificant;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndhcm5pbmctb3Itc2lnbmlmaWNhbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoid2FybmluZy1vci1zaWduaWZpY2FudC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gV2FybmluZ09yU2lnbmlmaWNhbnQoeyBzaXplLCBwcmltYXJ5Q29sb3IsIHRlc3RJZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPHN2Z1xuICAgICAgY3NzPXt7XG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgIH19XG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIHZpZXdCb3g9XCIwIDAgMzIgMzJcIlxuICAgICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgICAgcm9sZT1cImltZ1wiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMTYgNmExLjkgMS45IDAgMDExLjM0OS41NTlsOC4wOTIgOC4wOTJhMS45MDYgMS45MDYgMCAwMTAgMi42OThsLTguMDkyIDguMDkyYTEuOTA0IDEuOTA0IDAgMDEtMi42OTggMGwtOC4wOTItOC4wOTJhMS45MDYgMS45MDYgMCAwMTAtMi42OThsOC4wOTItOC4wOTJBMS45IDEuOSAwIDAxMTYgNnptMCAyaC0uMDAyTDggMTZsOCA4IDgtOC04LTh6bTAgMTAuNWExIDEgMCAwMS4xMTcgMS45OTNMMTYgMjAuNWExIDEgMCAxMTAtMnptLjA1OC03LjVjLjUyMSAwIC45NDIuNDIyLjk0Mi45NDN2NS4xMTVjMCAuNTItLjQyMS45NDItLjk0Mi45NDJoLS4xMTVhLjk0My45NDMgMCAwMS0uOTQzLS45NDJ2LTUuMTE1YzAtLjUyMS40MjItLjk0My45NDMtLjk0M3pcIlxuICAgICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5XYXJuaW5nT3JTaWduaWZpY2FudC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFdhcm5pbmdPclNpZ25pZmljYW50O1xuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
function WarningOrSignificant(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, testId = _ref.testId;
    return jsx("svg", {
        css: _ref2$1,
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16 6a1.9 1.9 0 011.349.559l8.092 8.092a1.906 1.906 0 010 2.698l-8.092 8.092a1.904 1.904 0 01-2.698 0l-8.092-8.092a1.906 1.906 0 010-2.698l8.092-8.092A1.9 1.9 0 0116 6zm0 2h-.002L8 16l8 8 8-8-8-8zm0 10.5a1 1 0 01.117 1.993L16 20.5a1 1 0 110-2zm.058-7.5c.521 0 .942.422.942.943v5.115c0 .52-.421.942-.942.942h-.115a.943.943 0 01-.943-.942v-5.115c0-.521.422-.943.943-.943z",
        fillRule: "evenodd",
        fill: primaryColor
    }));
}
WarningOrSignificant.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    testId: PropTypes.string
};

function YouTube(_ref) {
    var size = _ref.size, primaryColor = _ref.primaryColor, hoverColor = _ref.hoverColor, testId = _ref.testId;
    var theme = useTheme();
    return jsx("svg", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            fill: primaryColor,
            transition: hoverColor ? theme.transitions.icon : null,
            ":hover": _objectSpread2({}, hoverColor && {
                fill: hoverColor
            })
        }, process.env.NODE_ENV === "production" ? "" : ";label:YouTube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("path", {
        d: "M16.3395033,6.84081649 C17.8995578,6.84801236 24.3787171,6.90677861 26.1580154,7.38670301 C27.2767627,7.68762579 28.1576672,8.57429174 28.4566696,9.70027772 C29.0000147,11.740998 29.0000147,15.9989741 29.0000147,15.9989741 L29.000002,16.0092505 C28.9995711,16.240469 28.9844905,20.3151173 28.4566696,22.2978183 C28.1576672,23.4236566 27.2767627,24.3103225 26.1580154,24.611393 C24.25458,25.1246618 16.9726125,25.1560864 16.088078,25.1580104 L15.9117503,25.1580104 C15.0272158,25.1560864 7.74524828,25.1246618 5.84181288,24.611393 C4.72321332,24.3103225 3.84216105,23.4236566 3.54315874,22.2978183 C3.06191022,20.4900615 3.00691039,16.9432378 3.00062469,16.1561467 L3.00062469,15.8417967 C3.00691039,15.0546825 3.06191022,11.5077729 3.54315874,9.70027772 C3.84216105,8.57429174 4.72321332,7.68762579 5.84181288,7.38670301 C7.62111119,6.90677861 14.1002705,6.84801236 15.660325,6.84081649 Z M13.3408027,12.1330693 L13.3408027,19.864879 L20.1363098,15.9991219 L13.3408027,12.1330693 Z",
        fillRule: "evenodd"
    }));
}
YouTube.propTypes = {
    size: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    hoverColor: PropTypes.string,
    testId: PropTypes.string
};

var iconListMapping = {
    "arrow-back": ArrowBack,
    "arrow-forward": ArrowForward,
    assistance: Assistance,
    birthday: Birthday,
    blocking: Blocking,
    calculator: Calculator,
    call: Call,
    "chevron-down": ChevronDown,
    "chevron-left": ChevronLeft,
    "chevron-right": ChevronRight,
    "chevron-up": ChevronUp,
    comparison: Comparison,
    critical: Critical,
    "cross-small": CrossSmall,
    cross: Cross,
    devices: Devices,
    document: Document,
    download: Download,
    duplicate: Duplicate,
    edit: Edit,
    "external-link": ExternalLink,
    "eye-hidden": EyeHidden,
    "eye-visible": EyeVisible,
    "face-id": FaceID,
    facebook: Facebook,
    fingerprint: Fingerprint,
    github: GitHub,
    hamburger: Hamburger,
    home: Home,
    "info-or-minor": InfoOrMinor,
    instagram: Instagram,
    link: Link$1,
    linkedin: LinkedIn,
    "lock-small": LockSmall,
    lock: Lock,
    logout: Logout,
    mail: Mail,
    message: Message$1,
    "notification-new": NotificationNew,
    notification: Notification,
    "overflow-menu": OverflowMenu,
    payment: Payment,
    person: Person,
    question: Question,
    search: Search,
    "select-object": SelectObject,
    shield: Shield,
    stop: Stop,
    "stopwatch-alt": StopwatchAlt,
    stopwatch: Stopwatch,
    success: Success,
    "tick-small": TickSmall,
    tick: Tick,
    time: Time,
    trash: Trash,
    "triangle-down": TriangleDown,
    "triangle-up": TriangleUp,
    twitter: Twitter,
    "warning-or-significant": WarningOrSignificant,
    youtube: YouTube
};

var NAMES$1 = ["assistance", "arrow-back", "arrow-forward", "birthday", "blocking", "calculator", "call", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "comparison", "critical", "cross-small", "cross", "devices", "document", "download", "duplicate", "edit", "external-link", "eye-hidden", "eye-visible", "face-id", "facebook", "fingerprint", "github", "hamburger", "home", "info-or-minor", "instagram", "link", "linkedin", "lock-small", "lock", "logout", "mail", "message", "notification-new", "notification", "overflow-menu", "payment", "person", "question", "search", "select-object", "shield", "stop", "stopwatch-alt", "stopwatch", "success", "tick-small", "tick", "time", "trash", "triangle-down", "triangle-up", "twitter", "warning-or-significant", "youtube"];
var SIZES$1 = ["24px", "32px"];
var COLORS$w = ["black", "grey.t75", "primary.blue.t100", "highlight.blue.t100", "conditional.positive.graphics", "conditional.negative.graphics", "white"];
var HOVER_COLORS = ["black", "highlight.blue.t100", "secondary.lightBlue.t60"];
var SECONDARY_COLORS = ["highlight.blue.t100"];
var DEFAULT_PROPS$J = {
    size: "32px",
    color: "grey.t75",
    secondaryColor: "highlight.blue.t100"
};
Icon.NAMES = NAMES$1;
Icon.SIZES = SIZES$1;
Icon.COLORS = COLORS$w;
Icon.HOVER_COLORS = HOVER_COLORS;
Icon.SECONDARY_COLORS = SECONDARY_COLORS;
Icon.DEFAULT_PROPS = DEFAULT_PROPS$J;
function Icon(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$J), _props);
    var name = props.name, size = props.size, color = props.color, hoverColor = props.hoverColor, secondaryColor = props.secondaryColor, testId = props.testId;
    var theme = useTheme();
    if (!NAMES$1.includes(name)) {
        return null;
    }
    var IconComponent = iconListMapping[name];
    return jsx(IconComponent, {
        size: size,
        primaryColor: theme.getColor(color),
        secondaryColor: theme.getColor(secondaryColor),
        hoverColor: theme.getColor(hoverColor),
        testId: testId
    });
}
Icon.propTypes = {
    name: PropTypes.oneOf(NAMES$1).isRequired,
    size: PropTypes.oneOf(SIZES$1),
    color: PropTypes.oneOf(COLORS$w),
    hoverColor: PropTypes.oneOf(HOVER_COLORS),
    secondaryColor: PropTypes.oneOf(SECONDARY_COLORS),
    testId: PropTypes.string
};
/*
  Tools used to simplify the icons:
  - https://svgomg.firebaseapp.com/
  - https://transform.tools/svg-to-jsx
*/

var COLORS$v = ["grey.t07", "secondary.lightBlue.t25", "white"];
var TEXT_COLORS = ["black", "primary.blue.t100"];
var ITEM_GAP = ["small", "large"];
var ITEM_HEADER_AS = ["h2", "h3", "h4", "h5", "h6"];
var DEFAULT_PROPS$I = {
    color: "grey.t07",
    textColor: "black",
    itemHeaderAs: "h3",
    itemGap: "large"
};
Accordion.COLORS = COLORS$v;
Accordion.TEXT_COLORS = TEXT_COLORS;
Accordion.ITEM_GAP = ITEM_GAP;
Accordion.ITEM_HEADER_AS = ITEM_HEADER_AS;
Accordion.DEFAULT_PROPS = DEFAULT_PROPS$I;
function Header$2(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$__internal__keyb = _ref.__internal__keyboardFocus, __internal__keyboardFocus = _ref$__internal__keyb === void 0 ? false : _ref$__internal__keyb;
    var theme = useTheme();
    var _useAccordion = useAccordion(), colorMap = _useAccordion.colorMap, textColor = _useAccordion.textColor, HeaderComponent = _useAccordion.itemHeaderAs, onItemToggle = _useAccordion.onItemToggle;
    var buttonCSS = useResponsivePropsCSS({}, {}, {
        backgroundColor: function backgroundColor(propsAtBreakpoint, theme, bp) {
            return theme.accordion.getCSS({
                targetElement: "headerButton",
                color: colorMap[bp],
                textColor: textColor,
                __internal__keyboardFocus: __internal__keyboardFocus
            });
        }
    });
    var _useAccordionItem = useAccordionItem(), headerId = _useAccordionItem.headerId, contentId = _useAccordionItem.contentId, isOpen = _useAccordionItem.isOpen, toggleAccordionItem = _useAccordionItem.toggleAccordionItem;
    var onClick = useCallback(function () {
        toggleAccordionItem();
        onItemToggle && onItemToggle({
            isOpen: !isOpen,
            itemHeaderChildren: children
        });
    }, [toggleAccordionItem, onItemToggle, isOpen, children]);
    return jsx(HeaderComponent, {
        css: theme.accordion.getCSS({
            targetElement: "headerContainer"
        }),
        "data-testid": testId
    }, jsx("button", {
        id: headerId,
        css: buttonCSS,
        type: "button",
        "aria-controls": contentId,
        "aria-expanded": isOpen ? "true" : "false",
        onClick: onClick
    }, jsx("div", {
        css: theme.accordion.getCSS({
            targetElement: "headerContent"
        })
    }, children), jsx("div", {
        css: theme.accordion.getCSS({
            targetElement: "headerChevron",
            isOpen: isOpen
        })
    }, jsx(Icon, {
        name: "chevron-down",
        color: textColor
    }))));
}
Header$2.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string,
    __internal__keyboardFocus: PropTypes.bool
};
function HeaderIcon(_ref2) {
    var name = _ref2.name, testId = _ref2.testId;
    var theme = useTheme();
    var _useAccordion2 = useAccordion(), textColor = _useAccordion2.textColor;
    return jsx("div", {
        css: theme.accordion.getCSS({
            targetElement: "headerIcon"
        }),
        "data-testid": testId
    }, jsx(Icon, {
        name: name,
        color: textColor
    }));
}
HeaderIcon.propTypes = {
    name: PropTypes.oneOf(Icon.NAMES).isRequired,
    testId: PropTypes.string
};
function Content(props) {
    var children = props.children, testId = props.testId;
    var theme = useTheme();
    var _useAccordion3 = useAccordion(), colorMap = _useAccordion3.colorMap;
    var bgMap = mapResponsiveValues(colorMap, theme.accordion.getContentColor, theme);
    var css = useResponsivePropsCSS(props, {}, {
        backgroundColor: function backgroundColor(propsAtBreakpoint, theme, bp) {
            return theme.accordion.getCSS({
                targetElement: "content",
                color: colorMap[bp]
            });
        },
        /*
          Note:
            `padding` needs to come after `backgroundColor` because
            `backgroundColor` sets a default padding and we want to
            allow users to override it.
        */
        padding: responsivePadding
    });
    var _useAccordionItem2 = useAccordionItem(), headerId = _useAccordionItem2.headerId, contentId = _useAccordionItem2.contentId, isOpen = _useAccordionItem2.isOpen;
    return jsx(BackgroundProvider, {
        value: bgMap
    }, jsx("div", {
        id: contentId,
        css: css,
        role: "region",
        "aria-labelledby": headerId,
        hidden: !isOpen,
        "data-testid": testId
    }, children));
}
Content.propTypes = _objectSpread2(_objectSpread2({}, responsivePaddingType), {}, {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
});
var DEFAULT_ITEM_PROPS$1 = {
    initiallyOpen: false
};
Item$4.DEFAULT_PROPS = DEFAULT_ITEM_PROPS$1;
function Item$4(props) {
    var theme = useTheme();
    var windowFromContext = useWindow();
    var _useAccordion4 = useAccordion(), itemGap = _useAccordion4.itemGap;
    var _useState = useState(function () {
        return "accordion-item-header-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), headerId = _useState2[0];
    var _useState3 = useState(function () {
        return "accordion-item-content-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), contentId = _useState4[0];
    var mergedProps = mergeProps$1(props, DEFAULT_ITEM_PROPS$1, {}, {
        initiallyOpen: function initiallyOpen(_initiallyOpen) {
            return typeof _initiallyOpen === "boolean";
        },
        open: function open(_open) {
            return typeof _open === "boolean";
        },
        onToggle: function onToggle(_onToggle) {
            return typeof _onToggle === "function";
        }
    });
    var initiallyOpen = mergedProps.initiallyOpen, open = mergedProps.open, onToggle = mergedProps.onToggle, children = mergedProps.children, testId = mergedProps.testId;
    if (open !== undefined && !onToggle) {
        windowFromContext.console.warn("If you provide the `open` prop to `Accordion.Item`, you should also provide the `onToggle` handler. Otherwise, clicking the `Accordion.Item.Header` would be ignored.");
    }
    var _useState5 = useState(initiallyOpen || open), _useState6 = _slicedToArray(_useState5, 2), isOpen = _useState6[0], setIsOpen = _useState6[1];
    var toggleAccordionItem = useCallback(function () {
        setIsOpen(function (isOpen) {
            return !isOpen;
        });
        onToggle && onToggle(!open);
    }, [open, onToggle]);
    var accordionItemInfo = useMemo(function () {
        return {
            headerId: headerId,
            contentId: contentId,
            isOpen: open === undefined ? isOpen : open,
            toggleAccordionItem: toggleAccordionItem
        };
    }, [headerId, contentId, isOpen, open, toggleAccordionItem]);
    return jsx(AccordionItemProvider, {
        value: accordionItemInfo
    }, jsx("div", {
        css: theme.accordion.getCSS({
            targetElement: "item",
            itemGap: itemGap
        }),
        "data-testid": testId
    }, children));
}
Item$4.propTypes = {
    initiallyOpen: PropTypes.bool,
    open: PropTypes.bool,
    onToggle: PropTypes.func,
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function Accordion(props) {
    var theme = useTheme();
    var _useBackground = useBackground(), bgMap = _useBackground.bgMap;
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$I, {}, {
        color: function color(_color) {
            return COLORS$v.includes(_color);
        },
        textColor: function textColor(_textColor) {
            return TEXT_COLORS.includes(_textColor);
        },
        itemGap: function itemGap(_itemGap) {
            return ITEM_GAP.includes(_itemGap);
        },
        itemHeaderAs: function itemHeaderAs(_itemHeaderAs) {
            return ITEM_HEADER_AS.includes(_itemHeaderAs);
        }
    });
    var color = mergedProps.color, textColor = mergedProps.textColor, itemHeaderAs = mergedProps.itemHeaderAs, itemGap = mergedProps.itemGap, onItemToggle = mergedProps.onItemToggle, children = mergedProps.children, testId = mergedProps.testId;
    var colorMap = hasOwnProperty(props, "color") && hasOwnProperty(mergedProps, "color") ? mapResponsiveValues(bgMap, function () {
        return color;
    }, theme) : mapResponsiveValues(bgMap, function (backgroundColor) {
        return [undefined, "transparent", "white"].includes(backgroundColor) ? DEFAULT_PROPS$I.color : "white";
    }, theme);
    var accordionInfo = useMemo(function () {
        return {
            colorMap: colorMap,
            textColor: textColor,
            itemGap: itemGap,
            itemHeaderAs: itemHeaderAs,
            onItemToggle: onItemToggle
        };
    }, [colorMap, textColor, itemGap, itemHeaderAs, onItemToggle]);
    return jsx(AccordionProvider, {
        value: accordionInfo
    }, jsx("div", {
        "data-testid": testId
    }, children));
}
Accordion.propTypes = {
    color: PropTypes.oneOf(COLORS$v),
    textColor: PropTypes.oneOf(TEXT_COLORS),
    itemGap: PropTypes.oneOf(ITEM_GAP),
    itemHeaderAs: PropTypes.oneOf(ITEM_HEADER_AS),
    onItemToggle: PropTypes.func,
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
Header$2.Icon = HeaderIcon;
Item$4.Header = Header$2;
Item$4.Content = Content;
Accordion.Item = Item$4;

var ComponentNames;
(function (ComponentNames) {
    ComponentNames["RadioGroup"] = "BasisRadioGroup";
    ComponentNames["Input"] = "BasisInput";
    ComponentNames["Textarea"] = "BasisTextarea";
    ComponentNames["Select"] = "BasisSelect";
    ComponentNames["DateInput"] = "BasisDateInput";
    ComponentNames["Frequency"] = "BasisFrequency";
    ComponentNames["Checkbox"] = "BasisCheckbox";
    ComponentNames["CheckboxGroup"] = "BasisCheckboxGroup";
    ComponentNames["AutoComplete"] = "BasisAutoComplete";
})(ComponentNames || (ComponentNames = {}));

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e$1=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n$1=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r$1=b?Symbol.for("react.memo"):60115,t$1=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e$1:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n$1:case t$1:case r$1:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n$1;var Fragment=e$1;var Lazy=t$1;var Memo=r$1;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n$1};var isFragment=function(a){return z(a)===e$1};var isLazy=function(a){return z(a)===t$1};
var isMemo=function(a){return z(a)===r$1};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$1||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n$1||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

function t(t){return "object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return (!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return !1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}function computeScrollIntoView(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p);}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else {F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)));}C.push({el:k,top:F,left:G});}return C}

var idCounter = 0;
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */


function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }

  var actions = computeScrollIntoView(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child) {
  return parent === child || parent.contains && parent.contains(child);
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */


function debounce(fn, time) {
  var timeoutId;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }

  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */


function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}

function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */


function generateId$1() {
  return String(idCounter++);
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */


function getA11yStatusMessage(_ref2) {
  var isOpen = _ref2.isOpen,
      resultCount = _ref2.resultCount,
      previousResultCount = _ref2.previousResultCount;

  if (!isOpen) {
    return '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */


function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */


function isControlledProp(props, key) {
  return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */


function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */


function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }

  if (itemCount === 0) {
    return -1;
  }

  var itemsLastIndex = itemCount - 1;

  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }

  var newIndex = baseIndex + moveAmount;

  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }

  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);

  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }

  return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */


function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);

  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }

  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) {
      if (!getItemNodeFromIndex(index).hasAttribute('disabled')) {
        return index;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) {
        return _index;
      }
    }
  }

  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }

  return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Document} document The document.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */


function targetWithinDownshift(target, downshiftElements, document, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }

  return downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target) || checkActiveElement && isOrContainsNode(contextNode, document.activeElement));
  });
}

function validateControlledUnchanged(state, prevProps, nextProps) {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(state).forEach(function (propKey) {
    if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
    } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
    }
  });
}

var cleanupStatus = debounce(function () {
  getStatusDiv().textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);

  if (!status) {
    return;
  }

  div.textContent = status;
  cleanupStatus();
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */


function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }

  var statusDiv = documentProp.getElementById('a11y-status-message');

  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

process.env.NODE_ENV !== "production" ? '__autocomplete_unknown__' : 0;
process.env.NODE_ENV !== "production" ? '__autocomplete_mouseup__' : 1;
process.env.NODE_ENV !== "production" ? '__autocomplete_item_mouseenter__' : 2;
process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_up__' : 3;
process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_down__' : 4;
process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_escape__' : 5;
process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_enter__' : 6;
process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_home__' : 7;
process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_end__' : 8;
process.env.NODE_ENV !== "production" ? '__autocomplete_click_item__' : 9;
process.env.NODE_ENV !== "production" ? '__autocomplete_blur_input__' : 10;
process.env.NODE_ENV !== "production" ? '__autocomplete_change_input__' : 11;
process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_space_button__' : 12;
process.env.NODE_ENV !== "production" ? '__autocomplete_click_button__' : 13;
process.env.NODE_ENV !== "production" ? '__autocomplete_blur_button__' : 14;
process.env.NODE_ENV !== "production" ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
process.env.NODE_ENV !== "production" ? '__autocomplete_touchend__' : 16;

process.env.NODE_ENV !== "production" ? {
  children: PropTypes.func,
  defaultHighlightedIndex: PropTypes.number,
  defaultIsOpen: PropTypes.bool,
  initialHighlightedIndex: PropTypes.number,
  initialSelectedItem: PropTypes.any,
  initialInputValue: PropTypes.string,
  initialIsOpen: PropTypes.bool,
  getA11yStatusMessage: PropTypes.func,
  itemToString: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onStateChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  onUserAction: PropTypes.func,
  onOuterClick: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  stateReducer: PropTypes.func,
  itemCount: PropTypes.number,
  id: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  }),
  suppressRefError: PropTypes.bool,
  scrollIntoView: PropTypes.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components

  /* eslint-disable react/no-unused-prop-types */
  selectedItem: PropTypes.any,
  isOpen: PropTypes.bool,
  inputValue: PropTypes.string,
  highlightedIndex: PropTypes.number,
  labelId: PropTypes.string,
  inputId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func
  /* eslint-enable react/no-unused-prop-types */

} : void 0;

var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ''
};

function callOnChangeProps(action, state, newState) {
  var props = action.props,
      type = action.type;
  var changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, props, state, newState);

    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });

  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(_extends({
      type: type
    }, changes));
  }
}

function invokeOnChangeHandler(key, props, state, newState) {
  var handler = "on" + capitalizeString(key) + "Change";

  if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) {
    props[handler](newState);
  }
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */


function stateReducer(s, a) {
  return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : '';
}
/**
 * Debounced call for updating the a11y message.
 */


var updateA11yStatus = debounce(function (getA11yMessage, document) {
  setStatus(getA11yMessage(), document);
}, 200);
function getElementIds(_ref) {
  var id = _ref.id,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      getItemId = _ref.getItemId,
      toggleButtonId = _ref.toggleButtonId;
  var uniqueId = id === undefined ? "downshift-" + generateId$1() : id;
  return {
    labelId: labelId || uniqueId + "-label",
    menuId: menuId || uniqueId + "-menu",
    getItemId: getItemId || function (index) {
      return uniqueId + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || uniqueId + "-toggle-button"
  };
}
function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }

  if (items.length === 0) {
    return -1;
  }

  return items.indexOf(item);
}

function itemToString(item) {
  return item ? String(item) : '';
}

function getPropTypesValidator(caller, propTypes) {
  // istanbul ignore next
  return function (options) {
    if (options === void 0) {
      options = {};
    }

    Object.keys(propTypes).forEach(function (key) {
      PropTypes.checkPropTypes(propTypes, options, key, caller.name);
    });
  };
}
function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}
function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function useLatestRef(val) {
  var ref = useRef(val); // technically this is not "concurrent mode safe" because we're manipulating
  // the value during render (so it's not idempotent). However, the places this
  // hook is used is to support memoizing callbacks which will be called
  // *during* render, so we need the latest values *during* render.
  // If not for this, then we'd probably want to use useLayoutEffect instead.

  ref.current = val;
  return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */

function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = useRef();
  var actionRef = useRef();
  var enhancedReducer = useCallback(function (state, action) {
    actionRef.current = action;
    state = getState(state, action.props);
    var changes = reducer(state, action);
    var newState = action.props.stateReducer(state, _extends({}, action, {
      changes: changes
    }));
    return newState;
  }, [reducer]);

  var _useReducer = useReducer(enhancedReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var propsRef = useLatestRef(props);
  var dispatchWithProps = useCallback(function (action) {
    return dispatch(_extends({
      props: propsRef.current
    }, action));
  }, [propsRef]);
  var action = actionRef.current;
  useEffect(function () {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, getState(prevStateRef.current, action.props), state);
    }

    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */

function useControlledReducer(reducer, initialState, props) {
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
      state = _useEnhancedReducer[0],
      dispatch = _useEnhancedReducer[1];

  return [getState(state, props), dispatch];
}
var defaultProps$1 = {
  itemToString: itemToString,
  stateReducer: stateReducer,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  circularNavigation: false,
  environment: typeof window === 'undefined'
  /* istanbul ignore next (ssr) */
  ? {} : window
};
function getDefaultValue(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  var defaultPropKey = "default" + capitalizeString(propKey);

  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }

  return defaultStateValues[propKey];
}
function getInitialValue(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  if (propKey in props) {
    return props[propKey];
  }

  var initialPropKey = "initial" + capitalizeString(propKey);

  if (initialPropKey in props) {
    return props[initialPropKey];
  }

  return getDefaultValue(props, propKey, defaultStateValues);
}
function getInitialState(props) {
  var selectedItem = getInitialValue(props, 'selectedItem');
  var isOpen = getInitialValue(props, 'isOpen');
  var highlightedIndex = getInitialValue(props, 'highlightedIndex');
  var inputValue = getInitialValue(props, 'inputValue');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}
function getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
  var items = props.items,
      initialHighlightedIndex = props.initialHighlightedIndex,
      defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex;

  if (items.length === 0) {
    return -1;
  } // initialHighlightedIndex will give value to highlightedIndex on initial state only.


  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }

  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }

  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }

    return getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
  }

  if (offset === 0) {
    return -1;
  }

  return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */

function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = useRef({
    isMouseDown: false,
    isTouchMove: false
  });
  useEffect(function () {
    // The same strategy for checking if a click occurred inside or outside downsift
    // as in downshift.js.
    var onMouseDown = function () {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };

    var onMouseUp = function (event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;

      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment.document)) {
        handleBlur();
      }
    };

    var onTouchStart = function () {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };

    var onTouchMove = function () {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };

    var onTouchEnd = function (event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment.document, false)) {
        handleBlur();
      }
    };

    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);
    return function () {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}
/**
 * Custom hook that checks if getter props are called correctly.
 *
 * @param  {...any} propKeys Getter prop names to be handled.
 * @returns {Function} Setter function called inside getter props to set call information.
 */

function useGetterPropsCalledChecker() {
  var isNotProduction = process.env.NODE_ENV !== 'production';
  var isInitialMountRef = useRef(true);

  for (var _len = arguments.length, propKeys = new Array(_len), _key = 0; _key < _len; _key++) {
    propKeys[_key] = arguments[_key];
  }

  var getterPropsCalledRef = useRef(propKeys.reduce(function (acc, propKey) {
    acc[propKey] = {};
    return acc;
  }, {}));
  useEffect(function () {
    if (!isNotProduction) {
      return;
    }

    Object.keys(getterPropsCalledRef.current).forEach(function (propKey) {
      var propCallInfo = getterPropsCalledRef.current[propKey];

      if (isInitialMountRef.current) {
        if (!Object.keys(propCallInfo).length) {
          // eslint-disable-next-line no-console
          console.error("downshift: You forgot to call the " + propKey + " getter function on your component / element.");
          return;
        }
      }

      var suppressRefError = propCallInfo.suppressRefError,
          refKey = propCallInfo.refKey,
          elementRef = propCallInfo.elementRef;

      if ((!elementRef || !elementRef.current) && !suppressRefError) {
        // eslint-disable-next-line no-console
        console.error("downshift: The ref prop \"" + refKey + "\" from " + propKey + " was not applied correctly on your element.");
      }
    });
    isInitialMountRef.current = false;
  });
  var setGetterPropCallInfo = useCallback(function (propKey, suppressRefError, refKey, elementRef) {
    if (process.env.NODE_ENV !== 'production') {
      getterPropsCalledRef.current[propKey] = {
        suppressRefError: suppressRefError,
        refKey: refKey,
        elementRef: elementRef
      };
    }
  }, []);
  return setGetterPropCallInfo;
}

function getItemIndexByCharacterKey(keysSoFar, highlightedIndex, items, itemToStringParam, getItemNodeFromIndex) {
  var lowerCasedItemStrings = items.map(function (item) {
    return itemToStringParam(item).toLowerCase();
  });
  var lowerCasedKeysSoFar = keysSoFar.toLowerCase();

  var isValid = function (itemString, index) {
    var element = getItemNodeFromIndex(index);
    return itemString.startsWith(lowerCasedKeysSoFar) && !(element && element.hasAttribute('disabled'));
  };

  for (var index = highlightedIndex + 1; index < lowerCasedItemStrings.length; index++) {
    var itemString = lowerCasedItemStrings[index];

    if (isValid(itemString, index)) {
      return index;
    }
  }

  for (var _index = 0; _index < highlightedIndex; _index++) {
    var _itemString = lowerCasedItemStrings[_index];

    if (isValid(_itemString, _index)) {
      return _index;
    }
  }

  return highlightedIndex;
}

var propTypes = {
  items: PropTypes.array.isRequired,
  itemToString: PropTypes.func,
  getA11yStatusMessage: PropTypes.func,
  getA11ySelectionMessage: PropTypes.func,
  circularNavigation: PropTypes.bool,
  highlightedIndex: PropTypes.number,
  defaultHighlightedIndex: PropTypes.number,
  initialHighlightedIndex: PropTypes.number,
  isOpen: PropTypes.bool,
  defaultIsOpen: PropTypes.bool,
  initialIsOpen: PropTypes.bool,
  selectedItem: PropTypes.any,
  initialSelectedItem: PropTypes.any,
  defaultSelectedItem: PropTypes.any,
  id: PropTypes.string,
  labelId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func,
  toggleButtonId: PropTypes.string,
  stateReducer: PropTypes.func,
  onSelectedItemChange: PropTypes.func,
  onHighlightedIndexChange: PropTypes.func,
  onStateChange: PropTypes.func,
  onIsOpenChange: PropTypes.func,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  })
};
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */

function getA11yStatusMessage$1(_ref) {
  var isOpen = _ref.isOpen,
      resultCount = _ref.resultCount,
      previousResultCount = _ref.previousResultCount;

  if (!isOpen) {
    return '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.";
  }

  return '';
}

var defaultProps$1$1 = _extends({}, defaultProps$1, {
  getA11yStatusMessage: getA11yStatusMessage$1
});

var MenuKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_down__' : 0;
var MenuKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_up__' : 1;
var MenuKeyDownEscape = process.env.NODE_ENV !== "production" ? '__menu_keydown_escape__' : 2;
var MenuKeyDownHome = process.env.NODE_ENV !== "production" ? '__menu_keydown_home__' : 3;
var MenuKeyDownEnd = process.env.NODE_ENV !== "production" ? '__menu_keydown_end__' : 4;
var MenuKeyDownEnter = process.env.NODE_ENV !== "production" ? '__menu_keydown_enter__' : 5;
var MenuKeyDownSpaceButton = process.env.NODE_ENV !== "production" ? '__menu_keydown_space_button__' : 6;
var MenuKeyDownCharacter = process.env.NODE_ENV !== "production" ? '__menu_keydown_character__' : 7;
var MenuBlur = process.env.NODE_ENV !== "production" ? '__menu_blur__' : 8;
var MenuMouseLeave = process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 9;
var ItemMouseMove = process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 10;
var ItemClick = process.env.NODE_ENV !== "production" ? '__item_click__' : 11;
var ToggleButtonClick = process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 12;
var ToggleButtonKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_down__' : 13;
var ToggleButtonKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_up__' : 14;
var ToggleButtonKeyDownCharacter = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_character__' : 15;
var FunctionToggleMenu = process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 16;
var FunctionOpenMenu = process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 17;
var FunctionCloseMenu = process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 18;
var FunctionSetHighlightedIndex = process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 19;
var FunctionSelectItem = process.env.NODE_ENV !== "production" ? '__function_select_item__' : 20;
var FunctionSetInputValue = process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 21;
var FunctionReset = process.env.NODE_ENV !== "production" ? '__function_reset__' : 22;

var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown: MenuKeyDownArrowDown,
  MenuKeyDownArrowUp: MenuKeyDownArrowUp,
  MenuKeyDownEscape: MenuKeyDownEscape,
  MenuKeyDownHome: MenuKeyDownHome,
  MenuKeyDownEnd: MenuKeyDownEnd,
  MenuKeyDownEnter: MenuKeyDownEnter,
  MenuKeyDownSpaceButton: MenuKeyDownSpaceButton,
  MenuKeyDownCharacter: MenuKeyDownCharacter,
  MenuBlur: MenuBlur,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonClick: ToggleButtonClick,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionReset: FunctionReset
});

/* eslint-disable complexity */

function downshiftSelectReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case ItemClick:
      changes = {
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        selectedItem: props.items[action.index]
      };
      break;

    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var inputValue = "" + state.inputValue + lowercasedKey;
        var itemIndex = getItemIndexByCharacterKey(inputValue, state.selectedItem ? props.items.indexOf(state.selectedItem) : -1, props.items, props.itemToString, action.getItemNodeFromIndex);
        changes = _extends({
          inputValue: inputValue
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;

    case ToggleButtonKeyDownArrowDown:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;

    case ToggleButtonKeyDownArrowUp:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;

    case MenuKeyDownEnter:
    case MenuKeyDownSpaceButton:
      changes = _extends({
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex')
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;

    case MenuKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuBlur:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownCharacter:
      {
        var _lowercasedKey = action.key;

        var _inputValue = "" + state.inputValue + _lowercasedKey;

        var highlightedIndex = getItemIndexByCharacterKey(_inputValue, state.highlightedIndex, props.items, props.itemToString, action.getItemNodeFromIndex);
        changes = _extends({
          inputValue: _inputValue
        }, highlightedIndex >= 0 && {
          highlightedIndex: highlightedIndex
        });
      }
      break;

    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;

    case ToggleButtonClick:
    case FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;

    case FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem
      };
      break;

    case FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;

    case FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        isOpen: getDefaultValue(props, 'isOpen'),
        selectedItem: getDefaultValue(props, 'selectedItem'),
        inputValue: getDefaultValue(props, 'inputValue')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return _extends({}, state, changes);
}
/* eslint-enable complexity */

var validatePropTypes = process.env.NODE_ENV === 'production' ?
/* istanbul ignore next */
null : getPropTypesValidator(useSelect, propTypes);
useSelect.stateChangeTypes = stateChangeTypes$1;

function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  /* istanbul ignore else */
  if (process.env.NODE_ENV !== 'production') {
    validatePropTypes(userProps);
  } // Props defaults and destructuring.


  var props = _extends({}, defaultProps$1$1, userProps);

  var items = props.items,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment,
      initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      itemToString = props.itemToString,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      getA11yStatusMessage = props.getA11yStatusMessage; // Initial state depending on controlled props.

  var initialState = getInitialState(props);

  var _useControlledReducer = useControlledReducer(downshiftSelectReducer, initialState, props),
      state = _useControlledReducer[0],
      dispatch = _useControlledReducer[1];

  var isOpen = state.isOpen,
      highlightedIndex = state.highlightedIndex,
      selectedItem = state.selectedItem,
      inputValue = state.inputValue; // Element efs.

  var toggleButtonRef = useRef(null);
  var menuRef = useRef(null);
  var itemRefs = useRef();
  itemRefs.current = {}; // used not to scroll when highlight by mouse.

  var shouldScrollRef = useRef(true); // used not to trigger menu blur action in some scenarios.

  var shouldBlurRef = useRef(true); // used to keep the inputValue clearTimeout object between renders.

  var clearTimeoutRef = useRef(null); // prevent id re-generation between renders.

  var elementIdsRef = useRef(getElementIds(props)); // used to keep track of how many items we had on previous cycle.

  var previousResultCountRef = useRef();
  var isInitialMountRef = useRef(true); // used for checking when props are moving from controlled to uncontrolled.

  var prevPropsRef = useRef(props); // utility callback to get item element.

  var latest = useLatestRef({
    state: state,
    props: props
  }); // Some utils.

  var getItemNodeFromIndex = function (index) {
    return itemRefs.current[elementIdsRef.current.getItemId(index)];
  }; // Effects.
  // Sets a11y status message on changes in state.


  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    var previousResultCount = previousResultCountRef.current;
    updateA11yStatus(function () {
      return getA11yStatusMessage({
        isOpen: isOpen,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        inputValue: inputValue,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length,
        itemToString: itemToString,
        previousResultCount: previousResultCount
      });
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, highlightedIndex, inputValue, items]); // Sets a11y status message on changes in selectedItem.

  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    var previousResultCount = previousResultCountRef.current;
    updateA11yStatus(function () {
      return getA11ySelectionMessage({
        isOpen: isOpen,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        inputValue: inputValue,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length,
        itemToString: itemToString,
        previousResultCount: previousResultCount
      });
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]); // Sets cleanup for the keysSoFar after 500ms.

  useEffect(function () {
    // init the clean function here as we need access to dispatch.
    if (isInitialMountRef.current) {
      clearTimeoutRef.current = debounce(function (outerDispatch) {
        outerDispatch({
          type: FunctionSetInputValue,
          inputValue: ''
        });
      }, 500);
    }

    if (!inputValue) {
      return;
    }

    clearTimeoutRef.current(dispatch); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);
  /* Controls the focus on the menu or the toggle button. */

  useEffect(function () {
    // Don't focus menu on first render.
    if (isInitialMountRef.current) {
      // Unless it was initialised as open.
      if ((initialIsOpen || defaultIsOpen || isOpen) && menuRef.current) {
        menuRef.current.focus();
      }

      return;
    } // Focus menu on open.


    if (isOpen) {
      // istanbul ignore else
      if (menuRef.current) {
        menuRef.current.focus();
      }

      return;
    } // Focus toggleButton on close, but not if it was closed with (Shift+)Tab.


    if (environment.document.activeElement === menuRef.current) {
      // istanbul ignore else
      if (toggleButtonRef.current) {
        shouldBlurRef.current = false;
        toggleButtonRef.current.focus();
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]); // Scroll on highlighted item if change comes from keyboard.

  useEffect(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }

    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoView(getItemNodeFromIndex(highlightedIndex), menuRef.current);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    previousResultCountRef.current = items.length;
  });
  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    validateControlledUnchanged(state, prevPropsRef.current, props);
    prevPropsRef.current = props;
  }, [state, props]); // Add mouse/touch events to document.

  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: MenuBlur
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps'); // Make initial ref false.

  useEffect(function () {
    isInitialMountRef.current = false;
  }, []); // Event handler functions.

  var toggleButtonKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowDown,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowUp,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      }
    };
  }, [dispatch]);
  var menuKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownArrowDown,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownArrowUp,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      Home: function Home(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        dispatch({
          type: MenuKeyDownEscape
        });
      },
      Enter: function Enter(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownEnter
        });
      },
      ' ': function _(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownSpaceButton
        });
      }
    };
  }, [dispatch]); // Action functions.

  var toggleMenu = useCallback(function () {
    dispatch({
      type: FunctionToggleMenu
    });
  }, [dispatch]);
  var closeMenu = useCallback(function () {
    dispatch({
      type: FunctionCloseMenu
    });
  }, [dispatch]);
  var openMenu = useCallback(function () {
    dispatch({
      type: FunctionOpenMenu
    });
  }, [dispatch]);
  var setHighlightedIndex = useCallback(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = useCallback(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset
    });
  }, [dispatch]);
  var setInputValue = useCallback(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch]); // Getter functions.

  var getLabelProps = useCallback(function (labelProps) {
    return _extends({
      id: elementIdsRef.current.labelId,
      htmlFor: elementIdsRef.current.toggleButtonId
    }, labelProps);
  }, []);
  var getMenuProps = useCallback(function (_temp, _temp2) {
    var _extends2;

    var _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
        onKeyDown = _ref.onKeyDown,
        onBlur = _ref.onBlur,
        ref = _ref.ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"]);

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

    var latestState = latest.current.state;
    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIdsRef.current.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = elementIdsRef.current.labelId, _extends2.tabIndex = -1, _extends2), latestState.isOpen && latestState.highlightedIndex > -1 && {
      'aria-activedescendant': elementIdsRef.current.getItemId(latestState.highlightedIndex)
    }, {
      onMouseLeave: callAllEventHandlers(onMouseLeave, function menuHandleMouseLeave() {
        dispatch({
          type: MenuMouseLeave
        });
      }),
      onKeyDown: callAllEventHandlers(onKeyDown, function menuHandleKeyDown(event) {
        var key = normalizeArrowKey(event);

        if (key && menuKeyDownHandlers[key]) {
          menuKeyDownHandlers[key](event);
        } else if (isAcceptedCharacterKey(key)) {
          dispatch({
            type: MenuKeyDownCharacter,
            key: key,
            getItemNodeFromIndex: getItemNodeFromIndex
          });
        }
      }),
      onBlur: callAllEventHandlers(onBlur, function menuHandleBlur() {
        // if the blur was a result of selection, we don't trigger this action.
        if (shouldBlurRef.current === false) {
          shouldBlurRef.current = true;
          return;
        }

        var shouldBlur = !mouseAndTouchTrackersRef.current.isMouseDown;
        /* istanbul ignore else */

        if (shouldBlur) {
          dispatch({
            type: MenuBlur
          });
        }
      })
    }, rest);
  }, [dispatch, latest, menuKeyDownHandlers, mouseAndTouchTrackersRef, setGetterPropCallInfo]);
  var getToggleButtonProps = useCallback(function (_temp3, _temp4) {
    var _extends3;

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        onClick = _ref3.onClick,
        onKeyDown = _ref3.onKeyDown,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
        ref = _ref3.ref,
        rest = _objectWithoutPropertiesLoose(_ref3, ["onClick", "onKeyDown", "refKey", "ref"]);

    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        _ref4$suppressRefErro = _ref4.suppressRefError,
        suppressRefError = _ref4$suppressRefErro === void 0 ? false : _ref4$suppressRefErro;

    var toggleButtonHandleClick = function () {
      dispatch({
        type: ToggleButtonClick
      });
    };

    var toggleButtonHandleKeyDown = function (event) {
      var key = normalizeArrowKey(event);

      if (key && toggleButtonKeyDownHandlers[key]) {
        toggleButtonKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: ToggleButtonKeyDownCharacter,
          key: key,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };

    var toggleProps = _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends3.id = elementIdsRef.current.toggleButtonId, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-expanded'] = latest.current.state.isOpen, _extends3['aria-labelledby'] = elementIdsRef.current.labelId + " " + elementIdsRef.current.toggleButtonId, _extends3), rest);

    if (!rest.disabled) {
      toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
      toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
    }

    setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
    return toggleProps;
  }, [dispatch, latest, toggleButtonKeyDownHandlers, setGetterPropCallInfo]);
  var getItemProps = useCallback(function (_temp5) {
    var _extends4;

    var _ref5 = _temp5 === void 0 ? {} : _temp5,
        item = _ref5.item,
        index = _ref5.index,
        onMouseMove = _ref5.onMouseMove,
        onClick = _ref5.onClick,
        _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
        ref = _ref5.ref,
        rest = _objectWithoutPropertiesLoose(_ref5, ["item", "index", "onMouseMove", "onClick", "refKey", "ref"]);

    var _latest$current = latest.current,
        latestState = _latest$current.state,
        latestProps = _latest$current.props;

    var itemHandleMouseMove = function () {
      if (index === latestState.highlightedIndex) {
        return;
      }

      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove,
        index: index
      });
    };

    var itemHandleClick = function () {
      dispatch({
        type: ItemClick,
        index: index
      });
    };

    var itemIndex = getItemIndex(index, item, latestProps.items);

    if (itemIndex < 0) {
      throw new Error('Pass either item or item index in getItemProps!');
    }

    var itemProps = _extends((_extends4 = {
      role: 'option',
      'aria-selected': "" + (itemIndex === latestState.highlightedIndex),
      id: elementIdsRef.current.getItemId(itemIndex)
    }, _extends4[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIdsRef.current.getItemId(itemIndex)] = itemNode;
      }
    }), _extends4), rest);

    if (!rest.disabled) {
      itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove);
      itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick);
    }

    return itemProps;
  }, [dispatch, latest]);
  return {
    // prop getters.
    getToggleButtonProps: getToggleButtonProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getItemProps: getItemProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    selectItem: selectItem,
    reset: reset,
    setInputValue: setInputValue,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var InputKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_down__' : 0;
var InputKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_up__' : 1;
var InputKeyDownEscape = process.env.NODE_ENV !== "production" ? '__input_keydown_escape__' : 2;
var InputKeyDownHome = process.env.NODE_ENV !== "production" ? '__input_keydown_home__' : 3;
var InputKeyDownEnd = process.env.NODE_ENV !== "production" ? '__input_keydown_end__' : 4;
var InputKeyDownEnter = process.env.NODE_ENV !== "production" ? '__input_keydown_enter__' : 5;
var InputChange = process.env.NODE_ENV !== "production" ? '__input_change__' : 6;
var InputBlur = process.env.NODE_ENV !== "production" ? '__input_blur__' : 7;
var MenuMouseLeave$1 = process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 8;
var ItemMouseMove$1 = process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 9;
var ItemClick$1 = process.env.NODE_ENV !== "production" ? '__item_click__' : 10;
var ToggleButtonClick$1 = process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 11;
var FunctionToggleMenu$1 = process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 12;
var FunctionOpenMenu$1 = process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 13;
var FunctionCloseMenu$1 = process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 14;
var FunctionSetHighlightedIndex$1 = process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 15;
var FunctionSelectItem$1 = process.env.NODE_ENV !== "production" ? '__function_select_item__' : 16;
var FunctionSetInputValue$1 = process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 17;
var FunctionReset$1 = process.env.NODE_ENV !== "production" ? '__function_reset__' : 18;
var ControlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__controlled_prop_updated_selected_item__' : 19;

var stateChangeTypes$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownEscape: InputKeyDownEscape,
  InputKeyDownHome: InputKeyDownHome,
  InputKeyDownEnd: InputKeyDownEnd,
  InputKeyDownEnter: InputKeyDownEnter,
  InputChange: InputChange,
  InputBlur: InputBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  ToggleButtonClick: ToggleButtonClick$1,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem: ControlledPropUpdatedSelectedItem
});

function getElementIds$1(_ref) {
  var id = _ref.id,
      inputId = _ref.inputId,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "inputId"]);

  var uniqueId = id === undefined ? "downshift-" + generateId$1() : id;
  return _extends({
    inputId: inputId || uniqueId + "-input"
  }, getElementIds(_extends({
    id: id
  }, rest)));
}
function getInitialState$1(props) {
  var initialState = getInitialState(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;

  if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) {
    inputValue = props.itemToString(selectedItem);
  }

  return _extends({}, initialState, {
    inputValue: inputValue
  });
}
var propTypes$1 = {
  items: PropTypes.array.isRequired,
  itemToString: PropTypes.func,
  getA11yStatusMessage: PropTypes.func,
  getA11ySelectionMessage: PropTypes.func,
  circularNavigation: PropTypes.bool,
  highlightedIndex: PropTypes.number,
  defaultHighlightedIndex: PropTypes.number,
  initialHighlightedIndex: PropTypes.number,
  isOpen: PropTypes.bool,
  defaultIsOpen: PropTypes.bool,
  initialIsOpen: PropTypes.bool,
  selectedItem: PropTypes.any,
  initialSelectedItem: PropTypes.any,
  defaultSelectedItem: PropTypes.any,
  inputValue: PropTypes.string,
  defaultInputValue: PropTypes.string,
  initialInputValue: PropTypes.string,
  id: PropTypes.string,
  labelId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func,
  inputId: PropTypes.string,
  toggleButtonId: PropTypes.string,
  stateReducer: PropTypes.func,
  onSelectedItemChange: PropTypes.func,
  onHighlightedIndexChange: PropTypes.func,
  onStateChange: PropTypes.func,
  onIsOpenChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  })
};
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */

function useControlledReducer$1(reducer, initialState, props) {
  var previousSelectedItemRef = useRef();

  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
      state = _useEnhancedReducer[0],
      dispatch = _useEnhancedReducer[1]; // ToDo: if needed, make same approach as selectedItemChanged from Downshift.


  useEffect(function () {
    if (isControlledProp(props, 'selectedItem')) {
      if (previousSelectedItemRef.current !== props.selectedItem) {
        dispatch({
          type: ControlledPropUpdatedSelectedItem,
          inputValue: props.itemToString(props.selectedItem)
        });
      }

      previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    }
  });
  return [getState(state, props), dispatch];
}
var defaultProps$2 = _extends({}, defaultProps$1, {
  getA11yStatusMessage: getA11yStatusMessage,
  circularNavigation: true
});

/* eslint-disable complexity */

function downshiftUseComboboxReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemMouseMove$1:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;

    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: true
        };
      }

      break;

    case InputKeyDownArrowUp:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: true
        };
      }

      break;

    case InputKeyDownEnter:
      changes = _extends({}, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;

    case InputKeyDownEscape:
      changes = {
        isOpen: false,
        selectedItem: null,
        highlightedIndex: -1,
        inputValue: ''
      };
      break;

    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputBlur:
      changes = _extends({
        isOpen: false
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex]),
        highlightedIndex: -1
      });
      break;

    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        inputValue: action.inputValue
      };
      break;

    case MenuMouseLeave$1:
      changes = {
        highlightedIndex: -1
      };
      break;

    case ToggleButtonClick$1:
    case FunctionToggleMenu$1:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionOpenMenu$1:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionCloseMenu$1:
      changes = {
        isOpen: false
      };
      break;

    case FunctionSetHighlightedIndex$1:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;

    case ControlledPropUpdatedSelectedItem:
    case FunctionSetInputValue$1:
      changes = {
        inputValue: action.inputValue
      };
      break;

    case FunctionReset$1:
      changes = {
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        isOpen: getDefaultValue(props, 'isOpen'),
        selectedItem: getDefaultValue(props, 'selectedItem'),
        inputValue: getDefaultValue(props, 'inputValue')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return _extends({}, state, changes);
}
/* eslint-enable complexity */

var validatePropTypes$1 = process.env.NODE_ENV === 'production' ?
/* istanbul ignore next */
null : getPropTypesValidator(useCombobox, propTypes$1);
useCombobox.stateChangeTypes = stateChangeTypes$2;

function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  /* istanbul ignore else */
  if (process.env.NODE_ENV !== 'production') {
    validatePropTypes$1(userProps);
  } // Props defaults and destructuring.


  var props = _extends({}, defaultProps$2, userProps);

  var initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      items = props.items,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment,
      getA11yStatusMessage = props.getA11yStatusMessage,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      itemToString = props.itemToString; // Initial state depending on controlled props.

  var initialState = getInitialState$1(props);

  var _useControlledReducer = useControlledReducer$1(downshiftUseComboboxReducer, initialState, props),
      state = _useControlledReducer[0],
      dispatch = _useControlledReducer[1];

  var isOpen = state.isOpen,
      highlightedIndex = state.highlightedIndex,
      selectedItem = state.selectedItem,
      inputValue = state.inputValue; // Element refs.

  var menuRef = useRef(null);
  var itemRefs = useRef();
  var inputRef = useRef(null);
  var toggleButtonRef = useRef(null);
  var comboboxRef = useRef(null);
  itemRefs.current = {}; // used not to scroll on highlight by mouse.

  var shouldScrollRef = useRef(true);
  var isInitialMountRef = useRef(true); // prevent id re-generation between renders.

  var elementIdsRef = useRef(getElementIds$1(props)); // used to keep track of how many items we had on previous cycle.

  var previousResultCountRef = useRef(); // used for checking when props are moving from controlled to uncontrolled.

  var prevPropsRef = useRef(props); // utility callback to get item element.

  var latest = useLatestRef({
    state: state,
    props: props
  });

  var getItemNodeFromIndex = function (index) {
    return itemRefs.current[elementIdsRef.current.getItemId(index)];
  }; // Effects.
  // Sets a11y status message on changes in state.


  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    var previousResultCount = previousResultCountRef.current;
    updateA11yStatus(function () {
      return getA11yStatusMessage({
        isOpen: isOpen,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        inputValue: inputValue,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length,
        itemToString: itemToString,
        previousResultCount: previousResultCount
      });
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, highlightedIndex, inputValue, items]); // Sets a11y status message on changes in selectedItem.

  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    var previousResultCount = previousResultCountRef.current;
    updateA11yStatus(function () {
      return getA11ySelectionMessage({
        isOpen: isOpen,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        inputValue: inputValue,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length,
        itemToString: itemToString,
        previousResultCount: previousResultCount
      });
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]); // Scroll on highlighted item if change comes from keyboard.

  useEffect(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }

    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoView(getItemNodeFromIndex(highlightedIndex), menuRef.current);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]); // Controls the focus on the menu or the toggle button.

  useEffect(function () {
    // Don't focus menu on first render.
    if (isInitialMountRef.current) {
      // Unless it was initialised as open.
      if (initialIsOpen || defaultIsOpen || isOpen) {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    previousResultCountRef.current = items.length;
  });
  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    validateControlledUnchanged(state, prevPropsRef.current, props);
    prevPropsRef.current = props;
  }, [state, props]); // Add mouse/touch events to document.

  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [comboboxRef, menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: InputBlur
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getInputProps', 'getComboboxProps', 'getMenuProps'); // Make initial ref false.

  useEffect(function () {
    isInitialMountRef.current = false;
  }, []);
  /* Event handler functions */

  var inputKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowDown,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowUp,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Home: function Home(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        dispatch({
          type: InputKeyDownEscape
        });
      },
      Enter: function Enter(event) {
        // if IME composing, wait for next Enter keydown event.
        if (event.which === 229) {
          return;
        }

        var latestState = latest.current.state;

        if (latestState.isOpen && latestState.highlightedIndex > -1) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownEnter,
            getItemNodeFromIndex: getItemNodeFromIndex
          });
        }
      }
    };
  }, [dispatch, latest]); // Getter props.

  var getLabelProps = useCallback(function (labelProps) {
    return _extends({
      id: elementIdsRef.current.labelId,
      htmlFor: elementIdsRef.current.inputId
    }, labelProps);
  }, []);
  var getMenuProps = useCallback(function (_temp, _temp2) {
    var _extends2;

    var _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
        ref = _ref.ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["onMouseLeave", "refKey", "ref"]);

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIdsRef.current.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = elementIdsRef.current.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function () {
      dispatch({
        type: MenuMouseLeave$1
      });
    }), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo]);
  var getItemProps = useCallback(function (_temp3) {
    var _extends3, _ref4;

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        item = _ref3.item,
        index = _ref3.index,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
        ref = _ref3.ref,
        onMouseMove = _ref3.onMouseMove,
        onClick = _ref3.onClick;
        _ref3.onPress;
        var rest = _objectWithoutPropertiesLoose(_ref3, ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"]);

    var _latest$current = latest.current,
        latestProps = _latest$current.props,
        latestState = _latest$current.state;
    var itemIndex = getItemIndex(index, item, latestProps.items);

    if (itemIndex < 0) {
      throw new Error('Pass either item or item index in getItemProps!');
    }

    var onSelectKey = 'onClick';
    var customClickHandler = onClick;
    return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIdsRef.current.getItemId(itemIndex)] = itemNode;
      }
    }), _extends3.role = 'option', _extends3['aria-selected'] = "" + (itemIndex === latestState.highlightedIndex), _extends3.id = elementIdsRef.current.getItemId(itemIndex), _extends3), !rest.disabled && (_ref4 = {
      onMouseMove: callAllEventHandlers(onMouseMove, function itemHandleMouseMove() {
        if (index === latestState.highlightedIndex) {
          return;
        }

        shouldScrollRef.current = false;
        dispatch({
          type: ItemMouseMove$1,
          index: index
        });
      })
    }, _ref4[onSelectKey] = callAllEventHandlers(customClickHandler, function itemHandleClick() {
      dispatch({
        type: ItemClick$1,
        index: index
      });

      if (inputRef.current) {
        inputRef.current.focus();
      }
    }), _ref4), rest);
  }, [dispatch, latest]);
  var getToggleButtonProps = useCallback(function (_temp4) {
    var _extends4;

    var _ref5 = _temp4 === void 0 ? {} : _temp4,
        onClick = _ref5.onClick;
        _ref5.onPress;
        var _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
        ref = _ref5.ref,
        rest = _objectWithoutPropertiesLoose(_ref5, ["onClick", "onPress", "refKey", "ref"]);

    var toggleButtonHandleClick = function () {
      dispatch({
        type: ToggleButtonClick$1
      });

      if (!latest.current.state.isOpen && inputRef.current) {
        inputRef.current.focus();
      }
    };

    return _extends((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends4.id = elementIdsRef.current.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && _extends({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    }), rest);
  }, [dispatch, latest]);
  var getInputProps = useCallback(function (_temp5, _temp6) {
    var _extends5;

    var _ref6 = _temp5 === void 0 ? {} : _temp5,
        onKeyDown = _ref6.onKeyDown,
        onChange = _ref6.onChange,
        onInput = _ref6.onInput,
        onBlur = _ref6.onBlur;
        _ref6.onChangeText;
        var _ref6$refKey = _ref6.refKey,
        refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey,
        ref = _ref6.ref,
        rest = _objectWithoutPropertiesLoose(_ref6, ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"]);

    var _ref7 = _temp6 === void 0 ? {} : _temp6,
        _ref7$suppressRefErro = _ref7.suppressRefError,
        suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;

    setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
    var latestState = latest.current.state;

    var inputHandleKeyDown = function (event) {
      var key = normalizeArrowKey(event);

      if (key && inputKeyDownHandlers[key]) {
        inputKeyDownHandlers[key](event);
      }
    };

    var inputHandleChange = function (event) {
      dispatch({
        type: InputChange,
        inputValue: event.target.value
      });
    };

    var inputHandleBlur = function () {
      /* istanbul ignore else */
      if (!mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch({
          type: InputBlur
        });
      }
    };
    /* istanbul ignore next (preact) */


    var onChangeKey = 'onChange';
    var eventHandlers = {};

    if (!rest.disabled) {
      var _eventHandlers;

      eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers);
    }
    /* istanbul ignore if (react-native) */


    return _extends((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function (inputNode) {
      inputRef.current = inputNode;
    }), _extends5.id = elementIdsRef.current.inputId, _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = elementIdsRef.current.menuId, _extends5), latestState.isOpen && latestState.highlightedIndex > -1 && {
      'aria-activedescendant': elementIdsRef.current.getItemId(latestState.highlightedIndex)
    }, {
      'aria-labelledby': elementIdsRef.current.labelId,
      // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
      // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
      autoComplete: 'off',
      value: latestState.inputValue
    }, eventHandlers, rest);
  }, [dispatch, inputKeyDownHandlers, latest, mouseAndTouchTrackersRef, setGetterPropCallInfo]);
  var getComboboxProps = useCallback(function (_temp7, _temp8) {
    var _extends6;

    var _ref8 = _temp7 === void 0 ? {} : _temp7,
        _ref8$refKey = _ref8.refKey,
        refKey = _ref8$refKey === void 0 ? 'ref' : _ref8$refKey,
        ref = _ref8.ref,
        rest = _objectWithoutPropertiesLoose(_ref8, ["refKey", "ref"]);

    var _ref9 = _temp8 === void 0 ? {} : _temp8,
        _ref9$suppressRefErro = _ref9.suppressRefError,
        suppressRefError = _ref9$suppressRefErro === void 0 ? false : _ref9$suppressRefErro;

    setGetterPropCallInfo('getComboboxProps', suppressRefError, refKey, comboboxRef);
    return _extends((_extends6 = {}, _extends6[refKey] = handleRefs(ref, function (comboboxNode) {
      comboboxRef.current = comboboxNode;
    }), _extends6.role = 'combobox', _extends6['aria-haspopup'] = 'listbox', _extends6['aria-owns'] = elementIdsRef.current.menuId, _extends6['aria-expanded'] = latest.current.state.isOpen, _extends6), rest);
  }, [latest, setGetterPropCallInfo]); // returns

  var toggleMenu = useCallback(function () {
    dispatch({
      type: FunctionToggleMenu$1
    });
  }, [dispatch]);
  var closeMenu = useCallback(function () {
    dispatch({
      type: FunctionCloseMenu$1
    });
  }, [dispatch]);
  var openMenu = useCallback(function () {
    dispatch({
      type: FunctionOpenMenu$1
    });
  }, [dispatch]);
  var setHighlightedIndex = useCallback(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = useCallback(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem$1,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var setInputValue = useCallback(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue$1,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset$1
    });
  }, [dispatch]);
  return {
    // prop getters.
    getItemProps: getItemProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getInputProps: getInputProps,
    getComboboxProps: getComboboxProps,
    getToggleButtonProps: getToggleButtonProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    setInputValue: setInputValue,
    selectItem: selectItem,
    reset: reset,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

({
  selectedItems: PropTypes.array,
  initialSelectedItems: PropTypes.array,
  defaultSelectedItems: PropTypes.array,
  itemToString: PropTypes.func,
  getA11yRemovalMessage: PropTypes.func,
  stateReducer: PropTypes.func,
  activeIndex: PropTypes.number,
  initialActiveIndex: PropTypes.number,
  defaultActiveIndex: PropTypes.number,
  onActiveIndexChange: PropTypes.func,
  onSelectedItemsChange: PropTypes.func,
  keyNavigationNext: PropTypes.string,
  keyNavigationPrevious: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  })
});

process.env.NODE_ENV !== "production" ? '__selected_item_click__' : 0;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_delete__' : 1;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_backspace__' : 2;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_next__' : 3;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_previous__' : 4;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_navigation_previous__' : 5;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_backspace__' : 6;
process.env.NODE_ENV !== "production" ? '__dropdown_click__' : 7;
process.env.NODE_ENV !== "production" ? '__function_add_selected_item__' : 8;
process.env.NODE_ENV !== "production" ? '__function_remove_selected_item__' : 9;
process.env.NODE_ENV !== "production" ? '__function_set_selected_items__' : 10;
process.env.NODE_ENV !== "production" ? '__function_set_active_index__' : 11;
process.env.NODE_ENV !== "production" ? '__function_reset__' : 12;

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash_isequal = createCommonjsModule(function (module, exports) {
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;
});

function mergeProps(props, defaultProps) {
    var overridenProps = Object.fromEntries(Object.entries(props).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [
            key,
            value === undefined ? defaultProps[key] : value,
        ];
    }));
    return __assign(__assign({}, defaultProps), overridenProps);
}

var useMergedProps = function (props, defaultProps) {
    return useMemo(function () { return mergeProps(props, defaultProps); }, [props, defaultProps]);
};

var attachEventListeners = function (node, onFocusChange) {
    var iframeWindow = node === null || node === void 0 ? void 0 : node.ownerDocument;
    var iframeDocument = node === null || node === void 0 ? void 0 : node.ownerDocument.defaultView;
    if (iframeWindow && iframeDocument) {
        iframeWindow.addEventListener("focus", onFocusChange, true);
        iframeDocument.addEventListener("mousedown", onFocusChange);
        iframeDocument.addEventListener("touchstart", onFocusChange);
    }
    window.addEventListener("focus", onFocusChange, true);
    document.addEventListener("mousedown", onFocusChange);
    document.addEventListener("touchstart", onFocusChange);
};
var detachEventListeners = function (node, onFocusChange) {
    var iframeWindow = node === null || node === void 0 ? void 0 : node.ownerDocument;
    var iframeDocument = node === null || node === void 0 ? void 0 : node.ownerDocument.defaultView;
    if (iframeWindow && iframeDocument) {
        iframeWindow.removeEventListener("focus", onFocusChange, true);
        iframeDocument.removeEventListener("mousedown", onFocusChange);
        iframeDocument.removeEventListener("touchstart", onFocusChange);
    }
    window.removeEventListener("focus", onFocusChange, true);
    document.removeEventListener("mousedown", onFocusChange);
    document.removeEventListener("touchstart", onFocusChange);
};
var useWrapperFocus = function (_a) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur, _b = _a.defaultFocus, defaultFocus = _b === void 0 ? false : _b;
    /** Useful when working with autoFocus */
    var wrapper = useRef(null);
    var prevFocused = useRef(defaultFocus);
    var functionRefs = useRef({
        onFocus: onFocus,
        onBlur: onBlur,
    });
    useEffect(function () {
        functionRefs.current.onBlur = onBlur;
        functionRefs.current.onFocus = onFocus;
    }, [onBlur, onFocus]);
    useEffect(function () {
        var onFocusChange = function (event) {
            var _a, _b, _c, _d, _e;
            if (!wrapper.current || !event.target) {
                return;
            }
            if (event.target instanceof Window ||
                event.target instanceof HTMLDocument) {
                return;
            }
            var currFocused = (_a = wrapper.current.contains(event.target)) !== null && _a !== void 0 ? _a : false;
            if (currFocused && !prevFocused.current) {
                (_c = (_b = functionRefs.current).onFocus) === null || _c === void 0 ? void 0 : _c.call(_b);
            }
            else if (!currFocused && prevFocused.current) {
                (_e = (_d = functionRefs.current).onBlur) === null || _e === void 0 ? void 0 : _e.call(_d);
            }
            prevFocused.current = currFocused;
        };
        var node = wrapper.current;
        attachEventListeners(node, onFocusChange);
        return function () {
            detachEventListeners(node, onFocusChange);
        };
    }, []);
    return wrapper;
};

// don't want to install an npm package for this just adding the code into here.
// https://github.com/gregberge/react-merge-refs/blob/3dc2804807097562e9952cfa6057a8a3bef9f39f/src/index.tsx
function mergeRefs(refs) {
    return function (value) {
        refs.forEach(function (ref) {
            if (typeof ref === "function") {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
    };
}

var DEFAULT_GRID_ITEM_PROPS = {};
Item$3.DEFAULT_PROPS = DEFAULT_GRID_ITEM_PROPS;
function Item$3(props) {
    var children = props.children, testId = props.testId;
    var responsivePropsCSS = useResponsivePropsCSS(props, DEFAULT_GRID_ITEM_PROPS, {
        colSpan: function (_a) {
            var colSpan = _a.colSpan;
            var gridColumn = getGridRowColumn(colSpan, { allAllowed: true });
            return gridColumn ? { gridColumn: gridColumn } : {};
        },
        rowSpan: function (_a) {
            var rowSpan = _a.rowSpan;
            var gridRow = getGridRowColumn(rowSpan);
            return gridRow ? { gridRow: gridRow } : {};
        },
    });
    return (jsx$1("div", __assign({ css: __assign({ 
            /*
              Don't add overflow: hidden here because it will hide the focus style
              of the components that use Grid (e.g. TimeSpan, Frequency).
            */
            minWidth: 0, 
            /*
              This helps in situations where Grid.Item has a vertical scrollbar.
              Without setting `minHeight: 0`, if Grid.Item's height is 1fr, for example,
              the actual height would be greater than what you'd expect (lots of content
              makes it go beyond the desired 1fr).
            */
            minHeight: 0 }, responsivePropsCSS), "data-testid": testId }, { children: children }), void 0));
}
var PRESETS = ["page"];
var presetsMap = {
    page: {
        cols: 4,
        "cols-sm": 8,
        "cols-lg": 12,
        colsGap: "30px",
    },
};
var DEFAULT_GRID_PROPS = {};
Grid.PRESETS = PRESETS;
Grid.DEFAULT_PROPS = DEFAULT_GRID_PROPS;
function Grid(props) {
    var preset = props.preset, children = props.children, testId = props.testId;
    var theme = useTheme();
    var parsedProps = __assign(__assign({}, (preset && presetsMap[preset])), props);
    var responsivePropsCSS = useResponsivePropsCSS(parsedProps, DEFAULT_GRID_PROPS, {
        cols: function (_a) {
            var _b;
            var cols = _a.cols;
            return {
                gridTemplateColumns: (_b = getGridTemplateColumns(cols)) !== null && _b !== void 0 ? _b : undefined,
            };
        },
        rows: function (_a) {
            var _b;
            var rows = _a.rows;
            return {
                gridTemplateRows: (_b = getGridTemplateRows(rows)) !== null && _b !== void 0 ? _b : undefined,
            };
        },
        colsGap: function (_a) {
            var colsGap = _a.colsGap;
            return {
                gridColumnGap: getGapPx(colsGap, theme),
            };
        },
        rowsGap: function (_a) {
            var rowsGap = _a.rowsGap;
            return {
                gridRowGap: getGapPx(rowsGap, theme),
            };
        },
        margin: responsiveMargin,
        height: responsiveSize("height"),
    });
    return (jsx$1("div", __assign({ css: __assign({ display: "grid" }, responsivePropsCSS), "data-testid": testId }, { children: children }), void 0));
}
Grid.Item = Item$3;

var TextStyleContext = React__default.createContext(undefined);
var TextStyleProvider = TextStyleContext.Provider;
function useTextStyle() {
    var theme = useTheme();
    var textStyle = useContext(TextStyleContext);
    return {
        textStyle: textStyle,
        textStyleCSS: theme.getTextStyleCSS(textStyle),
    };
}

var AS = ["h1", "h2", "h3", "h4", "h5", "h6", "p"];
var COLORS$u = [
    "black",
    "white",
    "grey.t75",
    "primary.blue.t100",
    "highlight.blue.t100",
    "conditional.positive.text",
    "conditional.negative.text",
];
var ALIGNS = TEXT_ALIGNS;
var allowedColors = [
    {
        textStyles: [
            "hero",
            "heading1",
            "heading2",
            "heading3",
            "heading4",
            "heading5",
            "heading6",
        ],
        allowedColors: ["black", "white", "primary.blue.t100"],
    },
    {
        textStyles: ["subtitle1", "subtitle2", "body1", "body2", "legal"],
        allowedColors: [
            "black",
            "white",
            "grey.t75",
            "primary.blue.t100",
            "highlight.blue.t100",
            "conditional.positive.text",
            "conditional.negative.text",
        ],
    },
    {
        textStyles: ["overline"],
        allowedColors: [
            "black",
            "white",
            "grey.t75",
            "primary.blue.t100",
            "highlight.blue.t100",
        ],
    },
];
function getInheritedColor(backgroundColor) {
    return backgroundColor === "primary.blue.t100" ? "white" : "black";
}
var DEFAULT_PROPS$H = {
    as: "p",
    textStyle: "body1",
    color: "black",
    align: "inherit",
    wrap: true,
};
Text.AS = AS;
Text.TEXT_STYLES = TEXT_STYLES$1;
Text.COLORS = COLORS$u;
Text.ALIGNS = ALIGNS;
Text.allowedColors = allowedColors;
Text.DEFAULT_PROPS = DEFAULT_PROPS$H;
function Text(props) {
    var inheritedTextStyle = useTextStyle().textStyle;
    var bgMap = useBackground().bgMap;
    var inheritedProps = inheritedTextStyle && {
        textStyle: inheritedTextStyle,
    };
    var mergedProps = useMergedProps(props, __assign(__assign({}, DEFAULT_PROPS$H), inheritedProps));
    var id = mergedProps.id, as = mergedProps.as, align = mergedProps.align, wrap = mergedProps.wrap, role = mergedProps.role, children = mergedProps.children, testId = mergedProps.testId;
    var css = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$H, {
        color: function (_, theme, bp) {
            var color = hasOwnProperty(props, "color") && hasOwnProperty(mergedProps, "color")
                ? mergedProps.color
                : getInheritedColor(bgMap === null || bgMap === void 0 ? void 0 : bgMap[bp]);
            return theme.text.getCSS({
                color: color,
                wrap: wrap,
                align: align,
            });
        },
        margin: responsiveMargin,
        textStyle: responsiveTextStyle,
    });
    var Component = as;
    return (jsx$1(Component, __assign({ id: id, css: css, role: role, "data-testid": testId }, { children: children }), void 0));
}

var css = {
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    clip: "rect(0, 0, 0, 0)",
    clipPath: "inset(50%)"
};
function VisuallyHidden(_ref) {
    var children = _ref.children;
    if (typeof children === "string") {
        return jsx("span", {
            css: css
        }, children);
    }
    var child = React__default.Children.only(children);
    /*
      Note: We avoid adding extra DOM elements here since we rely on elements order in some places.
      For example, Radio has the following DOM structure:
        <VisuallyHidden>
          <input>
        </VisuallyHidden>
        <label>
      and one of the CSS selectors we use on the input is: ":checked + label"
      If we wrapped the input with a span/div, we'd break the styling.
    */
    return /*#__PURE__*/ React__default.cloneElement(child, {
        // See: https://github.com/emotion-js/emotion/issues/1713#issuecomment-574121500
        style: css
    });
}
VisuallyHidden.propTypes = {
    children: PropTypes.node.isRequired
};

function Field$1(_a) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, optional = _a.optional, disabled = _a.disabled, label = _a.label, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, _d = _a.renderLabel, renderLabel = _d === void 0 ? true : _d, labelId = _a.labelId, labelFor = _a.labelFor, auxId = _a.auxId, helpText = _a.helpText, errors = _a.errors, children = _a.children, testId = _a.testId;
    var theme = useTheme();
    var labelToRender = null;
    if (renderLabel) {
        var LabelElement = labelFor ? "label" : "div";
        var labelContent = (jsxs(LabelElement, __assign({ css: theme.field.getCSS({ targetElement: "label" }), id: labelId, htmlFor: labelFor }, { children: [label,
                optional && (jsx$1("span", __assign({ css: theme.field.getCSS({ targetElement: "optionalTag" }) }, { children: "Optional" }), void 0))] }), void 0));
        labelToRender = hideLabel ? (jsx$1(VisuallyHidden, { children: labelContent }, void 0)) : (labelContent);
    }
    return (jsxs("div", __assign({ css: theme.field.getCSS({
            targetElement: "fieldContainer",
            fullWidth: fullWidth,
            disabled: disabled,
        }), "data-testid": testId }, { children: [labelToRender,
            children,
            Array.isArray(errors) && errors.length > 0 ? (jsx$1("div", __assign({ css: theme.field.getCSS({
                    targetElement: "errorsContainer",
                }), id: auxId }, { children: jsx$1(Grid, __assign({ cols: 1, rowsGap: 1 }, { children: errors.map(function (error, index) { return (jsx$1(Text, __assign({ textStyle: "body2", color: "conditional.negative.text" }, { children: error }), index)); }) }), void 0) }), void 0)) : helpText ? (jsx$1("div", __assign({ css: theme.field.getCSS({ targetElement: "helpText" }), id: auxId }, { children: jsx$1(Text, __assign({ textStyle: "body2" }, { children: helpText }), void 0) }), void 0)) : null] }), void 0));
}

var TYPES$4 = ["text", "password", "email", "tel"];
var VARIANTS$5 = ["text", "numeric", "decimal"];
var COLORS$t = ["grey.t05", "white"];
var NUMERIC_REGEX$2 = /^\d*$/;
var DECIMAL_REGEX$1 = /^\d*(\.\d{2})?$/;
var DEFAULT_PROPS$G = {
    type: "text",
    variant: "text",
    color: "grey.t05",
    disabled: false,
    autoComplete: "off",
    isLoading: false,
    hasSuffixButton: false,
    pasteAllowed: true,
    isValid: true,
    __internal__focus: false,
};
var InternalInput = function (props) {
    var name = props.name, parentName = props.parentName, innerRef = props.innerRef, id = props.id, testId = props.testId, _a = props.type, type = _a === void 0 ? DEFAULT_PROPS$G.type : _a, placeholder = props.placeholder, _b = props.variant, variant = _b === void 0 ? DEFAULT_PROPS$G.variant : _b, prefix = props.prefix, suffix = props.suffix, isLoading = props.isLoading, hasSuffixButton = props.hasSuffixButton, maxLength = props.maxLength, _c = props.autoComplete, autoComplete = _c === void 0 ? DEFAULT_PROPS$G.autoComplete : _c, _d = props.disabled, disabled = _d === void 0 ? DEFAULT_PROPS$G.disabled : _d, pasteAllowed = props.pasteAllowed, _e = props.isValid, isValid = _e === void 0 ? DEFAULT_PROPS$G.isValid : _e, describedBy = props.describedBy, onFocus = props.onFocus, onBlur = props.onBlur, value = props.value, onChange = props.onChange, onKeyDown = props.onKeyDown, ariaLabel = props["aria-label"], _f = props.__internal__focus, __internal__focus = _f === void 0 ? DEFAULT_PROPS$G.__internal__focus : _f;
    var theme = useTheme();
    var inputColorMap = useBackground().inputColorMap;
    var inputCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$G, {
        color: function (propsAtBreakpoint, theme, bp) {
            var _a;
            var color = (_a = props.color) !== null && _a !== void 0 ? _a : inputColorMap[bp];
            return theme.input.getCSS({
                targetElement: "input",
                variant: variant,
                prefix: prefix,
                suffix: suffix,
                color: color,
                isLoading: isLoading,
                hasSuffixButton: hasSuffixButton,
                __internal__focus: __internal__focus,
            });
        },
    });
    var onPaste = useCallback(function (event) {
        if (!pasteAllowed) {
            event.preventDefault();
        }
    }, [pasteAllowed]);
    var variantProps = variant === "numeric"
        ? {
            // See: https://technology.blog.gov.uk/2020/02/24/why-the-gov-uk-design-system-team-changed-the-input-type-for-numbers
            inputMode: "numeric",
            pattern: "[0-9]*",
        }
        : variant === "decimal"
            ? {
                inputMode: "decimal",
            }
            : {};
    return (jsx$1("div", __assign({ css: theme.input.getCSS({
            targetElement: "inputContainer",
            variant: variant,
            prefix: prefix,
            suffix: suffix,
        }) }, { children: jsx$1("input", __assign({ css: inputCSS, "aria-label": ariaLabel, name: name, ref: innerRef, id: id, "data-testid": testId, "data-parent-name": parentName, placeholder: placeholder, type: type }, variantProps, { maxLength: typeof maxLength === "string" ? parseInt(maxLength, 10) : maxLength, disabled: disabled, onPaste: onPaste, autoComplete: autoComplete, autoCorrect: "off", autoCapitalize: "off", spellCheck: "false", "aria-invalid": isValid ? "false" : "true", "aria-describedby": describedBy, onFocus: onFocus, onBlur: onBlur, value: value, onChange: onChange, onKeyDown: onKeyDown }), void 0) }), void 0));
};
InternalInput.displayName = "BasisInternalInput";
InternalInput.TYPES = TYPES$4;
InternalInput.VARIANTS = VARIANTS$5;
InternalInput.COLORS = COLORS$t;
InternalInput.NUMERIC_REGEX = NUMERIC_REGEX$2;
InternalInput.DECIMAL_REGEX = DECIMAL_REGEX$1;
InternalInput.DEFAULT_PROPS = DEFAULT_PROPS$G;

var SIZES = ["small", "medium", "large"];
var COLORS$s = ["highlight.blue.t100", "white", "black"];
var DEFAULT_PROPS$F = {
    size: "small",
    color: "highlight.blue.t100"
};
var circleRadiusMap = {
    small: 4,
    medium: 8,
    large: 12
};
LoadingIcon.SIZES = SIZES;
LoadingIcon.COLORS = COLORS$s;
LoadingIcon.DEFAULT_PROPS = DEFAULT_PROPS$F;
function LoadingIcon(_props) {
    var _circleRadiusMap$size;
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$F), _props);
    var size = props.size, testId = props.testId;
    var radius = (_circleRadiusMap$size = circleRadiusMap[size]) !== null && _circleRadiusMap$size !== void 0 ? _circleRadiusMap$size : 4;
    var stepPx = "".concat(3 * radius, "px");
    var frames = 12; // 3 circles * 4 steps each
    var percantagePerFrame = 100 / frames;
    var duration = 3; // sec
    /*
      circle diameter + space between circles + circle diameter
        (2 * radius)  +        radius         +   (2 * radius)
    */
    var svgSize = 5 * radius;
    var start = {
        transform: "translate3d(0, 0, 0)"
    };
    var right = {
        transform: "translate3d(".concat(stepPx, ", 0, 0)")
    };
    var bottom = {
        transform: "translate3d(0, ".concat(stepPx, ", 0)")
    };
    var left = {
        transform: "translate3d(-".concat(stepPx, ", 0, 0)")
    };
    var up = {
        transform: "translate3d(0, -".concat(stepPx, ", 0)")
    };
    var rightAndBottom = {
        transform: "translate3d(".concat(stepPx, ", ").concat(stepPx, ", 0)")
    };
    var upAndRight = {
        transform: "translate3d(".concat(stepPx, ", -").concat(stepPx, ", 0)")
    };
    var leftAndUp = {
        transform: "translate3d(-".concat(stepPx, ", -").concat(stepPx, ", 0)")
    };
    var getKeyframes = function getKeyframes(steps) {
        return keyframes(steps.reduce(function (acc, step, index) {
            acc["".concat(index * percantagePerFrame, "%")] = step;
            return acc;
        }, {}));
    };
    var svgCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$F, {
        color: function color(_ref, theme) {
            var _theme$getColor;
            var _color = _ref.color;
            return {
                fill: (_theme$getColor = theme.getColor(_color)) !== null && _theme$getColor !== void 0 ? _theme$getColor : theme.colors.black
            };
        }
    });
    var circleCSS = [getKeyframes([start, right, right, right, rightAndBottom, rightAndBottom, rightAndBottom, bottom, bottom, bottom, start, start]), getKeyframes([start, start, up, up, up, upAndRight, upAndRight, upAndRight, right, right, right, start]), getKeyframes([start, start, start, left, left, left, leftAndUp, leftAndUp, leftAndUp, up, up, up])].map(function (animation) {
        return {
            animation: "".concat(animation, " ").concat(duration, "s ease infinite")
        };
    });
    return jsx("svg", {
        css: svgCSS,
        width: svgSize,
        height: svgSize,
        viewBox: "0 0 ".concat(svgSize, " ").concat(svgSize),
        focusable: "false",
        role: "img",
        "aria-label": "Loading icon",
        "data-testid": testId
    }, jsx("circle", {
        cx: radius,
        cy: radius,
        r: radius,
        css: circleCSS[0]
    }), jsx("circle", {
        cx: radius,
        cy: 4 * radius,
        r: radius,
        css: circleCSS[1]
    }), jsx("circle", {
        cx: 4 * radius,
        cy: 4 * radius,
        r: radius,
        css: circleCSS[2]
    }));
}
LoadingIcon.propTypes = _objectSpread2(_objectSpread2({}, responsivePropType("color", PropTypes.oneOf(COLORS$s))), {}, {
    size: PropTypes.oneOf(SIZES),
    testId: PropTypes.string
});

var defaultAutoCompleteProps = {
    hideLabel: false,
    disabled: false,
    __internal__keyboardFocus: false,
    optional: false,
};

var ActionType;
(function (ActionType) {
    ActionType["LOAD_ITEMS_SUCCESS"] = "LOAD_ITEMS_SUCCESS";
    ActionType["UPDATE_STATE"] = "UPDATE_STATE";
})(ActionType || (ActionType = {}));

var reducer = function (state, action) { return (__assign(__assign({}, state), action.payload)); };
function useGetItems(getItemsSource, footerId, hasItemsFooter) {
    var _this = this;
    var initial = {
        status: "IDLE",
        items: [],
    };
    var _a = useReducer(reducer, initial), state = _a[0], dispatch = _a[1];
    var getItems = useCallback(function (changed) { return __awaiter(_this, void 0, void 0, function () {
        var data, apiItems, items, error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getItemsSource) {
                        return [2 /*return*/];
                    }
                    dispatch({
                        type: ActionType.UPDATE_STATE,
                        payload: { status: "LOADING" },
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getItemsSource({
                            inputValue: changed === null || changed === void 0 ? void 0 : changed.inputValue,
                        })];
                case 2:
                    data = _a.sent();
                    apiItems = hasItemsFooter ? __spreadArray(__spreadArray([], data), [{ id: footerId }]) : data;
                    items = (apiItems || []).filter(Boolean);
                    dispatch({
                        type: ActionType.LOAD_ITEMS_SUCCESS,
                        payload: { items: items, status: "SUCCESS" },
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    message = "Basis cannot get items!";
                    console.error(message, error_1);
                    dispatch({
                        type: ActionType.UPDATE_STATE,
                        payload: {
                            status: "ERROR",
                            error: message,
                        },
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [footerId, getItemsSource, hasItemsFooter]);
    return __assign(__assign({}, state), { getItems: getItems });
}

var getFieldErrors = function (error) {
    if (error === undefined) {
        return { fieldErrors: undefined, hasErrors: false };
    }
    var fieldErrors = Array.isArray(error) ? error : [error];
    return { fieldErrors: fieldErrors, hasErrors: true };
};

function AutoComplete$1(props) {
    var mergedProps = useMergedProps(props, defaultAutoCompleteProps);
    var theme = useTheme();
    var label = mergedProps.label, _a = mergedProps.innerRef, innerRef = _a === void 0 ? null : _a, error = mergedProps.error, onChange = mergedProps.onChange, onBlur = mergedProps.onBlur, onFocus = mergedProps.onFocus, disabled = mergedProps.disabled, helpText = mergedProps.helpText, itemToStringFn = mergedProps.itemToString, _b = mergedProps.placeholder, placeholder = _b === void 0 ? "Search here" : _b, renderItemsFooter = mergedProps.renderItemsFooter, ListItem = mergedProps.listItem, onItemsFooterSelect = mergedProps.onItemsFooterSelect, hideLabel = mergedProps.hideLabel, testId = mergedProps.testId, value = mergedProps.value, optional = mergedProps.optional, emptyValue = mergedProps.emptyValue, defaultValue = mergedProps.defaultValue, __internal__open = mergedProps.__internal__open, __internal__highlightedIndex = mergedProps.__internal__highlightedIndex, __internal__loading = mergedProps.__internal__loading, __internal__focus = mergedProps.__internal__focus, _c = mergedProps.__internal__items, __internal__items = _c === void 0 ? [] : _c;
    var hasFooter = !!renderItemsFooter;
    var auxId = useMemo(function () { return "auto-complete-aux-" + nanoid(); }, []);
    var footerId = useMemo(function () { return (hasFooter ? "footer-id-" + nanoid() : ""); }, [
        hasFooter,
    ]);
    var _d = useGetItems(props.getItems, footerId, hasFooter), data = _d.items, getItems = _d.getItems, status = _d.status;
    var _e = getFieldErrors(error), fieldErrors = _e.fieldErrors, hasErrors = _e.hasErrors;
    var describedBy = helpText || hasErrors ? auxId : undefined;
    var itemToString = function (item) {
        if (item.id === footerId) {
            return "";
        }
        return itemToStringFn ? itemToStringFn === null || itemToStringFn === void 0 ? void 0 : itemToStringFn(item) : item ? String(item) : "";
    };
    var inputRef = useRef(null);
    var defaultItems = value && !lodash_isequal(value, emptyValue) ? [value] : __internal__items;
    var items = data.length ? data : defaultItems;
    var _f = useCombobox({
        items: items,
        defaultSelectedItem: value || defaultValue || emptyValue,
        onInputValueChange: function (changed) {
            getItems(changed);
        },
        onSelectedItemChange: function (_a) {
            var selectedItem = _a.selectedItem;
            /**
             * 🦘 Handle the case where the menu has extra footer (eg. Cant find)
             * and we need to call onItemsFooterSelect when that item is selected.
             */
            if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === footerId) {
                onItemsFooterSelect === null || onItemsFooterSelect === void 0 ? void 0 : onItemsFooterSelect();
                onChange === null || onChange === void 0 ? void 0 : onChange(emptyValue);
                return;
            }
            if (!selectedItem) {
                onChange === null || onChange === void 0 ? void 0 : onChange(emptyValue);
                return;
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(selectedItem);
        },
        itemToString: itemToString,
    }), isOpen = _f.isOpen, getMenuProps = _f.getMenuProps, getInputProps = _f.getInputProps, getItemProps = _f.getItemProps, getComboboxProps = _f.getComboboxProps, getToggleButtonProps = _f.getToggleButtonProps, highlightedIndex = _f.highlightedIndex, inputValue = _f.inputValue, selectItem = _f.selectItem, closeMenu = _f.closeMenu, setInputValue = _f.setInputValue, selectedItem = _f.selectedItem;
    var onClear = function () {
        var _a;
        selectItem(emptyValue);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        closeMenu();
    };
    var menuIsOpen = isOpen || (__internal__open !== null && __internal__open !== void 0 ? __internal__open : false);
    var showClearIcon = (menuIsOpen && items.length > 0) || inputValue !== "";
    var showMagnifier = !showClearIcon;
    var loading = status === "LOADING" || __internal__loading;
    var renderListItem = function (record) {
        if (ListItem) {
            return jsx$1(ListItem, { inputValue: inputValue, item: record }, void 0);
        }
        return (jsx$1("span", __assign({ css: theme.autoComplete.getCSS({ targetElement: "listItemContent" }) }, { children: itemToString ? itemToString(record) : record }), void 0));
    };
    var wrapperRef = useWrapperFocus({
        onBlur: function () {
            if (highlightedIndex === -1) {
                setInputValue(itemToString(selectedItem));
            }
            setTimeout(function () {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur();
            });
        },
    });
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, hideLabel: hideLabel, auxId: auxId, helpText: helpText, errors: fieldErrors, testId: testId }, { children: jsxs("div", __assign({ ref: wrapperRef, css: theme.autoComplete.getCSS({ targetElement: "container" }) }, { children: [jsx$1("div", __assign({}, getComboboxProps(), { children: jsx$1(InternalInput, __assign({}, getInputProps({
                        refKey: "innerRef",
                        ref: mergeRefs([innerRef, inputRef]),
                    }), { label: label, describedBy: describedBy, onFocus: onFocus, placeholder: placeholder, __internal__focus: __internal__focus, autoComplete: "off", hasSuffixButton: true, isLoading: loading }), void 0) }), void 0),
                jsxs("div", __assign({ css: theme.autoComplete.getCSS({ targetElement: "right" }) }, { children: [loading && jsx$1(LoadingIcon, {}, void 0),
                        jsxs("button", __assign({ type: "button", onClick: onClear, css: theme.autoComplete.getCSS({
                                targetElement: "clearIcon",
                                showClearIcon: showClearIcon,
                            }) }, { children: [jsx$1(Icon, { name: "cross" }, void 0),
                                jsx$1(VisuallyHidden, { children: "Clear" }, void 0)] }), void 0),
                        showMagnifier && (jsxs("button", __assign({ type: "button" }, getToggleButtonProps(), { css: theme.autoComplete.getCSS({ targetElement: "searchIcon" }) }, { children: [jsx$1(Icon, { name: "search" }, void 0),
                                jsx$1(VisuallyHidden, { children: "Search" }, void 0)] }), void 0))] }), void 0),
                jsx$1("ul", __assign({}, getMenuProps(), { css: theme.autoComplete.getCSS({
                        targetElement: "ul",
                    }) }, { children: menuIsOpen &&
                        items.map(function (record, index) { return (jsx$1("li", __assign({ css: theme.autoComplete.getCSS({
                                targetElement: "li",
                                isHighlighted: highlightedIndex === index ||
                                    __internal__highlightedIndex === index,
                            }) }, getItemProps({ index: index, item: record }), { children: index === items.length - 1 && !!renderItemsFooter
                                ? renderItemsFooter()
                                : renderListItem(record) }), record.id || index)); }) }), void 0)] }), void 0) }), void 0));
}

function AutoCompleteComponent(props, ref) {
    return jsx$1(AutoComplete$1, __assign({}, props, { innerRef: ref }), void 0);
}
var AutoComplete = forwardRef(AutoCompleteComponent);
// 🚨  Ref: https://stackoverflow.com/a/58473012/340827
AutoComplete.displayName =
    ComponentNames.AutoComplete;
AutoComplete.defaultProps = defaultAutoCompleteProps;

function formatArray(arr) {
    return "[".concat(arr.map(function (item) {
        return "\"".concat(item, "\"");
    }).join(", "), "]");
}

var VARIANTS$4 = ["primary", "secondary", "icon"];
var COLORS$r = ["highlight.blue.t100", "white", "black", "green"];
var TYPES$3 = ["button", "submit"];
var DEFAULT_PROPS$E = {
    variant: "primary",
    color: "highlight.blue.t100",
    loading: false,
    disabled: false,
    type: "button",
    __internal__keyboardFocus: false,
    __internal__hover: false,
    __internal__active: false
};
Button.VARIANTS = VARIANTS$4;
Button.COLORS = COLORS$r;
Button.TYPES = TYPES$3;
Button.DEFAULT_PROPS = DEFAULT_PROPS$E;
var darkColorsMap$1 = {
    "primary.blue.t100": true,
    "highlight.blue.t100": true,
    "highlight.pink.t100": true,
    "highlight.purple.t100": true
};
var mediumColorsMap$1 = {
    "grey.t07": true,
    "grey.t10": true,
    "grey.t16": true,
    "secondary.lightBlue.t25": true,
    "secondary.pink.t30": true,
    "secondary.pink.t15": true,
    "secondary.purple.t30": true,
    "secondary.purple.t15": true,
    "secondary.turquoise.t30": true,
    "secondary.turquoise.t10": true
};
function getButtonColor(bg) {
    return darkColorsMap$1[bg] ? "white" : mediumColorsMap$1[bg] ? "black" : "highlight.blue.t100";
}
function getLoadingIconColor(bg) {
    return getButtonColor(bg);
}
function Button(props) {
    var theme = useTheme();
    var _useBackground = useBackground(), bgMap = _useBackground.bgMap;
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$E, {}, {
        variant: function variant(_variant) {
            return VARIANTS$4.includes(_variant);
        },
        color: function color(_color) {
            return COLORS$r.includes(_color);
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        type: function type(_type) {
            return TYPES$3.includes(_type);
        }
    });
    var variant = mergedProps.variant, loading = mergedProps.loading, disabled = mergedProps.disabled, type = mergedProps.type, onClick = mergedProps.onClick, children = mergedProps.children, testId = mergedProps.testId, __internal__keyboardFocus = mergedProps.__internal__keyboardFocus, __internal__hover = mergedProps.__internal__hover, __internal__active = mergedProps.__internal__active;
    var showLoadingIcon = ["primary", "secondary"].includes(variant) && props.color !== "green" && loading;
    var buttonCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$E, {
        color: function color(_, theme, bp) {
            var color = hasOwnProperty(props, "color") ? mergedProps.color : getButtonColor(bgMap === null || bgMap === void 0 ? void 0 : bgMap[bp]);
            if (color === "black" && variant !== "secondary" || color === "green" && variant !== "primary") {
                color = DEFAULT_PROPS$E.color;
            }
            return theme.button.getCSS({
                targetElement: "button",
                variant: variant,
                color: color,
                showLoadingIcon: showLoadingIcon,
                __internal__keyboardFocus: __internal__keyboardFocus,
                __internal__hover: __internal__hover,
                __internal__active: __internal__active
            });
        },
        margin: responsiveMargin,
        width: responsiveSize("width")
    });
    var loadingIconCSS = theme.button.getCSS({
        targetElement: "loadingIcon"
    });
    var contentCSS = theme.button.getCSS({
        targetElement: "content",
        showLoadingIcon: showLoadingIcon
    });
    var loadingIconColorProps = useMemo(function () {
        return getPropsFromMap("color", mapResponsiveValues(bgMap, function (bg) {
            return getLoadingIconColor(bg);
        }, theme));
    }, [bgMap, theme]);
    return jsx("button", {
        css: buttonCSS,
        disabled: showLoadingIcon || disabled,
        type: type,
        onClick: onClick,
        "data-testid": testId
    }, showLoadingIcon && jsx("span", {
        css: loadingIconCSS,
        "aria-hidden": "true"
    }, jsx(LoadingIcon, loadingIconColorProps)), jsx("span", {
        css: contentCSS
    }, children));
}
Button.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, responsiveMarginType), responsiveWidthType), {}, {
    variant: PropTypes.oneOf(VARIANTS$4),
    color: function color(props) {
        if (props.color === undefined) {
            return;
        }
        if (COLORS$r.includes(props.color) === false) {
            return new Error("Button: color=\"".concat(props.color, "\" is not supported. Must be one of: ").concat(formatArray(COLORS$r)));
        }
        if (props.variant === "primary" && ["highlight.blue.t100", "white", "green"].includes(props.color) === false) {
            return new Error("Button: variant=\"primary\" should be used only with these colors: ".concat(formatArray(["highlight.blue.t100", "white", "green"])));
        }
    },
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(TYPES$3),
    onClick: PropTypes.func,
    children: PropTypes.node,
    testId: PropTypes.string,
    __internal__keyboardFocus: PropTypes.bool,
    __internal__hover: PropTypes.bool,
    __internal__active: PropTypes.bool
});

var FormContext$1 = /*#__PURE__*/ React__default.createContext();
var FormProvider$1 = FormContext$1.Provider;
function useForm$1(componentName) {
    var context = useContext(FormContext$1);
    if (context) {
        return context;
    }
    throw new Error("".concat(componentName, " must be placed inside a Form"));
}

function useIsDeprecatedForm() {
    var context = useContext(FormContext$1);
    return !!context;
}

var defaultCheckboxProps = {
    hideLabel: false,
    disabled: false,
    __internal__keyboardFocus: false,
    optional: false,
};

var COLORS$q = ["grey.t05", "white"];
var DEFAULT_PROPS$D = {
    color: "grey.t05",
    disabled: false,
    __internal__keyboardFocus: false,
};
InternalCheckbox.COLORS = COLORS$q;
InternalCheckbox.DEFAULT_PROPS = DEFAULT_PROPS$D;
function CheckboxIcon(_a) {
    var color = _a.color, _b = _a.isChecked, isChecked = _b === void 0 ? false : _b;
    var theme = useTheme();
    var inputColorMap = useBackground().inputColorMap;
    var rectCSS = useResponsivePropsCSS({}, {}, {
        color: function (propsAtBreakpoint, theme, bp) {
            return theme.checkbox.getCSS({
                targetElement: "svgRect",
                color: color !== null && color !== void 0 ? color : inputColorMap[bp],
                isChecked: isChecked,
            });
        },
    });
    return (jsxs("svg", __assign({ css: theme.checkbox.getCSS({ targetElement: "svg" }), viewBox: "0 0 100 100", focusable: "false", "aria-hidden": "true" }, { children: [jsx$1("rect", { css: rectCSS, width: "100", height: "100", rx: "16" }, void 0),
            isChecked && (jsx$1("path", { css: theme.checkbox.getCSS({ targetElement: "svgPath" }), d: "M21 51 l22 18 l35 -39", fill: "transparent", strokeWidth: "14", strokeLinecap: "round", strokeLinejoin: "round" }, void 0))] }), void 0));
}
CheckboxIcon.propTypes = {
    color: PropTypes.oneOf(COLORS$q),
    isChecked: PropTypes.bool.isRequired,
};
function InternalCheckbox(_props) {
    var props = __assign(__assign({}, DEFAULT_PROPS$D), _props);
    var name = props.name, parentName = props.parentName, color = props.color, disabled = props.disabled, isValid = props.isValid, innerRef = props.innerRef, testId = props.testId, labelledBy = props.labelledBy, describedBy = props.describedBy, onFocus = props.onFocus, onBlur = props.onBlur, value = props.value, onChange = props.onChange, onMouseDown = props.onMouseDown, children = props.children, __internal__keyboardFocus = props.__internal__keyboardFocus;
    var theme = useTheme();
    var inputColorMap = useBackground().inputColorMap;
    var inputId = useState(function () { var _a; return (_a = props.inputId) !== null && _a !== void 0 ? _a : "checkbox-" + nanoid(); })[0];
    var labelCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$D, {
        color: function (propsAtBreakpoint, theme, bp) {
            var _a;
            return theme.checkbox.getCSS({
                targetElement: "label",
                color: (_a = _props.color) !== null && _a !== void 0 ? _a : inputColorMap[bp],
                __internal__keyboardFocus: __internal__keyboardFocus,
            });
        },
    });
    return (jsxs("div", __assign({ css: theme.checkbox.getCSS({ targetElement: "container" }) }, { children: [jsx$1(VisuallyHidden, { children: jsx$1("input", { css: theme.checkbox.getCSS({ targetElement: "input" }), ref: innerRef, "aria-invalid": isValid ? "false" : "true", "aria-labelledby": labelledBy, "aria-describedby": describedBy, type: "checkbox", "data-testid": testId, id: inputId, name: name, "data-parent-name": parentName, checked: value, disabled: disabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange }, void 0) }, void 0),
            jsxs("label", __assign({ css: labelCSS, htmlFor: inputId, onMouseDown: onMouseDown }, { children: [jsx$1(CheckboxIcon, { color: color, isChecked: value }, void 0),
                    jsx$1("span", { children: children }, void 0)] }), void 0)] }), void 0));
}

function Checkbox$2(props) {
    var mergedProps = useMergedProps(props, defaultCheckboxProps);
    var label = mergedProps.label, value = mergedProps.value, hideLabel = mergedProps.hideLabel, innerRef = mergedProps.innerRef, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, onChange = mergedProps.onChange, onFocus = mergedProps.onFocus, onBlur = mergedProps.onBlur, onMouseDown = mergedProps.onMouseDown, children = mergedProps.children, testId = mergedProps.testId, error = mergedProps.error, __internal__keyboardFocus = mergedProps.__internal__keyboardFocus;
    var labelId = useState(function () { return "radio-group-label-" + nanoid(); })[0];
    var inputId = useState(function () { return "checkbox-" + nanoid(); })[0];
    var auxId = useState(function () { return "checkbox-aux-" + nanoid(); })[0];
    var onCheckboxChange = function (event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
    };
    var fieldErrors = Array.isArray(error) || error === undefined ? error : [error];
    var hasErrors = Array.isArray(error) ? error.length !== 0 : !!error;
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, hideLabel: hideLabel, labelId: labelId, auxId: auxId, helpText: helpText, errors: fieldErrors }, { children: jsx$1(InternalCheckbox, __assign({ innerRef: innerRef, inputId: inputId, testId: testId, color: props.color, disabled: disabled, isValid: !hasErrors, labelledBy: label ? labelId : undefined, describedBy: helpText || hasErrors ? auxId : undefined, onFocus: onFocus, onBlur: onBlur, onMouseDown: onMouseDown, value: value, onChange: onCheckboxChange, __internal__keyboardFocus: __internal__keyboardFocus }, { children: children }), void 0) }), void 0));
}

function useField(componentName, _ref) {
    var name = _ref.name, disabled = _ref.disabled, optional = _ref.optional, validate = _ref.validate, data = _ref.data;
    if (typeof name !== "string" || name.trim() === "") {
        throw new Error("".concat(componentName, " component is missing a name prop"));
    }
    var _useForm = useForm$1(componentName), state = _useForm.state, onFocus = _useForm.onFocus, onBlur = _useForm.onBlur, onChange = _useForm.onChange, onMouseDown = _useForm.onMouseDown, registerField = _useForm.registerField, unregisterField = _useForm.unregisterField;
    var registerDataRef = useRef({
        registerField: registerField,
        unregisterField: unregisterField,
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    });
    if (typeof state.values === "undefined") {
        throw new Error("Form is missing initialValues");
    }
    var value = getPath(state.values, name);
    if (typeof value === "undefined") {
        throw new Error("".concat(name, " is missing in Form's initialValues"));
    }
    var errors = getPath(state.errors, name);
    var hasErrors = Array.isArray(errors) && errors.length > 0; // we need to store the data in a ref so that if the validateData prop changes, we have a reference
    // that we can update with the new value.
    useEffect(function () {
        registerDataRef.current = {
            registerField: registerField,
            unregisterField: unregisterField,
            name: name,
            disabled: disabled,
            optional: optional,
            validate: validate,
            data: data
        };
    }, [name, disabled, optional, validate, data, registerField, unregisterField]);
    useEffect(function () {
        registerField(name, registerDataRef);
        return function () {
            unregisterField(name);
        };
    }, [registerField, unregisterField, name]);
    return {
        value: value,
        errors: errors,
        hasErrors: hasErrors,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: onChange,
        onMouseDown: onMouseDown
    };
}

var COLORS$p = InternalCheckbox.COLORS;
var DEFAULT_PROPS$C = _objectSpread2(_objectSpread2({}, defaultCheckboxProps), {}, {
    color: InternalCheckbox.DEFAULT_PROPS.color,
    validate: function validate(value, _ref) {
        var isEmpty = _ref.isEmpty;
        if (isEmpty(value)) {
            return "Must be checked";
        }
        return null;
    }
});
Checkbox$1.COLORS = COLORS$p;
Checkbox$1.DEFAULT_PROPS = DEFAULT_PROPS$C;
function Checkbox$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$C, {}, {
        hideLabel: function hideLabel(_hideLabel) {
            return typeof _hideLabel === "boolean";
        },
        color: function color(_color) {
            return COLORS$p.includes(_color);
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        optional: function optional(_optional) {
            return typeof _optional === "boolean";
        }
    });
    var name = mergedProps.name, label = mergedProps.label, hideLabel = mergedProps.hideLabel, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, onChangeProp = mergedProps.onChange, children = mergedProps.children, testId = mergedProps.testId, __internal__keyboardFocus = mergedProps.__internal__keyboardFocus;
    var _useState = useState(function () {
        return "radio-group-label-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), labelId = _useState2[0];
    var _useState3 = useState(function () {
        return "checkbox-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), inputId = _useState4[0];
    var _useState5 = useState(function () {
        return "checkbox-aux-".concat(nanoid());
    }), _useState6 = _slicedToArray(_useState5, 1), auxId = _useState6[0];
    var isEmpty = useCallback(function (value) {
        return value === false;
    }, []);
    var data = useMemo(function () {
        return _objectSpread2({
            isEmpty: isEmpty
        }, validateData && {
            data: validateData
        });
    }, [isEmpty, validateData]);
    var _useField = useField("Checkbox", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, fieldOnChange = _useField.onChange, onMouseDown = _useField.onMouseDown;
    var onChange = useCallback(function (event) {
        fieldOnChange(event);
        onChangeProp && onChangeProp({
            isChecked: event.target.checked
        });
    }, [fieldOnChange, onChangeProp]);
    return jsx(Field$1, {
        optional: optional,
        disabled: disabled,
        label: label,
        hideLabel: hideLabel,
        labelId: labelId,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx(InternalCheckbox, {
        name: name,
        inputId: inputId // eslint-disable-next-line react/prop-types
        ,
        color: props.color,
        disabled: disabled,
        isValid: !hasErrors,
        labelledBy: label ? labelId : null,
        describedBy: helpText || hasErrors ? auxId : null,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: onMouseDown,
        value: value,
        onChange: onChange,
        __internal__keyboardFocus: __internal__keyboardFocus
    }, children));
}

var setDeprecatedProps$7 = function (props, isDeprecated) {
    return isDeprecated;
};

var COLORS$o = Checkbox$1.COLORS, DEFAULT_PROPS$B = Checkbox$1.DEFAULT_PROPS;
var CheckboxComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps$7(props, isDeprecatedForm)) {
        return jsx$1(Checkbox$1, __assign({}, props), void 0);
    }
    return jsx$1(Checkbox$2, __assign({}, props, { innerRef: ref }), void 0);
};
var Checkbox = forwardRef(CheckboxComponent);
Checkbox.displayName = ComponentNames.Checkbox;
Checkbox.defaultProps = defaultCheckboxProps;
Checkbox.COLORS = COLORS$o;
Checkbox.DEFAULT_PROPS = DEFAULT_PROPS$B;

var defaultCheckboxGroupProps = {
    disabled: false,
    optional: false,
};

/* Returns React children into an array, flattening fragments. */


function flattenChildren(children, depth, keys) {
    if (depth === void 0) { depth = 0; }
    if (keys === void 0) { keys = []; }
    return React__default.Children.toArray(children).reduce(function (acc, node, nodeIndex) {
        if (reactIs.isFragment(node)) {
            acc.push.apply(acc, flattenChildren(node.props.children, depth + 1, keys.concat(node.key || nodeIndex)));
        }
        else {
            if (React__default.isValidElement(node)) {
                acc.push(React__default.cloneElement(node, {
                    key: keys.concat(String(node.key)).join('.')
                }));
            }
            else if (typeof node === "string" || typeof node === "number") {
                acc.push(node);
            }
        }
        return acc;
    }, []);
}
var _default = flattenChildren;

var DIRECTIONS$1 = ["vertical", "horizontal"];
var ALIGNMENTS = ["normal", "left", "center", "right"];
var DEFAULT_PROPS$A = {
    direction: "vertical",
    align: "normal",
    gap: "0",
    flatten: false,
};
Stack.DIRECTIONS = DIRECTIONS$1;
Stack.ALIGNMENTS = ALIGNMENTS;
Stack.DEFAULT_PROPS = DEFAULT_PROPS$A;
function Stack(props) {
    var mergedProps = useMergedProps(props, DEFAULT_PROPS$A);
    var flatten = mergedProps.flatten, children = mergedProps.children, testId = mergedProps.testId;
    var maybeFlattenedChildren = flatten
        ? _default(children)
        : React__default.Children.toArray(children);
    var direction = useResponsiveProp(mergedProps, "direction");
    var flexWrapperCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$A, {
        margin: responsiveMargin,
        width: responsiveSize("width"),
        gap: function (_a, theme) {
            var gap = _a.gap;
            var gapValues = getGapValues(gap, theme);
            if (gapValues === null) {
                return {};
            }
            var rowGap = gapValues.rowGap;
            return {
                "::before": {
                    marginTop: "-" + (parseInt(rowGap, 10) + 1) + "px",
                },
            };
        },
    });
    var flexCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$A, {
        align: function (_a) {
            var _b;
            var direction = _a.direction, align = _a.align;
            if (!align) {
                return {};
            }
            return _b = {},
                _b[direction === "horizontal" ? "justifyContent" : "alignItems"] = [
                    "normal",
                    "center",
                ].includes(align)
                    ? align
                    : align === "right"
                        ? "flex-end"
                        : "flex-start",
                _b;
        },
        gap: function (_a, theme) {
            var gap = _a.gap;
            var gapValues = getGapValues(gap, theme);
            if (gapValues === null) {
                return {};
            }
            var columnGap = gapValues.columnGap;
            return {
                marginLeft: "-" + columnGap,
            };
        },
    });
    var childCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$A, {
        gap: function (_a, theme) {
            var gap = _a.gap;
            var gapValues = getGapValues(gap, theme);
            if (gapValues === null) {
                return {};
            }
            var rowGap = gapValues.rowGap, columnGap = gapValues.columnGap;
            return {
                marginTop: rowGap,
                marginLeft: columnGap,
            };
        },
    });
    return (jsx$1("div", __assign({ css: mergeResponsiveCSS({
            paddingTop: "1px",
            "::before": {
                content: '""',
                display: "block",
            },
        }, flexWrapperCSS), "data-testid": testId }, { children: jsx$1("div", __assign({ css: __assign({ display: "flex", flexDirection: direction === "horizontal" ? undefined : "column", flexWrap: direction === "horizontal" ? "wrap" : undefined }, flexCSS) }, { children: maybeFlattenedChildren
                .filter(function (child) { return child != null; })
                .map(function (child, index) { return (jsx$1("div", __assign({ css: __assign({ ":empty": {
                        display: "none",
                    } }, childCSS) }, { children: child }), index)); }) }), void 0) }), void 0));
}

var getValues = function (values, options) {
    return options
        .map(function (val) { return val.key; })
        .reduce(function (acc, curr) {
        var _a;
        var _b;
        return (__assign(__assign({}, acc), (_a = {}, _a[curr] = (_b = values[curr]) !== null && _b !== void 0 ? _b : false, _a)));
    }, {});
};
var CheckboxGroup$2 = function (props) {
    var _a;
    var mergedProps = useMergedProps(props, defaultCheckboxGroupProps);
    var name = mergedProps.name, label = mergedProps.label, options = mergedProps.options, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, _b = mergedProps.innerRef, innerRef = _b === void 0 ? null : _b, onChangeProp = mergedProps.onChange, onMouseDown = mergedProps.onMouseDown, error = mergedProps.error, onFocus = mergedProps.onFocus, onBlur = mergedProps.onBlur, testId = mergedProps.testId;
    var _c = useState(getValues({}, options)), internalValue = _c[0], setInternalValue = _c[1];
    var value = (_a = mergedProps.value) !== null && _a !== void 0 ? _a : internalValue;
    if (!options) {
        throw new Error("CheckboxGroup options are invalid");
    }
    var labelId = useState(function () { return "checkbox-group-label-" + nanoid(); })[0];
    var auxId = useState(function () { return "checkbox-group-aux-" + nanoid(); })[0];
    var onChange = function (event) {
        var _a;
        var newValue = getValues(__assign(__assign({}, value), (_a = {}, _a[event.target.name] = event.target.checked, _a)), options);
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(newValue);
        setInternalValue(newValue);
    };
    var fieldErrors = Object.values(error !== null && error !== void 0 ? error : {});
    var hasErrors = !!error;
    var checkboxRef = useRef(null);
    var onCheckboxBlur = useCallback(function (event) {
        var _a;
        if (!((_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        }
    }, [onBlur]);
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, labelId: labelId, auxId: auxId, helpText: helpText, errors: fieldErrors, testId: testId }, { children: jsx$1("div", __assign({ ref: mergeRefs([checkboxRef, innerRef]) }, { children: jsx$1(Stack, __assign({ gap: "1" }, { children: options.map(function (_a) {
                    var _b;
                    var key = _a.key, label = _a.label;
                    return (jsx$1(InternalCheckbox, __assign({ name: key, parentName: name, color: props.color, disabled: disabled, isValid: !hasErrors, onFocus: onFocus, onBlur: onCheckboxBlur, onMouseDown: onMouseDown, value: (_b = value[key]) !== null && _b !== void 0 ? _b : false, onChange: onChange }, { children: label }), key));
                }) }), void 0) }), void 0) }), void 0));
};

var COLORS$n = InternalCheckbox.COLORS;
var DEFAULT_PROPS$z = _objectSpread2(_objectSpread2({}, defaultCheckboxGroupProps), {}, {
    color: InternalCheckbox.DEFAULT_PROPS.color,
    validate: function validate(value, _ref) {
        var isEmpty = _ref.isEmpty;
        if (isEmpty(value)) {
            return "Please make a selection.";
        }
        return null;
    }
});
CheckboxGroup$1.COLORS = COLORS$n;
CheckboxGroup$1.DEFAULT_PROPS = DEFAULT_PROPS$z;
function getKeyFromName(name) {
    var index = name.lastIndexOf(".");
    return name.slice(index + 1);
}
function CheckboxGroup$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$z, {}, {
        color: function color(_color) {
            return COLORS$n.includes(_color);
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        optional: function optional(_optional) {
            return typeof _optional === "boolean";
        },
        options: function options(_options) {
            return areCheckboxOptionsValid(_options);
        }
    });
    var name = mergedProps.name, label = mergedProps.label, options = mergedProps.options, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, onChangeProp = mergedProps.onChange, testId = mergedProps.testId;
    if (!options) {
        throw new Error("CheckboxGroup options are invalid");
    }
    var _useState = useState(function () {
        return "checkbox-group-label-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), labelId = _useState2[0];
    var _useState3 = useState(function () {
        return "checkbox-group-aux-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), auxId = _useState4[0];
    var isEmpty = useCallback(function (value) {
        for (var key in value) {
            if (value[key] === true) {
                return false;
            }
        }
        return true;
    }, []);
    var data = useMemo(function () {
        return _objectSpread2({
            isEmpty: isEmpty
        }, validateData && {
            data: validateData
        });
    }, [isEmpty, validateData]);
    var _useField = useField("CheckboxGroup", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, fieldOnChange = _useField.onChange, onMouseDown = _useField.onMouseDown;
    var onChange = useCallback(function (event) {
        fieldOnChange(event);
        onChangeProp && onChangeProp({
            value: _objectSpread2(_objectSpread2({}, value), {}, _defineProperty({}, getKeyFromName(event.target.name), event.target.checked))
        });
    }, [fieldOnChange, onChangeProp, value]);
    return jsx(Field$1, {
        optional: optional,
        disabled: disabled,
        label: label,
        labelId: labelId,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx(Stack, {
        gap: "1"
    }, options.map(function (_ref2) {
        var key = _ref2.key, label = _ref2.label;
        return jsx(InternalCheckbox, {
            name: "".concat(name, ".").concat(key),
            parentName: name // eslint-disable-next-line react/prop-types
            ,
            color: props.color,
            disabled: disabled,
            isValid: !hasErrors,
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseDown: onMouseDown,
            value: value[key],
            onChange: onChange,
            key: key
        }, label);
    })));
}

var setDeprecatedProps$6 = function (props, isDeprecated) {
    return isDeprecated;
};

var COLORS$m = CheckboxGroup$1.COLORS, DEFAULT_PROPS$y = CheckboxGroup$1.DEFAULT_PROPS;
var CheckboxGroupComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps$6(props, isDeprecatedForm)) {
        return jsx$1(CheckboxGroup$1, __assign({}, props), void 0);
    }
    return jsx$1(CheckboxGroup$2, __assign({}, props, { innerRef: ref }), void 0);
};
var CheckboxGroup = forwardRef(CheckboxGroupComponent);
CheckboxGroup.displayName = ComponentNames.CheckboxGroup;
CheckboxGroup.defaultProps = defaultCheckboxGroupProps;
CheckboxGroup.COLORS = COLORS$m;
CheckboxGroup.DEFAULT_PROPS = DEFAULT_PROPS$y;

var BACKGROUNDS$1 = ["transparent", "white", "grey.t03", "grey.t05", "grey.t07", "secondary.lightBlue.t15", "secondary.lightBlue.t25", "primary.blue.t100"];
var borderColorMap = {
    transparent: "grey.t16",
    white: "grey.t16",
    "grey.t03": "grey.t10",
    "grey.t05": "grey.t16",
    "grey.t07": "grey.t16",
    "secondary.lightBlue.t15": "secondary.lightBlue.t60",
    "secondary.lightBlue.t25": "secondary.lightBlue.t80",
    "primary.blue.t100": "white"
};
var BOX_SHADOWS = ["header"];
var DEFAULT_PROPS$x = {
    bg: "transparent",
    flexGrow: false,
    hasBorder: false,
    hasBreakpointWidth: false,
    hide: false
};
Container.BACKGROUNDS = BACKGROUNDS$1;
Container.BOX_SHADOWS = BOX_SHADOWS;
Container.DEFAULT_PROPS = DEFAULT_PROPS$x;
function Container(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$x), _props); // eslint-disable-next-line react/prop-types
    var boxShadow = props.boxShadow, textStyle = props.textStyle, children = props.children, testId = props.testId;
    var theme = useTheme();
    var _useBackground = useBackground(), inheritedBgMap = _useBackground.bgMap;
    var myBgMap = getResponsivePropMap(_props, DEFAULT_PROPS$x, "bg", theme);
    var mergedResponsiveBgMap = mergeResponsivePropMaps(inheritedBgMap, myBgMap, theme);
    var responsiveCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$x, {
        margin: responsiveMargin,
        padding: responsivePadding,
        width: responsiveSize("width"),
        height: responsiveSize("height"),
        textAlign: responsiveTextAlign,
        overflow: responsiveOverflow,
        hasBreakpointWidth: responsiveHasBreakpointWidth,
        bg: function bg(_ref, theme, bp) {
            var hasBorder = _ref.hasBorder;
            var bg = mergedResponsiveBgMap[bp] === "transparent" ? "transparent" : mergedResponsiveBgMap[bp];
            var borderColor = hasBorder ? borderColorMap[bg] : null;
            return _objectSpread2({
                backgroundColor: bg === "transparent" ? "transparent" : theme.getColor(bg)
            }, borderColor && {
                border: "".concat(theme.borderWidths[0], " solid ").concat(theme.getColor(borderColor))
            });
        },
        flexGrow: function flexGrow(_ref2) {
            var _flexGrow = _ref2.flexGrow;
            if (_flexGrow) {
                return {
                    flexGrow: 1
                };
            }
            return {};
        },
        hide: function hide(_ref3) {
            var _hide = _ref3.hide;
            return _hide ? {
                display: "none"
            } : {};
        }
    });
    var container = jsx("div", {
        css: /*#__PURE__*/ css$1(_objectSpread2(_objectSpread2({
            boxSizing: "border-box"
        }, responsiveCSS), boxShadow === "header" && {
            "::after": {
                content: "''",
                display: "block",
                height: theme.borderWidths[1],
                boxShadow: theme.shadows.header
            }
        }), process.env.NODE_ENV === "production" ? "" : ";label:container;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        "data-testid": testId
    }, children);
    if (textStyle) {
        container = jsx(TextStyleProvider, {
            value: textStyle
        }, container);
    }
    return jsx(BackgroundProvider, {
        value: mergedResponsiveBgMap
    }, container);
} // Container.propTypes = {

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$1 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$1.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$1.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$1.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$1.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$1.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$1.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$1.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters$1.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

var isDateInputEmpty = function (_a, props) {
    var day = _a.day, month = _a.month, year = _a.year;
    return (props.dayMode === "none" || day.trim() === "") &&
        month.trim() === "" &&
        year.trim() === "";
};
var DAY_REGEX = /^([012]?[1-9]|[123]0|31)$/;
var MONTH_REGEX = /^(0?[1-9]|1[012])$/;
var TWO_DIGITS_YEAR_REGEX = /^\d{2}$/;
var FOUR_DIGITS_YEAR_REGEX = /^(19|20|21)\d{2}$/;
var validateDateInput = function (value, props) {
    var dayMode = props.dayMode, optional = props.optional, yearMode = props.yearMode;
    if (!optional && isDateInputEmpty(value, props)) {
        return { field: "Required" };
    }
    var day = value.day, month = value.month, year = value.year;
    var errors = {};
    if (dayMode === "2-digits") {
        if (DAY_REGEX.test(day) === false) {
            errors.day = "Day must be within 1-31.";
        }
    }
    if (MONTH_REGEX.test(month) === false) {
        errors.month = "Month must be within 1-12.";
    }
    if (yearMode === "2-digits") {
        if (TWO_DIGITS_YEAR_REGEX.test(year) === false) {
            errors.year = "Year must be within 00-99.";
        }
    }
    else {
        if (FOUR_DIGITS_YEAR_REGEX.test(year) === false) {
            errors.year = "Year must be within 1900-2199.";
        }
    }
    if (dayMode === "2-digits" && Object.values(errors).length === 0) {
        var twoDigitsDay = day.length === 1 ? "0" + day : day;
        var twoDigitsMonth = month.length === 1 ? "0" + month : month;
        if (isValid(parseISO((yearMode === "2-digits" ? "20" + year : year) + "-" + twoDigitsMonth + "-" + twoDigitsDay)) === false) {
            errors.field = "Invalid date.";
        }
    }
    return Object.values(errors).length ? errors : null;
};

var defaultDateInputProps = {
    dayMode: "2-digits",
    yearMode: "4-digits",
    disabled: false,
    optional: false,
};

var COLORS$l = InternalInput.COLORS;
var DAY_MODES$2 = ["none", "2-digits"];
var YEAR_MODES$2 = ["2-digits", "4-digits"];
var DEFAULT_PROPS$w = __assign(__assign({}, defaultDateInputProps), { color: InternalInput.DEFAULT_PROPS.color, validate: function (value, _a) {
        var isEmpty = _a.isEmpty, dayMode = _a.dayMode, yearMode = _a.yearMode;
        if (isEmpty(value)) {
            return "Required";
        }
        var day = value.day, month = value.month, year = value.year;
        var errors = [];
        if (dayMode === "2-digits") {
            if (DAY_REGEX.test(day) === false) {
                errors.push("Day must be within 1-31.");
            }
        }
        if (MONTH_REGEX.test(month) === false) {
            errors.push("Month must be within 1-12.");
        }
        if (yearMode === "2-digits") {
            if (TWO_DIGITS_YEAR_REGEX.test(year) === false) {
                errors.push("Year must be within 00-99.");
            }
        }
        else {
            if (FOUR_DIGITS_YEAR_REGEX.test(year) === false) {
                errors.push("Year must be within 1900-2199.");
            }
        }
        if (dayMode === "2-digits" && errors.length === 0) {
            var twoDigitsDay = day.length === 1 ? "0" + day : day;
            var twoDigitsMonth = month.length === 1 ? "0" + month : month;
            if (isValid(parseISO((yearMode === "2-digits" ? "20" + year : year) + "-" + twoDigitsMonth + "-" + twoDigitsDay)) === false) {
                errors.push("Invalid date.");
            }
        }
        return errors;
    } });
DateInput$2.COLORS = COLORS$l;
DateInput$2.DAY_MODES = DAY_MODES$2;
DateInput$2.YEAR_MODES = YEAR_MODES$2;
DateInput$2.DEFAULT_PROPS = DEFAULT_PROPS$w;
function getHelpText$2(value, dayMode, yearMode, defaultHelpText) {
    if (defaultHelpText === void 0) { defaultHelpText = ""; }
    if ((dayMode === "2-digits" && DAY_REGEX.test(value.day) === false) ||
        MONTH_REGEX.test(value.month) === false ||
        (yearMode === "2-digits" &&
            TWO_DIGITS_YEAR_REGEX.test(value.year) === false) ||
        (yearMode === "4-digits" &&
            FOUR_DIGITS_YEAR_REGEX.test(value.year) === false)) {
        return defaultHelpText;
    }
    var dayInt = dayMode === "2-digits" ? parseInt(value.day, 10) : 1;
    var monthInt = parseInt(value.month, 10);
    var yearInt = parseInt(value.year, 10);
    var date = new Date(yearMode === "2-digits" ? 2000 + yearInt : yearInt, monthInt - 1, dayInt);
    if (!isValid(date)) {
        return defaultHelpText;
    }
    return format(date, dayMode === "2-digits" ? "d MMMM yyyy" : "MMMM yyyy");
}
function DateInput$2(props) {
    var _a;
    var mergedProps = useMergedProps(props, defaultDateInputProps);
    var label = mergedProps.label, onBlur = mergedProps.onBlur, onFocus = mergedProps.onFocus, innerRef = mergedProps.innerRef, dayMode = mergedProps.dayMode, yearMode = mergedProps.yearMode, helpTextProp = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, ariaLabelledby = mergedProps["aria-labelledby"], testId = mergedProps.testId, error = mergedProps.error;
    var labelId = useMemo(function () { return "date-input-" + nanoid(); }, []);
    var auxId = useMemo(function () { return "date-input-aux-" + nanoid(); }, []);
    var _b = useState({
        day: "",
        month: "",
        year: "",
    }), internalValue = _b[0], setInternalValue = _b[1];
    var value = (_a = mergedProps.value) !== null && _a !== void 0 ? _a : internalValue;
    var helpText = useMemo(function () { return getHelpText$2(value, dayMode, yearMode, helpTextProp); }, [value, dayMode, yearMode, helpTextProp]);
    var onChange = function (event) {
        var _a;
        var _b;
        var _c = event.target, key = _c.name, updatedValue = _c.value;
        if (key !== "day" && key !== "month" && key !== "year") {
            return;
        }
        (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, __assign(__assign({}, value), (_a = {}, _a[key] = updatedValue, _a)));
        setInternalValue(function (val) {
            var _a;
            return (__assign(__assign({}, val), (_a = {}, _a[key] = updatedValue, _a)));
        });
    };
    var dateInputRef = useRef(null);
    var onDateInputBlur = useCallback(function (event) {
        var _a;
        if (!((_a = dateInputRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        }
    }, [onBlur]);
    var fieldErrors = Object.values(error !== null && error !== void 0 ? error : {});
    var hasErrors = !!error;
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, labelId: labelId, renderLabel: ariaLabelledby === undefined, auxId: auxId, helpText: helpText, errors: fieldErrors, testId: testId }, { children: jsx$1("div", __assign({ ref: mergeRefs([dateInputRef, innerRef !== null && innerRef !== void 0 ? innerRef : null]), "aria-invalid": hasErrors ? "true" : "false", "aria-labelledby": ariaLabelledby || labelId, "aria-describedby": helpText || hasErrors ? auxId : undefined }, { children: jsxs(Grid, __assign({ cols: dayMode === "none" && yearMode === "2-digits"
                    ? 2
                    : dayMode === "2-digits" && yearMode === "4-digits"
                        ? 4
                        : 3, colsGap: 1 }, { children: [dayMode === "2-digits" && (jsx$1(Grid.Item, __assign({ colSpan: 0 }, { children: jsx$1(InternalInput, { name: "day", "aria-label": "day", variant: "numeric", color: props.color, placeholder: "DD", maxLength: "2", disabled: disabled, onFocus: onFocus, onBlur: onDateInputBlur, value: value.day, onChange: onChange }, void 0) }), void 0)),
                    jsx$1(Grid.Item, __assign({ colSpan: dayMode === "2-digits" ? 1 : 0 }, { children: jsx$1(InternalInput, { name: "month", "aria-label": "month", variant: "numeric", color: props.color, placeholder: "MM", maxLength: "2", disabled: disabled, onFocus: onFocus, onBlur: onDateInputBlur, value: value.month, onChange: onChange }, void 0) }), void 0),
                    jsx$1(Grid.Item, __assign({ colSpan: dayMode === "none" && yearMode === "2-digits"
                            ? "1"
                            : dayMode === "none" && yearMode === "4-digits"
                                ? "1-2"
                                : dayMode === "2-digits" && yearMode === "2-digits"
                                    ? "2"
                                    : "2-3" }, { children: jsx$1(InternalInput, { name: "year", "aria-label": "year", variant: "numeric", color: props.color, placeholder: yearMode === "2-digits" ? "YY" : "YYYY", maxLength: yearMode === "2-digits" ? "2" : "4", disabled: disabled, onFocus: onFocus, onBlur: onDateInputBlur, value: value.year, onChange: onChange }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
}
DateInput$2.defaultProps = {
    optional: true,
};

var COLORS$k = InternalInput.COLORS;
var DAY_MODES$1 = ["none", "2-digits"];
var YEAR_MODES$1 = ["2-digits", "4-digits"];
var DEFAULT_PROPS$v = _objectSpread2(_objectSpread2({}, defaultDateInputProps), {}, {
    color: InternalInput.DEFAULT_PROPS.color,
    validate: function validate(value, _ref) {
        var isEmpty = _ref.isEmpty, dayMode = _ref.dayMode, yearMode = _ref.yearMode;
        if (isEmpty(value)) {
            return "Required";
        }
        var day = value.day, month = value.month, year = value.year;
        var errors = [];
        if (dayMode === "2-digits") {
            if (DAY_REGEX.test(day) === false) {
                errors.push("Day must be within 1-31.");
            }
        }
        if (MONTH_REGEX.test(month) === false) {
            errors.push("Month must be within 1-12.");
        }
        if (yearMode === "2-digits") {
            if (TWO_DIGITS_YEAR_REGEX.test(year) === false) {
                errors.push("Year must be within 00-99.");
            }
        }
        else {
            if (FOUR_DIGITS_YEAR_REGEX.test(year) === false) {
                errors.push("Year must be within 1900-2199.");
            }
        }
        if (dayMode === "2-digits" && errors.length === 0) {
            var twoDigitsDay = day.length === 1 ? "0".concat(day) : day;
            var twoDigitsMonth = month.length === 1 ? "0".concat(month) : month;
            if (isValid(parseISO("".concat(yearMode === "2-digits" ? "20".concat(year) : year, "-").concat(twoDigitsMonth, "-").concat(twoDigitsDay))) === false) {
                errors.push("Invalid date.");
            }
        }
        return errors;
    }
});
DateInput$1.COLORS = COLORS$k;
DateInput$1.DAY_MODES = DAY_MODES$1;
DateInput$1.YEAR_MODES = YEAR_MODES$1;
DateInput$1.DEFAULT_PROPS = DEFAULT_PROPS$v;
function getHelpText$1(value, dayMode, yearMode, defaultHelpText) {
    if (dayMode === "2-digits" && DAY_REGEX.test(value.day) === false || MONTH_REGEX.test(value.month) === false || yearMode === "2-digits" && TWO_DIGITS_YEAR_REGEX.test(value.year) === false || yearMode === "4-digits" && FOUR_DIGITS_YEAR_REGEX.test(value.year) === false) {
        return defaultHelpText;
    }
    var dayInt = dayMode === "2-digits" ? parseInt(value.day, 10) : 1;
    var monthInt = parseInt(value.month, 10);
    var yearInt = parseInt(value.year, 10);
    var date = new Date(yearMode === "2-digits" ? 2000 + yearInt : yearInt, monthInt - 1, dayInt);
    if (isNaN(date)) {
        return defaultHelpText;
    }
    return format(date, dayMode === "2-digits" ? "d MMMM yyyy" : "MMMM yyyy");
}
function DateInput$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$v, {}, {
        color: function color(_color) {
            return COLORS$k.includes(_color);
        },
        dayMode: function dayMode(_dayMode) {
            return DAY_MODES$1.includes(_dayMode);
        },
        yearMode: function yearMode(_yearMode) {
            return YEAR_MODES$1.includes(_yearMode);
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        optional: function optional(_optional) {
            return typeof _optional === "boolean";
        },
        "aria-labelledby": function ariaLabelledby(_ariaLabelledby) {
            return typeof _ariaLabelledby === "string" && _ariaLabelledby.trim() !== "";
        }
    });
    var name = mergedProps.name, label = mergedProps.label, dayMode = mergedProps.dayMode, yearMode = mergedProps.yearMode, helpTextProp = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, ariaLabelledby = mergedProps["aria-labelledby"], testId = mergedProps.testId;
    var _useState = useState(function () {
        return "date-input-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), labelId = _useState2[0];
    var _useState3 = useState(function () {
        return "date-input-aux-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), auxId = _useState4[0];
    var isEmpty = useCallback(function (_ref2) {
        var day = _ref2.day, month = _ref2.month, year = _ref2.year;
        return (dayMode === "none" || day.trim() === "") && month.trim() === "" && year.trim() === "";
    }, [dayMode]);
    var data = useMemo(function () {
        return _objectSpread2({
            isEmpty: isEmpty,
            dayMode: dayMode,
            yearMode: yearMode
        }, validateData && {
            data: validateData
        });
    }, [isEmpty, dayMode, yearMode, validateData]);
    var _useField = useField("DateInput", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, onChange = _useField.onChange;
    var helpText = useMemo(function () {
        return getHelpText$1(value, dayMode, yearMode, helpTextProp);
    }, [value, dayMode, yearMode, helpTextProp]);
    return jsx(Field$1, {
        optional: optional,
        disabled: disabled,
        label: label,
        labelId: labelId,
        renderLabel: ariaLabelledby === undefined,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx("div", {
        "aria-invalid": hasErrors ? "true" : null,
        "aria-labelledby": ariaLabelledby || labelId,
        "aria-describedby": helpText || hasErrors ? auxId : null
    }, jsx(Grid, {
        cols: dayMode === "none" && yearMode === "2-digits" ? 2 : dayMode === "2-digits" && yearMode === "4-digits" ? 4 : 3,
        colsGap: 1
    }, dayMode === "2-digits" && jsx(Grid.Item, {
        colSpan: 0
    }, jsx(InternalInput, {
        name: "".concat(name, ".day"),
        parentName: name,
        variant: "numeric",
        color: props.color,
        placeholder: "DD",
        maxLength: "2",
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value.day,
        onChange: onChange
    })), jsx(Grid.Item, {
        colSpan: dayMode === "2-digits" ? 1 : 0
    }, jsx(InternalInput, {
        name: "".concat(name, ".month"),
        parentName: name,
        variant: "numeric",
        color: props.color,
        placeholder: "MM",
        maxLength: "2",
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value.month,
        onChange: onChange
    })), jsx(Grid.Item, {
        colSpan: dayMode === "none" && yearMode === "2-digits" ? "1" : dayMode === "none" && yearMode === "4-digits" ? "1-2" : dayMode === "2-digits" && yearMode === "2-digits" ? "2" : "2-3"
    }, jsx(InternalInput, {
        name: "".concat(name, ".year"),
        parentName: name,
        variant: "numeric",
        color: props.color,
        placeholder: yearMode === "2-digits" ? "YY" : "YYYY",
        maxLength: yearMode === "2-digits" ? "2" : "4",
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value.year,
        onChange: onChange
    })))));
}
DateInput$1.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.oneOf(COLORS$k),
    label: PropTypes.string,
    dayMode: PropTypes.oneOf(DAY_MODES$1),
    yearMode: PropTypes.oneOf(YEAR_MODES$1),
    helpText: PropTypes.string,
    disabled: PropTypes.bool,
    optional: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    validateData: PropTypes.any,
    "aria-labelledby": PropTypes.string,
    testId: PropTypes.string
};

var setDeprecatedProps$5 = function (props, isDeprecated) {
    return isDeprecated;
};

var COLORS$j = DateInput$2.COLORS, DEFAULT_PROPS$u = DateInput$2.DEFAULT_PROPS, DAY_MODES = DateInput$2.DAY_MODES, YEAR_MODES = DateInput$2.YEAR_MODES;
var DateInputComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps$5(props, isDeprecatedForm)) {
        return jsx$1(DateInput$1, __assign({}, props), void 0);
    }
    return jsx$1(DateInput$2, __assign({}, props, { innerRef: ref }), void 0);
};
// can't be an arrow function due to: https://github.com/yannickcr/eslint-plugin-react/issues/2269
var DateInput = forwardRef(DateInputComponent);
DateInput.displayName = ComponentNames.DateInput;
DateInput.defaultProps = defaultDateInputProps;
DateInput.YEAR_MODES = YEAR_MODES;
DateInput.DAY_MODES = DAY_MODES;
DateInput.COLORS = COLORS$j;
DateInput.DEFAULT_PROPS = DEFAULT_PROPS$u;

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var COLORS$i = ["grey.t07"];
var DEFAULT_PROPS$t = {
    color: "grey.t07"
};
Divider.DEFAULT_PROPS = DEFAULT_PROPS$t;
var _ref = process.env.NODE_ENV === "production" ? {
    name: "kz14hk",
    styles: "transform:translateX(-4px);width:calc(100% + 4px);height:100%"
} : {
    name: "qj04v7-Divider",
    styles: "transform:translateX(-4px);width:calc(100% + 4px);height:100%;label:Divider;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
function Divider(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$t), _props);
    var color = props.color, testId = props.testId;
    var _useState = useState(function () {
        return "divider-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), patternId = _useState2[0];
    var theme = useTheme();
    var circleColor = theme.getColor(color);
    var responsiveCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$t, {
        margin: responsiveMargin
    });
    return jsx("svg", {
        css: responsiveCSS,
        width: "100%",
        height: "24",
        focusable: "false",
        role: "img",
        "data-testid": testId
    }, jsx("pattern", {
        id: patternId,
        x: "0",
        y: "0",
        width: "15",
        height: "24",
        patternUnits: "userSpaceOnUse"
    }, jsx("circle", {
        cx: "3",
        cy: "3",
        r: "3",
        fill: circleColor
    }), jsx("circle", {
        cx: "10.5",
        cy: "12",
        r: "3",
        fill: circleColor
    }), jsx("circle", {
        cx: "3",
        cy: "21",
        r: "3",
        fill: circleColor
    })), jsx("rect", {
        css: _ref,
        x: "0",
        y: "0",
        fill: "url(#".concat(patternId, ")")
    }));
}
Divider.propTypes = _objectSpread2(_objectSpread2({}, responsiveMarginType), {}, {
    color: PropTypes.oneOf(COLORS$i),
    testId: PropTypes.string
});

function useAllResponsiveProps(props, propName) {
    var theme = useTheme();
    var breakpoints = Object.keys(theme.breakpoints);
    var result = {};
    if (hasOwnProperty(props, propName)) {
        result[propName] = props[propName];
    }
    breakpoints.forEach(function (bp) {
        var prop = getPropName(propName, bp);
        if (hasOwnProperty(props, prop)) {
            result[prop] = props[prop];
        }
    });
    return result;
}

var COLORS$h = ["grey.t05", "white"];
function DropdownDefaultPlaceholder() {
    return jsx(Text, null, "Please select");
}
var DEFAULT_PROPS$s = {
    color: "grey.t05",
    placeholderComponent: DropdownDefaultPlaceholder,
    disabled: false,
    isValid: true,
    maxHeight: "600",
    __internal__focus: false,
    __internal__open: false
};
InternalDropdown.COLORS = COLORS$h;
InternalDropdown.DEFAULT_PROPS = DEFAULT_PROPS$s;
function InternalDropdown(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$s), _props);
    var name = props.name, parentName = props.parentName, PlaceholderComponent = props.placeholderComponent, OptionComponent = props.optionComponent, options = props.options, selectedOption = props.selectedOption, isOpen = props.isOpen, toggleButtonProps = props.toggleButtonProps, getMenuProps = props.getMenuProps, getItemProps = props.getItemProps, highlightedIndex = props.highlightedIndex, onFocus = props.onFocus, __internal__focus = props.__internal__focus, __internal__open = props.__internal__open, __internal__highlightedIndex = props.__internal__highlightedIndex;
    var theme = useTheme();
    var _useBackground = useBackground(), inputColorMap = _useBackground.inputColorMap;
    var colorMap = mapResponsiveValues(inputColorMap, function (inputColor) {
        var _props$color;
        return (_props$color = _props.color) !== null && _props$color !== void 0 ? _props$color : inputColor;
    }, theme);
    var buttonCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$s, {
        color: function color(propsAtBreakpoint, theme, bp) {
            return theme.dropdown.getCSS({
                targetElement: "button",
                color: colorMap[bp],
                isPlaceholder: !selectedOption,
                __internal__focus: __internal__focus
            });
        }
    });
    var optionsCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$s, {
        maxHeight: responsiveSize("maxHeight")
    });
    var menuProps = getMenuProps({
        "data-parent-name": parentName !== null && parentName !== void 0 ? parentName : name,
        onFocus: onFocus
    });
    return jsx("div", {
        css: theme.dropdown.getCSS({
            targetElement: "container"
        })
    }, jsx("button", _extends$1({
        css: buttonCSS,
        type: "button",
        name: name,
        "data-parent-name": parentName !== null && parentName !== void 0 ? parentName : name
    }, toggleButtonProps), jsx(BackgroundProvider, {
        value: colorMap
    }, jsx("div", {
        css: theme.dropdown.getCSS({
            targetElement: "buttonContent"
        })
    }, selectedOption ? jsx(OptionComponent, selectedOption) : jsx(PlaceholderComponent, null)), jsx("div", {
        css: theme.dropdown.getCSS({
            targetElement: "buttonChevron"
        })
    }, jsx(Icon, {
        name: "triangle-down",
        color: "black"
    })))), jsx("ul", _extends$1({
        css: /*#__PURE__*/ css$1(_objectSpread2(_objectSpread2({}, theme.dropdown.getCSS({
            targetElement: "options"
        })), optionsCSS), process.env.NODE_ENV === "production" ? "" : ";label:InternalDropdown;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }, menuProps), jsx(BackgroundProvider, {
        value: "white"
    }, (isOpen || __internal__open) && options.map(function (option, index) {
        return jsx("li", _extends$1({
            css: theme.dropdown.getCSS({
                targetElement: "option",
                isHighlighted: (__internal__highlightedIndex !== null && __internal__highlightedIndex !== void 0 ? __internal__highlightedIndex : highlightedIndex) === index
            })
        }, getItemProps({
            item: option,
            index: index
        }), {
            key: index
        }), jsx(OptionComponent, option));
    }))));
}
InternalDropdown.propTypes = _objectSpread2(_objectSpread2({
    name: PropTypes.string.isRequired,
    parentName: PropTypes.string,
    // While Dropdown doesn't pass a parentName, a composite component that contains an InternalDropdown would.
    color: PropTypes.oneOf(COLORS$h),
    PlaceholderComponent: PropTypes.func,
    optionComponent: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        data: PropTypes.object.isRequired,
        value: PropTypes.string.isRequired
    })).isRequired,
    selectedOption: PropTypes.shape({
        data: PropTypes.object.isRequired,
        value: PropTypes.string.isRequired
    }),
    isOpen: PropTypes.bool.isRequired,
    toggleButtonProps: PropTypes.object.isRequired,
    getMenuProps: PropTypes.func.isRequired,
    getItemProps: PropTypes.func.isRequired,
    highlightedIndex: PropTypes.number.isRequired,
    onFocus: PropTypes.func.isRequired
}, responsiveMaxHeightType), {}, {
    __internal__focus: PropTypes.bool,
    __internal__open: PropTypes.bool,
    __internal__highlightedIndex: PropTypes.number
});

var COLORS$g = InternalDropdown.COLORS;
function isOptionSelected$2(options, value) {
    return options.findIndex(function (option) {
        return option.value === value;
    }) > -1;
}
var DEFAULT_PROPS$r = {
    hideLabel: false,
    color: InternalDropdown.DEFAULT_PROPS.color,
    placeholderComponent: InternalDropdown.DEFAULT_PROPS.placeholderComponent,
    disabled: false,
    validate: function validate(value, _ref) {
        var isEmpty = _ref.isEmpty;
        if (isEmpty(value)) {
            return "Please make a selection.";
        }
        return null;
    }
};
Dropdown.COLORS = COLORS$g;
Dropdown.DEFAULT_PROPS = DEFAULT_PROPS$r;
function Dropdown(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$r, {}, {
        hideLabel: function hideLabel(_hideLabel) {
            return typeof _hideLabel === "boolean";
        },
        color: function color(_color) {
            return COLORS$g.includes(_color);
        },
        placeholderComponent: function placeholderComponent(_placeholderComponent) {
            return typeof _placeholderComponent === "function";
        },
        optionToString: function optionToString(_optionToString) {
            return typeof _optionToString === "function";
        },
        optionComponent: function optionComponent(_optionComponent) {
            return typeof _optionComponent === "function";
        },
        helpText: function helpText(_helpText) {
            return typeof _helpText === "string";
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        options: function options(_options) {
            return areDropdownOptionsValid(_options);
        },
        onChange: function onChange(_onChange) {
            return typeof _onChange === "function";
        }
    });
    var name = mergedProps.name, label = mergedProps.label, hideLabel = mergedProps.hideLabel, placeholderComponent = mergedProps.placeholderComponent, optionToString = mergedProps.optionToString, optionComponent = mergedProps.optionComponent, options = mergedProps.options, helpText = mergedProps.helpText, disabled = mergedProps.disabled, validate = mergedProps.validate, validateData = mergedProps.validateData, propsOnChange = mergedProps.onChange, testId = mergedProps.testId, __internal__focus = mergedProps.__internal__focus, __internal__open = mergedProps.__internal__open, __internal__highlightedIndex = mergedProps.__internal__highlightedIndex;
    if (!options) {
        throw new Error("Dropdown options should have the following format: [{ data: { ... }, value: \"option-value\" }, ...]");
    }
    var _useState = useState(function () {
        return "dropdown-aux-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), auxId = _useState2[0];
    var isEmpty = useCallback(function (value) {
        return isOptionSelected$2(options, value) === false;
    }, [options]);
    var data = useMemo(function () {
        return _objectSpread2({
            isEmpty: isEmpty
        }, validateData && {
            data: validateData
        });
    }, [isEmpty, validateData]);
    var _useField = useField("Dropdown", {
        name: name,
        disabled: disabled,
        optional: false,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, fieldOnChange = _useField.onChange;
    var windowFromContext = useWindow();
    var buttonRef = useRef();
    var itemToString = useCallback(function (option) {
        return option ? optionToString(option) : "";
    }, [optionToString]);
    var initialSelectedItem = options.find(function (option) {
        return option.value === value;
    });
    var _useSelect = useSelect({
        items: options,
        itemToString: itemToString,
        initialSelectedItem: initialSelectedItem,
        onSelectedItemChange: function onSelectedItemChange(_ref2) {
            var selectedOption = _ref2.selectedItem;
            fieldOnChange({
                target: buttonRef.current,
                value: selectedOption.value
            });
            propsOnChange && propsOnChange({
                selectedOption: selectedOption
            });
        },
        environment: windowFromContext
    }), isOpen = _useSelect.isOpen, selectedOption = _useSelect.selectedItem, highlightedIndex = _useSelect.highlightedIndex, getToggleButtonProps = _useSelect.getToggleButtonProps, getMenuProps = _useSelect.getMenuProps, getItemProps = _useSelect.getItemProps;
    var isValid = !hasErrors;
    var describedBy = helpText || hasErrors ? auxId : null;
    var toggleButtonProps = useMemo(function () {
        return getToggleButtonProps({
            onFocus: onFocus,
            onBlur: onBlur,
            disabled: disabled,
            "aria-invalid": isValid ? null : "true",
            "aria-describedby": describedBy,
            ref: buttonRef
        });
    }, [getToggleButtonProps, onFocus, onBlur, disabled, isValid, describedBy]);
    var maxHeightProps = useAllResponsiveProps(props, "maxHeight");
    return jsx(Field$1, {
        optional: false,
        disabled: disabled,
        label: label,
        hideLabel: hideLabel,
        labelFor: toggleButtonProps.id,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx(InternalDropdown, _extends$1({
        name: name,
        color: props.color,
        placeholderComponent: placeholderComponent,
        optionComponent: optionComponent,
        options: options,
        selectedOption: selectedOption,
        isOpen: isOpen,
        toggleButtonProps: toggleButtonProps,
        getMenuProps: getMenuProps,
        getItemProps: getItemProps,
        highlightedIndex: highlightedIndex,
        onFocus: onFocus
    }, maxHeightProps, {
        __internal__focus: __internal__focus,
        __internal__open: __internal__open,
        __internal__highlightedIndex: __internal__highlightedIndex
    })));
}
Dropdown.propTypes = _objectSpread2(_objectSpread2({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    hideLabel: PropTypes.bool,
    color: PropTypes.oneOf(COLORS$g),
    placeholderComponent: PropTypes.func,
    optionToString: PropTypes.func.isRequired,
    optionComponent: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        data: PropTypes.object.isRequired,
        value: PropTypes.string.isRequired
    })).isRequired,
    helpText: PropTypes.string,
    disabled: PropTypes.bool
}, responsiveMaxHeightType), {}, {
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    validateData: PropTypes.any,
    onChange: PropTypes.func,
    testId: PropTypes.string,
    __internal__focus: PropTypes.bool,
    __internal__open: PropTypes.bool,
    __internal__highlightedIndex: PropTypes.number
});

var DIRECTIONS = FLEX_DIRECTIONS;
var PLACE_ITEMS = FLEX_PLACE_ITEMS;
var DEFAULT_PROPS$q = {
    direction: "row"
};
Flex.DIRECTIONS = DIRECTIONS;
Flex.PLACE_ITEMS = PLACE_ITEMS;
Flex.DEFAULT_PROPS = DEFAULT_PROPS$q;
function Flex(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$q), _props);
    var children = props.children, testId = props.testId;
    var wrapperCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$q, {
        margin: responsiveMargin,
        width: responsiveSize("width"),
        height: responsiveSize("height")
    });
    var flexCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$q, {
        placeItems: responsiveFlexPlaceItems,
        direction: responsiveFlexDirection
    });
    return jsx("div", {
        css: /*#__PURE__*/ css$1(_objectSpread2({
            display: "flex"
        }, wrapperCSS), process.env.NODE_ENV === "production" ? "" : ";label:Flex;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        "data-testid": testId
    }, jsx("div", {
        css: /*#__PURE__*/ css$1(_objectSpread2({
            display: "flex",
            width: "100%",
            height: "100%"
        }, flexCSS), process.env.NODE_ENV === "production" ? "" : ";label:Flex;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }, children));
}
Flex.propTypes = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, responsiveMarginType), responsiveWidthType), responsiveHeightType), responsivePropType("direction", PropTypes.oneOf(DIRECTIONS))), responsivePropType("placeItems", PropTypes.oneOf(PLACE_ITEMS))), {}, {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
});

var isNewProps = function (props) {
    return "methods" in props;
};

var DEFAULT_PROPS$p = {
    debug: false
};
function getParentFieldName(target) {
    var _target$dataset$paren;
    return (_target$dataset$paren = target.dataset.parentName) !== null && _target$dataset$paren !== void 0 ? _target$dataset$paren : target.name;
}
Form$2.DEFAULT_PROPS = DEFAULT_PROPS$p;
function Form$2(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$p), _props);
    var initialValues = props.initialValues, initialErrors = props.initialErrors, onSubmit = props.onSubmit, debug = props.debug, children = props.children, testId = props.testId;
    var _useState = useState({
        values: initialValues,
        errors: initialErrors !== null && initialErrors !== void 0 ? initialErrors : {},
        shouldValidateOnChange: false,
        namesToValidate: null,
        submitStatus: "READY"
    }), _useState2 = _slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var exposedState = useMemo(function () {
        return {
            values: state.values,
            errors: state.errors
        };
    }, [state.values, state.errors]);
    var fields = useRef({});
    var lastFocusedFieldName = useRef(null);
    var lastMouseDownInputElement = useRef(null);
    var onFocus = function onFocus(event) {
        var target = event.target;
        var parentName = getParentFieldName(target);
        lastFocusedFieldName.current = parentName;
        setState(function (state) {
            var errors = getPath(state.errors, parentName);
            var hasErrors = Array.isArray(errors) && errors.length > 0;
            return setPath(state, "shouldValidateOnChange", hasErrors);
        });
    };
    var onBlur = function onBlur(event) {
        var target = event.target;
        var parentName = getParentFieldName(target);
        lastFocusedFieldName.current = null;
        if (target === lastMouseDownInputElement.current) {
            lastMouseDownInputElement.current = null;
        }
        /*
          We use setTimeout in order to differentiate between onBlur to another field within
          the same parent (e.g. DateInput) and onBlur out of the parent.
        */
        setTimeout(function () {
            if (isMountedRef.current && parentName !== lastFocusedFieldName.current && (lastMouseDownInputElement.current === null || parentName !== getParentFieldName(lastMouseDownInputElement.current))) {
                setState(function (state) {
                    return setPath(state, "namesToValidate", [parentName]);
                });
            }
        });
    };
    var onChange = function onChange(event) {
        var _event$value;
        var target = event.target;
        var name = target.name;
        var isCheckbox = target.type === "checkbox";
        var newValue = isCheckbox ? target.checked : (_event$value = event.value) !== null && _event$value !== void 0 ? _event$value : target.value;
        setState(function (state) {
            var newState = setPath(state, "values.".concat(name), newValue);
            /*
              Without validating the Checkbox on every change, we have the following unwanted behaviour.
              When the Checkbox is not checked:
                1. Click the Checkbox twice (it should be unchecked again).
                2. Press the Checkbox without releasing it (validation error appears).
                3. If you resease the Checkbox now, the validation error disappears.
            */
            if (state.shouldValidateOnChange || isCheckbox && target.dataset.parentName === undefined) {
                newState = setPath(newState, "namesToValidate", [getParentFieldName(target)]);
            }
            return newState;
        });
    };
    var onMouseDown = function onMouseDown(event) {
        var target = event.target;
        var document = target.ownerDocument;
        var inputElement = document.querySelector("#".concat(target.htmlFor));
        lastMouseDownInputElement.current = inputElement;
    };
    var registerField = useCallback(function (name, field) {
        fields.current[name] = field;
    }, []);
    var unregisterField = useCallback(function (name) {
        delete fields.current[name];
        setState(function (state) {
            return deletePath(state, "errors.".concat(name), {
                deleteEmptyObjects: {
                    except: ["errors"]
                }
            });
        });
    }, []);
    var providerValue = {
        state: state,
        onFocus: onFocus,
        // should be called by inputs
        onBlur: onBlur,
        // should be called by inputs
        onChange: onChange,
        // should be called by inputs
        onMouseDown: onMouseDown,
        // should be called by input labels that have a "for" attribute
        registerField: registerField,
        unregisterField: unregisterField
    };
    var getFieldErrors = useCallback(function (values, name) {
        var _fields$current$name, _field$data;
        var value = getPath(values, name);
        /*
          Note:
          `getFieldErrors` is called by `useEffect` below when `namesToValidate` change,
          and we set `namesToValidate` inside `setTimeout` in `onBlur`. This means that
          `getFieldErrors` will be called with a little delay.
          This opens the door for `unregisterField` being called BEFORE `getFieldErrors` is called.
          Think about an input field being focused and then the user clicks on a Next button which
          unmounts the current form and mounts the next form page.
          In this case, `getFieldErrors` will be called with a `name` that doesn't exist in `fields.current`
          anymore since `unregisterField` deleted it.
          That's why we need to take case of this scenario :)
        */
        var field = (_fields$current$name = fields.current[name]) === null || _fields$current$name === void 0 ? void 0 : _fields$current$name.current;
        if (!field || // See: https://stackoverflow.com/q/65659161/247243
            field.disabled === true || field.optional === true && typeof ((_field$data = field.data) === null || _field$data === void 0 ? void 0 : _field$data.isEmpty) === "function" && field.data.isEmpty(value) === true) {
            return null;
        }
        if (typeof field.validate === "function") {
            var errors = field.validate(value, field.data);
            if (typeof errors === "string") {
                return [errors];
            }
            if (Array.isArray(errors) && errors.length > 0) {
                return errors;
            }
        }
        return null;
    }, []);
    var getNewErrors = useCallback(function (state) {
        var namesToValidate = state.namesToValidate, values = state.values;
        return namesToValidate.reduce(function (acc, name) {
            var errors = getFieldErrors(values, name);
            return errors === null ? deletePath(acc, name, {
                deleteEmptyObjects: true
            }) : setPath(acc, name, errors);
        }, state.errors);
    }, [getFieldErrors]);
    var validateField = useCallback(function (name) {
        if (fields.current[name].current) {
            setState(function (state) {
                var errors = getFieldErrors(state.values, name);
                return errors === null ? deletePath(state, "errors.".concat(name), {
                    deleteEmptyObjects: {
                        except: ["errors"]
                    }
                }) : setPath(state, "errors.".concat(name), errors);
            });
        }
        else {
            console.error("Can't validate field \"".concat(name, "\" because it's not found. Existing fields: ").concat(formatArray(Object.keys(fields.current))));
        }
    }, [getFieldErrors]);
    var submitForm = useCallback(function () {
        setState(function (state) {
            return _objectSpread2(_objectSpread2({}, state), {}, {
                namesToValidate: Object.keys(fields.current),
                submitStatus: "VALIDATE_THEN_SUBMIT"
            });
        });
    }, []);
    var onFormSubmit = useCallback(function (event) {
        event.preventDefault();
        submitForm();
    }, [submitForm]);
    var setValues = function setValues(updateValues) {
        setState(function (state) {
            return _objectSpread2(_objectSpread2({}, state), {}, {
                values: updateValues(state.values)
            });
        });
    };
    var setErrors = useCallback(function (errorsMap) {
        setState(function (state) {
            var newErrors = Object.keys(fields.current).reduce(function (acc, name) {
                if (typeof errorsMap[name] === "string") {
                    return setPath(acc, name, [errorsMap[name]]);
                }
                if (Array.isArray(errorsMap[name])) {
                    return setPath(acc, name, errorsMap[name]);
                }
                return acc;
            }, _objectSpread2({}, state.errors));
            return _objectSpread2(_objectSpread2({}, state), {}, {
                errors: newErrors
            });
        });
    }, []);
    var resetForm = function resetForm() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, values = _ref.values, errors = _ref.errors;
        setState(function (state) {
            var _ref2;
            return _objectSpread2(_objectSpread2({}, state), {}, {
                values: values !== null && values !== void 0 ? values : initialValues,
                errors: (_ref2 = errors !== null && errors !== void 0 ? errors : initialErrors) !== null && _ref2 !== void 0 ? _ref2 : {}
            });
        });
    };
    var responsiveFormCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$p, {
        width: responsiveSize("width")
    });
    var isMountedRef = useRef(true);
    useEffect(function () {
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    useEffect(function () {
        if (state.namesToValidate === null) {
            return;
        }
        setState(function (state) {
            var newState = setPath(state, "errors", getNewErrors(state));
            if (state.submitStatus === "VALIDATE_THEN_SUBMIT") {
                newState = setPath(newState, "submitStatus", "SUBMIT");
            }
            return newState;
        });
    }, [state.namesToValidate, getNewErrors]);
    useEffect(function () {
        if (state.submitStatus === "SUBMIT") {
            onSubmit && onSubmit({
                errors: state.errors,
                values: state.values,
                setErrors: setErrors
            });
            setState(function (state) {
                return setPath(state, "submitStatus", "READY");
            });
        }
    }, [state.submitStatus, state.errors, state.values, onSubmit, setErrors]);
    return jsx(FormProvider$1, {
        value: providerValue
    }, jsx("form", {
        css: responsiveFormCSS,
        method: "POST",
        action: "#" // https://stackoverflow.com/a/45705325/247243
        ,
        noValidate: true,
        onSubmit: onFormSubmit,
        "data-testid": testId
    }, typeof children === "function" ? children({
        state: exposedState,
        validateField: validateField,
        submitForm: submitForm,
        setValues: setValues,
        setErrors: setErrors,
        resetForm: resetForm
    }) : children), debug && jsx("pre", null, JSON.stringify(exposedState, null, 2)));
}
Form$2.propTypes = _objectSpread2(_objectSpread2({}, responsiveWidthType), {}, {
    initialValues: PropTypes.object.isRequired,
    initialErrors: PropTypes.object,
    onSubmit: PropTypes.func,
    debug: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
    testId: PropTypes.string
});

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !(value instanceof Date);

var getControllerValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/.\d/)) || name;

var isNameInFieldArray = (names, name) => [...names].some((current) => getNodeParentName(name) === current);

var compact = (value) => value.filter(Boolean);

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (isObject(obj) && path) {
        const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => (isNullOrUndefined(result) ? result : result[key]), obj);
        return isUndefined(result) || result === obj
            ? isUndefined(obj[path])
                ? defaultValue
                : obj[path]
            : result;
    }
    return undefined;
};

const EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

var omit = (source, key) => {
    const copy = Object.assign({}, source);
    delete copy[key];
    return copy;
};

const FormContext = React.createContext(null);
FormContext.displayName = 'RHFContext';
const useFormContext = () => React.useContext(FormContext);
const FormProvider = (props) => (React.createElement(FormContext.Provider, { value: omit(props, 'children') }, props.children));

var getProxyFormState = (isProxyEnabled, formState, readFormStateRef, localReadFormStateRef, isRoot = true) => isProxyEnabled
    ? new Proxy(formState, {
        get: (obj, prop) => {
            if (prop in obj) {
                if (readFormStateRef.current[prop] !== VALIDATION_MODE.all) {
                    readFormStateRef.current[prop] = isRoot
                        ? VALIDATION_MODE.all
                        : true;
                }
                localReadFormStateRef &&
                    (localReadFormStateRef.current[prop] = true);
                return obj[prop];
            }
            return undefined;
        },
    })
    : formState;

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, readFormStateRef, isRoot) => {
    const formState = omit(formStateData, 'name');
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(readFormStateRef).length ||
        Object.keys(formState).find((key) => readFormStateRef[key] ===
            (isRoot ? VALIDATION_MODE.all : true)));
};

var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

const isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== 'undefined';

function useFormState(props) {
    const { control, name } = props || {};
    const methods = useFormContext();
    const { formStateRef, subjectsRef, readFormStateRef } = control || methods.control;
    const nameRef = React.useRef(name);
    nameRef.current = name;
    const [formState, updateFormState] = React.useState(formStateRef.current);
    const readFormState = React.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    React.useEffect(() => {
        const formStateSubscription = subjectsRef.current.state.subscribe({
            next: (formState) => (!nameRef.current ||
                !formState.name ||
                convertToArrayPayload(nameRef.current).includes(formState.name)) &&
                shouldRenderFormState(formState, readFormState.current) &&
                updateFormState(Object.assign(Object.assign({}, formStateRef.current), formState)),
        });
        return () => formStateSubscription.unsubscribe();
    }, []);
    return getProxyFormState(isProxyEnabled, formState, readFormStateRef, readFormState, false);
}

function useController({ name, rules, defaultValue, control, shouldUnregister, }) {
    const methods = useFormContext();
    const { defaultValuesRef, register, fieldsRef, unregister, namesRef, subjectsRef, shouldUnmount, inFieldArrayActionRef, } = control || methods.control;
    const isFieldArray = isNameInFieldArray(namesRef.current.array, name);
    const field = get(fieldsRef.current, name);
    const [value, setInputStateValue] = React.useState(isFieldArray || !field || !field._f
        ? isFieldArray || isUndefined(get(defaultValuesRef.current, name))
            ? defaultValue
            : get(defaultValuesRef.current, name)
        : field._f.value);
    const { onChange, onBlur, ref } = register(name, Object.assign(Object.assign({}, rules), { value }));
    const formState = useFormState({
        control: control || methods.control,
        name,
    });
    React.useEffect(() => {
        const controllerSubscription = subjectsRef.current.control.subscribe({
            next: (data) => (!data.name || name === data.name) &&
                setInputStateValue(get(data.values, name)),
        });
        return () => {
            controllerSubscription.unsubscribe();
            const shouldUnmountField = shouldUnmount || shouldUnregister;
            if (isFieldArray
                ? shouldUnmountField && !inFieldArrayActionRef.current
                : shouldUnmountField) {
                unregister(name);
            }
            else {
                const field = get(fieldsRef.current, name);
                if (field && field._f) {
                    field._f.mount = false;
                }
            }
        };
    }, [name]);
    return {
        field: {
            onChange: (event) => {
                const value = getControllerValue(event);
                setInputStateValue(value);
                onChange({
                    target: {
                        value,
                        name: name,
                    },
                    type: EVENTS.CHANGE,
                });
            },
            onBlur: () => {
                onBlur({
                    target: {
                        name: name,
                    },
                    type: EVENTS.BLUR,
                });
            },
            name,
            value,
            ref: (elm) => elm &&
                ref({
                    focus: () => elm.focus && elm.focus(),
                }),
        },
        formState,
        fieldState: {
            invalid: !!get(formState.errors, name),
            isDirty: !!get(formState.dirtyFields, name),
            isTouched: !!get(formState.touchedFields, name),
            error: get(formState.errors, name),
        },
    };
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? Object.assign(Object.assign({}, errors[name]), { types: Object.assign(Object.assign({}, (errors[name] && errors[name].types ? errors[name].types : {})), { [type]: message || true }) }) : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const _f = field._f;
            const current = omit(field, '_f');
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && isUndefined(_f.ref.focus())) {
                    break;
                }
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(current)) {
                focusFieldBy(current, callback);
            }
        }
    }
};

const getFieldsValues = (fieldsRef, output = {}) => {
    for (const name in fieldsRef.current) {
        const field = fieldsRef.current[name];
        if (field && !isNullOrUndefined(output)) {
            const _f = field._f;
            const current = omit(field, '_f');
            set(output, name, _f && _f.ref
                ? _f.ref.disabled || (_f.refs && _f.refs.every((ref) => ref.disabled))
                    ? undefined
                    : _f.value
                : Array.isArray(field)
                    ? []
                    : {});
            current &&
                getFieldsValues({
                    current,
                }, output[name]);
        }
    }
    return output;
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var mapIds = (values = [], keyName) => values.map((value) => (Object.assign({ [keyName]: (value && value[keyName]) || generateId() }, value)));

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2, isErrorObject) {
    if (isPrimitive(object1) ||
        isPrimitive(object2) ||
        object1 instanceof Date ||
        object2 instanceof Date) {
        return object1 === object2;
    }
    if (!React.isValidElement(object1)) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (const key of keys1) {
            const val1 = object1[key];
            if (!(isErrorObject && key === 'ref')) {
                const val2 = object2[key];
                if ((isObject(val1) || Array.isArray(val1)) &&
                    (isObject(val2) || Array.isArray(val2))
                    ? !deepEqual(val1, val2, isErrorObject)
                    : val1 !== val2) {
                    return false;
                }
            }
        }
    }
    return true;
}

function deepMerge(target, source) {
    if (isPrimitive(target) || isPrimitive(source)) {
        return source;
    }
    for (const key in source) {
        const targetValue = target[key];
        const sourceValue = source[key];
        try {
            target[key] =
                (isObject(targetValue) && isObject(sourceValue)) ||
                    (Array.isArray(targetValue) && Array.isArray(sourceValue))
                    ? deepMerge(targetValue, sourceValue)
                    : sourceValue;
        }
        catch (_a) { }
    }
    return target;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    let index = -1;
    while (++index < values.length) {
        for (const key in values[index]) {
            if (Array.isArray(values[index][key])) {
                !dirtyFields[index] && (dirtyFields[index] = {});
                dirtyFields[index][key] = [];
                setDirtyFields(values[index][key], get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
            }
            else {
                deepEqual(get(defaultValues[index] || {}, key), values[index][key])
                    ? set(dirtyFields[index] || {}, key)
                    : (dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), { [key]: true }));
            }
        }
        parentNode &&
            !dirtyFields.length &&
            delete parentNode[parentName];
    }
    return dirtyFields;
}
var setFieldArrayDirtyFields = (values, defaultValues, dirtyFields) => deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var fillEmptyArray = (value) => Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (Array.isArray(data)) {
        if (isUndefined(data[to])) {
            data[to] = undefined;
        }
        data.splice(to, 0, data.splice(from, 1)[0]);
        return data;
    }
    return [];
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...data];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

var isBoolean = (value) => typeof value === 'boolean';

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) &&
                        !objectRef.filter((data) => (isObject(data) && !isEmptyObject(data)) || isBoolean(data)).length))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

const useFieldArray = ({ control, name, keyName = 'id', shouldUnregister, }) => {
    const methods = useFormContext();
    const focusNameRef = React.useRef('');
    const isMountedRef = React.useRef(false);
    const { getIsDirty, namesRef, fieldsRef, defaultValuesRef, formStateRef, subjectsRef, readFormStateRef, updateIsValid, fieldArrayDefaultValuesRef, unregister, shouldUnmount, inFieldArrayActionRef, register, } = control || methods.control;
    const [fields, setFields] = React.useState(mapIds((get(fieldsRef.current, name) && isMountedRef.current
        ? get(getFieldsValues(fieldsRef), name)
        : get(fieldArrayDefaultValuesRef.current, getNodeParentName(name))
            ? get(fieldArrayDefaultValuesRef.current, name)
            : get(defaultValuesRef.current, name)) || [], keyName));
    set(fieldArrayDefaultValuesRef.current, name, [...fields]);
    namesRef.current.array.add(name);
    const omitKey = (fields) => fields.map((field = {}) => omit(field, keyName));
    const getCurrentFieldsValues = () => {
        const values = get(getFieldsValues(fieldsRef), name, []);
        return mapIds(get(fieldArrayDefaultValuesRef.current, name, []).map((item, index) => (Object.assign(Object.assign({}, item), values[index]))), keyName);
    };
    const getFocusFieldName = (index, options) => options && !options.shouldFocus
        ? options.focusName || `${name}.${options.focusIndex}.`
        : `${name}.${index}.`;
    const setFieldsAndNotify = (fieldsValues = []) => setFields(mapIds(fieldsValues, keyName));
    const cleanup = (ref) => !compact(get(ref, name, [])).length && unset(ref, name);
    const batchStateUpdate = (method, args, updatedFieldArrayValues = [], shouldSet = true) => {
        inFieldArrayActionRef.current = true;
        if (get(fieldsRef.current, name)) {
            const output = method(get(fieldsRef.current, name), args.argA, args.argB);
            shouldSet && set(fieldsRef.current, name, output);
        }
        if (Array.isArray(get(formStateRef.current.errors, name))) {
            const output = method(get(formStateRef.current.errors, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.errors, name, output);
            cleanup(formStateRef.current.errors);
        }
        if (readFormStateRef.current.touchedFields &&
            get(formStateRef.current.touchedFields, name)) {
            const output = method(get(formStateRef.current.touchedFields, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.touchedFields, name, output);
            cleanup(formStateRef.current.touchedFields);
        }
        if (readFormStateRef.current.dirtyFields ||
            readFormStateRef.current.isDirty) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
            updatedFieldArrayValues &&
                set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
            cleanup(formStateRef.current.dirtyFields);
        }
        subjectsRef.current.state.next({
            isDirty: getIsDirty(name, omitKey(updatedFieldArrayValues)),
            errors: formStateRef.current.errors,
            isValid: formStateRef.current.isValid,
        });
    };
    const registerFieldArray = (values, index = 0, parentName = '') => values.forEach((appendValueItem, valueIndex) => {
        const rootName = `${parentName || name}.${parentName ? valueIndex : index + valueIndex}`;
        isPrimitive(appendValueItem)
            ? register(rootName, {
                value: appendValueItem,
            })
            : Object.entries(appendValueItem).forEach(([key, value]) => {
                const inputName = rootName + '.' + key;
                Array.isArray(value)
                    ? registerFieldArray(value, valueIndex, inputName)
                    : register(inputName, { value: isPrimitive(value) ? value : Object.assign({}, value) });
            });
    });
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(value);
        const updatedFieldArrayValues = append(getCurrentFieldsValues(), appendValue);
        const currentIndex = updatedFieldArrayValues.length - appendValue.length;
        setFieldsAndNotify(updatedFieldArrayValues);
        batchStateUpdate(append, {
            argA: fillEmptyArray(value),
        }, updatedFieldArrayValues, false);
        registerFieldArray(appendValue, currentIndex);
        focusNameRef.current = getFocusFieldName(currentIndex, options);
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(value);
        const updatedFieldArrayValues = prepend(getCurrentFieldsValues(), prependValue);
        setFieldsAndNotify(updatedFieldArrayValues);
        batchStateUpdate(prepend, {
            argA: fillEmptyArray(value),
        }, updatedFieldArrayValues);
        registerFieldArray(prependValue);
        focusNameRef.current = getFocusFieldName(0, options);
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(getCurrentFieldsValues(), index);
        setFieldsAndNotify(updatedFieldArrayValues);
        batchStateUpdate(removeArrayAt, {
            argA: index,
        }, updatedFieldArrayValues);
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(value);
        const updatedFieldArrayValues = insert(getCurrentFieldsValues(), index, insertValue);
        setFieldsAndNotify(updatedFieldArrayValues);
        batchStateUpdate(insert, {
            argA: index,
            argB: fillEmptyArray(value),
        }, updatedFieldArrayValues);
        registerFieldArray(insertValue, index);
        focusNameRef.current = getFocusFieldName(index, options);
    };
    const swap = (indexA, indexB) => {
        const fieldValues = getCurrentFieldsValues();
        swapArrayAt(fieldValues, indexA, indexB);
        batchStateUpdate(swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, fieldValues, false);
        setFieldsAndNotify(fieldValues);
    };
    const move = (from, to) => {
        const fieldValues = getCurrentFieldsValues();
        moveArrayAt(fieldValues, from, to);
        setFieldsAndNotify(fieldValues);
        batchStateUpdate(moveArrayAt, {
            argA: from,
            argB: to,
        }, fieldValues, false);
    };
    React.useEffect(() => {
        inFieldArrayActionRef.current = false;
        if (namesRef.current.watchAll) {
            subjectsRef.current.state.next({});
        }
        else {
            for (const watchField of namesRef.current.watch) {
                if (name.startsWith(watchField)) {
                    subjectsRef.current.state.next({});
                    break;
                }
            }
        }
        subjectsRef.current.watch.next({
            name,
            values: getFieldsValues(fieldsRef),
        });
        focusNameRef.current &&
            focusFieldBy(fieldsRef.current, (key) => key.startsWith(focusNameRef.current));
        focusNameRef.current = '';
        subjectsRef.current.array.next({
            name,
            values: omitKey([...fields]),
        });
        readFormStateRef.current.isValid && updateIsValid();
    }, [fields, name]);
    React.useEffect(() => {
        const fieldArraySubscription = subjectsRef.current.array.subscribe({
            next({ name: inputFieldArrayName, values, isReset }) {
                if (isReset) {
                    unset(fieldsRef.current, inputFieldArrayName || name);
                    inputFieldArrayName
                        ? set(fieldArrayDefaultValuesRef.current, inputFieldArrayName, values)
                        : (fieldArrayDefaultValuesRef.current = values);
                    setFieldsAndNotify(get(fieldArrayDefaultValuesRef.current, name));
                }
            },
        });
        !get(fieldsRef.current, name) && set(fieldsRef.current, name, []);
        isMountedRef.current = true;
        return () => {
            fieldArraySubscription.unsubscribe();
            if (shouldUnmount || shouldUnregister) {
                unregister(name);
                unset(fieldArrayDefaultValuesRef.current, name);
            }
            else {
                const fieldArrayValues = get(getFieldsValues(fieldsRef), name);
                fieldArrayValues &&
                    set(fieldArrayDefaultValuesRef.current, name, fieldArrayValues);
            }
        };
    }, []);
    return {
        swap: React.useCallback(swap, [name]),
        move: React.useCallback(move, [name]),
        prepend: React.useCallback(prepend$1, [name]),
        append: React.useCallback(append$1, [name]),
        remove: React.useCallback(remove, [name]),
        insert: React.useCallback(insert$1, [name]),
        fields: fields,
    };
};

var isFileInput = (element) => element.type === 'file';

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioInput = (element) => element.type === 'radio';

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : +value
        : valueAsDate
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

var getMultipleSelectValue = (options) => [...options]
    .filter(({ selected }) => selected)
    .map(({ value }) => value);

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getFieldValue(field) {
    if (field && field._f) {
        const ref = field._f.ref;
        if (ref.disabled) {
            return;
        }
        if (isFileInput(ref)) {
            return ref.files;
        }
        if (isRadioInput(ref)) {
            return getRadioValue(field._f.refs).value;
        }
        if (isMultipleSelect(ref)) {
            return getMultipleSelectValue(ref.options);
        }
        if (isCheckBoxInput(ref)) {
            return getCheckboxValue(field._f.refs).value;
        }
        return getFieldValueAs(isUndefined(ref.value) ? field._f.ref.value : ref.value, field._f);
    }
}

var getResolverOptions = (fieldsNames, fieldsRefs, criteriaMode) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(fieldsRefs, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
    };
};

var hasValidation = (options, mounted) => mounted &&
    options &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

var skipValidation = ({ isOnBlur, isOnChange, isOnTouch, isTouched, isReValidateOnBlur, isReValidateOnChange, isBlurEvent, isSubmitted, isOnAll, }) => {
    if (isOnAll) {
        return false;
    }
    else if (!isSubmitted && isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? isReValidateOnChange : isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var isFunction = (value) => typeof value === 'function';

var isString = (value) => typeof value === 'string';

var isMessage = (value) => isString(value) || React.isValidElement(value);

var isRegex = (value) => value instanceof RegExp;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async ({ _f: { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, value: inputValue, valueAsNumber, mount, }, }, validateAllFieldCriteria) => {
    if (!mount) {
        return {};
    }
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = Object.assign({ type: exceedMax ? maxType : minType, message,
            ref }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (required &&
        ((!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(inputValue))) ||
            (isBoolean(inputValue) && !inputValue) ||
            (isCheckBox && !getCheckboxValue(refs).isValid) ||
            (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message, ref: isRadioOrCheckbox ? (refs || [])[0] || {} : ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if ((!isNullOrUndefined(min) || !isNullOrUndefined(max)) &&
        inputValue !== '') {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || parseFloat(inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (isString(inputValue) && !isEmpty && (maxLength || minLength)) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (isString(inputValue) && pattern && !isEmpty) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.pattern, message,
                ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (validate) {
        const validateRef = isRadioOrCheckbox && refs ? refs[0] : ref;
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, validateRef);
            if (validateError) {
                error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const [key, validateFunction] of Object.entries(validate)) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateResult = await validateFunction(inputValue);
                const validateError = getValidateError(validateResult, validateRef, key);
                if (validateError) {
                    validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = Object.assign({ ref: validateRef }, validationResult);
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    return error;
};

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isHTMLElement = (value) => value instanceof HTMLElement;

var isRadioOrCheckboxFunction = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

class Subscription {
    constructor() {
        this.tearDowns = [];
    }
    add(tearDown) {
        this.tearDowns.push(tearDown);
    }
    unsubscribe() {
        for (const teardown of this.tearDowns) {
            teardown();
        }
        this.tearDowns = [];
    }
}
class Subscriber {
    constructor(observer, subscription) {
        this.observer = observer;
        this.closed = false;
        subscription.add(() => (this.closed = true));
    }
    next(value) {
        if (!this.closed) {
            this.observer.next(value);
        }
    }
}
class Subject {
    constructor() {
        this.observers = [];
    }
    next(value) {
        for (const observer of this.observers) {
            observer.next(value);
        }
    }
    subscribe(observer) {
        const subscription = new Subscription();
        const subscriber = new Subscriber(observer, subscription);
        this.observers.push(subscriber);
        return subscription;
    }
    unsubscribe() {
        this.observers = [];
    }
}

const isWindowUndefined = typeof window === 'undefined';
function useForm({ mode = VALIDATION_MODE.onSubmit, reValidateMode = VALIDATION_MODE.onChange, resolver, context, defaultValues = {}, shouldFocusError = true, shouldUnregister, criteriaMode, } = {}) {
    const [formState, updateFormState] = React.useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    });
    const readFormStateRef = React.useRef({
        isDirty: !isProxyEnabled,
        dirtyFields: !isProxyEnabled,
        touchedFields: !isProxyEnabled,
        isValidating: !isProxyEnabled,
        isValid: !isProxyEnabled,
        errors: !isProxyEnabled,
    });
    const resolverRef = React.useRef(resolver);
    const formStateRef = React.useRef(formState);
    const fieldsRef = React.useRef({});
    const defaultValuesRef = React.useRef(defaultValues);
    const fieldArrayDefaultValuesRef = React.useRef({});
    const contextRef = React.useRef(context);
    const inFieldArrayActionRef = React.useRef(false);
    const isMountedRef = React.useRef(false);
    const subjectsRef = React.useRef({
        watch: new Subject(),
        control: new Subject(),
        array: new Subject(),
        state: new Subject(),
    });
    const namesRef = React.useRef({
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        watchAll: false,
    });
    const validationMode = getValidationModes(mode);
    const isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;
    resolverRef.current = resolver;
    contextRef.current = context;
    const isFieldWatched = (name) => namesRef.current.watchAll ||
        namesRef.current.watch.has(name) ||
        namesRef.current.watch.has((name.match(/\w+/) || [])[0]);
    const shouldRenderBaseOnError = React.useCallback(async (shouldSkipRender, name, error, inputState, isValidFromResolver, isWatched) => {
        const previousError = get(formStateRef.current.errors, name);
        const isValid = readFormStateRef.current.isValid
            ? resolver
                ? isValidFromResolver
                : await validateForm(fieldsRef.current, true)
            : false;
        error
            ? set(formStateRef.current.errors, name, error)
            : unset(formStateRef.current.errors, name);
        if ((isWatched ||
            (error ? !deepEqual(previousError, error, true) : previousError) ||
            !isEmptyObject(inputState) ||
            formStateRef.current.isValid !== isValid) &&
            !shouldSkipRender) {
            const updatedFormState = Object.assign(Object.assign({}, inputState), { isValid: !!isValid, errors: formStateRef.current.errors, name });
            formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), updatedFormState);
            subjectsRef.current.state.next(isWatched ? { name } : updatedFormState);
        }
        subjectsRef.current.state.next({
            isValidating: false,
        });
    }, []);
    const setFieldValue = React.useCallback((name, rawValue, options = {}, shouldRender, shouldRegister) => {
        shouldRegister && register(name);
        const field = get(fieldsRef.current, name);
        if (field) {
            const _f = field._f;
            if (_f) {
                const value = isWeb && isHTMLElement(_f.ref) && isNullOrUndefined(rawValue)
                    ? ''
                    : rawValue;
                _f.value = getFieldValueAs(rawValue, _f);
                if (isRadioInput(_f.ref)) {
                    (_f.refs || []).forEach((radioRef) => (radioRef.checked = radioRef.value === value));
                }
                else if (isFileInput(_f.ref) && !isString(value)) {
                    _f.ref.files = value;
                }
                else if (isMultipleSelect(_f.ref)) {
                    [..._f.ref.options].forEach((selectRef) => (selectRef.selected = value.includes(selectRef.value)));
                }
                else if (isCheckBoxInput(_f.ref) && _f.refs) {
                    _f.refs.length > 1
                        ? _f.refs.forEach((checkboxRef) => (checkboxRef.checked = Array.isArray(value)
                            ? !!value.find((data) => data === checkboxRef.value)
                            : value === checkboxRef.value))
                        : (_f.refs[0].checked = !!value);
                }
                else {
                    _f.ref.value = value;
                }
                if (shouldRender) {
                    const values = getFieldsValues(fieldsRef);
                    set(values, name, rawValue);
                    subjectsRef.current.control.next({
                        values: Object.assign(Object.assign({}, defaultValuesRef.current), values),
                        name,
                    });
                }
                (options.shouldDirty || options.shouldTouch) &&
                    updateTouchAndDirtyState(name, value, options.shouldTouch);
                options.shouldValidate && trigger(name);
            }
            else {
                field._f = {
                    ref: {
                        name,
                        value: rawValue,
                    },
                    value: rawValue,
                };
            }
        }
    }, []);
    const getIsDirty = React.useCallback((name, data) => {
        const formValues = getFieldsValues(fieldsRef);
        name && data && set(formValues, name, data);
        return !deepEqual(formValues, defaultValuesRef.current);
    }, []);
    const updateTouchAndDirtyState = React.useCallback((name, inputValue, isCurrentTouched, shouldRender = true) => {
        const state = {
            name,
        };
        let isChanged = false;
        if (readFormStateRef.current.isDirty) {
            const previousIsDirty = formStateRef.current.isDirty;
            formStateRef.current.isDirty = getIsDirty();
            state.isDirty = formStateRef.current.isDirty;
            isChanged = previousIsDirty !== state.isDirty;
        }
        if (readFormStateRef.current.dirtyFields && !isCurrentTouched) {
            const isPreviousFieldDirty = get(formStateRef.current.dirtyFields, name);
            const isCurrentFieldDirty = !deepEqual(get(defaultValuesRef.current, name), inputValue);
            isCurrentFieldDirty
                ? set(formStateRef.current.dirtyFields, name, true)
                : unset(formStateRef.current.dirtyFields, name);
            state.dirtyFields = formStateRef.current.dirtyFields;
            isChanged =
                isChanged ||
                    isPreviousFieldDirty !== get(formStateRef.current.dirtyFields, name);
        }
        const isPreviousFieldTouched = get(formStateRef.current.touchedFields, name);
        if (isCurrentTouched && !isPreviousFieldTouched) {
            set(formStateRef.current.touchedFields, name, isCurrentTouched);
            state.touchedFields = formStateRef.current.touchedFields;
            isChanged =
                isChanged ||
                    (readFormStateRef.current.touchedFields &&
                        isPreviousFieldTouched !== isCurrentTouched);
        }
        isChanged && shouldRender && subjectsRef.current.state.next(state);
        return isChanged ? state : {};
    }, []);
    const executeInlineValidation = React.useCallback(async (name, skipReRender) => {
        const error = (await validateField(get(fieldsRef.current, name), isValidateAllFieldCriteria))[name];
        shouldRenderBaseOnError(skipReRender, name, error);
        return isUndefined(error);
    }, [isValidateAllFieldCriteria]);
    const executeResolverValidation = React.useCallback(async (names) => {
        const { errors } = await resolverRef.current(getFieldsValues(fieldsRef), contextRef.current, getResolverOptions(namesRef.current.mount, fieldsRef.current, criteriaMode));
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(formStateRef.current.errors, name, error)
                    : unset(formStateRef.current.errors, name);
            }
        }
        else {
            formStateRef.current.errors = errors;
        }
        return errors;
    }, [criteriaMode]);
    const validateForm = async (fieldsRef, shouldCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fieldsRef) {
            const field = fieldsRef[name];
            if (field) {
                const _f = field._f;
                const current = omit(field, '_f');
                if (_f) {
                    const fieldError = await validateField(field, isValidateAllFieldCriteria);
                    if (shouldCheckValid) {
                        if (fieldError[_f.name]) {
                            context.valid = false;
                            break;
                        }
                    }
                    else {
                        fieldError[_f.name]
                            ? set(formStateRef.current.errors, _f.name, fieldError[_f.name])
                            : unset(formStateRef.current.errors, _f.name);
                    }
                }
                current && (await validateForm(current, shouldCheckValid, context));
            }
        }
        return context.valid;
    };
    const trigger = React.useCallback(async (name, options = {}) => {
        const fieldNames = convertToArrayPayload(name);
        let isValid;
        subjectsRef.current.state.next({
            isValidating: true,
        });
        if (resolver) {
            const schemaResult = await executeResolverValidation(isUndefined(name) ? name : fieldNames);
            isValid = name
                ? fieldNames.every((name) => !get(schemaResult, name))
                : isEmptyObject(schemaResult);
        }
        else {
            if (name) {
                isValid = (await Promise.all(fieldNames
                    .filter((fieldName) => get(fieldsRef.current, fieldName))
                    .map(async (fieldName) => await executeInlineValidation(fieldName, true)))).every(Boolean);
            }
            else {
                await validateForm(fieldsRef.current);
                isValid = isEmptyObject(formStateRef.current.errors);
            }
        }
        subjectsRef.current.state.next(Object.assign(Object.assign({}, (isString(name) ? { name } : {})), { errors: formStateRef.current.errors, isValidating: false }));
        if (options.shouldFocus && !isValid) {
            focusFieldBy(fieldsRef.current, (key) => get(formStateRef.current.errors, key), fieldNames);
        }
        readFormStateRef.current.isValid && updateIsValid();
        return isValid;
    }, [executeResolverValidation, executeInlineValidation]);
    const updateIsValidAndInputValue = (name, ref) => {
        const field = get(fieldsRef.current, name);
        if (field) {
            const isValueUndefined = isUndefined(field._f.value);
            const defaultValue = isValueUndefined
                ? get(defaultValuesRef.current, name)
                : field._f.value;
            if (!isUndefined(defaultValue)) {
                if (ref && ref.defaultChecked) {
                    field._f.value = getFieldValue(field);
                }
                else if (isNameInFieldArray(namesRef.current.array, name)) {
                    field._f.value = defaultValue;
                }
                else {
                    setFieldValue(name, defaultValue);
                }
            }
            else if (isValueUndefined) {
                field._f.value = getFieldValue(field);
            }
        }
        isMountedRef.current && readFormStateRef.current.isValid && updateIsValid();
    };
    const updateIsValid = React.useCallback(async (values = {}) => {
        const isValid = resolver
            ? isEmptyObject((await resolverRef.current(Object.assign(Object.assign({}, getFieldsValues(fieldsRef)), values), contextRef.current, getResolverOptions(namesRef.current.mount, fieldsRef.current, criteriaMode))).errors)
            : await validateForm(fieldsRef.current, true);
        isValid !== formStateRef.current.isValid &&
            subjectsRef.current.state.next({
                isValid,
            });
    }, [criteriaMode]);
    const setInternalValues = React.useCallback((name, value, options) => Object.entries(value).forEach(([inputKey, inputValue]) => {
        const fieldName = `${name}.${inputKey}`;
        const field = get(fieldsRef.current, fieldName);
        const isFieldArray = namesRef.current.array.has(name);
        isFieldArray || !isPrimitive(inputValue) || (field && !field._f)
            ? setInternalValues(fieldName, inputValue, options)
            : setFieldValue(fieldName, inputValue, options, true, !field);
    }), [trigger]);
    const setValue = (name, value, options = {}) => {
        const field = get(fieldsRef.current, name);
        const isFieldArray = namesRef.current.array.has(name);
        if (isFieldArray) {
            subjectsRef.current.array.next({
                values: value,
                name,
                isReset: true,
            });
            if ((readFormStateRef.current.isDirty ||
                readFormStateRef.current.dirtyFields) &&
                options.shouldDirty) {
                set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
                subjectsRef.current.state.next({
                    name,
                    dirtyFields: formStateRef.current.dirtyFields,
                    isDirty: getIsDirty(name, value),
                });
            }
            !value.length &&
                set(fieldsRef.current, name, []) &&
                set(fieldArrayDefaultValuesRef.current, name, []);
        }
        ((field && !field._f) || isFieldArray) && !isNullOrUndefined(value)
            ? setInternalValues(name, value, isFieldArray ? {} : options)
            : setFieldValue(name, value, options, true, !field);
        isFieldWatched(name) && subjectsRef.current.state.next({});
        subjectsRef.current.watch.next({ name, values: getValues() });
    };
    const handleChange = React.useCallback(async ({ type, target, target: { value, type: inputType } }) => {
        let name = target.name;
        let error;
        let isValid;
        const field = get(fieldsRef.current, name);
        if (field) {
            let inputValue = inputType ? getFieldValue(field) : undefined;
            inputValue = isUndefined(inputValue) ? value : inputValue;
            const isBlurEvent = type === EVENTS.BLUR;
            const { isOnBlur: isReValidateOnBlur, isOnChange: isReValidateOnChange, } = getValidationModes(reValidateMode);
            const shouldSkipValidation = (!hasValidation(field._f, field._f.mount) &&
                !resolver &&
                !get(formStateRef.current.errors, name)) ||
                skipValidation(Object.assign({ isBlurEvent, isTouched: !!get(formStateRef.current.touchedFields, name), isSubmitted: formStateRef.current.isSubmitted, isReValidateOnBlur,
                    isReValidateOnChange }, validationMode));
            const isWatched = !isBlurEvent && isFieldWatched(name);
            if (!isUndefined(inputValue)) {
                field._f.value = inputValue;
            }
            const inputState = updateTouchAndDirtyState(name, field._f.value, isBlurEvent, false);
            const shouldRender = !isEmptyObject(inputState) || isWatched;
            if (shouldSkipValidation) {
                !isBlurEvent &&
                    subjectsRef.current.watch.next({
                        name,
                        type,
                        values: getValues(),
                    });
                return (shouldRender &&
                    subjectsRef.current.state.next(isWatched ? { name } : Object.assign(Object.assign({}, inputState), { name })));
            }
            subjectsRef.current.state.next({
                isValidating: true,
            });
            if (resolver) {
                const { errors } = await resolverRef.current(getFieldsValues(fieldsRef), contextRef.current, getResolverOptions([name], fieldsRef.current, criteriaMode));
                error = get(errors, name);
                if (isCheckBoxInput(target) && !error) {
                    const parentNodeName = getNodeParentName(name);
                    const currentError = get(errors, parentNodeName, {});
                    currentError.type && currentError.message && (error = currentError);
                    if (currentError ||
                        get(formStateRef.current.errors, parentNodeName)) {
                        name = parentNodeName;
                    }
                }
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, isValidateAllFieldCriteria))[name];
            }
            !isBlurEvent &&
                subjectsRef.current.watch.next({
                    name,
                    type,
                    values: getValues(),
                });
            shouldRenderBaseOnError(false, name, error, inputState, isValid, isWatched);
        }
    }, []);
    const getValues = (fieldNames) => {
        const values = Object.assign(Object.assign({}, defaultValuesRef.current), getFieldsValues(fieldsRef));
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(formStateRef.current.errors, inputName))
            : (formStateRef.current.errors = {});
        subjectsRef.current.state.next({
            errors: formStateRef.current.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = ((get(fieldsRef.current, name) || { _f: {} })._f || {}).ref;
        set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), { ref }));
        subjectsRef.current.state.next({
            name,
            errors: formStateRef.current.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watchInternal = React.useCallback((fieldNames, defaultValue, isGlobal, formValues) => {
        const isArrayNames = Array.isArray(fieldNames);
        const fieldValues = formValues || isMountedRef.current
            ? Object.assign(Object.assign({}, defaultValuesRef.current), (formValues || getFieldsValues(fieldsRef))) : isUndefined(defaultValue)
            ? defaultValuesRef.current
            : isArrayNames
                ? defaultValue
                : { [fieldNames]: defaultValue };
        if (isUndefined(fieldNames)) {
            isGlobal && (namesRef.current.watchAll = true);
            return fieldValues;
        }
        const result = [];
        for (const fieldName of convertToArrayPayload(fieldNames)) {
            isGlobal && namesRef.current.watch.add(fieldName);
            result.push(get(fieldValues, fieldName));
        }
        return isArrayNames ? result : result[0];
    }, []);
    const watch = (fieldName, defaultValue) => isFunction(fieldName)
        ? subjectsRef.current.watch.subscribe({
            next: (info) => fieldName(watchInternal(undefined, defaultValue), info),
        })
        : watchInternal(fieldName, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const inputName of name
            ? convertToArrayPayload(name)
            : namesRef.current.mount) {
            namesRef.current.mount.delete(inputName);
            namesRef.current.array.delete(inputName);
            if (get(fieldsRef.current, inputName)) {
                !options.keepError && unset(formStateRef.current.errors, inputName);
                !options.keepValue && unset(fieldsRef.current, inputName);
                !options.keepDirty &&
                    unset(formStateRef.current.dirtyFields, inputName);
                !options.keepTouched &&
                    unset(formStateRef.current.touchedFields, inputName);
                !options.keepDefaultValue && unset(defaultValuesRef.current, inputName);
                subjectsRef.current.watch.next({
                    name: inputName,
                    values: getValues(),
                });
            }
        }
        subjectsRef.current.state.next(Object.assign(Object.assign({}, formStateRef.current), (!options.keepDirty ? {} : { isDirty: getIsDirty() })));
        !options.keepIsValid && updateIsValid();
    };
    const registerFieldRef = (name, ref, options) => {
        register(name, options);
        let field = get(fieldsRef.current, name);
        const isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
        if (ref === field._f.ref ||
            (isRadioOrCheckbox &&
                compact(field._f.refs || []).find((option) => option === ref))) {
            return;
        }
        field = {
            _f: isRadioOrCheckbox
                ? Object.assign(Object.assign({}, field._f), { refs: [
                        ...compact(field._f.refs || []).filter((ref) => isHTMLElement(ref) && document.contains(ref)),
                        ref,
                    ], ref: { type: ref.type, name } }) : Object.assign(Object.assign({}, field._f), { ref }),
        };
        set(fieldsRef.current, name, field);
        updateIsValidAndInputValue(name, ref);
    };
    const register = React.useCallback((name, options = {}) => {
        const field = get(fieldsRef.current, name);
        set(fieldsRef.current, name, {
            _f: Object.assign(Object.assign(Object.assign({}, (field && field._f ? field._f : { ref: { name } })), { name, mount: true }), options),
        });
        namesRef.current.mount.add(name);
        !field && updateIsValidAndInputValue(name);
        return isWindowUndefined
            ? { name: name }
            : {
                name,
                onChange: handleChange,
                onBlur: handleChange,
                ref: (ref) => {
                    if (ref) {
                        registerFieldRef(name, ref, options);
                    }
                    else {
                        const field = get(fieldsRef.current, name, {});
                        const shouldUnmount = shouldUnregister || options.shouldUnregister;
                        if (field._f) {
                            field._f.mount = false;
                            // If initial state of field element is disabled,
                            // value is not set on first "register"
                            // re-sync the value in when it switched to enabled
                            if (isUndefined(field._f.value)) {
                                field._f.value = field._f.ref.value;
                            }
                        }
                        shouldUnmount &&
                            !(isNameInFieldArray(namesRef.current.array, name) &&
                                inFieldArrayActionRef.current) &&
                            namesRef.current.unMount.add(name);
                    }
                },
            };
    }, []);
    const handleSubmit = React.useCallback((onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = getFieldsValues(fieldsRef);
        subjectsRef.current.state.next({
            isSubmitting: true,
        });
        try {
            if (resolver) {
                const { errors, values } = await resolverRef.current(fieldValues, contextRef.current, getResolverOptions(namesRef.current.mount, fieldsRef.current, criteriaMode));
                formStateRef.current.errors = errors;
                fieldValues = values;
            }
            else {
                await validateForm(fieldsRef.current);
            }
            if (isEmptyObject(formStateRef.current.errors) &&
                Object.keys(formStateRef.current.errors).every((name) => get(fieldValues, name))) {
                subjectsRef.current.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                onInvalid && (await onInvalid(formStateRef.current.errors, e));
                shouldFocusError &&
                    focusFieldBy(fieldsRef.current, (key) => get(formStateRef.current.errors, key), namesRef.current.mount);
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            formStateRef.current.isSubmitted = true;
            subjectsRef.current.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(formStateRef.current.errors) && hasNoPromiseError,
                submitCount: formStateRef.current.submitCount + 1,
                errors: formStateRef.current.errors,
            });
        }
    }, [shouldFocusError, isValidateAllFieldCriteria, criteriaMode]);
    const registerAbsentFields = (defaultValues, name = '') => {
        for (const key in defaultValues) {
            const value = defaultValues[key];
            const fieldName = name + (name ? '.' : '') + key;
            const field = get(fieldsRef.current, fieldName);
            if (!field || !field._f) {
                if (isObject(value) || Array.isArray(value)) {
                    registerAbsentFields(value, fieldName);
                }
                else if (!field) {
                    register(fieldName, { value });
                }
            }
        }
    };
    const reset = (values, keepStateOptions = {}) => {
        const updatedValues = values || defaultValuesRef.current;
        if (isWeb && !keepStateOptions.keepValues) {
            for (const name of namesRef.current.mount) {
                const field = get(fieldsRef.current, name);
                if (field && field._f) {
                    const inputRef = Array.isArray(field._f.refs)
                        ? field._f.refs[0]
                        : field._f.ref;
                    try {
                        isHTMLElement(inputRef) && inputRef.closest('form').reset();
                        break;
                    }
                    catch (_a) { }
                }
            }
        }
        !keepStateOptions.keepDefaultValues &&
            (defaultValuesRef.current = Object.assign({}, updatedValues));
        if (!keepStateOptions.keepValues) {
            fieldsRef.current = {};
            subjectsRef.current.control.next({
                values: Object.assign({}, updatedValues),
            });
            subjectsRef.current.watch.next({
                values: Object.assign({}, updatedValues),
            });
            subjectsRef.current.array.next({
                values: Object.assign({}, updatedValues),
                isReset: true,
            });
        }
        !keepStateOptions.keepDefaultValues &&
            !shouldUnregister &&
            registerAbsentFields(Object.assign({}, updatedValues));
        namesRef.current = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
        };
        subjectsRef.current.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? formStateRef.current.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? formStateRef.current.isDirty
                : keepStateOptions.keepDefaultValues
                    ? deepEqual(values, defaultValuesRef.current)
                    : false,
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? formStateRef.current.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty
                ? formStateRef.current.dirtyFields
                : {},
            touchedFields: keepStateOptions.keepTouched
                ? formStateRef.current.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? formStateRef.current.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
        isMountedRef.current = !!keepStateOptions.keepIsValid;
    };
    const setFocus = (name) => get(fieldsRef.current, name)._f.ref.focus();
    React.useEffect(() => {
        !shouldUnregister && registerAbsentFields(defaultValuesRef.current);
        const formStateSubscription = subjectsRef.current.state.subscribe({
            next(formState) {
                if (shouldRenderFormState(formState, readFormStateRef.current, true)) {
                    formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), formState);
                    updateFormState(formStateRef.current);
                }
            },
        });
        const useFieldArraySubscription = subjectsRef.current.array.subscribe({
            next(state) {
                if (state.values && state.name && readFormStateRef.current.isValid) {
                    const values = getFieldsValues(fieldsRef);
                    set(values, state.name, state.values);
                    updateIsValid(values);
                }
            },
        });
        return () => {
            formStateSubscription.unsubscribe();
            useFieldArraySubscription.unsubscribe();
        };
    }, []);
    React.useEffect(() => {
        const isLiveInDom = (ref) => !isHTMLElement(ref) || !document.contains(ref);
        if (!isMountedRef.current) {
            isMountedRef.current = true;
            readFormStateRef.current.isValid && updateIsValid();
        }
        for (const name of namesRef.current.unMount) {
            const field = get(fieldsRef.current, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every(isLiveInDom)
                    : isLiveInDom(field._f.ref)) &&
                unregister(name);
        }
        namesRef.current.unMount = new Set();
    });
    return {
        control: React.useMemo(() => ({
            register,
            inFieldArrayActionRef,
            getIsDirty,
            subjectsRef,
            watchInternal,
            fieldsRef,
            updateIsValid,
            namesRef,
            readFormStateRef,
            formStateRef,
            defaultValuesRef,
            fieldArrayDefaultValuesRef,
            unregister,
            shouldUnmount: shouldUnregister,
        }), []),
        formState: getProxyFormState(isProxyEnabled, formState, readFormStateRef),
        trigger,
        register,
        handleSubmit,
        watch: React.useCallback(watch, []),
        setValue: React.useCallback(setValue, [setInternalValues]),
        getValues: React.useCallback(getValues, []),
        reset: React.useCallback(reset, []),
        clearErrors: React.useCallback(clearErrors, []),
        unregister: React.useCallback(unregister, []),
        setError: React.useCallback(setError, []),
        setFocus: React.useCallback(setFocus, []),
    };
}

function useWatch(props) {
    const { control, name, defaultValue } = props || {};
    const methods = useFormContext();
    const nameRef = React.useRef(name);
    nameRef.current = name;
    const { watchInternal, subjectsRef } = control || methods.control;
    const [value, updateValue] = React.useState(isUndefined(defaultValue)
        ? watchInternal(name)
        : defaultValue);
    React.useEffect(() => {
        watchInternal(name);
        const watchSubscription = subjectsRef.current.watch.subscribe({
            next: ({ name: inputName, values }) => (!nameRef.current ||
                !inputName ||
                convertToArrayPayload(nameRef.current).some((fieldName) => inputName &&
                    fieldName &&
                    (fieldName.startsWith(inputName) ||
                        inputName.startsWith(fieldName)))) &&
                updateValue(watchInternal(nameRef.current, defaultValue, false, values)),
        });
        return () => watchSubscription.unsubscribe();
    }, []);
    return value;
}

function Form$1(_a) {
    var methods = _a.methods, children = _a.children, onSubmit = _a.onSubmit, testId = _a.testId, rest = __rest(_a, ["methods", "children", "onSubmit", "testId"]);
    var handleSubmit = methods.handleSubmit;
    var responsiveFormCSS = useResponsivePropsCSS(rest, {}, {
        width: responsiveSize("width"),
    });
    return (jsx$1(FormProvider, __assign({}, methods, { children: jsx$1("form", __assign({ css: responsiveFormCSS, action: "#", "data-testid": testId, onSubmit: handleSubmit(onSubmit), noValidate: true }, { children: children }), void 0) }), void 0));
}

var Form = function (props) {
    if (isNewProps(props)) {
        return jsx$1(Form$1, __assign({}, props), void 0);
    }
    // @ts-ignore
    return jsx$1(Form$2, __assign({}, props), void 0);
};

var APPEARANCES = ["text", "primary-button", "secondary-button", "icon"];
var VARIANTS$3 = ["light-bg", "medium-bg", "dark-bg", "blue-button", "white-button", "black-button", "green-button"];
var DEFAULT_PROPS$o = {
    appearance: "text",
    variant: "light-bg",
    __internal__keyboardFocus: false,
    __internal__hover: false,
    __internal__active: false
};
Link.APPEARANCES = APPEARANCES;
Link.VARIANTS = VARIANTS$3;
Link.DEFAULT_PROPS = DEFAULT_PROPS$o;
var darkColorsMap = {
    "primary.blue.t100": true,
    "highlight.blue.t100": true,
    "highlight.pink.t100": true,
    "highlight.purple.t100": true
};
var mediumColorsMap = {
    "grey.t07": true,
    "grey.t10": true,
    "grey.t16": true,
    "secondary.lightBlue.t25": true,
    "secondary.pink.t30": true,
    "secondary.pink.t15": true,
    "secondary.purple.t30": true,
    "secondary.purple.t15": true,
    "secondary.turquoise.t30": true,
    "secondary.turquoise.t10": true
};
function Link(props) {
    var theme = useTheme();
    var _useBackground = useBackground(), bgMap = _useBackground.bgMap;
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$o, {}, {
        appearance: function appearance(_appearance) {
            return APPEARANCES.includes(_appearance);
        },
        variant: function variant(_variant) {
            return VARIANTS$3.includes(_variant);
        },
        newTab: function newTab(_newTab) {
            return typeof _newTab === "boolean";
        },
        title: function title(_title) {
            return typeof _title === "string";
        }
    });
    var appearance = mergedProps.appearance, href = mergedProps.href, newTab = mergedProps.newTab, title = mergedProps.title, state = mergedProps.state, onClick = mergedProps.onClick, children = mergedProps.children, testId = mergedProps.testId, __internal__keyboardFocus = mergedProps.__internal__keyboardFocus, __internal__hover = mergedProps.__internal__hover, __internal__active = mergedProps.__internal__active;
    var variantMap = mapResponsiveValues(bgMap, function (backgroundColor) {
        var isDarkBackground = darkColorsMap[backgroundColor] === true;
        var isMediumBackground = mediumColorsMap[backgroundColor] === true;
        if (appearance === "text") {
            return isDarkBackground ? "dark-bg" : isMediumBackground ? "medium-bg" : "light-bg";
        }
        if (appearance === "primary-button") {
            return isDarkBackground ? "white-button" : "blue-button";
        }
        if (appearance === "secondary-button") {
            return isDarkBackground ? "white-button" : isMediumBackground ? "black-button" : "blue-button";
        }
        return null;
    }, theme);
    var anchorCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$o, {
        variant: function variant(_, theme) {
            var appearance = mergedProps.appearance;
            return theme.link.getCSS({
                targetElement: "anchor",
                appearance: appearance,
                __internal__keyboardFocus: __internal__keyboardFocus
            });
        },
        margin: responsiveMargin,
        width: responsiveSize("width")
    });
    var spanCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$o, {
        variant: function variant(_, theme, bp) {
            var appearance = mergedProps.appearance;
            var variant = hasOwnProperty(props, "variant") ? mergedProps.variant : variantMap[bp];
            return theme.link.getCSS({
                targetElement: "span",
                appearance: appearance,
                variant: variant,
                buttonTheme: theme.button,
                __internal__keyboardFocus: __internal__keyboardFocus,
                __internal__hover: __internal__hover,
                __internal__active: __internal__active
            });
        }
    });
    var _useContext = useContext(LinkContext), InternalLink = _useContext.InternalLink, isLinkInternal = _useContext.isLinkInternal;
    var newTabProps = newTab ? {
        target: "_blank",
        rel: "noreferrer" // See: https://developers.google.com/web/tools/lighthouse/audits/noopener, https://html.spec.whatwg.org/multipage/links.html#link-type-noreferrer
    } : {};
    if (!newTab && InternalLink && isLinkInternal(href)) {
        /*
          Note: We assume here that InternalLink respects the following contract:
             - It gets a `state` prop
            - It gets a `to` prop, which gets mapped to <a>'s `href` prop.
            - It gets the following props and sets them on the rendered <a>:
              * title
              * onClick
              * data-testid
              * children
           Example: Gatsby `Link` component.
        */
        return jsx(InternalLink, {
            css: anchorCSS,
            to: href,
            title: title,
            state: state,
            onClick: onClick,
            "data-testid": testId
        }, jsx("span", {
            css: spanCSS
        }, children));
    }
    return jsx("a", _extends$1({
        css: anchorCSS,
        href: href,
        title: title,
        onClick: onClick,
        "data-testid": testId
    }, newTabProps), jsx("span", {
        css: spanCSS
    }, children));
}
Link.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, responsiveMarginType), responsiveWidthType), {}, {
    appearance: function appearance(props) {
        if (props.appearance === undefined) {
            return;
        }
        if (APPEARANCES.includes(props.appearance) === false) {
            return new Error("Link: appearance=\"".concat(props.appearance, "\" is not supported. Must be one of: ").concat(formatArray(APPEARANCES)));
        }
        if (props.appearance === "text" && props.variant && ["light-bg", "medium-bg", "dark-bg"].includes(props.variant) === false) {
            return new Error("Link: appearance=\"text\" should be used only with these variants: ".concat(formatArray(["light-bg", "medium-bg", "dark-bg"])));
        }
        if (props.appearance === "primary-button" && props.variant && ["blue-button", "white-button", "green-button"].includes(props.variant) === false) {
            return new Error("Link: appearance=\"primary-button\" should be used only with these variants: ".concat(formatArray(["blue-button", "white-button", "green-button"])));
        }
        if (props.appearance === "secondary-button" && props.variant && ["blue-button", "white-button", "black-button"].includes(props.variant) === false) {
            return new Error("Link: appearance=\"secondary-button\" should be used only with these variants: ".concat(formatArray(["blue-button", "white-button", "black-button"])));
        }
        if (["primary-button", "secondary-button"].includes(props.appearance) === false) {
            for (var prop in props) {
                if (prop.startsWith("width")) {
                    return new Error("Link: ".concat(prop, " should be used only with these appearances: ").concat(formatArray(["primary-button", "secondary-button"])));
                }
            }
        }
    },
    variant: PropTypes.oneOf(VARIANTS$3),
    href: PropTypes.string.isRequired,
    newTab: PropTypes.bool.isRequired,
    title: PropTypes.string,
    state: PropTypes.object,
    onClick: PropTypes.func,
    children: PropTypes.node,
    testId: PropTypes.string,
    __internal__keyboardFocus: PropTypes.bool,
    __internal__hover: PropTypes.bool,
    __internal__active: PropTypes.bool
});

var COLORS$f = ["primary.blue.t100", "black", "white"];
var DEFAULT_PROPS$n = {
    color: "primary.blue.t100",
    height: "40px"
};
function GemLogo(props) {
    var theme = useTheme();
    var _useBackground = useBackground(), bgMap = _useBackground.bgMap;
    var colorMap = mapResponsiveValues(bgMap, function (backgroundColor) {
        var _props$color;
        return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : backgroundColor === "primary.blue.t100" ? "white" : "primary.blue.t100";
    }, theme);
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$n, {}, {
        color: function color(_color) {
            return COLORS$f.includes(_color);
        }
    });
    var testId = mergedProps.testId;
    var svgResponsiveCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$n, {
        height: responsiveSize("height")
    });
    var pathResponsiveCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$n, {
        color: function color(propsAtBreakpoint, theme, bp) {
            return {
                fill: theme.getColor(colorMap[bp])
            };
        }
    });
    return jsx("svg", {
        css: /*#__PURE__*/ css$1(_objectSpread2({
            display: "flex"
        }, svgResponsiveCSS), process.env.NODE_ENV === "production" ? "" : ";label:GemLogo;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        viewBox: "0 0 113 48",
        focusable: "false",
        role: "img",
        "aria-label": "Gem by Latitude logo",
        "data-testid": testId
    }, jsx("path", {
        css: pathResponsiveCSS,
        d: "M96.1,44.2c0,1-0.4,1.7-1.5,1.7c-1.1,0-1.5-0.8-1.5-1.7v-2.9h-0.8v3    c0,1,0.4,2.4,2.2,2.4c1.8,0,2.2-1.3,2.2-2.4v-3h-0.8V44.2z M104.7,43.9c0-1.2-0.9-1.9-2.1-1.9h-1.4v3.8h1.4    C103.7,45.8,104.7,45.2,104.7,43.9L104.7,43.9z M105.4,43.9c0,1.7-1.3,2.7-2.8,2.7h-2.2v-5.3h2.2    C104.2,41.3,105.4,42.2,105.4,43.9L105.4,43.9z M68.6,44.3l-1-2.3l-1,2.3H68.6z M68,41.3l2.4,5.3h-0.8L69,45.1h-2.7l-0.7,1.5h-0.8    l2.4-5.3H68z M72.5,42h1.8v4.6h0.8V42h1.8v-0.8h-4.4V42z M84.5,42h1.8v4.6h0.8V42h1.8v-0.8h-4.4V42z M80.3,46.6h0.8v-5.3h-0.8    V46.6z M112.6,42v-0.8h-3.9v5.3h3.9v-0.8h-3.1v-1.5h2.7v-0.8h-2.7V42H112.6z M59,41.3h-0.8v5.3h3.9v-0.8H59V41.3z M44.8,45.9    L44.8,45.9h-2v-1.3h2c0.4,0,0.7,0.3,0.7,0.7C45.4,45.7,45.1,45.9,44.8,45.9L44.8,45.9z M42.8,42.7h1.7c0.4,0,0.7,0.3,0.7,0.7    S44.9,44,44.5,44h-1.7V42.7z M45.5,44.2c0.2-0.2,0.3-0.5,0.3-0.9c0-0.7-0.6-1.3-1.3-1.3h-2.4v4.6c0,0,2.6,0,2.7,0    c0.7,0,1.3-0.6,1.3-1.3C46.1,44.8,45.8,44.4,45.5,44.2L45.5,44.2z M50.8,46.8l-0.1,0.2c-0.1,0.3-0.3,0.5-0.5,0.7    c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.6-0.1-0.9-0.3l0.3-0.6c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.4    l0.1-0.1l-1.5-3.5h0.7l1.2,2.7l1.2-2.7h0.7L50.8,46.8z M41.3,17.1c0-3.3,1.1-6,3.4-8.3C47,6.6,49.8,5.4,53,5.4    c2.3,0,4.2,0.5,5.7,1.4l-16,16C41.8,21.4,41.3,19.4,41.3,17.1L41.3,17.1z M106.1,7.5c1.3,1.1,1.3,2.8,1.3,2.8v23.1h5.3V10.7    c0-2.6-0.8-4.8-2.7-6.8c-1.9-2-4.8-3-7.5-3c-2.6,0-6,0.9-8,2.8c0,0-0.1,0.1-0.2,0.2c-0.1-0.1-0.1-0.1-0.2-0.2    c-1.8-1.8-4.5-2.8-7.4-2.8c-2.3,0-5.4,0.7-7.4,2.3c-1.3-1.8-2.8-1.9-3.7-1.9c-1,0-2.3,0.2-3.5,1.4c-2.1,2-3.6,3.9-5.1,10.7l0,0.1    c-1.1,6.9-5.3,11.6-5.6,11.9c-2.4,2.3-5.1,3.4-8.3,3.4c-2.7,0-5-0.7-6.7-2L66.5,6.5L65.1,5C61.4,1.2,57,0,53,0    c-4.7,0-8.8,1.7-12.1,5c-3.3,3.3-5,7.4-5,12.1c0,4.7,1.7,8.8,5,12.1c3.3,3.3,7.4,5,12.1,5c4.9,0,9-1.7,12.2-5    c5.1-5.4,6.6-13.8,6.9-15.4l0,0c0.5-2.6,1.8-6.1,2.9-6.1c0.2,0,0.9,0,0.8,1.9l0,23.9H81V10.7c0-1.3,0.4-2.4,1.3-3.3    c0.8-0.8,2.9-1.3,4.3-1.3c1.2,0,2.8,0.4,3.7,1.3c0.8,0.8,1.3,1.7,1.3,2.7v23.3h5.3V10.6c0-1.3,0.5-2.3,1.3-3.1    c0.8-0.8,2.8-1.3,4.3-1.3C104.7,6.2,106.1,7.5,106.1,7.5L106.1,7.5z M17.1,28.9c-6.5,0-11.7-5.3-11.7-11.7S10.6,5.4,17.1,5.4    s11.7,5.3,11.7,11.7S23.6,28.9,17.1,28.9L17.1,28.9z M28.6,4.3C25.2,1.5,21.4,0,17.1,0C12.4,0,8.3,1.7,5,5c-3.3,3.3-5,7.4-5,12.1    c0,4.7,1.7,8.8,5,12.1c3.3,3.3,7.4,5,12.1,5c4.1,0,7.7-1.3,10.7-3.8c-0.5,1.2-1.4,2.6-2.7,3.9c-2.3,2.3-5,3.4-8.2,3.4    c-3.3,0-6-1.1-8.3-3.4c-0.3-0.3-1.4-1.6-1.4-1.6l-5.3,1.9c0,0,1.9,2.7,2.9,3.6c3.3,3.3,7.4,5,12.1,5c4.7,0,8.8-1.7,12.1-5    c3.1-3.1,4.9-7.7,4.9-12.5V2.6h-5.3V4.3z"
    }));
}
GemLogo.propTypes = _objectSpread2(_objectSpread2({
    color: PropTypes.oneOf(COLORS$f)
}, responsiveHeightType), {}, {
    testId: PropTypes.string
});

var COLORS$e = ["primary.blue.t100", "black", "white"];
var DEFAULT_PROPS$m = {
    color: "primary.blue.t100",
    height: "40px"
};
function LatitudeLogo(props) {
    var theme = useTheme();
    var _useBackground = useBackground(), bgMap = _useBackground.bgMap;
    var colorMap = mapResponsiveValues(bgMap, function (backgroundColor) {
        var _props$color;
        return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : backgroundColor === "primary.blue.t100" ? "white" : "primary.blue.t100";
    }, theme);
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$m, {}, {
        color: function color(_color) {
            return COLORS$e.includes(_color);
        }
    });
    var testId = mergedProps.testId;
    var svgResponsiveCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$m, {
        height: responsiveSize("height"),
        maxWidth: responsiveSize("maxWidth")
    });
    var pathResponsiveCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$m, {
        color: function color(propsAtBreakpoint, theme, bp) {
            return {
                fill: theme.getColor(colorMap[bp])
            };
        }
    });
    return jsx("svg", {
        css: /*#__PURE__*/ css$1(_objectSpread2({
            display: "flex"
        }, svgResponsiveCSS), process.env.NODE_ENV === "production" ? "" : ";label:LatitudeLogo;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        viewBox: "0 0 203 48",
        focusable: "false",
        role: "img",
        "aria-label": "Latitude logo",
        "data-testid": testId
    }, jsx("path", {
        css: pathResponsiveCSS,
        d: "M157.39425,25.1795 C157.39425,27.79625 156.3495,29.86475 153.3255,29.86475 C150.30075,29.86475 149.25675,27.79625 149.25675,25.1795 L149.25675,17.2265 L147.18075,17.2265 L147.18075,25.48925 C147.18075,28.2845 148.2975,31.925 153.3255,31.925 C158.3535,31.925 159.471,28.2845 159.471,25.48925 L159.471,17.2265 L157.39425,17.2265 L157.39425,25.1795 Z M180.9465,24.4925 C180.9465,21.15875 178.42575,19.301 175.25325,19.301 L171.495,19.301 L171.495,29.684 L175.25325,29.684 C178.42575,29.684 180.9465,27.827 180.9465,24.4925 L180.9465,24.4925 Z M183.051,24.4925 C183.05025,29.15975 179.62425,31.75925 175.398,31.75925 L169.41825,31.75925 L169.41825,17.2265 L175.398,17.2265 C179.62425,17.2265 183.05025,19.826 183.051,24.4925 L183.051,24.4925 Z M82.40325,25.52975 L79.6725,19.301 L76.9425,25.52975 L82.40325,25.52975 Z M80.71125,17.2265 L87.31275,31.75925 L85.13325,31.75925 L83.313,27.605 L76.03425,27.605 L74.21325,31.75925 L72.075,31.75925 L78.65625,17.2265 L80.71125,17.2265 Z M93.06375,19.301 L98.0355,19.301 L98.0355,31.75925 L100.11225,31.75925 L100.11225,19.301 L105.08475,19.301 L105.08475,17.2265 L93.06375,17.2265 L93.06375,19.301 Z M125.8725,19.301 L130.845,19.301 L130.845,31.75925 L132.92025,31.75925 L132.92025,19.301 L137.89275,19.301 L137.89275,17.2265 L125.8725,17.2265 L125.8725,19.301 Z M114.441,31.75925 L116.517,31.75925 L116.517,17.2265 L114.441,17.2265 L114.441,31.75925 Z M202.69725,19.301 L202.69725,17.2265 L192.15075,17.2265 L192.15075,31.75925 L202.69725,31.75925 L202.69725,29.684 L194.22675,29.684 L194.22675,25.52975 L201.51375,25.52975 L201.51375,23.45525 L194.22675,23.45525 L194.22675,19.301 L202.69725,19.301 Z M56.169,17.2265 L54.09375,17.2265 L54.09375,31.75925 L64.64025,31.75925 L64.64025,29.684 L56.169,29.684 L56.169,17.2265 Z M5.775,8 L1.84741111e-13,8 L1.84741111e-13,41 L33,41 L33,35.225 L5.775,35.225 L5.775,8 Z M21.03675,13.77425 C22.632,13.77425 23.92425,12.482 23.92425,10.88675 C23.92425,9.29225 22.632,8 21.03675,8 C19.44225,8 18.15,9.29225 18.15,10.88675 C18.15,12.482 19.44225,13.77425 21.03675,13.77425 L21.03675,13.77425 Z M30.1125,26.15 C28.518,26.15 27.225,27.443 27.225,29.03825 C27.225,30.63275 28.518,31.925 30.1125,31.925 C31.707,31.925 33,30.63275 33,29.03825 C33,27.443 31.707,26.15 30.1125,26.15 L30.1125,26.15 Z M11.9625,13.77425 C13.557,13.77425 14.84925,12.482 14.84925,10.88675 C14.84925,9.29225 13.557,8 11.9625,8 C10.36725,8 9.07425,9.29225 9.07425,10.88675 C9.07425,12.482 10.36725,13.77425 11.9625,13.77425 L11.9625,13.77425 Z M30.1125,17.075 C28.518,17.075 27.225,18.368 27.225,19.9625 C27.225,21.557 28.518,22.85 30.1125,22.85 C31.707,22.85 33,21.557 33,19.9625 C33,18.368 31.707,17.075 30.1125,17.075 L30.1125,17.075 Z M33,10.88675 C33,12.482 31.707,13.77425 30.1125,13.77425 C28.518,13.77425 27.225,12.482 27.225,10.88675 C27.225,9.29225 28.518,8 30.1125,8 C31.707,8 33,9.29225 33,10.88675 L33,10.88675 Z",
        fillRule: "evenodd"
    }));
}
LatitudeLogo.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({
    color: PropTypes.oneOf(COLORS$e)
}, responsiveHeightType), responsiveMaxWidthType), {}, {
    testId: PropTypes.string
});

var logoListMapping = {
    gem: GemLogo,
    latitude: LatitudeLogo
};

var NAMES = ["latitude", "gem"];
var COLORS$d = ["primary.blue.t100", "black", "white"];
var DEFAULT_PROPS$l = {};
Logo.NAMES = NAMES;
Logo.COLORS = COLORS$d;
Logo.DEFAULT_PROPS = DEFAULT_PROPS$l;
function Logo(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$l), _props);
    var name = props.name, color = props.color, testId = props.testId;
    var heightProps = useAllResponsiveProps(props, "height");
    var maxWidthProps = useAllResponsiveProps(props, "maxWidth");
    if (!NAMES.includes(name)) {
        return null;
    }
    var LogoComponent = logoListMapping[name];
    var logoProps = _objectSpread2(_objectSpread2(_objectSpread2({
        color: color
    }, heightProps), maxWidthProps), {}, {
        testId: testId
    });
    return jsx(LogoComponent, logoProps);
}
Logo.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({
    name: PropTypes.oneOf(NAMES).isRequired,
    color: PropTypes.oneOf(COLORS$d)
}, responsiveHeightType), responsiveMaxWidthType), {}, {
    testId: PropTypes.string
});

var FooterLinksContext = /*#__PURE__*/ React__default.createContext();
var FooterLinksProvider = FooterLinksContext.Provider;
function useFooterLinks() {
    return useContext(FooterLinksContext);
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HeaderLogo$1(_ref) {
    var name = _ref.name, testId = _ref.testId;
    return jsx(Container, {
        height: "56",
        "height-lg": "80",
        testId: testId
    }, jsx(Flex, {
        height: "100%",
        placeItems: "left center"
    }, jsx(Logo, {
        name: name,
        color: "white",
        height: "36",
        "height-xs": "40",
        "height-lg": "48",
        maxWidth: "120",
        "maxWidth-xs": "none"
    })));
}
HeaderLogo$1.propTypes = {
    name: PropTypes.oneOf(Logo.NAMES).isRequired,
    testId: PropTypes.string
};
function HeaderSocial(_ref2) {
    var children = _ref2.children, testId = _ref2.testId;
    return jsx(Container, {
        height: "56",
        width: "100%",
        "width-sm": "auto",
        "margin-sm": "0 0 0 auto",
        testId: testId
    }, jsx(Flex, {
        height: "100%",
        placeItems: "left center"
    }, jsx(Text, {
        margin: "0",
        "margin-sm": "0 4 0 0"
    }, jsx("strong", null, "Connect with us")), jsx(Stack, {
        direction: "horizontal",
        gap: "3",
        margin: "0 0 0 auto",
        "margin-sm": "0"
    }, children)));
}
HeaderSocial.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function SocialFacebook(_ref3) {
    var href = _ref3.href, title = _ref3.title, onClick = _ref3.onClick, testId = _ref3.testId;
    return jsx(Link, {
        appearance: "icon",
        href: href,
        newTab: true,
        title: title,
        onClick: onClick,
        testId: testId
    }, jsx(Icon, {
        name: "facebook",
        color: "white",
        hoverColor: "secondary.lightBlue.t60"
    }));
}
SocialFacebook.propTypes = {
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    testId: PropTypes.string
};
function SocialYouTube(_ref4) {
    var href = _ref4.href, title = _ref4.title, onClick = _ref4.onClick, testId = _ref4.testId;
    return jsx(Link, {
        appearance: "icon",
        href: href,
        newTab: true,
        title: title,
        onClick: onClick,
        testId: testId
    }, jsx(Icon, {
        name: "youtube",
        color: "white",
        hoverColor: "secondary.lightBlue.t60"
    }));
}
SocialYouTube.propTypes = {
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    testId: PropTypes.string
};
function SocialTwitter(_ref5) {
    var href = _ref5.href, title = _ref5.title, onClick = _ref5.onClick, testId = _ref5.testId;
    return jsx(Link, {
        appearance: "icon",
        href: href,
        newTab: true,
        title: title,
        onClick: onClick,
        testId: testId
    }, jsx(Icon, {
        name: "twitter",
        color: "white",
        hoverColor: "secondary.lightBlue.t60"
    }));
}
SocialTwitter.propTypes = {
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    testId: PropTypes.string
};
function SocialInstagram(_ref6) {
    var href = _ref6.href, title = _ref6.title, onClick = _ref6.onClick, testId = _ref6.testId;
    return jsx(Link, {
        appearance: "icon",
        href: href,
        newTab: true,
        title: title,
        onClick: onClick,
        testId: testId
    }, jsx(Icon, {
        name: "instagram",
        color: "white",
        hoverColor: "secondary.lightBlue.t60"
    }));
}
SocialInstagram.propTypes = {
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    testId: PropTypes.string
};
function SocialLinkedIn(_ref7) {
    var href = _ref7.href, title = _ref7.title, onClick = _ref7.onClick, testId = _ref7.testId;
    return jsx(Link, {
        appearance: "icon",
        href: href,
        newTab: true,
        title: title,
        onClick: onClick,
        testId: testId
    }, jsx(Icon, {
        name: "linkedin",
        color: "white",
        hoverColor: "secondary.lightBlue.t60"
    }));
}
SocialLinkedIn.propTypes = {
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    testId: PropTypes.string
};
function Header$1(_ref8) {
    var children = _ref8.children, testId = _ref8.testId;
    return jsx(Container, {
        bg: "primary.blue.t100",
        testId: testId
    }, jsx(Container, {
        bg: "primary.blue.t100",
        hasBreakpointWidth: true
    }, jsx(Flex, {
        direction: "column",
        "direction-sm": "row",
        placeItems: "left center"
    }, children)));
}
Header$1.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
var SECTION_TITLES_AS = ["h2", "h3", "h4", "h5", "h6"];
var LINKS_DEFAULT_PROPS = {
    sectionTitlesAs: "h5",
    switchLayoutAt: "md"
};
Links.SECTION_TITLES_AS = SECTION_TITLES_AS;
Links.DEFAULT_PROPS = LINKS_DEFAULT_PROPS;
var _ref9 = process.env.NODE_ENV === "production" ? {
    name: "1eoy87d",
    styles: "display:flex;justify-content:space-between"
} : {
    name: "yxvzqf-Links",
    styles: "display:flex;justify-content:space-between;label:Links;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function Links(props) {
    var mergedProps = mergeProps$1(props, LINKS_DEFAULT_PROPS);
    var sectionTitlesAs = mergedProps.sectionTitlesAs, switchLayoutAt = mergedProps.switchLayoutAt, children = mergedProps.children, testId = mergedProps.testId;
    var theme = useTheme();
    var bp = useBreakpoint();
    var result = compareBreakpoints(bp, switchLayoutAt, theme);
    var isColumnsLayout = result >= 0;
    return jsx(FooterLinksProvider, {
        value: {
            sectionTitlesAs: sectionTitlesAs
        }
    }, jsx(Container, {
        bg: isColumnsLayout ? "white" : "primary.blue.t100",
        padding: isColumnsLayout ? "8 0" : "8 0 0 0",
        testId: testId
    }, jsx(Container, {
        hasBreakpointWidth: true
    }, isColumnsLayout ? jsx("div", {
        css: _ref9
    }, children) : jsx(Accordion, {
        itemGap: "small"
    }, Children.map(children, function (child, index) {
        return jsx(Accordion.Item, {
            key: index
        }, jsx(Accordion.Item.Header, null, child.props.title), jsx(Accordion.Item.Content, null, jsx(Stack, {
            gap: "5"
        }, child.props.children)));
    })))));
}
Links.propTypes = {
    sectionTitlesAs: PropTypes.oneOf(SECTION_TITLES_AS),
    switchLayoutAt: PropTypes.string,
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function LinksSection(_ref10) {
    var title = _ref10.title, children = _ref10.children, testId = _ref10.testId;
    var _useFooterLinks = useFooterLinks(), sectionTitlesAs = _useFooterLinks.sectionTitlesAs;
    return jsx("div", {
        "data-testid": testId
    }, jsx(Text, {
        as: sectionTitlesAs,
        textStyle: "subtitle2",
        margin: "0 0 4 0"
    }, jsx("strong", null, title)), jsx(Stack, {
        gap: "5"
    }, children));
}
LinksSection.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function LegalLinks(_ref11) {
    var children = _ref11.children, testId = _ref11.testId;
    return jsx(Container, {
        padding: "0 4",
        "padding-lg": "0",
        textAlign: "center"
    }, jsx(Stack, {
        direction: "horizontal",
        align: "center",
        gap: "3 4",
        testId: testId
    }, children));
}
LegalLinks.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function LegalCopy(_ref12) {
    var children = _ref12.children, testId = _ref12.testId;
    return jsx(Container, {
        textStyle: "legal",
        margin: "7 0 0 0",
        testId: testId
    }, children);
}
LegalCopy.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function Legal(_ref13) {
    var children = _ref13.children, testId = _ref13.testId;
    return jsx(Container, {
        bg: "secondary.lightBlue.t25",
        testId: testId
    }, jsx(Container, {
        hasBreakpointWidth: true,
        padding: "9 0",
        textAlign: "center"
    }, children));
}
Legal.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function Footer$1(_ref14) {
    var children = _ref14.children, testId = _ref14.testId;
    return jsx("footer", {
        "data-testid": testId
    }, children);
}
Footer$1.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
Footer$1.Header = Header$1;
Footer$1.Header.Logo = HeaderLogo$1;
Footer$1.Header.Social = HeaderSocial;
Footer$1.Header.Social.Facebook = SocialFacebook;
Footer$1.Header.Social.YouTube = SocialYouTube;
Footer$1.Header.Social.Twitter = SocialTwitter;
Footer$1.Header.Social.Instagram = SocialInstagram;
Footer$1.Header.Social.LinkedIn = SocialLinkedIn;
Footer$1.Links = Links;
Footer$1.Links.Section = LinksSection;
Footer$1.Legal = Legal;
Footer$1.Legal.Links = LegalLinks;
Footer$1.Legal.Copy = LegalCopy;

var ALL_FREQUENCY_OPTIONS = [
    {
        label: "Annually",
        value: "annually",
    },
    {
        label: "Quarterly",
        value: "quarterly",
    },
    {
        label: "Monthly",
        value: "monthly",
    },
    {
        label: "Fortnightly",
        value: "fortnightly",
    },
    {
        label: "Weekly",
        value: "weekly",
    },
];

var defaultSelectProps = {
    placeholder: "Please select",
    fullWidth: true,
    disabled: false,
    optional: false,
};

var defaultFrequencyProps = {
    mode: "radio-group",
    annually: true,
    quarterly: true,
    monthly: true,
    fortnightly: true,
    weekly: true,
    disabled: false,
    selectPlaceholder: defaultSelectProps.placeholder,
    optional: false,
};

var COLORS$c = ["grey.t05", "white"];
var DEFAULT_PROPS$k = {
    color: "grey.t05",
    disabled: false,
    isValid: true,
};
InternalRadioGroup.COLORS = COLORS$c;
InternalRadioGroup.DEFAULT_PROPS = DEFAULT_PROPS$k;
function RadioCircle(props) {
    var isChecked = props.isChecked;
    var theme = useTheme();
    var inputColorMap = useBackground().inputColorMap;
    var outerCircleCSS = useResponsivePropsCSS(props, {}, {
        color: function (propsAtBreakpoint, theme, bp) {
            var _a;
            return theme.radioGroup.getCSS({
                targetElement: "outerCircle",
                color: (_a = props.color) !== null && _a !== void 0 ? _a : inputColorMap[bp],
                isChecked: isChecked,
            });
        },
    });
    return (jsxs("svg", __assign({ css: theme.radioGroup.getCSS({ targetElement: "circleSvg" }), viewBox: "0 0 24 24", focusable: "false", "aria-hidden": "true" }, { children: [jsx$1("circle", { css: outerCircleCSS, cx: "12", cy: "12", r: "12" }, void 0),
            isChecked && (jsx$1("circle", { css: theme.radioGroup.getCSS({ targetElement: "innerCircle" }), cx: "12", cy: "12", r: "6" }, void 0))] }), void 0));
}
function Radio(props) {
    var name = props.name, innerRef = props.innerRef, parentName = props.parentName, label = props.label, isLabelBold = props.isLabelBold, description = props.description, isChecked = props.isChecked, disabled = props.disabled, onFocus = props.onFocus, onBlur = props.onBlur, onMouseDown = props.onMouseDown, value = props.value, onChange = props.onChange;
    var theme = useTheme();
    var inputColorMap = useBackground().inputColorMap;
    var labelCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$k, {
        color: function (propsAtBreakpoint, theme, bp) {
            var _a;
            return theme.radioGroup.getCSS({
                targetElement: "radioLabel",
                color: (_a = props.color) !== null && _a !== void 0 ? _a : inputColorMap[bp],
            });
        },
    });
    var inputId = useState(function () { return "radio-input-" + nanoid(); })[0];
    return (jsxs("div", __assign({ css: theme.radioGroup.getCSS({ targetElement: "radio" }), role: "radio", "aria-checked": isChecked }, { children: [jsx$1(VisuallyHidden, { children: jsx$1("input", { css: theme.radioGroup.getCSS({ targetElement: "radioInput" }), ref: innerRef, type: "radio", id: inputId, name: name, "data-parent-name": parentName, value: value, checked: isChecked, disabled: disabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange }, void 0) }, void 0),
            jsxs("label", __assign({ css: labelCSS, htmlFor: inputId, onMouseDown: onMouseDown }, { children: [
                    // @ts-ignore TODO: find out why there the colors are different
                    jsx$1(RadioCircle, { color: props.color, isChecked: isChecked }, void 0),
                    jsxs("div", { children: [isLabelBold ? jsx$1("strong", { children: label }, void 0) : label,
                            description ? (jsx$1("div", __assign({ css: theme.radioGroup.getCSS({ targetElement: "description" }) }, { children: description }), void 0)) : null] }, void 0)] }), void 0)] }), void 0));
}
function InternalRadioGroup(props) {
    var name = props.name, innerRef = props.innerRef, parentName = props.parentName, labelId = props.labelId, options = props.options, columns = props.columns, color = props.color, _a = props.disabled, disabled = _a === void 0 ? DEFAULT_PROPS$k.disabled : _a, isValid = props.isValid, ariaLabel = props["aria-label"], describedBy = props.describedBy, onFocus = props.onFocus, testId = props.testId, onBlur = props.onBlur, onMouseDown = props.onMouseDown, checkedValue = props.value, onChange = props.onChange;
    var cols = columns === undefined ? options.length : columns;
    var areLabelsBold = options.some(function (option) { return "description" in option; });
    var radioGroupRef = useRef(null);
    var onRadioBlur = useCallback(function (event) {
        var _a;
        if (!((_a = radioGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        }
    }, [onBlur]);
    return (jsx$1("div", __assign({ role: "radiogroup", ref: mergeRefs([radioGroupRef, innerRef !== null && innerRef !== void 0 ? innerRef : null]), "data-testid": testId, "aria-invalid": isValid ? "false" : "true", "aria-labelledby": labelId, "aria-label": ariaLabel, "aria-describedby": describedBy }, { children: jsx$1(Grid, __assign({ cols: cols, colsGap: 1, rowsGap: 1 }, { children: options.map(function (_a, index) {
                var label = _a.label, value = _a.value, description = _a.description;
                return (jsx$1(Grid.Item, __assign({ colSpan: index % cols, rowSpan: Math.floor(index / cols) }, { children: jsx$1(Radio, { name: name, parentName: parentName, color: color, label: label, isLabelBold: areLabelsBold, description: description, value: value, isChecked: value === checkedValue, disabled: disabled, onFocus: onFocus, onBlur: onRadioBlur, onMouseDown: onMouseDown, onChange: onChange }, void 0) }), value));
            }) }), void 0) }), void 0));
}

var COLORS$b = ["grey.t05", "white"];
var DEFAULT_PROPS$j = {
    color: "grey.t05",
    placeholder: "Please select",
    fullWidth: true,
    disabled: false,
    isValid: true,
    __internal__focus: false,
};
InternalSelect.COLORS = COLORS$b;
InternalSelect.DEFAULT_PROPS = DEFAULT_PROPS$j;
function InternalSelect(props) {
    var name = props.name, innerRef = props.innerRef, testId = props.testId, parentName = props.parentName, id = props.id, _a = props.placeholder, placeholder = _a === void 0 ? DEFAULT_PROPS$j.placeholder : _a, options = props.options, _b = props.fullWidth, fullWidth = _b === void 0 ? DEFAULT_PROPS$j.fullWidth : _b, optional = props.optional, _c = props.disabled, disabled = _c === void 0 ? DEFAULT_PROPS$j.disabled : _c, _d = props.isValid, isValid = _d === void 0 ? DEFAULT_PROPS$j.isValid : _d, describedBy = props.describedBy, ariaLabel = props["aria-label"], onFocus = props.onFocus, onBlur = props.onBlur, value = props.value, onChange = props.onChange, color = props.color, _e = props.__internal__focus, __internal__focus = _e === void 0 ? DEFAULT_PROPS$j.__internal__focus : _e;
    var inputColorMap = useBackground().inputColorMap;
    var css = useResponsivePropsCSS(props, DEFAULT_PROPS$j, {
        color: function (propsAtBreakpoint, theme, bp) {
            return theme.select.getCSS({
                color: color !== null && color !== void 0 ? color : inputColorMap[bp],
                fullWidth: fullWidth,
                __internal__focus: __internal__focus,
            });
        },
    });
    return (jsxs("select", __assign({ ref: innerRef, css: css, id: id, name: name, "data-parent-name": parentName, "data-testid": testId, "aria-invalid": isValid ? "false" : "true", "aria-describedby": describedBy, "aria-label": ariaLabel, disabled: disabled, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange }, { children: [placeholder && (jsx$1("option", __assign({ value: "", disabled: !optional }, { children: placeholder }), void 0)),
            options.map(function (option) { return (
            /*
              Note: We use `option.label` as the key here because users shouldn't have
                    multiple options with the same label.
                    They can have multiple options with the same value though!
                    For example:
                      <option value="us">USA</option>
                      <option value="us">United States</option>
            */
            jsx$1("option", __assign({ value: option.value }, { children: option.label }), option.label)); })] }), void 0));
}

function Frequency$2(props) {
    var _a;
    var mergedProps = useMergedProps(props, defaultFrequencyProps);
    var mode = mergedProps.mode, label = mergedProps.label, annually = mergedProps.annually, _b = mergedProps.innerRef, innerRef = _b === void 0 ? null : _b, error = mergedProps.error, quarterly = mergedProps.quarterly, monthly = mergedProps.monthly, fortnightly = mergedProps.fortnightly, weekly = mergedProps.weekly, amountPrefix = mergedProps.amountPrefix, amountPlaceholder = mergedProps.amountPlaceholder, selectPlaceholder = mergedProps.selectPlaceholder, amountMaxLength = mergedProps.amountMaxLength, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, testId = mergedProps.testId, onFocus = mergedProps.onFocus, onBlur = mergedProps.onBlur, onChange = mergedProps.onChange, onMouseDown = mergedProps.onMouseDown;
    var labelId = useState(function () { return "frequency-label-" + nanoid(); })[0];
    var auxId = useState(function () { return "frequency-aux-" + nanoid(); })[0];
    var frequencyOptions = useMemo(function () {
        var frequencyPropsMap = {
            annually: annually,
            quarterly: quarterly,
            monthly: monthly,
            fortnightly: fortnightly,
            weekly: weekly,
        };
        return ALL_FREQUENCY_OPTIONS.filter(function (option) { return frequencyPropsMap[option.value]; });
    }, [annually, quarterly, monthly, fortnightly, weekly]);
    var _c = useState({
        amount: "",
        frequency: "",
    }), internalValue = _c[0], setInternalValue = _c[1];
    var value = (_a = props.value) !== null && _a !== void 0 ? _a : internalValue;
    var onFrequencyChange = function (event) {
        var _a;
        var _b = event.target, key = _b.name, updatedValue = _b.value;
        if (key !== "amount" && key !== "frequency") {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), (_a = {}, _a[key] = updatedValue, _a)));
        setInternalValue(function (val) {
            var _a;
            return (__assign(__assign({}, val), (_a = {}, _a[key] = updatedValue, _a)));
        });
    };
    var frequencyRef = useRef(null);
    var fieldErrors = Object.values(error !== null && error !== void 0 ? error : {});
    var hasErrors = !!error;
    var onFrequencyBlur = useCallback(function (event) {
        var _a;
        if (!((_a = frequencyRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        }
    }, [onBlur]);
    var inputComponent = (jsx$1(InternalInput, { name: "amount", variant: "numeric", "aria-label": "amount", prefix: amountPrefix, color: props.color, placeholder: amountPlaceholder, maxLength: amountMaxLength, disabled: disabled, onFocus: onFocus, onBlur: onFrequencyBlur, value: value.amount, onChange: onFrequencyChange }, void 0));
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, labelId: labelId, auxId: auxId, helpText: helpText, errors: fieldErrors }, { children: jsxs("div", __assign({ ref: mergeRefs([innerRef, frequencyRef]), "aria-invalid": hasErrors ? "true" : "false", "aria-labelledby": labelId, "aria-describedby": helpText || hasErrors ? auxId : undefined, "data-testid": testId }, { children: [mode === "radio-group" && (jsxs(Grid, __assign({ cols: 1, rowsGap: 1 }, { children: [inputComponent,
                        frequencyOptions.length > 0 && (jsx$1(InternalRadioGroup, { name: "frequency", "aria-label": "frequency", color: props.color, options: frequencyOptions, columns: 2, disabled: disabled, onFocus: onFocus, onBlur: onFrequencyBlur, onMouseDown: onMouseDown, value: value.frequency, onChange: onFrequencyChange }, void 0))] }), void 0)),
                mode === "select" && (jsxs(Grid, __assign({ cols: 2, colsGap: 1 }, { children: [jsx$1(Grid.Item, __assign({ colSpan: "0" }, { children: inputComponent }), void 0),
                        jsx$1(Grid.Item, __assign({ colSpan: "1" }, { children: jsx$1(InternalSelect, { name: "frequency", "aria-label": "frequency", color: props.color, optional: optional, placeholder: selectPlaceholder, options: frequencyOptions, disabled: disabled, onFocus: onFocus, onBlur: onFrequencyBlur, value: value.frequency, onChange: onFrequencyChange }, void 0) }), void 0)] }), void 0))] }), void 0) }), void 0));
}

var COLORS$a = InternalInput.COLORS, NUMERIC_REGEX$1 = InternalInput.NUMERIC_REGEX;
var MODES$1 = ["radio-group", "select"];
function isFrequencySelected(frequency, frequencyPropsMap) {
    return ALL_FREQUENCY_OPTIONS.findIndex(function (option) {
        return option.value === frequency;
    }) > -1 && frequencyPropsMap[frequency] === true;
}
var DEFAULT_PROPS$i = _objectSpread2(_objectSpread2({}, defaultFrequencyProps), {}, {
    color: InternalInput.DEFAULT_PROPS.color,
    validate: function validate(value, _ref) {
        var isInputEmpty = _ref.isInputEmpty, isFrequencyEmpty = _ref.isFrequencyEmpty;
        var errors = [];
        if (isInputEmpty(value.amount)) {
            errors.push("Please enter an amount.");
        }
        if (NUMERIC_REGEX$1.test(value.amount) === false) {
            errors.push("Amount can contain only digits.");
        }
        if (isFrequencyEmpty(value.frequency)) {
            errors.push("Please select a frequency.");
        }
        return errors;
    }
});
Frequency$1.ALL_FREQUENCY_OPTIONS = ALL_FREQUENCY_OPTIONS;
Frequency$1.COLORS = COLORS$a;
Frequency$1.MODES = MODES$1;
Frequency$1.DEFAULT_PROPS = DEFAULT_PROPS$i;
function Frequency$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$i, {}, {
        color: function color(_color) {
            return COLORS$a.includes(_color);
        },
        mode: function mode(_mode) {
            return MODES$1.includes(_mode);
        },
        annually: function annually(_annually) {
            return typeof _annually === "boolean";
        },
        quarterly: function quarterly(_quarterly) {
            return typeof _quarterly === "boolean";
        },
        monthly: function monthly(_monthly) {
            return typeof _monthly === "boolean";
        },
        fortnightly: function fortnightly(_fortnightly) {
            return typeof _fortnightly === "boolean";
        },
        weekly: function weekly(_weekly) {
            return typeof _weekly === "boolean";
        },
        amountPrefix: function amountPrefix(_amountPrefix) {
            return typeof _amountPrefix === "string" && _amountPrefix.length > 0;
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        optional: function optional(_optional) {
            return typeof _optional === "boolean";
        }
    });
    var name = mergedProps.name, mode = mergedProps.mode, label = mergedProps.label, annually = mergedProps.annually, quarterly = mergedProps.quarterly, monthly = mergedProps.monthly, fortnightly = mergedProps.fortnightly, weekly = mergedProps.weekly, amountPrefix = mergedProps.amountPrefix, amountPlaceholder = mergedProps.amountPlaceholder, selectPlaceholder = mergedProps.selectPlaceholder, amountMaxLength = mergedProps.amountMaxLength, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, testId = mergedProps.testId;
    var _useState = useState(function () {
        return "frequency-label-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), labelId = _useState2[0];
    var _useState3 = useState(function () {
        return "frequency-aux-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), auxId = _useState4[0];
    var frequencyPropsMap = useMemo(function () {
        return {
            annually: annually,
            quarterly: quarterly,
            monthly: monthly,
            fortnightly: fortnightly,
            weekly: weekly
        };
    }, [annually, quarterly, monthly, fortnightly, weekly]);
    var frequencyOptions = useMemo(function () {
        return ALL_FREQUENCY_OPTIONS.reduce(function (acc, option) {
            if (frequencyPropsMap[option.value] === true) {
                acc.push(option);
            }
            return acc;
        }, []);
    }, [frequencyPropsMap]);
    var isInputEmpty = useCallback(function (amount) {
        return amount.trim() === "";
    }, []);
    var isFrequencyEmpty = useCallback(function (frequency) {
        return isFrequencySelected(frequency, frequencyPropsMap) === false;
    }, [frequencyPropsMap]);
    var isEmpty = useCallback(function (_ref2) {
        var amount = _ref2.amount, frequency = _ref2.frequency;
        return isInputEmpty(amount) && isFrequencyEmpty(frequency);
    }, [isInputEmpty, isFrequencyEmpty]);
    var data = useMemo(function () {
        return _objectSpread2({
            isInputEmpty: isInputEmpty,
            isFrequencyEmpty: isFrequencyEmpty,
            isEmpty: isEmpty
        }, validateData && {
            data: validateData
        });
    }, [isInputEmpty, isFrequencyEmpty, isEmpty, validateData]);
    var _useField = useField("Frequency", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, onChange = _useField.onChange, onMouseDown = _useField.onMouseDown;
    var inputComponent = jsx(InternalInput, {
        name: "".concat(name, ".amount"),
        parentName: name,
        variant: "numeric",
        prefix: amountPrefix,
        color: props.color,
        placeholder: amountPlaceholder,
        maxLength: amountMaxLength,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value.amount,
        onChange: onChange
    });
    return jsx(Field$1, {
        optional: optional,
        disabled: disabled,
        label: label,
        labelId: labelId,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx("div", {
        "aria-invalid": hasErrors ? "true" : null,
        "aria-labelledby": labelId,
        "aria-describedby": helpText || hasErrors ? auxId : null
    }, mode === "radio-group" && jsx(Grid, {
        cols: 1,
        rowsGap: 1
    }, inputComponent, frequencyOptions.length > 0 && jsx(InternalRadioGroup, {
        name: "".concat(name, ".frequency"),
        parentName: name,
        color: props.color,
        options: frequencyOptions,
        columns: 2,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: onMouseDown,
        value: value.frequency,
        onChange: onChange
    })), mode === "select" && jsx(Grid, {
        cols: 2,
        colsGap: 1
    }, jsx(Grid.Item, {
        colSpan: "0"
    }, inputComponent), jsx(Grid.Item, {
        colSpan: "1"
    }, jsx(InternalSelect, {
        name: "".concat(name, ".frequency"),
        parentName: name,
        color: props.color,
        optional: optional,
        placeholder: selectPlaceholder,
        options: frequencyOptions,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value.frequency,
        onChange: onChange
    })))));
}
Frequency$1.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.oneOf(COLORS$a),
    mode: PropTypes.oneOf(MODES$1),
    label: PropTypes.string.isRequired,
    annually: PropTypes.bool,
    quarterly: PropTypes.bool,
    monthly: PropTypes.bool,
    fortnightly: PropTypes.bool,
    weekly: PropTypes.bool,
    amountPrefix: PropTypes.string,
    amountPlaceholder: PropTypes.string,
    amountMaxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectPlaceholder: PropTypes.string,
    helpText: PropTypes.node,
    disabled: PropTypes.bool,
    optional: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    validateData: PropTypes.any,
    testId: PropTypes.string
};

var setDeprecatedProps$4 = function (props, isDeprecated) {
    return isDeprecated;
};

var COLORS$9 = Frequency$1.COLORS, DEFAULT_PROPS$h = Frequency$1.DEFAULT_PROPS, MODES = Frequency$1.MODES;
var FrequencyComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps$4(props, isDeprecatedForm)) {
        return jsx$1(Frequency$1, __assign({}, props), void 0);
    }
    return jsx$1(Frequency$2, __assign({}, props, { innerRef: ref }), void 0);
};
var Frequency = forwardRef(FrequencyComponent);
Frequency.displayName = ComponentNames.Frequency;
Frequency.defaultProps = defaultFrequencyProps;
Frequency.COLORS = COLORS$9;
Frequency.DEFAULT_PROPS = DEFAULT_PROPS$h;
Frequency.MODES = MODES;
Frequency.ALL_FREQUENCY_OPTIONS = ALL_FREQUENCY_OPTIONS;

function HeaderLogo(_ref) {
    var name = _ref.name, testId = _ref.testId;
    return jsx(Logo, {
        name: name,
        height: "36",
        "height-xs": "40",
        "height-lg": "48",
        maxWidth: "120",
        "maxWidth-xs": "none",
        testId: testId
    });
}
HeaderLogo.propTypes = {
    name: PropTypes.oneOf(Logo.NAMES).isRequired,
    testId: PropTypes.string
};
var DEFAULT_PROPS$g = {};
Header.DEFAULT_PROPS = DEFAULT_PROPS$g;
Header.ID = "Header";
Header.HEIGHT_MAP = {
    "default": 56,
    lg: 80
};
function Header(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$g), _props);
    var children = props.children, testId = props.testId;
    var heightMap = Header.HEIGHT_MAP;
    var heightProps = useMemo(function () {
        return getPropsFromMap("height", heightMap);
    }, [heightMap]);
    return jsx("header", {
        "data-testid": testId
    }, jsx(Container, _extends$1({
        bg: "white"
    }, heightProps, {
        boxShadow: "header"
    }), jsx(Container, {
        hasBreakpointWidth: true,
        height: "100%"
    }, jsx(Flex, {
        height: "100%",
        placeItems: "left center"
    }, children))));
}
Header.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
Header.Logo = HeaderLogo;

var defaultInputProps = {
    type: "text",
    variant: "text",
    disabled: false,
    pasteAllowed: true,
    optional: false,
};

var Input$2 = function (props) {
    var mergedProps = useMergedProps(props, defaultInputProps);
    var type = mergedProps.type, variant = mergedProps.variant, prefix = mergedProps.prefix, suffix = mergedProps.suffix, maxLength = mergedProps.maxLength, autoComplete = mergedProps.autoComplete, label = mergedProps.label, placeholder = mergedProps.placeholder, helpText = mergedProps.helpText, innerRef = mergedProps.innerRef, disabled = mergedProps.disabled, pasteAllowed = mergedProps.pasteAllowed, optional = mergedProps.optional, onChange = mergedProps.onChange, onBlur = mergedProps.onBlur, onFocus = mergedProps.onFocus, testId = mergedProps.testId, value = mergedProps.value, error = mergedProps.error, id = mergedProps.id, onKeyDown = mergedProps.onKeyDown, __internal__focus = mergedProps.__internal__focus;
    var inputId = useState(function () { return id !== null && id !== void 0 ? id : "input-" + nanoid(); })[0];
    var auxId = useState(function () { return "input-aux-" + nanoid(); })[0];
    var fieldErrors = Array.isArray(error) || error === undefined ? error : [error];
    var hasErrors = Array.isArray(error) ? error.length !== 0 : !!error;
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, labelFor: inputId, auxId: auxId, helpText: helpText, errors: fieldErrors }, { children: jsx$1(InternalInput, { id: label ? inputId : undefined, testId: testId, innerRef: innerRef, type: type, variant: variant, prefix: prefix, suffix: suffix, maxLength: maxLength, autoComplete: autoComplete, placeholder: placeholder, color: props.color, disabled: disabled, pasteAllowed: pasteAllowed, isValid: !hasErrors, describedBy: helpText || hasErrors ? auxId : undefined, onFocus: onFocus, onBlur: onBlur, value: value, onChange: onChange, onKeyDown: onKeyDown, __internal__focus: __internal__focus }, void 0) }), void 0));
};

var NUMERIC_REGEX = /^\d*$/;
var DECIMAL_REGEX = /^\d*(\.\d{2})?$/;
var isInputEmpty = function (value) { return value.trim() === ""; };
var validateInput = function (value, inputProps) {
    var optional = inputProps.optional, variant = inputProps.variant;
    if (isInputEmpty(value)) {
        return optional ? null : "Required";
    }
    if (variant === "numeric" && NUMERIC_REGEX.test(value) === false) {
        return "Only 0-9 are allowed";
    }
    if (variant === "decimal" && DECIMAL_REGEX.test(value) === false) {
        return "Invalid";
    }
    return null;
};

var TYPES$2 = InternalInput.TYPES, VARIANTS$2 = InternalInput.VARIANTS, COLORS$8 = InternalInput.COLORS;
var DEFAULT_PROPS$f = _objectSpread2(_objectSpread2({}, defaultInputProps), {}, {
    color: InternalInput.DEFAULT_PROPS.color,
    validate: validateInput
});
Input$1.TYPES = TYPES$2;
Input$1.VARIANTS = VARIANTS$2;
Input$1.COLORS = COLORS$8;
Input$1.DEFAULT_PROPS = DEFAULT_PROPS$f;
function Input$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$f, {}, {
        type: function type(_type) {
            return TYPES$2.includes(_type);
        },
        variant: function variant(_variant) {
            return VARIANTS$2.includes(_variant);
        },
        prefix: function prefix(_prefix) {
            return typeof _prefix === "string" && _prefix.length > 0;
        },
        suffix: function suffix(_suffix) {
            return typeof _suffix === "string" && _suffix.length > 0;
        },
        maxLength: function maxLength(_maxLength) {
            return typeof _maxLength === "string" || typeof _maxLength === "number";
        },
        autoComplete: function autoComplete(_autoComplete) {
            return typeof _autoComplete === "string";
        },
        color: function color(_color) {
            return COLORS$8.includes(_color);
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        pasteAllowed: function pasteAllowed(_pasteAllowed) {
            return typeof _pasteAllowed === "boolean";
        },
        optional: function optional(_optional) {
            return typeof _optional === "boolean";
        }
    });
    var name = mergedProps.name, type = mergedProps.type, variant = mergedProps.variant, prefix = mergedProps.prefix, suffix = mergedProps.suffix, maxLength = mergedProps.maxLength, autoComplete = mergedProps.autoComplete, label = mergedProps.label, placeholder = mergedProps.placeholder, helpText = mergedProps.helpText, disabled = mergedProps.disabled, pasteAllowed = mergedProps.pasteAllowed, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, onChangeProp = mergedProps.onChange, testId = mergedProps.testId, __internal__focus = mergedProps.__internal__focus;
    var _useState = useState(function () {
        return "input-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), inputId = _useState2[0];
    var _useState3 = useState(function () {
        return "input-aux-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), auxId = _useState4[0];
    var isEmpty = useCallback(function (value) {
        return value.trim() === "";
    }, []);
    var data = useMemo(function () {
        return _objectSpread2({
            isEmpty: isEmpty,
            variant: variant
        }, validateData && {
            data: validateData
        });
    }, [isEmpty, variant, validateData]);
    var _useField = useField("Input", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, fieldOnChange = _useField.onChange;
    var onChange = useCallback(function (event) {
        fieldOnChange(event);
        onChangeProp && onChangeProp({
            value: event.target.value
        });
    }, [fieldOnChange, onChangeProp]);
    return jsx(Field$1, {
        optional: optional,
        disabled: disabled,
        label: label,
        labelFor: inputId,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx(InternalInput, {
        id: label ? inputId : null,
        name: name,
        type: type,
        variant: variant,
        prefix: prefix,
        suffix: suffix,
        maxLength: maxLength,
        autoComplete: autoComplete,
        placeholder: placeholder,
        color: props.color,
        disabled: disabled,
        pasteAllowed: pasteAllowed,
        isValid: !hasErrors,
        describedBy: helpText || hasErrors ? auxId : null,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value,
        onChange: onChange,
        __internal__focus: __internal__focus
    }));
}
Input$1.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(TYPES$2),
    variant: PropTypes.oneOf(VARIANTS$2),
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    autoComplete: PropTypes.string,
    color: PropTypes.oneOf(COLORS$8),
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    helpText: PropTypes.node,
    disabled: PropTypes.bool,
    pasteAllowed: PropTypes.bool,
    optional: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    validateData: PropTypes.any,
    onChange: PropTypes.func,
    testId: PropTypes.string,
    __internal__focus: PropTypes.bool
};

var setDeprecatedProps$3 = function (props, isDeprecated) {
    return isDeprecated;
};

var TYPES$1 = Input$1.TYPES, VARIANTS$1 = Input$1.VARIANTS, COLORS$7 = Input$1.COLORS, DEFAULT_PROPS$e = Input$1.DEFAULT_PROPS;
var InputComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps$3(props, isDeprecatedForm)) {
        return jsx$1(Input$1, __assign({}, props), void 0);
    }
    return jsx$1(Input$2, __assign({}, props, { innerRef: ref }), void 0);
};
var Input = forwardRef(InputComponent);
Input.displayName = ComponentNames.Input;
Input.defaultProps = defaultInputProps;
Input.TYPES = TYPES$1;
Input.VARIANTS = VARIANTS$1;
Input.COLORS = COLORS$7;
Input.DEFAULT_PROPS = DEFAULT_PROPS$e;

var ListTypeContext = /*#__PURE__*/ React__default.createContext();
var ListTypeProvider = ListTypeContext.Provider;
function useListType() {
    var listInfo = useContext(ListTypeContext);
    var _ref = listInfo !== null && listInfo !== void 0 ? listInfo : {
        type: null,
        variant: null
    }, type = _ref.type, variant = _ref.variant;
    return {
        type: type,
        variant: variant
    };
}

var TYPES = ["unordered", "ordered", "steps"];
var VARIANTS = ["default", "danger"];
var TEXT_STYLES = ["subtitle1", "subtitle2", "body1", "body2"];
var DEFAULT_PROPS$d = {
    type: "unordered",
    variant: "default",
    textStyle: "body1"
};
List.TYPES = TYPES;
List.VARIANTS = VARIANTS;
List.TEXT_STYLES = TEXT_STYLES;
List.DEFAULT_PROPS = DEFAULT_PROPS$d;
function Item$2(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var theme = useTheme();
    var _useListType = useListType(), type = _useListType.type, variant = _useListType.variant;
    var _useTextStyle = useTextStyle(), textStyle = _useTextStyle.textStyle;
    return jsx("li", {
        css: theme.list.getCSS({
            targetElement: "item",
            type: type,
            variant: variant,
            textStyle: textStyle
        }),
        "data-testid": testId
    }, children);
}
Item$2.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
function List(props) {
    var _useListType2 = useListType(), inheritedListType = _useListType2.type, inheritedVariantType = _useListType2.variant;
    var _useTextStyle2 = useTextStyle(), inheritedTextStyle = _useTextStyle2.textStyle;
    var inheritedProps = {
        type: inheritedListType,
        variant: inheritedVariantType,
        textStyle: inheritedTextStyle
    };
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$d, inheritedProps, {
        type: function type(_type) {
            return TYPES.includes(_type);
        },
        variant: function variant(_variant) {
            return VARIANTS.includes(_variant);
        },
        textStyle: function textStyle(_textStyle) {
            return TEXT_STYLES.includes(_textStyle);
        }
    });
    var type = mergedProps.type, variant = mergedProps.variant, textStyle = mergedProps.textStyle, children = mergedProps.children, testId = mergedProps.testId;
    var listInfo = useMemo(function () {
        return {
            type: type,
            variant: variant
        };
    }, [type, variant]);
    var listCSS = useResponsivePropsCSS(mergedProps, DEFAULT_PROPS$d, {
        textStyle: function textStyle(_ref2, theme) {
            var _textStyle2 = _ref2.textStyle;
            return theme.list.getCSS({
                targetElement: "list",
                type: type,
                textStyle: _textStyle2
            });
        },
        margin: responsiveMargin
    });
    var ListComponent = type === "unordered" ? "ul" : "ol";
    var items = React__default.Children.toArray(children).filter(// Ignore all children that aren't List.Item
    function (child) {
        return child.type === Item$2;
    });
    var list = jsx(ListComponent, {
        css: listCSS,
        "data-testid": testId
    }, items);
    if (textStyle) {
        list = jsx(TextStyleProvider, {
            value: textStyle
        }, list);
    }
    return jsx(ListTypeProvider, {
        value: listInfo
    }, list);
}
List.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, responsiveMarginType), responsivePropType("textStyle", PropTypes.oneOf(TEXT_STYLES))), {}, {
    type: PropTypes.oneOf(TYPES),
    variant: PropTypes.oneOf(VARIANTS),
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
});
List.Item = Item$2;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SEVERITIES = ["assistance", "info-or-minor", "warning-or-significant", "blocking", "stop", "critical", "success"];
var BACKGROUNDS = ["highlight.pink.t100", "secondary.pink.t30", "primary.blue.t100", "secondary.lightBlue.t25", "grey.t10", "grey.t05", "white", "transparent"];
var DEFAULT_PROPS$c = {
    bg: "grey.t10",
    hasBreakpointWidth: false
};
Message.SEVERITIES = SEVERITIES;
Message.BACKGROUNDS = BACKGROUNDS;
Message.DEFAULT_PROPS = DEFAULT_PROPS$c;
var _ref2 = process.env.NODE_ENV === "production" ? {
    name: "to3ihi",
    styles: "flex-grow:1;display:flex;align-items:center"
} : {
    name: "1u2ux4l-Message",
    styles: "flex-grow:1;display:flex;align-items:center;label:Message;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function Message(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$c, {}, {
        severity: function severity(_severity) {
            return SEVERITIES.includes(_severity);
        },
        bg: function bg(_bg) {
            return BACKGROUNDS.includes(_bg);
        },
        title: function title(_title) {
            return typeof _title === "string" && _title.length > 0;
        }
    });
    var severity = mergedProps.severity, bg = mergedProps.bg, title = mergedProps.title, callToAction = mergedProps.callToAction, role = mergedProps.role, children = mergedProps.children, testId = mergedProps.testId;
    var theme = useTheme();
    var textAndIconColor = ["highlight.pink.t100", "primary.blue.t100"].includes(bg) ? "white" : "black";
    var switchLayoutAt = "md";
    var iconSize = 32;
    var distanceFromIcon = 8;
    var iconMarginLeft = -4;
    var textYpadding = (iconSize - 24) / 2; // 24px is the line-height of the body1 text style
    var responsiveCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$c, {
        hasBreakpointWidth: responsiveHasBreakpointWidth,
        padding: function padding(_ref, theme) {
            var hasBreakpointWidth = _ref.hasBreakpointWidth, _padding = _ref.padding;
            return {
                padding: hasBreakpointWidth ? "".concat(theme.space[4], " 0") : theme.getSpaceValue(_padding !== null && _padding !== void 0 ? _padding : 4)
            };
        }
    });
    return jsx(BackgroundProvider, {
        value: bg
    }, jsx("div", {
        css: /*#__PURE__*/ css$1({
            backgroundColor: theme.getColor(bg)
        }, process.env.NODE_ENV === "production" ? "" : ";label:Message;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        "data-testid": testId
    }, jsx("div", {
        css: /*#__PURE__*/ css$1(_objectSpread2({
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column"
        }, mergeResponsiveCSS(_defineProperty({}, theme.minMediaQueries[switchLayoutAt], {
            flexDirection: "row"
        }), responsiveCSS)), process.env.NODE_ENV === "production" ? "" : ";label:Message;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }, jsx("div", {
        css: _ref2
    }, jsx("div", {
        css: /*#__PURE__*/ css$1({
            display: "flex",
            alignItems: "flex-start",
            marginTop: -textYpadding,
            marginBottom: -textYpadding
        }, process.env.NODE_ENV === "production" ? "" : ";label:Message;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }, jsx("div", {
        css: /*#__PURE__*/ css$1({
            flexShrink: 0,
            display: "flex",
            marginLeft: iconMarginLeft
        }, process.env.NODE_ENV === "production" ? "" : ";label:Message;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }, jsx(Icon, {
        name: severity,
        color: textAndIconColor,
        size: "".concat(iconSize, "px")
    })), jsx("div", {
        css: /*#__PURE__*/ css$1(_objectSpread2({
            paddingTop: textYpadding,
            paddingBottom: textYpadding,
            paddingLeft: distanceFromIcon,
            paddingRight: 0
        }, callToAction && _defineProperty({}, theme.minMediaQueries[switchLayoutAt], {
            paddingRight: theme.space[6]
        })), process.env.NODE_ENV === "production" ? "" : ";label:Message;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }, jsx(Text, {
        color: textAndIconColor,
        role: role
    }, title && jsx("strong", {
        css: /*#__PURE__*/ css$1({
            display: "block",
            marginBottom: theme.space[1]
        }, process.env.NODE_ENV === "production" ? "" : ";label:Message;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }, title), children)))), callToAction && jsx("div", {
        css: /*#__PURE__*/ css$1(_defineProperty({
            marginLeft: iconMarginLeft + iconSize + distanceFromIcon,
            marginTop: theme.space[3]
        }, theme.minMediaQueries[switchLayoutAt], {
            marginLeft: "auto",
            marginTop: 0
        }), process.env.NODE_ENV === "production" ? "" : ";label:Message;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lc3NhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0pjIiwiZmlsZSI6Ik1lc3NhZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5pbXBvcnQgSWNvbiBmcm9tIFwiLi9JY29uXCI7XG5pbXBvcnQgVGV4dCBmcm9tIFwiLi9UZXh0XCI7XG5pbXBvcnQgdXNlVGhlbWUgZnJvbSBcIi4uL2hvb2tzL3VzZVRoZW1lXCI7XG5pbXBvcnQgeyBCYWNrZ3JvdW5kUHJvdmlkZXIgfSBmcm9tIFwiLi4vaG9va3MvdXNlQmFja2dyb3VuZFwiO1xuaW1wb3J0IHtcbiAgcmVzcG9uc2l2ZVBhZGRpbmdUeXBlLFxuICByZXNwb25zaXZlUHJvcFR5cGUsXG59IGZyb20gXCIuLi9ob29rcy91c2VSZXNwb25zaXZlUHJvcFwiO1xuaW1wb3J0IHVzZVJlc3BvbnNpdmVQcm9wc0NTUyBmcm9tIFwiLi4vaG9va3MvdXNlUmVzcG9uc2l2ZVByb3BzQ1NTXCI7XG5pbXBvcnQgeyBtZXJnZVByb3BzIH0gZnJvbSBcIi4uL3V0aWxzL2NvbXBvbmVudFwiO1xuaW1wb3J0IHsgcmVzcG9uc2l2ZUhhc0JyZWFrcG9pbnRXaWR0aCwgbWVyZ2VSZXNwb25zaXZlQ1NTIH0gZnJvbSBcIi4uL3V0aWxzL2Nzc1wiO1xuXG5jb25zdCBTRVZFUklUSUVTID0gW1xuICBcImFzc2lzdGFuY2VcIixcbiAgXCJpbmZvLW9yLW1pbm9yXCIsXG4gIFwid2FybmluZy1vci1zaWduaWZpY2FudFwiLFxuICBcImJsb2NraW5nXCIsXG4gIFwic3RvcFwiLFxuICBcImNyaXRpY2FsXCIsXG4gIFwic3VjY2Vzc1wiLFxuXTtcbmNvbnN0IEJBQ0tHUk9VTkRTID0gW1xuICBcImhpZ2hsaWdodC5waW5rLnQxMDBcIixcbiAgXCJzZWNvbmRhcnkucGluay50MzBcIixcbiAgXCJwcmltYXJ5LmJsdWUudDEwMFwiLFxuICBcInNlY29uZGFyeS5saWdodEJsdWUudDI1XCIsXG4gIFwiZ3JleS50MTBcIixcbiAgXCJncmV5LnQwNVwiLFxuICBcIndoaXRlXCIsXG4gIFwidHJhbnNwYXJlbnRcIixcbl07XG5cbmNvbnN0IERFRkFVTFRfUFJPUFMgPSB7XG4gIGJnOiBcImdyZXkudDEwXCIsXG4gIGhhc0JyZWFrcG9pbnRXaWR0aDogZmFsc2UsXG59O1xuXG5NZXNzYWdlLlNFVkVSSVRJRVMgPSBTRVZFUklUSUVTO1xuTWVzc2FnZS5CQUNLR1JPVU5EUyA9IEJBQ0tHUk9VTkRTO1xuTWVzc2FnZS5ERUZBVUxUX1BST1BTID0gREVGQVVMVF9QUk9QUztcblxuZnVuY3Rpb24gTWVzc2FnZShwcm9wcykge1xuICBjb25zdCBtZXJnZWRQcm9wcyA9IG1lcmdlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgREVGQVVMVF9QUk9QUyxcbiAgICB7fSxcbiAgICB7XG4gICAgICBzZXZlcml0eTogKHNldmVyaXR5KSA9PiBTRVZFUklUSUVTLmluY2x1ZGVzKHNldmVyaXR5KSxcbiAgICAgIGJnOiAoYmcpID0+IEJBQ0tHUk9VTkRTLmluY2x1ZGVzKGJnKSxcbiAgICAgIHRpdGxlOiAodGl0bGUpID0+IHR5cGVvZiB0aXRsZSA9PT0gXCJzdHJpbmdcIiAmJiB0aXRsZS5sZW5ndGggPiAwLFxuICAgIH1cbiAgKTtcbiAgY29uc3Qge1xuICAgIHNldmVyaXR5LFxuICAgIGJnLFxuICAgIHRpdGxlLFxuICAgIGNhbGxUb0FjdGlvbixcbiAgICByb2xlLFxuICAgIGNoaWxkcmVuLFxuICAgIHRlc3RJZCxcbiAgfSA9IG1lcmdlZFByb3BzO1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IHRleHRBbmRJY29uQ29sb3IgPSBbXG4gICAgXCJoaWdobGlnaHQucGluay50MTAwXCIsXG4gICAgXCJwcmltYXJ5LmJsdWUudDEwMFwiLFxuICBdLmluY2x1ZGVzKGJnKVxuICAgID8gXCJ3aGl0ZVwiXG4gICAgOiBcImJsYWNrXCI7XG4gIGNvbnN0IHN3aXRjaExheW91dEF0ID0gXCJtZFwiO1xuICBjb25zdCBpY29uU2l6ZSA9IDMyO1xuICBjb25zdCBkaXN0YW5jZUZyb21JY29uID0gODtcbiAgY29uc3QgaWNvbk1hcmdpbkxlZnQgPSAtNDtcbiAgY29uc3QgdGV4dFlwYWRkaW5nID0gKGljb25TaXplIC0gMjQpIC8gMjsgLy8gMjRweCBpcyB0aGUgbGluZS1oZWlnaHQgb2YgdGhlIGJvZHkxIHRleHQgc3R5bGVcbiAgY29uc3QgcmVzcG9uc2l2ZUNTUyA9IHVzZVJlc3BvbnNpdmVQcm9wc0NTUyhwcm9wcywgREVGQVVMVF9QUk9QUywge1xuICAgIGhhc0JyZWFrcG9pbnRXaWR0aDogcmVzcG9uc2l2ZUhhc0JyZWFrcG9pbnRXaWR0aCxcbiAgICBwYWRkaW5nOiAoeyBoYXNCcmVha3BvaW50V2lkdGgsIHBhZGRpbmcgfSwgdGhlbWUpID0+IHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGhhc0JyZWFrcG9pbnRXaWR0aFxuICAgICAgICAgID8gYCR7dGhlbWUuc3BhY2VbNF19IDBgXG4gICAgICAgICAgOiB0aGVtZS5nZXRTcGFjZVZhbHVlKHBhZGRpbmcgPz8gNCksXG4gICAgICB9O1xuICAgIH0sXG4gIH0pO1xuXG4gIHJldHVybiAoXG4gICAgPEJhY2tncm91bmRQcm92aWRlciB2YWx1ZT17Ymd9PlxuICAgICAgPGRpdlxuICAgICAgICBjc3M9e3tcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmdldENvbG9yKGJnKSxcbiAgICAgICAgfX1cbiAgICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICAgID5cbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17e1xuICAgICAgICAgICAgYm94U2l6aW5nOiBcImJvcmRlci1ib3hcIixcbiAgICAgICAgICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgICAgICAgICAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgICAgICAgICAgIC4uLm1lcmdlUmVzcG9uc2l2ZUNTUyhcbiAgICAgICAgICAgICAge1xuICAgICAgICAgICAgICAgIFt0aGVtZS5taW5NZWRpYVF1ZXJpZXNbc3dpdGNoTGF5b3V0QXRdXToge1xuICAgICAgICAgICAgICAgICAgZmxleERpcmVjdGlvbjogXCJyb3dcIixcbiAgICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgICByZXNwb25zaXZlQ1NTXG4gICAgICAgICAgICApLFxuICAgICAgICAgIH19XG4gICAgICAgID5cbiAgICAgICAgICA8ZGl2IGNzcz17eyBmbGV4R3JvdzogMSwgZGlzcGxheTogXCJmbGV4XCIsIGFsaWduSXRlbXM6IFwiY2VudGVyXCIgfX0+XG4gICAgICAgICAgICA8ZGl2XG4gICAgICAgICAgICAgIGNzcz17e1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgICAgICAgICAgICAgIGFsaWduSXRlbXM6IFwiZmxleC1zdGFydFwiLFxuICAgICAgICAgICAgICAgIG1hcmdpblRvcDogLXRleHRZcGFkZGluZyxcbiAgICAgICAgICAgICAgICBtYXJnaW5Cb3R0b206IC10ZXh0WXBhZGRpbmcsXG4gICAgICAgICAgICAgIH19XG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIDxkaXZcbiAgICAgICAgICAgICAgICBjc3M9e3tcbiAgICAgICAgICAgICAgICAgIGZsZXhTaHJpbms6IDAsXG4gICAgICAgICAgICAgICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgICAgICAgICAgICAgIG1hcmdpbkxlZnQ6IGljb25NYXJnaW5MZWZ0LFxuICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICA8SWNvblxuICAgICAgICAgICAgICAgICAgbmFtZT17c2V2ZXJpdHl9XG4gICAgICAgICAgICAgICAgICBjb2xvcj17dGV4dEFuZEljb25Db2xvcn1cbiAgICAgICAgICAgICAgICAgIHNpemU9e2Ake2ljb25TaXplfXB4YH1cbiAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgPGRpdlxuICAgICAgICAgICAgICAgIGNzcz17e1xuICAgICAgICAgICAgICAgICAgcGFkZGluZ1RvcDogdGV4dFlwYWRkaW5nLFxuICAgICAgICAgICAgICAgICAgcGFkZGluZ0JvdHRvbTogdGV4dFlwYWRkaW5nLFxuICAgICAgICAgICAgICAgICAgcGFkZGluZ0xlZnQ6IGRpc3RhbmNlRnJvbUljb24sXG4gICAgICAgICAgICAgICAgICBwYWRkaW5nUmlnaHQ6IDAsXG4gICAgICAgICAgICAgICAgICAuLi4oY2FsbFRvQWN0aW9uICYmIHtcbiAgICAgICAgICAgICAgICAgICAgW3RoZW1lLm1pbk1lZGlhUXVlcmllc1tzd2l0Y2hMYXlvdXRBdF1dOiB7XG4gICAgICAgICAgICAgICAgICAgICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjZVs2XSxcbiAgICAgICAgICAgICAgICAgICAgfSxcbiAgICAgICAgICAgICAgICAgIH0pLFxuICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICA8VGV4dCBjb2xvcj17dGV4dEFuZEljb25Db2xvcn0gcm9sZT17cm9sZX0+XG4gICAgICAgICAgICAgICAgICB7dGl0bGUgJiYgKFxuICAgICAgICAgICAgICAgICAgICA8c3Ryb25nXG4gICAgICAgICAgICAgICAgICAgICAgY3NzPXt7IGRpc3BsYXk6IFwiYmxvY2tcIiwgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjZVsxXSB9fVxuICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAge3RpdGxlfVxuICAgICAgICAgICAgICAgICAgICA8L3N0cm9uZz5cbiAgICAgICAgICAgICAgICAgICl9XG4gICAgICAgICAgICAgICAgICB7Y2hpbGRyZW59XG4gICAgICAgICAgICAgICAgPC9UZXh0PlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIHtjYWxsVG9BY3Rpb24gJiYgKFxuICAgICAgICAgICAgPGRpdlxuICAgICAgICAgICAgICBjc3M9e3tcbiAgICAgICAgICAgICAgICBtYXJnaW5MZWZ0OiBpY29uTWFyZ2luTGVmdCArIGljb25TaXplICsgZGlzdGFuY2VGcm9tSWNvbixcbiAgICAgICAgICAgICAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNlWzNdLFxuICAgICAgICAgICAgICAgIFt0aGVtZS5taW5NZWRpYVF1ZXJpZXNbc3dpdGNoTGF5b3V0QXRdXToge1xuICAgICAgICAgICAgICAgICAgbWFyZ2luTGVmdDogXCJhdXRvXCIsXG4gICAgICAgICAgICAgICAgICBtYXJnaW5Ub3A6IDAsXG4gICAgICAgICAgICAgICAgfSxcbiAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAge2NhbGxUb0FjdGlvbn1cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICl9XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9kaXY+XG4gICAgPC9CYWNrZ3JvdW5kUHJvdmlkZXI+XG4gICk7XG59XG5cbk1lc3NhZ2UucHJvcFR5cGVzID0ge1xuICBzZXZlcml0eTogUHJvcFR5cGVzLm9uZU9mKFNFVkVSSVRJRVMpLmlzUmVxdWlyZWQsXG4gIGJnOiBQcm9wVHlwZXMub25lT2YoQkFDS0dST1VORFMpLFxuICB0aXRsZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgLi4ucmVzcG9uc2l2ZVByb3BUeXBlKFwiaGFzQnJlYWtwb2ludFdpZHRoXCIsIFByb3BUeXBlcy5ib29sKSxcbiAgLi4ucmVzcG9uc2l2ZVBhZGRpbmdUeXBlLFxuICByb2xlOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTWVzc2FnZTtcbiJdfQ== */")
    }, callToAction))));
}
Message.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({
    severity: PropTypes.oneOf(SEVERITIES).isRequired,
    bg: PropTypes.oneOf(BACKGROUNDS),
    title: PropTypes.string
}, responsivePropType("hasBreakpointWidth", PropTypes.bool)), responsivePaddingType), {}, {
    role: PropTypes.string,
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
});

var tabbable_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];
});

var handleBlur_1 = handleBlur;
var handleFocus_1 = handleFocus;
var markForFocusLater_1 = markForFocusLater;
var returnFocus_1 = returnFocus;
var popWithoutFocus_1 = popWithoutFocus;
var setupScopedFocus_1 = setupScopedFocus;
var teardownScopedFocus_1 = teardownScopedFocus;



var _tabbable2 = _interopRequireDefault$2(tabbable_1);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

var focusManager = /*#__PURE__*/Object.defineProperty({
	handleBlur: handleBlur_1,
	handleFocus: handleFocus_1,
	markForFocusLater: markForFocusLater_1,
	returnFocus: returnFocus_1,
	popWithoutFocus: popWithoutFocus_1,
	setupScopedFocus: setupScopedFocus_1,
	teardownScopedFocus: teardownScopedFocus_1
}, '__esModule', {value: true});

var scopeTab_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];
});

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

var exenv = createCommonjsModule(function (module) {
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
});

var safeHTMLElement = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;



var _exenv2 = _interopRequireDefault(exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;
});

var assertNodeList_1 = assertNodeList;
var setElement_1 = setElement;
var validateElement_1 = validateElement;
var hide_1 = hide;
var show_1 = show;
var documentNotReadyOrSSRTesting_1 = documentNotReadyOrSSRTesting;
var resetForTesting_1 = resetForTesting;



var _warning2 = _interopRequireDefault$1(warning_1);



function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

var ariaAppHider = /*#__PURE__*/Object.defineProperty({
	assertNodeList: assertNodeList_1,
	setElement: setElement_1,
	validateElement: validateElement_1,
	hide: hide_1,
	show: show_1,
	documentNotReadyOrSSRTesting: documentNotReadyOrSSRTesting_1,
	resetForTesting: resetForTesting_1
}, '__esModule', {value: true});

var classList = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
});

var portalOpenInstances_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];
});

var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

var ModalPortal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();





var _propTypes2 = _interopRequireDefault(PropTypes);



var focusManager$1 = _interopRequireWildcard(focusManager);



var _scopeTab2 = _interopRequireDefault(scopeTab_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var classList$1 = _interopRequireWildcard(classList);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList$1.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider$1.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus(_this.props.preventScroll);
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== "production") {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList$1.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider$1.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(React__default.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

var _reactLifecyclesCompat = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

var Modal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _reactDom2 = _interopRequireDefault(_reactDom);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _ModalPortal2 = _interopRequireDefault(ModalPortal_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider$1.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(React__default.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;
});

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _Modal2 = _interopRequireDefault(Modal_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
});

var ReactModal = /*@__PURE__*/getDefaultExportFromCjs(lib);

function Footer(_a) {
    var children = _a.children;
    var theme = useTheme();
    return jsx$1("footer", __assign({ css: { marginTop: theme.space[8] } }, { children: children }), void 0);
}
var defaultProps = {
    open: false,
    width: "600",
};
function Modal(props) {
    var title = props.title, _a = props.open, open = _a === void 0 ? false : _a, onClose = props.onClose, children = props.children, testId = props.testId;
    var windowFromContext = useWindow();
    var theme = useTheme();
    var headerId = useState(function () { return "modal-header-" + nanoid(); })[0];
    var _b = useState(), appElement = _b[0], setAppElement = _b[1];
    var closeModal = function () {
        onClose && onClose();
    };
    var responsiveCSS = useResponsivePropsCSS(props, defaultProps, {
        width: responsiveSize("width"),
    });
    var responsiveContentCSS = __assign(__assign({}, responsiveCSS), { position: "absolute", left: 0, right: 0, top: 0, bottom: 0, height: "fit-content", border: 0, boxSizing: "border-box", margin: "auto", padding: theme.space[4] + " " + theme.space[7] + " " + theme.space[6] + " " + theme.space[7], maxWidth: "calc(100% - " + theme.space[8] + ")", backgroundColor: theme.colors.white, borderRadius: theme.radii[1], boxShadow: "\n      rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,\n      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px\n    ", ":focus": {
            outline: 0,
        } });
    var modalStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
    };
    useEffect(function () {
        var element = windowFromContext.document.querySelector("[data-basis-modal-app]");
        if (element) {
            setAppElement(element);
        }
        else {
            throw new Error("Modal: could not find an element with the `data-basis-modal-app` attribute.");
        }
    }, [windowFromContext]);
    /*
      Without this, if open={true} by default, react-modal doesn't set
      aria-hidden="true" on the appElement.
    */
    if (!appElement) {
        return null;
    }
    return (jsxs(ReactModal, __assign({ css: responsiveContentCSS, style: modalStyles, isOpen: open, onRequestClose: closeModal, appElement: appElement, parentSelector: function () { return windowFromContext.document.body; }, contentElement: function (props, children) { return jsx$1("section", __assign({}, props, { children: children }), void 0); }, aria: {
            labelledby: headerId,
        }, testId: testId }, { children: [jsxs("div", __assign({ css: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: theme.space[4],
                } }, { children: [jsx$1("header", __assign({ id: headerId, css: __assign(__assign({}, theme.textStyles.heading4), { color: theme.colors.primary.blue.t100 }) }, { children: title }), void 0),
                    jsx$1("div", __assign({ css: { marginRight: "-" + theme.space[4] } }, { children: jsxs(Button, __assign({ variant: "icon", onClick: closeModal }, { children: [jsx$1(Icon, { name: "cross" }, void 0),
                                jsx$1(VisuallyHidden, { children: "Close modal" }, void 0)] }), void 0) }), void 0)] }), void 0),
            children] }), void 0));
}
Modal.defaultProps = defaultProps;
Modal.Footer = Footer;

var DEFAULT_PROPS$b = {
    height: "72px",
    label: "Placeholder"
};
function Placeholder(props) {
    var theme = useTheme();
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$b, {}, {
        label: function label(_label) {
            return typeof _label === "string" && _label.trim().length > 0;
        }
    });
    var label = mergedProps.label, testId = mergedProps.testId;
    var responsivePropsCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$b, {
        width: responsiveSize("width"),
        height: responsiveSize("height")
    });
    return jsx("div", {
        css: /*#__PURE__*/ css$1(_objectSpread2(_objectSpread2({}, responsivePropsCSS), {}, {
            backgroundColor: theme.getColor("grey.t07"),
            border: "".concat(theme.borderWidths[1], " solid ").concat(theme.getColor("grey.t30")),
            boxSizing: "border-box"
        }), process.env.NODE_ENV === "production" ? "" : ";label:Placeholder;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        "data-testid": testId
    }, jsx(Flex, {
        height: "100%",
        placeItems: "center"
    }, jsx(Text, null, label)));
}
Placeholder.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, responsiveWidthType), responsiveHeightType), {}, {
    label: PropTypes.string,
    testId: PropTypes.string
});

var defaultRadioGroupProps = {
    disabled: false,
    optional: false,
};

var COLORS$6 = InternalRadioGroup.COLORS;
var DEFAULT_PROPS$a = __assign(__assign({}, defaultRadioGroupProps), { color: InternalRadioGroup.DEFAULT_PROPS.color, 
    // @ts-ignore
    validate: function (value, _a) {
        var isEmpty = _a.isEmpty;
        if (isEmpty(value)) {
            return "Please make a selection.";
        }
        return null;
    } });
RadioGroup$2.COLORS = COLORS$6;
RadioGroup$2.DEFAULT_PROPS = DEFAULT_PROPS$a;
function RadioGroup$2(props) {
    var mergedProps = useMergedProps(props, defaultRadioGroupProps);
    var name = mergedProps.name, value = mergedProps.value, label = mergedProps.label, options = mergedProps.options, columns = mergedProps.columns, helpText = mergedProps.helpText, innerRef = mergedProps.innerRef, disabled = mergedProps.disabled, optional = mergedProps.optional, _a = mergedProps.color, color = _a === void 0 ? DEFAULT_PROPS$a.color : _a, error = mergedProps.error, onChange = mergedProps.onChange, onFocus = mergedProps.onFocus, onBlur = mergedProps.onBlur, onMouseDown = mergedProps.onMouseDown, testId = mergedProps.testId;
    if (!options) {
        throw new Error("RadioGroup options are invalid");
    }
    var labelId = useMemo(function () { return "radio-group-label-" + nanoid(); }, []);
    var auxId = useMemo(function () { return "radio-group-aux-" + nanoid(); }, []);
    var radioName = useMemo(function () { return name || "radio-group-name-" + nanoid(); }, [
        name,
    ]);
    var fieldErrors = Array.isArray(error) || error === undefined ? error : [error];
    var hasErrors = Array.isArray(error) ? error.length !== 0 : !!error;
    // @ts-ignore
    var cols = options.some(function (option) { return option.description; })
        ? 1
        : columns === undefined
            ? options.length
            : columns;
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, labelId: labelId, auxId: auxId, helpText: helpText, errors: fieldErrors }, { children: jsx$1(InternalRadioGroup, { testId: testId, name: radioName, labelId: labelId, innerRef: innerRef, options: options, columns: cols, color: color, disabled: disabled, isValid: !hasErrors, describedBy: helpText || hasErrors ? auxId : undefined, onFocus: onFocus, onBlur: onBlur, onMouseDown: onMouseDown, value: value, onChange: onChange }, void 0) }), void 0));
}

var COLORS$5 = InternalRadioGroup.COLORS;
function isOptionSelected$1(options, value) {
    return (options.findIndex(function (option) { return option.value === value; }) > -1);
}
var DEFAULT_PROPS$9 = __assign(__assign({}, defaultRadioGroupProps), { color: InternalRadioGroup.DEFAULT_PROPS.color, 
    // @ts-ignore
    validate: function (value, _a) {
        var isEmpty = _a.isEmpty;
        if (isEmpty(value)) {
            return "Please make a selection.";
        }
        return null;
    } });
RadioGroup$1.COLORS = COLORS$5;
RadioGroup$1.DEFAULT_PROPS = DEFAULT_PROPS$9;
function RadioGroup$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$9, {}, {
        // @ts-ignore
        color: function (color) { return COLORS$5.includes(color); },
        // @ts-ignore
        disabled: function (disabled) { return typeof disabled === "boolean"; },
        // @ts-ignore
        optional: function (optional) { return typeof optional === "boolean"; },
        // @ts-ignore
        options: function (options) { return areOptionsValid(options); },
    });
    var name = mergedProps.name, label = mergedProps.label, options = mergedProps.options, columns = mergedProps.columns, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, onChangeProp = mergedProps.onChange, testId = mergedProps.testId;
    if (!options) {
        throw new Error("RadioGroup options are invalid");
    }
    var labelId = useState(function () { return "radio-group-label-" + nanoid(); })[0];
    var auxId = useState(function () { return "radio-group-aux-" + nanoid(); })[0];
    // @ts-ignore
    var cols = options.some(function (option) { return option.description; })
        ? 1
        : columns === undefined
            ? options.length
            : columns;
    var isEmpty = useCallback(function (value) { return isOptionSelected$1(options, value) === false; }, [options]);
    var data = useMemo(function () { return (__assign({ isEmpty: isEmpty }, (validateData && { data: validateData }))); }, [isEmpty, validateData]);
    var _a = useField("RadioGroup", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data,
    }), value = _a.value, errors = _a.errors, hasErrors = _a.hasErrors, onFocus = _a.onFocus, onBlur = _a.onBlur, fieldOnChange = _a.onChange, onMouseDown = _a.onMouseDown;
    var onChange = useCallback(function (event) {
        fieldOnChange(event);
        var selectedValue = event.target.value;
        var selectedOption = options.find(
        // @ts-ignore
        function (option) { return option.value === selectedValue; });
        onChangeProp && onChangeProp({ selectedOption: selectedOption });
    }, [fieldOnChange, onChangeProp, options]);
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, labelId: labelId, auxId: auxId, helpText: helpText, errors: errors, testId: testId }, { children: jsx$1(InternalRadioGroup, { name: name, labelId: labelId, options: options, columns: cols, color: props.color, disabled: disabled, isValid: !hasErrors, describedBy: helpText || hasErrors ? auxId : undefined, onFocus: onFocus, onBlur: onBlur, onMouseDown: onMouseDown, value: value, onChange: onChange }, void 0) }), void 0));
}

var setDeprecatedProps$2 = function (props, isDeprecated) {
    return isDeprecated;
};

var COLORS$4 = RadioGroup$1.COLORS, DEFAULT_PROPS$8 = RadioGroup$1.DEFAULT_PROPS;
var RadioGroupComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps$2(props, isDeprecatedForm)) {
        return jsx$1(RadioGroup$1, __assign({}, props), void 0);
    }
    return jsx$1(RadioGroup$2, __assign({}, props, { innerRef: ref }), void 0);
};
var RadioGroup = forwardRef(RadioGroupComponent);
RadioGroup.defaultProps = defaultRadioGroupProps;
RadioGroup.displayName = ComponentNames.RadioGroup;
RadioGroup.COLORS = COLORS$4;
RadioGroup.DEFAULT_PROPS = DEFAULT_PROPS$8;

function Select$2(props) {
    var mergedProps = useMergedProps(props, defaultSelectProps);
    var value = mergedProps.value, innerRef = mergedProps.innerRef, label = mergedProps.label, placeholder = mergedProps.placeholder, options = mergedProps.options, fullWidth = mergedProps.fullWidth, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, onChange = mergedProps.onChange, onFocus = mergedProps.onFocus, onBlur = mergedProps.onBlur, error = mergedProps.error, testId = mergedProps.testId, color = mergedProps.color, __internal__focus = mergedProps.__internal__focus;
    if (!options) {
        throw new Error("Select options should have the following format: [{ label: \"option-label\", value: \"option-value\" }, ...]");
    }
    var selectId = useState(function () { return "select-" + nanoid(); })[0];
    var auxId = useState(function () { return "select-aux-" + nanoid(); })[0];
    var fieldErrors = Array.isArray(error) || error === undefined ? error : [error];
    var hasErrors = Array.isArray(error) ? error.length !== 0 : !!error;
    return (jsx$1(Field$1, __assign({ fullWidth: fullWidth, optional: optional, disabled: disabled, label: label, labelFor: selectId, auxId: auxId, helpText: helpText, errors: fieldErrors }, { children: jsx$1(InternalSelect, { testId: testId, innerRef: innerRef, id: selectId, color: color, placeholder: placeholder, options: options, fullWidth: fullWidth, optional: optional, disabled: disabled, isValid: !hasErrors, describedBy: helpText || hasErrors ? auxId : undefined, onFocus: onFocus, onBlur: onBlur, value: value, onChange: onChange, __internal__focus: __internal__focus }, void 0) }), void 0));
}

var COLORS$3 = InternalSelect.COLORS;
// @ts-ignore
function isOptionSelected(options, value) {
    // @ts-ignore
    return options.findIndex(function (option) { return option.value === value; }) > -1;
}
var DEFAULT_PROPS$7 = __assign(__assign({}, defaultSelectProps), { color: InternalSelect.DEFAULT_PROPS.color, 
    // @ts-ignore
    validate: function (value, _a) {
        var isEmpty = _a.isEmpty;
        if (isEmpty(value)) {
            return "Please make a selection.";
        }
        return null;
    } });
Select$1.COLORS = COLORS$3;
Select$1.DEFAULT_PROPS = DEFAULT_PROPS$7;
function Select$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$7, {}, {
        // @ts-ignore
        color: function (color) { return COLORS$3.includes(color); },
        // @ts-ignore
        placeholder: function (placeholder) { return typeof placeholder === "string"; },
        // @ts-ignore
        fullWidth: function (fullWidth) { return typeof fullWidth === "boolean"; },
        // @ts-ignore
        helpText: function (helpText) { return typeof helpText === "string"; },
        // @ts-ignore
        disabled: function (disabled) { return typeof disabled === "boolean"; },
        // @ts-ignore
        optional: function (optional) { return typeof optional === "boolean"; },
        // @ts-ignore
        options: function (options) { return areOptionsValid(options); },
        // @ts-ignore
        onChange: function (onChange) { return typeof onChange === "function"; },
    });
    var name = mergedProps.name, label = mergedProps.label, placeholder = mergedProps.placeholder, options = mergedProps.options, fullWidth = mergedProps.fullWidth, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, propsOnChange = mergedProps.onChange, testId = mergedProps.testId, __internal__focus = mergedProps.__internal__focus;
    if (!options) {
        throw new Error("Select options should have the following format: [{ label: \"option-label\", value: \"option-value\" }, ...]");
    }
    var selectId = useState(function () { return "select-" + nanoid(); })[0];
    var auxId = useState(function () { return "select-aux-" + nanoid(); })[0];
    var isEmpty = useCallback(function (value) { return isOptionSelected(options, value) === false; }, [options]);
    var data = useMemo(function () { return (__assign({ isEmpty: isEmpty }, (validateData && { data: validateData }))); }, [isEmpty, validateData]);
    var _a = useField("Select", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data,
    }), value = _a.value, errors = _a.errors, hasErrors = _a.hasErrors, onFocus = _a.onFocus, onBlur = _a.onBlur, fieldOnChange = _a.onChange;
    // @ts-ignore
    var onChange = function (event) {
        fieldOnChange(event);
        var selectedValue = event.target.value;
        // @ts-ignore
        var selectedOption = options.find(function (_a) {
            var value = _a.value;
            return value === selectedValue;
        });
        propsOnChange && propsOnChange({ selectedOption: selectedOption });
    };
    return (jsx$1(Field$1, __assign({ fullWidth: fullWidth, optional: optional, disabled: disabled, label: label, labelFor: selectId, auxId: auxId, helpText: helpText, errors: errors, testId: testId }, { children: jsx$1(InternalSelect, { id: selectId, name: name, color: props.color, placeholder: placeholder, options: options, fullWidth: fullWidth, optional: optional, disabled: disabled, isValid: !hasErrors, describedBy: helpText || hasErrors ? auxId : undefined, onFocus: onFocus, onBlur: onBlur, value: value, onChange: onChange, __internal__focus: __internal__focus }, void 0) }), void 0));
}

var setDeprecatedProps$1 = function (props, isDeprecated) {
    return isDeprecated;
};

var DEFAULT_PROPS$6 = __assign(__assign({}, defaultSelectProps), { disabled: false, optional: false });
var SelectComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps$1(props, isDeprecatedForm)) {
        return jsx$1(Select$1, __assign({}, props), void 0);
    }
    return jsx$1(Select$2, __assign({}, props, { innerRef: ref }), void 0);
};
var Select = forwardRef(SelectComponent);
Select.defaultProps = defaultSelectProps;
Select.displayName = ComponentNames.Select;
Select.COLORS = Select$1.COLORS;
Select.DEFAULT_PROPS = DEFAULT_PROPS$6;

var sizesMap = {
    tiny: {
        offset: 20,
        borderWidth: 20,
        minSize: 60
    },
    small: {
        offset: 40,
        borderWidth: 24,
        minSize: 104
    },
    medium: {
        offset: 48,
        borderWidth: 32,
        minSize: 128
    },
    large: {
        offset: 60,
        borderWidth: 40,
        minSize: 160
    }
};
var colorsMap = {
    low: {
        grey: {
            contentBackgroundColor: "grey.t03",
            shadowBorderColor: "grey.t07"
        },
        blue: {
            contentBackgroundColor: "secondary.lightBlue.t25",
            shadowBorderColor: "secondary.lightBlue.t15"
        },
        pink: {
            contentBackgroundColor: "secondary.pink.t30",
            shadowBorderColor: "secondary.pink.t15"
        },
        purple: {
            contentBackgroundColor: "secondary.purple.t30",
            shadowBorderColor: "secondary.purple.t15"
        }
    },
    medium: {
        grey: {
            contentBackgroundColor: "white",
            shadowBorderColor: "grey.t07"
        },
        blue: {
            contentBackgroundColor: "secondary.lightBlue.t25",
            shadowBorderColor: "secondary.lightBlue.t60"
        },
        pink: {
            contentBackgroundColor: "secondary.pink.t30",
            shadowBorderColor: "secondary.pink.t60"
        },
        purple: {
            contentBackgroundColor: "secondary.purple.t30",
            shadowBorderColor: "secondary.purple.t60"
        }
    },
    high: {
        grey: {
            contentBackgroundColor: "white",
            shadowBorderColor: "grey.t16"
        },
        blue: {
            contentBackgroundColor: "secondary.lightBlue.t60",
            shadowBorderColor: "secondary.lightBlue.t100"
        },
        pink: {
            contentBackgroundColor: "secondary.pink.t60",
            shadowBorderColor: "secondary.pink.t100"
        },
        purple: {
            contentBackgroundColor: "secondary.purple.t60",
            shadowBorderColor: "secondary.purple.t100"
        }
    }
};
function getColors(backgroundVariant, shadowColor) {
    var _colorsMap$background = colorsMap[backgroundVariant][shadowColor], contentBackgroundColor = _colorsMap$background.contentBackgroundColor, shadowBorderColor = _colorsMap$background.shadowBorderColor;
    return {
        contentBackgroundColor: contentBackgroundColor,
        shadowBorderColor: shadowBorderColor
    };
}
var SHADOW_SIZES = ["none", "tiny", "small", "medium", "large"];
var SHADOW_DIRECTIONS = ["left", "right"];
var SHADOW_COLORS = ["grey", "blue", "pink", "purple"];
var SHADOW_CONTRASTS = ["low", "medium", "high"];
var DEFAULT_PROPS$5 = {
    shadowSize: "large",
    shadowDirection: "right",
    shadowColor: "grey",
    shadowContrast: "high"
};
ShadowContainer.SHADOW_SIZES = SHADOW_SIZES;
ShadowContainer.SHADOW_DIRECTIONS = SHADOW_DIRECTIONS;
ShadowContainer.SHADOW_COLORS = SHADOW_COLORS;
ShadowContainer.SHADOW_CONTRASTS = SHADOW_CONTRASTS;
ShadowContainer.DEFAULT_PROPS = DEFAULT_PROPS$5;
function ShadowContainer(props) {
    var theme = useTheme();
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$5, {}, {
        shadowSize: function shadowSize(_shadowSize) {
            return SHADOW_SIZES.includes(_shadowSize);
        },
        shadowDirection: function shadowDirection(_shadowDirection) {
            return SHADOW_DIRECTIONS.includes(_shadowDirection);
        },
        shadowColor: function shadowColor(_shadowColor) {
            return SHADOW_COLORS.includes(_shadowColor);
        },
        shadowContrast: function shadowContrast(_shadowContrast) {
            return SHADOW_CONTRASTS.includes(_shadowContrast);
        }
    });
    var shadowDirection = mergedProps.shadowDirection, shadowColor = mergedProps.shadowColor, shadowContrast = mergedProps.shadowContrast, children = mergedProps.children, testId = mergedProps.testId;
    var _getColors = getColors(shadowContrast, shadowColor), contentBackgroundColor = _getColors.contentBackgroundColor, shadowBorderColor = _getColors.shadowBorderColor;
    var contentHasBorder = shadowColor === "grey";
    var contentBorderWidth = contentHasBorder ? parseInt(theme.borderWidths[0], 10) : 0;
    var contentBorderColor = theme.colors.grey.t10;
    var shadowSizePx = "calc(100% + ".concat(2 * contentBorderWidth, "px)");
    var contentResponsiveCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$5, {
        margin: responsiveMargin,
        padding: responsivePadding,
        shadowSize: function shadowSize(_ref) {
            var _shadowSize2 = _ref.shadowSize;
            if (_shadowSize2 === "none") {
                return {};
            }
            var contentMinSize = sizesMap[_shadowSize2].minSize;
            return {
                minWidth: contentMinSize,
                minHeight: contentMinSize
            };
        }
    });
    var contentBeforeResponsiveCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$5, {
        shadowSize: function shadowSize(_ref2) {
            var _shadowSize3 = _ref2.shadowSize;
            var display = _shadowSize3 === "none" ? "none" : "block";
            if (_shadowSize3 === "none") {
                return {
                    display: display
                };
            }
            var shadowOffset = sizesMap[_shadowSize3].offset;
            var shadowBorderWidth = sizesMap[_shadowSize3].borderWidth;
            return {
                display: display,
                top: shadowOffset - contentBorderWidth,
                left: (shadowDirection === "left" ? -shadowOffset : shadowOffset) - contentBorderWidth,
                border: "".concat(shadowBorderWidth, "px solid ").concat(theme.getColor(shadowBorderColor))
            };
        }
    });
    return jsx(BackgroundProvider, {
        value: contentBackgroundColor
    }, jsx("div", {
        css: /*#__PURE__*/ css$1(_objectSpread2(_objectSpread2(_objectSpread2({
            /*
              We set { display: "flex", flexDirection: "column" } in order to allow `children`
              to be full height.
              See: https://stackoverflow.com/q/8468066/247243
            */
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box"
        }, contentResponsiveCSS), {}, {
            backgroundColor: theme.getColor(contentBackgroundColor)
        }, contentHasBorder && {
            border: "".concat(contentBorderWidth, "px solid ").concat(contentBorderColor)
        }), {}, {
            position: "relative",
            transformStyle: "preserve-3d",
            // See: https://stackoverflow.com/a/51432213/247243
            "::before": _objectSpread2({
                transform: "translateZ(-1px)",
                // See: https://stackoverflow.com/a/51432213/247243
                boxSizing: "border-box",
                content: '""',
                position: "absolute",
                width: shadowSizePx,
                height: shadowSizePx
            }, contentBeforeResponsiveCSS)
        }), process.env.NODE_ENV === "production" ? "" : ";label:ShadowContainer;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        "data-testid": testId
    }, children));
}
ShadowContainer.propTypes = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, responsiveMarginType), responsivePaddingType), responsivePropType("shadowSize", PropTypes.oneOf(SHADOW_SIZES))), {}, {
    shadowDirection: PropTypes.oneOf(SHADOW_DIRECTIONS),
    shadowColor: PropTypes.oneOf(SHADOW_COLORS),
    shadowContrast: PropTypes.oneOf(SHADOW_CONTRASTS),
    children: PropTypes.node,
    testId: PropTypes.string
});

var DEFAULT_ITEM_PROPS = {
    minor: false,
    current: false
};
Item$1.DEFAULT_PROPS = DEFAULT_ITEM_PROPS;
function Item$1(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_ITEM_PROPS), _props);
    var minor = props.minor, current = props.current, index = props.index, total = props.total, isPrevious = props.isPrevious, majorStepNumber = props.majorStepNumber;
    var theme = useTheme();
    var label = useResponsiveProp(props, "label");
    var isFirst = index === 0;
    var isLast = index === total - 1;
    return jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "item",
            stepsCount: total
        })
    }, jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "labelContainer"
        })
    }, jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "label"
        })
    }, label && jsx(Text, {
        textStyle: "body2",
        color: current ? "primary.blue.t100" : "black",
        align: "center"
    }, jsx("strong", null, label)))), jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "itemContent"
        })
    }, !isFirst && jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "progressLeft",
            isPrevious: isPrevious,
            isCurrent: current
        })
    }), !isLast && jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "progressRight",
            isPrevious: isPrevious
        })
    }), jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "circle",
            isMinor: minor,
            isCurrent: current,
            isPrevious: isPrevious
        })
    }, isPrevious && !minor && jsx(Icon, {
        name: "tick",
        color: "white"
    }), !isPrevious && !minor && jsx(Text, {
        textStyle: "subtitle2",
        color: isPrevious ? "white" : "black"
    }, jsx("strong", null, majorStepNumber)))));
}
Item$1.propTypes = _objectSpread2(_objectSpread2({}, responsivePropType("label", PropTypes.node)), {}, {
    minor: PropTypes.bool,
    current: PropTypes.bool,
    index: PropTypes.number,
    total: PropTypes.number,
    isPrevious: PropTypes.bool,
    majorStepNumber: PropTypes.number
});
var DEFAULT_PROPS$4 = {
    completed: false
};
Stepper.DEFAULT_PROPS = DEFAULT_PROPS$4;
Stepper.ID = "Stepper";
Stepper.HEIGHT_MAP = {
    "default": 100
};
function Stepper(_props) {
    var props = _objectSpread2(_objectSpread2({}, DEFAULT_PROPS$4), _props);
    var completed = props.completed, children = props.children, testId = props.testId;
    var theme = useTheme();
    var steps = React__default.Children.toArray(children).filter(// Ignore all children that aren't Step.Item
    function (child) {
        return child.type === Item$1;
    });
    var currentStepIndex = steps.findIndex(function (step) {
        return step.props.current === true;
    });
    return jsx(Container, {
        bg: "grey.t07",
        testId: testId
    }, jsx(Container, {
        hasBreakpointWidth: true
    }, jsx("div", {
        css: theme.stepper.getCSS({
            targetElement: "container"
        })
    }, steps.reduce(function (acc, step, index) {
        var minor = step.props.minor === true;
        acc.items.push(/*#__PURE__*/ React__default.cloneElement(step, {
            index: index,
            total: steps.length,
            isPrevious: completed || index < currentStepIndex,
            majorStepNumber: minor ? null : acc.majorStepNumber
        }));
        if (!minor) {
            acc.majorStepNumber += 1;
        }
        return acc;
    }, {
        items: [],
        majorStepNumber: 1
    }).items)));
}
Stepper.propTypes = {
    completed: PropTypes.bool,
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
Stepper.Item = Item$1;

function getStickyItemInfo(children, theme) {
    var childrenArray = React__default.Children.toArray(children);
    if (childrenArray.length === 0) {
        throw new Error("Sticky.Item cannot be empty.");
    }
    if (childrenArray.length > 1) {
        throw new Error("Sticky.Item must have a single child.");
    }
    var component = childrenArray[0].type;
    var id = component.ID;
    if (!id || typeof id !== "string") {
        throw new Error('Sticky.Item\'s child must expose a unique ID, e.g.: MyChild.ID = "MyChild";');
    }
    var componentHeightMap = component.HEIGHT_MAP;
    if (!componentHeightMap || _typeof(componentHeightMap) !== "object") {
        throw new Error("Sticky.Item's child must expose a HEIGHT_MAP object.");
    }
    if (typeof componentHeightMap[DEFAULT_BREAKPOINT] === "undefined") {
        throw new Error("Sticky.Item's child exposes a HEIGHT_MAP object, but the object is missing a `".concat(DEFAULT_BREAKPOINT, "` property."));
    }
    var height = componentHeightMap[DEFAULT_BREAKPOINT];
    if (typeof height !== "number" || height <= 0) {
        throw new Error("Sticky.Item's child exposes a HEIGHT_MAP object, but object's `".concat(DEFAULT_BREAKPOINT, "` value is not a positive integer."));
    }
    var heightMap = _defineProperty({}, DEFAULT_BREAKPOINT, height);
    var lastHeight = height;
    for (var bp in theme.breakpoints) {
        height = componentHeightMap[bp];
        if (typeof height === "undefined") {
            heightMap[bp] = lastHeight;
        }
        else if (typeof height === "number" && height > 0) {
            heightMap[bp] = height;
            lastHeight = height;
        }
        else {
            throw new Error("Sticky.Item's child exposes a HEIGHT_MAP object, but object's `".concat(bp, "` value is not a positive integer."));
        }
    }
    return {
        id: id,
        heightMap: heightMap
    };
}
function getStickyItemCSS(_ref) {
    var heightMap = _ref.heightMap, offsetMap = _ref.offsetMap, theme = _ref.theme;
    var result = {
        /*
          We want to ensure that Sticky.Items are painted above normal content.
          Is normal content has `position: relative` (like Grid does), it would be
          painted on top of the Sticky.Item if the Sticky.Item doesn't have z-index > 0.
          That's why we define a z-index on Sticky.Items.
          See: https://stackoverflow.com/q/60825826/247243
        */
        zIndex: theme.zIndices.stickyItem,
        position: "sticky"
    };
    var lastHeight = null;
    var lastOffset = null;
    for (var bp in heightMap) {
        if (heightMap[bp] !== lastHeight) {
            lastHeight = heightMap[bp];
            var height = "".concat(lastHeight, "px");
            result = setPath(result, bp === DEFAULT_BREAKPOINT ? "height" : "".concat(theme.minMediaQueries[bp], ".height"), height);
        }
        if (offsetMap[bp] !== lastOffset) {
            lastOffset = offsetMap[bp];
            var top = "".concat(lastOffset, "px");
            result = setPath(result, bp === DEFAULT_BREAKPOINT ? "top" : "".concat(theme.minMediaQueries[bp], ".top"), top);
        }
    }
    return result;
}

var StickyContext = /*#__PURE__*/ React__default.createContext();
var StickyProvider = StickyContext.Provider;
function useSticky(_ref) {
    var id = _ref.id, heightMap = _ref.heightMap;
    var theme = useTheme();
    var stickyInfo = useContext(StickyContext);
    if (!stickyInfo) {
        throw new Error("Sticky.Item must be placed inside Sticky.");
    }
    var calculatedOffsetMap = stickyInfo.offsetMap[id];
    var css = getStickyItemCSS({
        heightMap: heightMap,
        offsetMap: calculatedOffsetMap !== null && calculatedOffsetMap !== void 0 ? calculatedOffsetMap : stickyInfo.accumulativeOffsetMap,
        theme: theme
    });
    if (!calculatedOffsetMap) {
        stickyInfo.updateOffsetMap(id, heightMap);
    }
    return {
        css: css
    };
}

function Item(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var theme = useTheme();
    var _useSticky = useSticky(getStickyItemInfo(children, theme)), css = _useSticky.css;
    return jsx("div", {
        css: css,
        "data-testid": testId
    }, children);
}
Item.propTypes = _objectSpread2(_objectSpread2({}, responsiveHeightType), {}, {
    children: PropTypes.node,
    testId: PropTypes.string
});
function Sticky(props) {
    var children = props.children, testId = props.testId;
    var theme = useTheme();
    var initialOffsetMap = useMemo(function () {
        var result = _defineProperty({}, DEFAULT_BREAKPOINT, 0);
        for (var bp in theme.breakpoints) {
            result[bp] = 0;
        }
        return result;
    }, [theme]);
    var accumulativeOffsetMap = useRef(initialOffsetMap);
    var offsetMap = useRef({});
    var updateOffsetMap = function updateOffsetMap(id, heightMap) {
        if (!offsetMap.current[id]) {
            offsetMap.current[id] = _objectSpread2({}, accumulativeOffsetMap.current); // Spread is important here since `accumulativeOffsetMap.current` is updated below.
            for (var bp in heightMap) {
                accumulativeOffsetMap.current[bp] += heightMap[bp];
            }
        }
    };
    /*
      Without this div, we have no control over sticky items' parent.
      If the parent ends up having `height: 100vh`, for example, the sticky items won't stick.
    */
    return jsx(StickyProvider, {
        value: {
            accumulativeOffsetMap: accumulativeOffsetMap.current,
            offsetMap: offsetMap.current,
            updateOffsetMap: updateOffsetMap
        }
    }, jsx("div", {
        "data-testid": testId
    }, children));
}
Sticky.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string
};
Sticky.Item = Item;

var defaultTextareaProps = {
    disabled: false,
    optional: false,
    __internal__focus: false,
};

var DEFAULT_PROPS$3 = __assign(__assign({}, defaultTextareaProps), { color: "grey.t05", validate: function (value, _a) {
        var isEmpty = _a.isEmpty;
        if (isEmpty(value)) {
            return "Required";
        }
        return null;
    } });
function Textarea$2(props) {
    var mergedProps = useMergedProps(props, defaultTextareaProps);
    var innerRef = mergedProps.innerRef, value = mergedProps.value, maxLength = mergedProps.maxLength, label = mergedProps.label, placeholder = mergedProps.placeholder, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, error = mergedProps.error, onChange = mergedProps.onChange, onFocus = mergedProps.onFocus, onBlur = mergedProps.onBlur, testId = mergedProps.testId, __internal__focus = mergedProps.__internal__focus;
    var textareaId = useState(function () { return "textarea-" + nanoid(); })[0];
    var auxId = useState(function () { return "textarea-aux-" + nanoid(); })[0];
    var inputColorMap = useBackground().inputColorMap;
    var textareaCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$3, {
        color: function (propsAtBreakpoint, theme, bp) {
            var _a;
            var color = (_a = props.color) !== null && _a !== void 0 ? _a : inputColorMap[bp];
            return theme.textarea.getCSS({
                color: color,
                __internal__focus: __internal__focus,
            });
        },
        height: responsiveSize("height"),
    });
    var fieldErrors = Array.isArray(error) || error === undefined ? error : [error];
    var hasErrors = Array.isArray(error) ? error.length !== 0 : !!error;
    return (jsx$1(Field$1, __assign({ optional: optional, disabled: disabled, label: label, labelFor: textareaId, auxId: auxId, helpText: helpText, errors: fieldErrors }, { children: jsx$1("textarea", { ref: innerRef, css: textareaCSS, id: textareaId, placeholder: placeholder, maxLength: typeof maxLength === "string" ? Number(maxLength) : maxLength, disabled: disabled, autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: "false", "aria-invalid": hasErrors ? "true" : "false", "aria-describedby": helpText || hasErrors ? auxId : undefined, "data-testid": testId, onFocus: onFocus, onBlur: onBlur, value: value, onChange: onChange }, void 0) }), void 0));
}

var COLORS$2 = ["grey.t05", "white"];
var DEFAULT_PROPS$2 = _objectSpread2(_objectSpread2({}, defaultTextareaProps), {}, {
    color: "grey.t05",
    validate: function validate(value, _ref) {
        var isEmpty = _ref.isEmpty;
        if (isEmpty(value)) {
            return "Required";
        }
        return null;
    }
});
Textarea$1.COLORS = COLORS$2;
Textarea$1.DEFAULT_PROPS = DEFAULT_PROPS$2;
function Textarea$1(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS$2, {}, {
        maxLength: function maxLength(_maxLength) {
            return typeof _maxLength === "string" || typeof _maxLength === "number";
        },
        color: function color(_color) {
            return COLORS$2.includes(_color);
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        optional: function optional(_optional) {
            return typeof _optional === "boolean";
        }
    });
    var name = mergedProps.name, maxLength = mergedProps.maxLength, label = mergedProps.label, placeholder = mergedProps.placeholder, helpText = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, onChangeProp = mergedProps.onChange, testId = mergedProps.testId, __internal__focus = mergedProps.__internal__focus;
    var _useState = useState(function () {
        return "textarea-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), textareaId = _useState2[0];
    var _useState3 = useState(function () {
        return "textarea-aux-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), auxId = _useState4[0];
    var isEmpty = useCallback(function (value) {
        return value.trim() === "";
    }, []);
    var data = useMemo(function () {
        return _objectSpread2({
            isEmpty: isEmpty
        }, validateData && {
            data: validateData
        });
    }, [isEmpty, validateData]);
    var _useField = useField("Textarea", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, fieldOnChange = _useField.onChange;
    var onChange = useCallback(function (event) {
        fieldOnChange(event);
        onChangeProp && onChangeProp({
            value: event.target.value
        });
    }, [fieldOnChange, onChangeProp]);
    var _useBackground = useBackground(), inputColorMap = _useBackground.inputColorMap;
    var textareaCSS = useResponsivePropsCSS(props, DEFAULT_PROPS$2, {
        color: function color(propsAtBreakpoint, theme, bp) {
            var _props$color;
            var color = (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : inputColorMap[bp];
            return theme.textarea.getCSS({
                color: color,
                __internal__focus: __internal__focus
            });
        },
        height: responsiveSize("height")
    });
    return jsx(Field$1, {
        optional: optional,
        disabled: disabled,
        label: label,
        labelFor: textareaId,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx("textarea", {
        css: textareaCSS,
        id: textareaId,
        name: name,
        placeholder: placeholder,
        maxLength: maxLength,
        disabled: disabled,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false",
        "aria-invalid": hasErrors ? "true" : null,
        "aria-describedby": helpText || hasErrors ? auxId : null,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value,
        onChange: onChange
    }));
}
Textarea$1.propTypes = _objectSpread2(_objectSpread2({
    name: PropTypes.string.isRequired,
    maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.oneOf(COLORS$2),
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    helpText: PropTypes.node,
    disabled: PropTypes.bool,
    optional: PropTypes.bool
}, responsiveHeightType), {}, {
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    validateData: PropTypes.any,
    onChange: PropTypes.func,
    testId: PropTypes.string,
    __internal__focus: PropTypes.bool
});

var setDeprecatedProps = function (props, isDeprecated) {
    return isDeprecated;
};

var COLORS$1 = Textarea$1.COLORS, DEFAULT_PROPS$1 = Textarea$1.DEFAULT_PROPS;
var TextareaComponent = function (props, ref) {
    var isDeprecatedForm = useIsDeprecatedForm();
    if (setDeprecatedProps(props, isDeprecatedForm)) {
        return jsx$1(Textarea$1, __assign({}, props), void 0);
    }
    return jsx$1(Textarea$2, __assign({}, props, { innerRef: ref }), void 0);
};
var Textarea = forwardRef(TextareaComponent);
Textarea.displayName = ComponentNames.Textarea;
Textarea.defaultProps = defaultTextareaProps;
Textarea.COLORS = COLORS$1;
Textarea.DEFAULT_PROPS = DEFAULT_PROPS$1;

function pluralize(count, word) {
    return count === 1 ? "1 ".concat(word) : "".concat(count, " ").concat(word, "s");
}

var COLORS = InternalInput.COLORS;
var YEARS_REGEX = /^\d{1,2}$/;
var MONTHS_REGEX = /^\d{1,2}$/;
var DEFAULT_PROPS = {
    color: InternalInput.DEFAULT_PROPS.color,
    disabled: false,
    optional: false,
    validate: function validate(_ref) {
        var years = _ref.years, months = _ref.months;
        var errors = [];
        if (YEARS_REGEX.test(years)) {
            var yearsInt = parseInt(years, 10);
            if (yearsInt < 0 || yearsInt > 99) {
                errors.push("Years must be within 0-99.");
            }
        }
        else if (years !== "") {
            errors.push("Years must be within 0-99.");
        }
        if (MONTHS_REGEX.test(months)) {
            var monthsInt = parseInt(months, 10);
            if (monthsInt < 0 || monthsInt > 11) {
                errors.push("Months must be within 0-11.");
            }
        }
        else if (months !== "") {
            errors.push("Months must be within 0-11.");
        }
        if (errors.length === 0) {
            var _yearsInt = parseInt(years || "0", 10);
            var _monthsInt = parseInt(months || "0", 10);
            if (_yearsInt === 0 && _monthsInt === 0) {
                errors.push("Must be at least 1 month.");
            }
        }
        return errors;
    }
};
function getHelpText(years, months) {
    var defaultHelpText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var yearsInt = parseInt(years || "0", 10);
    var monthsInt = parseInt(months || "0", 10);
    if (isNaN(yearsInt) || isNaN(monthsInt) || yearsInt === 0 && monthsInt === 0) {
        return defaultHelpText;
    }
    return [{
            count: yearsInt,
            word: "year"
        }, {
            count: monthsInt,
            word: "month"
        }].filter(function (_ref2) {
        var count = _ref2.count;
        return count > 0;
    }).map(function (_ref3) {
        var count = _ref3.count, word = _ref3.word;
        return pluralize(count, word);
    }).join(" and ");
}
TimeSpan.COLORS = COLORS;
TimeSpan.DEFAULT_PROPS = DEFAULT_PROPS;
TimeSpan.getHelpText = getHelpText;
function TimeSpan(props) {
    var mergedProps = mergeProps$1(props, DEFAULT_PROPS, {}, {
        color: function color(_color) {
            return COLORS.includes(_color);
        },
        disabled: function disabled(_disabled) {
            return typeof _disabled === "boolean";
        },
        optional: function optional(_optional) {
            return typeof _optional === "boolean";
        }
    });
    var name = mergedProps.name, label = mergedProps.label, helpTextProp = mergedProps.helpText, disabled = mergedProps.disabled, optional = mergedProps.optional, validate = mergedProps.validate, validateData = mergedProps.validateData, testId = mergedProps.testId, __internal__yearsFocus = mergedProps.__internal__yearsFocus, __internal__monthsFocus = mergedProps.__internal__monthsFocus;
    var _useState = useState(function () {
        return "time-span-".concat(nanoid());
    }), _useState2 = _slicedToArray(_useState, 1), labelId = _useState2[0];
    var _useState3 = useState(function () {
        return "time-span-aux-".concat(nanoid());
    }), _useState4 = _slicedToArray(_useState3, 1), auxId = _useState4[0];
    var isEmpty = useCallback(function (value) {
        return value.years.trim() === "" && value.months.trim() === "";
    }, []);
    var data = useMemo(function () {
        return _objectSpread2({
            isEmpty: isEmpty
        }, validateData && {
            data: validateData
        });
    }, [isEmpty, validateData]);
    var _useField = useField("TimeSpan", {
        name: name,
        disabled: disabled,
        optional: optional,
        validate: validate,
        data: data
    }), value = _useField.value, errors = _useField.errors, hasErrors = _useField.hasErrors, onFocus = _useField.onFocus, onBlur = _useField.onBlur, onChange = _useField.onChange;
    var helpText = useMemo(function () {
        return getHelpText(value.years, value.months, helpTextProp);
    }, [value.years, value.months, helpTextProp]);
    return jsx(Field$1, {
        optional: optional,
        disabled: disabled,
        label: label,
        labelId: labelId,
        auxId: auxId,
        helpText: helpText,
        errors: errors,
        testId: testId
    }, jsx("div", {
        "aria-invalid": hasErrors ? "true" : null,
        "aria-labelledby": labelId,
        "aria-describedby": helpText || hasErrors ? auxId : null
    }, jsx(Grid, {
        cols: 2,
        colsGap: 1
    }, jsx(Grid.Item, {
        colSpan: "0"
    }, jsx(InternalInput, {
        name: "".concat(name, ".years"),
        parentName: name,
        variant: "numeric",
        color: props.color,
        placeholder: "Years",
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value.years,
        onChange: onChange,
        __internal__focus: __internal__yearsFocus
    })), jsx(Grid.Item, {
        colSpan: "1"
    }, jsx(InternalInput, {
        name: "".concat(name, ".months"),
        parentName: name,
        variant: "numeric",
        color: props.color,
        placeholder: "Months",
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        value: value.months,
        onChange: onChange,
        __internal__focus: __internal__monthsFocus
    })))));
}
TimeSpan.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.oneOf(COLORS),
    label: PropTypes.string.isRequired,
    helpText: PropTypes.string,
    disabled: PropTypes.bool,
    optional: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    validateData: PropTypes.any,
    testId: PropTypes.string,
    __internal__yearsFocus: PropTypes.bool,
    __internal__monthsFocus: PropTypes.bool
};

var validateAutoComplete = function (value, autoCompleteProps) {
    var optional = autoCompleteProps.optional, emptyValue = autoCompleteProps.emptyValue;
    if (lodash_isequal(value, emptyValue) && !optional) {
        return "Required";
    }
    return null;
};

var isRadioGroupEmpty = function (value, options) {
    return options.findIndex(function (option) { return option.value === value; }) === -1;
};
var validateRadioGroup = function (value, props) {
    var options = props.options;
    if (isRadioGroupEmpty(value, options)) {
        return "Please make a selection.";
    }
    return null;
};

var isSelectEmpty = function (value, options) {
    return options.findIndex(function (option) { return option.value === value; }) === -1;
};
var validateSelect = function (value, props) {
    var options = props.options;
    if (isSelectEmpty(value, options)) {
        return "Please make a selection.";
    }
    return null;
};

var isTextareaEmpty = function (value) { return value.trim() === ""; };
var validateTextarea = function (value, textareaProps) {
    var optional = textareaProps.optional;
    if (isTextareaEmpty(value)) {
        return optional ? null : "Required";
    }
    return null;
};

var validateFrequency = function (value, props) {
    var annually = props.annually, quarterly = props.quarterly, monthly = props.monthly, fortnightly = props.fortnightly, weekly = props.weekly, optional = props.optional;
    var frequencyPropsMap = {
        annually: annually,
        quarterly: quarterly,
        monthly: monthly,
        fortnightly: fortnightly,
        weekly: weekly,
    };
    var options = ALL_FREQUENCY_OPTIONS.filter(function (option) { return frequencyPropsMap[option.value]; });
    var frequency = value.frequency, amount = value.amount;
    var error = {};
    if (isInputEmpty(amount) && !optional) {
        error.amount = "Please enter an amount.";
    }
    else if (NUMERIC_REGEX.test(value.amount) === false) {
        error.amount = "Amount can contain only digits.";
    }
    var isFrequencySelected = options.some(function (_a) {
        var value = _a.value;
        return value === frequency;
    });
    if (!isFrequencySelected && !optional) {
        error.frequency = "Please select a frequency";
    }
    return Object.values(error).length === 0 ? null : error;
};

var validateCheckbox = function (value, props) {
    if (!props.optional && !value) {
        return "Must be checked";
    }
    return null;
};

var isKeyInOptions = function (key, options) {
    return options.some(function (option) { return option.key === key; });
};
var validateCheckboxGroup = function (value, props) {
    var options = props.options;
    var isEmpty = Object.keys(value).every(function (key) { return !value[key] || !isKeyInOptions(key, options); });
    if (isEmpty) {
        return { field: "Please make a selection." };
    }
    return null;
};

var _a$1;
var nameToValidateMap = (_a$1 = {},
    _a$1[ComponentNames.Input] = validateInput,
    _a$1[ComponentNames.RadioGroup] = validateRadioGroup,
    _a$1[ComponentNames.Select] = validateSelect,
    _a$1[ComponentNames.DateInput] = validateDateInput,
    _a$1[ComponentNames.Textarea] = validateTextarea,
    _a$1[ComponentNames.Frequency] = validateFrequency,
    _a$1[ComponentNames.Checkbox] = validateCheckbox,
    _a$1[ComponentNames.CheckboxGroup] = validateCheckboxGroup,
    _a$1[ComponentNames.AutoComplete] = validateAutoComplete,
    _a$1);

var _a;
var nameToGetDefaultValueMap = (_a = {},
    _a[ComponentNames.Input] = function () { return ""; },
    _a[ComponentNames.Textarea] = function () { return ""; },
    _a[ComponentNames.RadioGroup] = function () { return ""; },
    _a[ComponentNames.Select] = function () { return ""; },
    _a[ComponentNames.DateInput] = function () { return ({
        day: "",
        month: "",
        year: "",
    }); },
    _a[ComponentNames.Frequency] = function () { return ({
        amount: "",
        frequency: "",
    }); },
    _a[ComponentNames.Checkbox] = function () { return false; },
    _a[ComponentNames.CheckboxGroup] = function () { return ({}); },
    _a[ComponentNames.AutoComplete] = function (_a) {
        var emptyValue = _a.emptyValue;
        return emptyValue;
    },
    _a);

var BASIS_JSON_ERROR_PREFIX = "__basis_json_error_prefix";
var rhfErrorConverter = {
    getRhfError: function (error) {
        if (error === null) {
            return true;
        }
        if (typeof error === "string") {
            return error;
        }
        return "" + BASIS_JSON_ERROR_PREFIX + JSON.stringify(error);
    },
    // TODO: check the error schema based on ComponentName
    // to ensure wrong error scheme doesn't go to the wrong component
    getBasisError: function (error) {
        if (!(error === null || error === void 0 ? void 0 : error.message)) {
            return null;
        }
        // split the result, if it was a simple string it will be the first results
        // if stringified then it will be the second result
        var _a = error.message.split(BASIS_JSON_ERROR_PREFIX), stringError = _a[0], jsonError = _a[1];
        if (stringError) {
            return stringError;
        }
        return JSON.parse(jsonError);
    },
};

var BASIS_INTERNAL_VALIDATION_KEY = "__internalBasisValidation";
var useBasisField = function (options) {
    var _a;
    var _b, _c;
    var name = options.name, defaultValue = options.defaultValue, _d = options.componentProps, componentProps = _d === void 0 ? {} : _d, customValidation = options.validate, _e = options.componentDisplayName, componentDisplayName = _e === void 0 ? "" : _e;
    var trigger = useFormContext().trigger;
    var validate = customValidation !== null && customValidation !== void 0 ? customValidation : nameToValidateMap[componentDisplayName];
    var internalBasisValidation = function (value) {
        var validationErrors = validate(value, componentProps);
        return rhfErrorConverter.getRhfError(validationErrors);
    };
    var getDefaultValue = nameToGetDefaultValueMap[componentDisplayName];
    var componentDefaultValue = (_b = getDefaultValue === null || getDefaultValue === void 0 ? void 0 : getDefaultValue(componentProps)) !== null && _b !== void 0 ? _b : undefined;
    var _f = useController({
        name: name,
        defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : componentDefaultValue,
        rules: {
            validate: (_a = {},
                _a[BASIS_INTERNAL_VALIDATION_KEY] = internalBasisValidation,
                _a),
        },
    }), field = _f.field, fieldState = _f.fieldState;
    var rhfRef = field.ref;
    // https://github.com/react-hook-form/react-hook-form/discussions/5548#discussioncomment-849081
    var ref = useCallback(function (e) {
        e &&
            rhfRef({
                focus: function () {
                    var tabIndex = e.tabIndex;
                    e.tabIndex = 1;
                    e.focus();
                    e.tabIndex = tabIndex;
                },
            });
    }, [rhfRef]);
    var _g = useState(false), hasBeenInvalid = _g[0], setHasBeenInvalid = _g[1];
    useEffect(function () {
        if (fieldState.invalid && !hasBeenInvalid) {
            setHasBeenInvalid(true);
        }
    }, [fieldState.invalid, hasBeenInvalid]);
    // functions in ref to avoid recreating event listeners when these change
    var functionRefs = useRef({
        trigger: trigger,
        componentOnChange: componentProps.onChange,
        componentOnBlur: componentProps.onBlur,
        fieldOnChange: field.onChange,
        fieldOnBlur: field.onBlur,
    });
    useEffect(function () {
        functionRefs.current.trigger = trigger;
        functionRefs.current.componentOnChange = componentProps.onChange;
        functionRefs.current.componentOnBlur = componentProps.onBlur;
        functionRefs.current.fieldOnChange = field.onChange;
        functionRefs.current.fieldOnBlur = field.onBlur;
    });
    var onChange = useCallback(function () {
        var _a;
        var _b, _c;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = functionRefs.current).fieldOnChange.apply(_a, args);
        (_c = (_b = functionRefs.current).componentOnChange) === null || _c === void 0 ? void 0 : _c.call.apply(_c, __spreadArray([_b], args));
        if (hasBeenInvalid) {
            functionRefs.current.trigger(name);
        }
    }, [name, hasBeenInvalid]);
    var onBlur = useCallback(function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_b = (_a = functionRefs.current).componentOnBlur) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args));
        functionRefs.current.fieldOnBlur();
        // if the onBlur is called with valid fieldState
        // then stop triggering validation checks on every change
        if (!fieldState.invalid) {
            setHasBeenInvalid(false);
        }
    }, [fieldState.invalid]);
    return __assign(__assign({}, field), { ref: ref,
        onBlur: onBlur,
        onChange: onChange, error: (_c = rhfErrorConverter.getBasisError(fieldState.error)) !== null && _c !== void 0 ? _c : undefined });
};

var CustomField = (function (props) {
    var name = props.name, defaultValue = props.defaultValue, validate = props.validate, children = props.children;
    var childProps = useBasisField({ name: name, defaultValue: defaultValue, validate: validate });
    return children(childProps);
});

var Field = forwardRef(function (props, ref) {
    var name = props.name, defaultValue = props.defaultValue, validate = props.validate, Component = props.as, rest = __rest(props, ["name", "defaultValue", "validate", "as"]);
    var componentProps = useMemo(function () { return (__assign(__assign({}, Component.defaultProps), rest)); }, [Component.defaultProps, rest]);
    var _a = useBasisField({
        name: name,
        componentDisplayName: Component.displayName,
        componentProps: componentProps,
        validate: validate,
        defaultValue: defaultValue,
    }), onChange = _a.onChange, onBlur = _a.onBlur, formComponentRef = _a.ref, error = _a.error, childProps = __rest(_a, ["onChange", "onBlur", "ref", "error"]);
    var mergedProps = __assign(__assign(__assign({}, props), childProps), { error: error,
        onChange: onChange,
        onBlur: onBlur, ref: mergeRefs([ref, formComponentRef]) });
    return jsx$1(Component, __assign({}, mergedProps), void 0);
});

var setBasisError = function (methods) { return function (name, error) {
    var message = rhfErrorConverter.getRhfError(error);
    if (typeof message !== "string") {
        return;
    }
    var setError = methods.setError;
    setError(name, {
        type: BASIS_INTERNAL_VALIDATION_KEY,
        message: message,
    });
}; };

function useBasisForm(options) {
    if (options === void 0) { options = {}; }
    var defaultValues = options.defaultValues;
    var methods = useForm({
        mode: "onBlur",
        defaultValues: defaultValues,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var setError = useCallback(setBasisError(methods), [methods]);
    return {
        methods: methods,
        Field: Field,
        CustomField: CustomField,
        setError: setError,
    };
}

function useBasisFormContext() {
    var methods = useFormContext();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var setError = useCallback(setBasisError(methods), [methods]);
    return {
        methods: methods,
        Field: Field,
        CustomField: CustomField,
        setError: setError,
    };
}

export { ALL_FREQUENCY_OPTIONS, Accordion, AutoComplete, BasisProvider, Button, Checkbox, CheckboxGroup, Container, DateInput, Divider, Dropdown, Flex, Footer$1 as Footer, Form, Frequency, Grid, Header, Icon, Input, Link, List, LoadingIcon, Logo, Message, Modal, Placeholder, RadioGroup, Select, ShadowContainer, Stack, Stepper, Sticky, Text, Textarea, TimeSpan, VisuallyHidden, theme as defaultTheme, getUniqueId, useBasisForm, useBasisFormContext, useBreakpoint, useFieldArray, useFormState, useTheme, useWatch, validateAutoComplete, validateCheckbox, validateCheckboxGroup, validateDateInput, validateFrequency, validateInput, validateRadioGroup, validateSelect, validateTextarea };
